(() => {
  var eu = Object.defineProperty, tu = Object.defineProperties;
  var iu = Object.getOwnPropertyDescriptors;
  var Co = Object.getOwnPropertySymbols;
  var nu = Object.prototype.hasOwnProperty, su = Object.prototype.propertyIsEnumerable;
  var Me = Math.pow, Ss = (e, t, i) => t in e ? eu(e, t, { enumerable: true, configurable: true, writable: true, value: i }) : e[t] = i, Ie = (e, t) => {
    for (var i in t || (t = {})) nu.call(t, i) && Ss(e, i, t[i]);
    if (Co) for (var i of Co(t)) su.call(t, i) && Ss(e, i, t[i]);
    return e;
  }, bi = (e, t) => tu(e, iu(t));
  var ie = (e, t, i) => Ss(e, typeof t != "symbol" ? t + "" : t, i);
  function ru(e, t) {
    if (typeof e == "undefined" || !e.document) throw new Error("jQuery requires a window with a document");
    var i = [], n = Object.getPrototypeOf, r = i.slice, o = i.flat ? function(s) {
      return i.flat.call(s);
    } : function(s) {
      return i.concat.apply([], s);
    }, l = i.push, c = i.indexOf, d = {}, v = d.toString, E = d.hasOwnProperty, y = E.toString, b = y.call(Object), p = {};
    function g(s) {
      return s == null ? s + "" : typeof s == "object" ? d[v.call(s)] || "object" : typeof s;
    }
    function C(s) {
      return s != null && s === s.window;
    }
    function _(s) {
      var a = !!s && s.length, u = g(s);
      return typeof s == "function" || C(s) ? false : u === "array" || a === 0 || typeof a == "number" && a > 0 && a - 1 in s;
    }
    var h = e.document, S = { type: true, src: true, nonce: true, noModule: true };
    function w(s, a, u) {
      u = u || h;
      var m, T = u.createElement("script");
      T.text = s;
      for (m in S) a && a[m] && (T[m] = a[m]);
      u.head.appendChild(T).parentNode && T.parentNode.removeChild(T);
    }
    var A = "4.0.0", L = /HTML$/i, f = function(s, a) {
      return new f.fn.init(s, a);
    };
    f.fn = f.prototype = { jquery: A, constructor: f, length: 0, toArray: function() {
      return r.call(this);
    }, get: function(s) {
      return s == null ? r.call(this) : s < 0 ? this[s + this.length] : this[s];
    }, pushStack: function(s) {
      var a = f.merge(this.constructor(), s);
      return a.prevObject = this, a;
    }, each: function(s) {
      return f.each(this, s);
    }, map: function(s) {
      return this.pushStack(f.map(this, function(a, u) {
        return s.call(a, u, a);
      }));
    }, slice: function() {
      return this.pushStack(r.apply(this, arguments));
    }, first: function() {
      return this.eq(0);
    }, last: function() {
      return this.eq(-1);
    }, even: function() {
      return this.pushStack(f.grep(this, function(s, a) {
        return (a + 1) % 2;
      }));
    }, odd: function() {
      return this.pushStack(f.grep(this, function(s, a) {
        return a % 2;
      }));
    }, eq: function(s) {
      var a = this.length, u = +s + (s < 0 ? a : 0);
      return this.pushStack(u >= 0 && u < a ? [this[u]] : []);
    }, end: function() {
      return this.prevObject || this.constructor();
    } }, f.extend = f.fn.extend = function() {
      var s, a, u, m, T, x, I = arguments[0] || {}, M = 1, O = arguments.length, z = false;
      for (typeof I == "boolean" && (z = I, I = arguments[M] || {}, M++), typeof I != "object" && typeof I != "function" && (I = {}), M === O && (I = this, M--); M < O; M++) if ((s = arguments[M]) != null) for (a in s) m = s[a], !(a === "__proto__" || I === m) && (z && m && (f.isPlainObject(m) || (T = Array.isArray(m))) ? (u = I[a], T && !Array.isArray(u) ? x = [] : !T && !f.isPlainObject(u) ? x = {} : x = u, T = false, I[a] = f.extend(z, x, m)) : m !== void 0 && (I[a] = m));
      return I;
    }, f.extend({ expando: "jQuery" + (A + Math.random()).replace(/\D/g, ""), isReady: true, error: function(s) {
      throw new Error(s);
    }, noop: function() {
    }, isPlainObject: function(s) {
      var a, u;
      return !s || v.call(s) !== "[object Object]" ? false : (a = n(s), a ? (u = E.call(a, "constructor") && a.constructor, typeof u == "function" && y.call(u) === b) : true);
    }, isEmptyObject: function(s) {
      var a;
      for (a in s) return false;
      return true;
    }, globalEval: function(s, a, u) {
      w(s, { nonce: a && a.nonce }, u);
    }, each: function(s, a) {
      var u, m = 0;
      if (_(s)) for (u = s.length; m < u && a.call(s[m], m, s[m]) !== false; m++) ;
      else for (m in s) if (a.call(s[m], m, s[m]) === false) break;
      return s;
    }, text: function(s) {
      var a, u = "", m = 0, T = s.nodeType;
      if (!T) for (; a = s[m++]; ) u += f.text(a);
      return T === 1 || T === 11 ? s.textContent : T === 9 ? s.documentElement.textContent : T === 3 || T === 4 ? s.nodeValue : u;
    }, makeArray: function(s, a) {
      var u = a || [];
      return s != null && (_(Object(s)) ? f.merge(u, typeof s == "string" ? [s] : s) : l.call(u, s)), u;
    }, inArray: function(s, a, u) {
      return a == null ? -1 : c.call(a, s, u);
    }, isXMLDoc: function(s) {
      var a = s && s.namespaceURI, u = s && (s.ownerDocument || s).documentElement;
      return !L.test(a || u && u.nodeName || "HTML");
    }, contains: function(s, a) {
      var u = a && a.parentNode;
      return s === u || !!(u && u.nodeType === 1 && (s.contains ? s.contains(u) : s.compareDocumentPosition && s.compareDocumentPosition(u) & 16));
    }, merge: function(s, a) {
      for (var u = +a.length, m = 0, T = s.length; m < u; m++) s[T++] = a[m];
      return s.length = T, s;
    }, grep: function(s, a, u) {
      for (var m, T = [], x = 0, I = s.length, M = !u; x < I; x++) m = !a(s[x], x), m !== M && T.push(s[x]);
      return T;
    }, map: function(s, a, u) {
      var m, T, x = 0, I = [];
      if (_(s)) for (m = s.length; x < m; x++) T = a(s[x], x, u), T != null && I.push(T);
      else for (x in s) T = a(s[x], x, u), T != null && I.push(T);
      return o(I);
    }, guid: 1, support: p }), typeof Symbol == "function" && (f.fn[Symbol.iterator] = i[Symbol.iterator]), f.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(s, a) {
      d["[object " + a + "]"] = a.toLowerCase();
    });
    function P(s, a) {
      return s.nodeName && s.nodeName.toLowerCase() === a.toLowerCase();
    }
    var D = i.pop, R = "[\\x20\\t\\r\\n\\f]", N = h.documentMode, $ = N && new RegExp(":enabled|:disabled|\\[" + R + "*name" + R + "*=" + R + `*(?:''|"")`), B = new RegExp("^" + R + "+|((?:^|[^\\\\])(?:\\\\.)*)" + R + "+$", "g"), V = "(?:\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", X = new RegExp("^" + R + "*([>+~]|" + R + ")" + R + "*"), Z = new RegExp(R + "|>"), F = /[+~]/, W = h.documentElement, Y = W.matches || W.msMatchesSelector;
    function J() {
      var s = [];
      function a(u, m) {
        return s.push(u + " ") > f.expr.cacheLength && delete a[s.shift()], a[u + " "] = m;
      }
      return a;
    }
    function oe(s) {
      return s && typeof s.getElementsByTagName != "undefined" && s;
    }
    var he = "\\[" + R + "*(" + V + ")(?:" + R + "*([*^$|!~]?=)" + R + `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + V + "))|)" + R + "*\\]", _e = ":(" + V + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + he + ")*)|.*)\\)|)", Ee = { ID: new RegExp("^#(" + V + ")"), CLASS: new RegExp("^\\.(" + V + ")"), TAG: new RegExp("^(" + V + "|[*])"), ATTR: new RegExp("^" + he), PSEUDO: new RegExp("^" + _e), CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + R + "*(even|odd|(([+-]|)(\\d*)n|)" + R + "*(?:([+-]|)" + R + "*(\\d+)|))" + R + "*\\)|)", "i") }, U = new RegExp(_e), Q = new RegExp("\\\\[\\da-fA-F]{1,6}" + R + "?|\\\\([^\\r\\n\\f])", "g"), ee = function(s, a) {
      var u = "0x" + s.slice(1) - 65536;
      return a || (u < 0 ? String.fromCharCode(u + 65536) : String.fromCharCode(u >> 10 | 55296, u & 1023 | 56320));
    };
    function K(s) {
      return s.replace(Q, ee);
    }
    function se(s) {
      f.error("Syntax error, unrecognized expression: " + s);
    }
    var Se = new RegExp("^" + R + "*," + R + "*"), Ge = J();
    function Ce(s, a) {
      var u, m, T, x, I, M, O, z = Ge[s + " "];
      if (z) return a ? 0 : z.slice(0);
      for (I = s, M = [], O = f.expr.preFilter; I; ) {
        (!u || (m = Se.exec(I))) && (m && (I = I.slice(m[0].length) || I), M.push(T = [])), u = false, (m = X.exec(I)) && (u = m.shift(), T.push({ value: u, type: m[0].replace(B, " ") }), I = I.slice(u.length));
        for (x in Ee) (m = f.expr.match[x].exec(I)) && (!O[x] || (m = O[x](m))) && (u = m.shift(), T.push({ value: u, type: x, matches: m }), I = I.slice(u.length));
        if (!u) break;
      }
      return a ? I.length : I ? se(s) : Ge(s, M).slice(0);
    }
    var Ze = { ATTR: function(s) {
      return s[1] = K(s[1]), s[3] = K(s[3] || s[4] || s[5] || ""), s[2] === "~=" && (s[3] = " " + s[3] + " "), s.slice(0, 4);
    }, CHILD: function(s) {
      return s[1] = s[1].toLowerCase(), s[1].slice(0, 3) === "nth" ? (s[3] || se(s[0]), s[4] = +(s[4] ? s[5] + (s[6] || 1) : 2 * (s[3] === "even" || s[3] === "odd")), s[5] = +(s[7] + s[8] || s[3] === "odd")) : s[3] && se(s[0]), s;
    }, PSEUDO: function(s) {
      var a, u = !s[6] && s[2];
      return Ee.CHILD.test(s[0]) ? null : (s[3] ? s[2] = s[4] || s[5] || "" : u && U.test(u) && (a = Ce(u, true)) && (a = u.indexOf(")", u.length - a) - u.length) && (s[0] = s[0].slice(0, a), s[2] = u.slice(0, a)), s.slice(0, 3));
    } };
    function ge(s) {
      for (var a = 0, u = s.length, m = ""; a < u; a++) m += s[a].value;
      return m;
    }
    function be(s, a, u, m, T, x, I) {
      var M = 0, O = s.length, z = u == null;
      if (g(u) === "object") {
        T = true;
        for (M in u) be(s, a, M, u[M], true, x, I);
      } else if (m !== void 0 && (T = true, typeof m != "function" && (I = true), z && (I ? (a.call(s, m), a = null) : (z = a, a = function(H, j, k) {
        return z.call(f(H), k);
      })), a)) for (; M < O; M++) a(s[M], u, I ? m : m.call(s[M], M, a(s[M], u)));
      return T ? s : z ? a.call(s) : O ? a(s[0], u) : x;
    }
    var Oe = /[^\x20\t\r\n\f]+/g;
    f.fn.extend({ attr: function(s, a) {
      return be(this, f.attr, s, a, arguments.length > 1);
    }, removeAttr: function(s) {
      return this.each(function() {
        f.removeAttr(this, s);
      });
    } }), f.extend({ attr: function(s, a, u) {
      var m, T, x = s.nodeType;
      if (!(x === 3 || x === 8 || x === 2)) {
        if (typeof s.getAttribute == "undefined") return f.prop(s, a, u);
        if ((x !== 1 || !f.isXMLDoc(s)) && (T = f.attrHooks[a.toLowerCase()]), u !== void 0) {
          if (u === null || u === false && a.toLowerCase().indexOf("aria-") !== 0) {
            f.removeAttr(s, a);
            return;
          }
          return T && "set" in T && (m = T.set(s, u, a)) !== void 0 ? m : (s.setAttribute(a, u), u);
        }
        return T && "get" in T && (m = T.get(s, a)) !== null ? m : (m = s.getAttribute(a), m == null ? void 0 : m);
      }
    }, attrHooks: {}, removeAttr: function(s, a) {
      var u, m = 0, T = a && a.match(Oe);
      if (T && s.nodeType === 1) for (; u = T[m++]; ) s.removeAttribute(u);
    } }), N && (f.attrHooks.type = { set: function(s, a) {
      if (a === "radio" && P(s, "input")) {
        var u = s.value;
        return s.setAttribute("type", a), u && (s.value = u), a;
      }
    } });
    var Et = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function st(s, a) {
      return a ? s === "\0" ? "�" : s.slice(0, -1) + "\\" + s.charCodeAt(s.length - 1).toString(16) + " " : "\\" + s;
    }
    f.escapeSelector = function(s) {
      return (s + "").replace(Et, st);
    };
    var dt = i.sort, Lt = i.splice, De;
    function ft(s, a) {
      if (s === a) return De = true, 0;
      var u = !s.compareDocumentPosition - !a.compareDocumentPosition;
      return u || (u = (s.ownerDocument || s) == (a.ownerDocument || a) ? s.compareDocumentPosition(a) : 1, u & 1 ? s == h || s.ownerDocument == h && f.contains(h, s) ? -1 : a == h || a.ownerDocument == h && f.contains(h, a) ? 1 : 0 : u & 4 ? -1 : 1);
    }
    f.uniqueSort = function(s) {
      var a, u = [], m = 0, T = 0;
      if (De = false, dt.call(s, ft), De) {
        for (; a = s[T++]; ) a === s[T] && (m = u.push(T));
        for (; m--; ) Lt.call(s, u[m], 1);
      }
      return s;
    }, f.fn.uniqueSort = function() {
      return this.pushStack(f.uniqueSort(r.apply(this)));
    };
    var je, rt, Te, St, we, $e = 0, ht = 0, Pr = J(), Dr = J(), an = J(), Zl = new RegExp(R + "+", "g"), Ql = new RegExp("^" + V + "$"), zr = f.extend({ needsContext: new RegExp("^" + R + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + R + "*((?:-\\d)?\\d*)" + R + "*\\)|)(?=[^-]|$)", "i") }, Ee), Jl = /^(?:input|select|textarea|button)$/i, ec = /^h\d$/i, tc = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, ic = function() {
      li();
    }, nc = ln(function(s) {
      return s.disabled === true && P(s, "fieldset");
    }, { dir: "parentNode", next: "legend" });
    function ot(s, a, u, m) {
      var T, x, I, M, O, z, H, j = a && a.ownerDocument, k = a ? a.nodeType : 9;
      if (u = u || [], typeof s != "string" || !s || k !== 1 && k !== 9 && k !== 11) return u;
      if (!m && (li(a), a = a || Te, we)) {
        if (k !== 11 && (O = tc.exec(s))) if (T = O[1]) {
          if (k === 9) return (I = a.getElementById(T)) && l.call(u, I), u;
          if (j && (I = j.getElementById(T)) && f.contains(a, I)) return l.call(u, I), u;
        } else {
          if (O[2]) return l.apply(u, a.getElementsByTagName(s)), u;
          if ((T = O[3]) && a.getElementsByClassName) return l.apply(u, a.getElementsByClassName(T)), u;
        }
        if (!an[s + " "] && (!$ || !$.test(s))) {
          if (H = s, j = a, k === 1 && (Z.test(s) || X.test(s))) {
            for (j = F.test(s) && oe(a.parentNode) || a, (j != a || N) && ((M = a.getAttribute("id")) ? M = f.escapeSelector(M) : a.setAttribute("id", M = f.expando)), z = Ce(s), x = z.length; x--; ) z[x] = (M ? "#" + M : ":scope") + " " + ge(z[x]);
            H = z.join(",");
          }
          try {
            return l.apply(u, j.querySelectorAll(H)), u;
          } catch (G) {
            an(s, true);
          } finally {
            M === f.expando && a.removeAttribute("id");
          }
        }
      }
      return kr(s.replace(B, "$1"), a, u, m);
    }
    function pt(s) {
      return s[f.expando] = true, s;
    }
    function sc(s) {
      return function(a) {
        return P(a, "input") && a.type === s;
      };
    }
    function rc(s) {
      return function(a) {
        return (P(a, "input") || P(a, "button")) && a.type === s;
      };
    }
    function $r(s) {
      return function(a) {
        return "form" in a ? a.parentNode && a.disabled === false ? "label" in a ? "label" in a.parentNode ? a.parentNode.disabled === s : a.disabled === s : a.isDisabled === s || a.isDisabled !== !s && nc(a) === s : a.disabled === s : "label" in a ? a.disabled === s : false;
      };
    }
    function jt(s) {
      return pt(function(a) {
        return a = +a, pt(function(u, m) {
          for (var T, x = s([], u.length, a), I = x.length; I--; ) u[T = x[I]] && (u[T] = !(m[T] = u[T]));
        });
      });
    }
    function li(s) {
      var a, u = s ? s.ownerDocument || s : h;
      u == Te || u.nodeType !== 9 || (Te = u, St = Te.documentElement, we = !f.isXMLDoc(Te), N && h != Te && (a = Te.defaultView) && a.top !== a && a.addEventListener("unload", ic));
    }
    ot.matches = function(s, a) {
      return ot(s, null, null, a);
    }, ot.matchesSelector = function(s, a) {
      if (li(s), we && !an[a + " "] && (!$ || !$.test(a))) try {
        return Y.call(s, a);
      } catch (u) {
        an(a, true);
      }
      return ot(a, Te, null, [s]).length > 0;
    }, f.expr = { cacheLength: 50, createPseudo: pt, match: zr, find: { ID: function(s, a) {
      if (typeof a.getElementById != "undefined" && we) {
        var u = a.getElementById(s);
        return u ? [u] : [];
      }
    }, TAG: function(s, a) {
      return typeof a.getElementsByTagName != "undefined" ? a.getElementsByTagName(s) : a.querySelectorAll(s);
    }, CLASS: function(s, a) {
      if (typeof a.getElementsByClassName != "undefined" && we) return a.getElementsByClassName(s);
    } }, relative: { ">": { dir: "parentNode", first: true }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: true }, "~": { dir: "previousSibling" } }, preFilter: Ze, filter: { ID: function(s) {
      var a = K(s);
      return function(u) {
        return u.getAttribute("id") === a;
      };
    }, TAG: function(s) {
      var a = K(s).toLowerCase();
      return s === "*" ? function() {
        return true;
      } : function(u) {
        return P(u, a);
      };
    }, CLASS: function(s) {
      var a = Pr[s + " "];
      return a || (a = new RegExp("(^|" + R + ")" + s + "(" + R + "|$)")) && Pr(s, function(u) {
        return a.test(typeof u.className == "string" && u.className || typeof u.getAttribute != "undefined" && u.getAttribute("class") || "");
      });
    }, ATTR: function(s, a, u) {
      return function(m) {
        var T = f.attr(m, s);
        return T == null ? a === "!=" : a ? (T += "", a === "=" ? T === u : a === "!=" ? T !== u : a === "^=" ? u && T.indexOf(u) === 0 : a === "*=" ? u && T.indexOf(u) > -1 : a === "$=" ? u && T.slice(-u.length) === u : a === "~=" ? (" " + T.replace(Zl, " ") + " ").indexOf(u) > -1 : a === "|=" ? T === u || T.slice(0, u.length + 1) === u + "-" : false) : true;
      };
    }, CHILD: function(s, a, u, m, T) {
      var x = s.slice(0, 3) !== "nth", I = s.slice(-4) !== "last", M = a === "of-type";
      return m === 1 && T === 0 ? function(O) {
        return !!O.parentNode;
      } : function(O, z, H) {
        var j, k, G, te, le, ae = x !== I ? "nextSibling" : "previousSibling", ve = O.parentNode, pe = M && O.nodeName.toLowerCase(), Be = !H && !M, ze = false;
        if (ve) {
          if (x) {
            for (; ae; ) {
              for (G = O; G = G[ae]; ) if (M ? P(G, pe) : G.nodeType === 1) return false;
              le = ae = s === "only" && !le && "nextSibling";
            }
            return true;
          }
          if (le = [I ? ve.firstChild : ve.lastChild], I && Be) {
            for (k = ve[f.expando] || (ve[f.expando] = {}), j = k[s] || [], te = j[0] === $e && j[1], ze = te && j[2], G = te && ve.childNodes[te]; G = ++te && G && G[ae] || (ze = te = 0) || le.pop(); ) if (G.nodeType === 1 && ++ze && G === O) {
              k[s] = [$e, te, ze];
              break;
            }
          } else if (Be && (k = O[f.expando] || (O[f.expando] = {}), j = k[s] || [], te = j[0] === $e && j[1], ze = te), ze === false) for (; (G = ++te && G && G[ae] || (ze = te = 0) || le.pop()) && !((M ? P(G, pe) : G.nodeType === 1) && ++ze && (Be && (k = G[f.expando] || (G[f.expando] = {}), k[s] = [$e, ze]), G === O)); ) ;
          return ze -= T, ze === m || ze % m === 0 && ze / m >= 0;
        }
      };
    }, PSEUDO: function(s, a) {
      var u = f.expr.pseudos[s] || f.expr.setFilters[s.toLowerCase()] || se("unsupported pseudo: " + s);
      return u[f.expando] ? u(a) : u;
    } }, pseudos: { not: pt(function(s) {
      var a = [], u = [], m = ss(s.replace(B, "$1"));
      return m[f.expando] ? pt(function(T, x, I, M) {
        for (var O, z = m(T, null, M, []), H = T.length; H--; ) (O = z[H]) && (T[H] = !(x[H] = O));
      }) : function(T, x, I) {
        return a[0] = T, m(a, null, I, u), a[0] = null, !u.pop();
      };
    }), has: pt(function(s) {
      return function(a) {
        return ot(s, a).length > 0;
      };
    }), contains: pt(function(s) {
      return s = K(s), function(a) {
        return (a.textContent || f.text(a)).indexOf(s) > -1;
      };
    }), lang: pt(function(s) {
      return Ql.test(s || "") || se("unsupported lang: " + s), s = K(s).toLowerCase(), function(a) {
        var u;
        do
          if (u = we ? a.lang : a.getAttribute("xml:lang") || a.getAttribute("lang")) return u = u.toLowerCase(), u === s || u.indexOf(s + "-") === 0;
        while ((a = a.parentNode) && a.nodeType === 1);
        return false;
      };
    }), target: function(s) {
      var a = e.location && e.location.hash;
      return a && a.slice(1) === s.id;
    }, root: function(s) {
      return s === St;
    }, focus: function(s) {
      return s === Te.activeElement && Te.hasFocus() && !!(s.type || s.href || ~s.tabIndex);
    }, enabled: $r(false), disabled: $r(true), checked: function(s) {
      return P(s, "input") && !!s.checked || P(s, "option") && !!s.selected;
    }, selected: function(s) {
      return N && s.parentNode && s.parentNode.selectedIndex, s.selected === true;
    }, empty: function(s) {
      for (s = s.firstChild; s; s = s.nextSibling) if (s.nodeType < 6) return false;
      return true;
    }, parent: function(s) {
      return !f.expr.pseudos.empty(s);
    }, header: function(s) {
      return ec.test(s.nodeName);
    }, input: function(s) {
      return Jl.test(s.nodeName);
    }, button: function(s) {
      return P(s, "input") && s.type === "button" || P(s, "button");
    }, text: function(s) {
      return P(s, "input") && s.type === "text";
    }, first: jt(function() {
      return [0];
    }), last: jt(function(s, a) {
      return [a - 1];
    }), eq: jt(function(s, a, u) {
      return [u < 0 ? u + a : u];
    }), even: jt(function(s, a) {
      for (var u = 0; u < a; u += 2) s.push(u);
      return s;
    }), odd: jt(function(s, a) {
      for (var u = 1; u < a; u += 2) s.push(u);
      return s;
    }), lt: jt(function(s, a, u) {
      var m;
      for (u < 0 ? m = u + a : u > a ? m = a : m = u; --m >= 0; ) s.push(m);
      return s;
    }), gt: jt(function(s, a, u) {
      for (var m = u < 0 ? u + a : u; ++m < a; ) s.push(m);
      return s;
    }) } }, f.expr.pseudos.nth = f.expr.pseudos.eq;
    for (je in { radio: true, checkbox: true, file: true, password: true, image: true }) f.expr.pseudos[je] = sc(je);
    for (je in { submit: true, reset: true }) f.expr.pseudos[je] = rc(je);
    function Nr() {
    }
    Nr.prototype = f.expr.pseudos, f.expr.setFilters = new Nr();
    function ln(s, a, u) {
      var m = a.dir, T = a.next, x = T || m, I = u && x === "parentNode", M = ht++;
      return a.first ? function(O, z, H) {
        for (; O = O[m]; ) if (O.nodeType === 1 || I) return s(O, z, H);
        return false;
      } : function(O, z, H) {
        var j, k, G = [$e, M];
        if (H) {
          for (; O = O[m]; ) if ((O.nodeType === 1 || I) && s(O, z, H)) return true;
        } else for (; O = O[m]; ) if (O.nodeType === 1 || I) if (k = O[f.expando] || (O[f.expando] = {}), T && P(O, T)) O = O[m] || O;
        else {
          if ((j = k[x]) && j[0] === $e && j[1] === M) return G[2] = j[2];
          if (k[x] = G, G[2] = s(O, z, H)) return true;
        }
        return false;
      };
    }
    function ts(s) {
      return s.length > 1 ? function(a, u, m) {
        for (var T = s.length; T--; ) if (!s[T](a, u, m)) return false;
        return true;
      } : s[0];
    }
    function oc(s, a, u) {
      for (var m = 0, T = a.length; m < T; m++) ot(s, a[m], u);
      return u;
    }
    function cn(s, a, u, m, T) {
      for (var x, I = [], M = 0, O = s.length, z = a != null; M < O; M++) (x = s[M]) && (!u || u(x, m, T)) && (I.push(x), z && a.push(M));
      return I;
    }
    function is(s, a, u, m, T, x) {
      return m && !m[f.expando] && (m = is(m)), T && !T[f.expando] && (T = is(T, x)), pt(function(I, M, O, z) {
        var H, j, k, G, te = [], le = [], ae = M.length, ve = I || oc(a || "*", O.nodeType ? [O] : O, []), pe = s && (I || !a) ? cn(ve, te, s, O, z) : ve;
        if (u ? (G = T || (I ? s : ae || m) ? [] : M, u(pe, G, O, z)) : G = pe, m) for (H = cn(G, le), m(H, [], O, z), j = H.length; j--; ) (k = H[j]) && (G[le[j]] = !(pe[le[j]] = k));
        if (I) {
          if (T || s) {
            if (T) {
              for (H = [], j = G.length; j--; ) (k = G[j]) && H.push(pe[j] = k);
              T(null, G = [], H, z);
            }
            for (j = G.length; j--; ) (k = G[j]) && (H = T ? c.call(I, k) : te[j]) > -1 && (I[H] = !(M[H] = k));
          }
        } else G = cn(G === M ? G.splice(ae, G.length) : G), T ? T(null, M, G, z) : l.apply(M, G);
      });
    }
    function ns(s) {
      for (var a, u, m, T = s.length, x = f.expr.relative[s[0].type], I = x || f.expr.relative[" "], M = x ? 1 : 0, O = ln(function(j) {
        return j === a;
      }, I, true), z = ln(function(j) {
        return c.call(a, j) > -1;
      }, I, true), H = [function(j, k, G) {
        var te = !x && (G || k != rt) || ((a = k).nodeType ? O(j, k, G) : z(j, k, G));
        return a = null, te;
      }]; M < T; M++) if (u = f.expr.relative[s[M].type]) H = [ln(ts(H), u)];
      else {
        if (u = f.expr.filter[s[M].type].apply(null, s[M].matches), u[f.expando]) {
          for (m = ++M; m < T && !f.expr.relative[s[m].type]; m++) ;
          return is(M > 1 && ts(H), M > 1 && ge(s.slice(0, M - 1).concat({ value: s[M - 2].type === " " ? "*" : "" })).replace(B, "$1"), u, M < m && ns(s.slice(M, m)), m < T && ns(s = s.slice(m)), m < T && ge(s));
        }
        H.push(u);
      }
      return ts(H);
    }
    function ac(s, a) {
      var u = a.length > 0, m = s.length > 0, T = function(x, I, M, O, z) {
        var H, j, k, G = 0, te = "0", le = x && [], ae = [], ve = rt, pe = x || m && f.expr.find.TAG("*", z), Be = $e += ve == null ? 1 : Math.random() || 0.1;
        for (z && (rt = I == Te || I || z); (H = pe[te]) != null; te++) {
          if (m && H) {
            for (j = 0, !I && H.ownerDocument != Te && (li(H), M = !we); k = s[j++]; ) if (k(H, I || Te, M)) {
              l.call(O, H);
              break;
            }
            z && ($e = Be);
          }
          u && ((H = !k && H) && G--, x && le.push(H));
        }
        if (G += te, u && te !== G) {
          for (j = 0; k = a[j++]; ) k(le, ae, I, M);
          if (x) {
            if (G > 0) for (; te--; ) le[te] || ae[te] || (ae[te] = D.call(O));
            ae = cn(ae);
          }
          l.apply(O, ae), z && !x && ae.length > 0 && G + a.length > 1 && f.uniqueSort(O);
        }
        return z && ($e = Be, rt = ve), le;
      };
      return u ? pt(T) : T;
    }
    function ss(s, a) {
      var u, m = [], T = [], x = Dr[s + " "];
      if (!x) {
        for (a || (a = Ce(s)), u = a.length; u--; ) x = ns(a[u]), x[f.expando] ? m.push(x) : T.push(x);
        x = Dr(s, ac(T, m)), x.selector = s;
      }
      return x;
    }
    function kr(s, a, u, m) {
      var T, x, I, M, O, z = typeof s == "function" && s, H = !m && Ce(s = z.selector || s);
      if (u = u || [], H.length === 1) {
        if (x = H[0] = H[0].slice(0), x.length > 2 && (I = x[0]).type === "ID" && a.nodeType === 9 && we && f.expr.relative[x[1].type]) {
          if (a = (f.expr.find.ID(K(I.matches[0]), a) || [])[0], a) z && (a = a.parentNode);
          else return u;
          s = s.slice(x.shift().value.length);
        }
        for (T = zr.needsContext.test(s) ? 0 : x.length; T-- && (I = x[T], !f.expr.relative[M = I.type]); ) if ((O = f.expr.find[M]) && (m = O(K(I.matches[0]), F.test(x[0].type) && oe(a.parentNode) || a))) {
          if (x.splice(T, 1), s = m.length && ge(x), !s) return l.apply(u, m), u;
          break;
        }
      }
      return (z || ss(s, H))(m, a, !we, u, !a || F.test(s) && oe(a.parentNode) || a), u;
    }
    li(), f.find = ot, ot.compile = ss, ot.select = kr, ot.setDocument = li, ot.tokenize = Ce;
    function ci(s, a, u) {
      for (var m = [], T = u !== void 0; (s = s[a]) && s.nodeType !== 9; ) if (s.nodeType === 1) {
        if (T && f(s).is(u)) break;
        m.push(s);
      }
      return m;
    }
    function Rr(s, a) {
      for (var u = []; s; s = s.nextSibling) s.nodeType === 1 && s !== a && u.push(s);
      return u;
    }
    var Hr = f.expr.match.needsContext, Br = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function Vr(s) {
      return s[0] === "<" && s[s.length - 1] === ">" && s.length >= 3;
    }
    function rs(s, a, u) {
      return typeof a == "function" ? f.grep(s, function(m, T) {
        return !!a.call(m, T, m) !== u;
      }) : a.nodeType ? f.grep(s, function(m) {
        return m === a !== u;
      }) : typeof a != "string" ? f.grep(s, function(m) {
        return c.call(a, m) > -1 !== u;
      }) : f.filter(a, s, u);
    }
    f.filter = function(s, a, u) {
      var m = a[0];
      return u && (s = ":not(" + s + ")"), a.length === 1 && m.nodeType === 1 ? f.find.matchesSelector(m, s) ? [m] : [] : f.find.matches(s, f.grep(a, function(T) {
        return T.nodeType === 1;
      }));
    }, f.fn.extend({ find: function(s) {
      var a, u, m = this.length, T = this;
      if (typeof s != "string") return this.pushStack(f(s).filter(function() {
        for (a = 0; a < m; a++) if (f.contains(T[a], this)) return true;
      }));
      for (u = this.pushStack([]), a = 0; a < m; a++) f.find(s, T[a], u);
      return m > 1 ? f.uniqueSort(u) : u;
    }, filter: function(s) {
      return this.pushStack(rs(this, s || [], false));
    }, not: function(s) {
      return this.pushStack(rs(this, s || [], true));
    }, is: function(s) {
      return !!rs(this, typeof s == "string" && Hr.test(s) ? f(s) : s || [], false).length;
    } });
    var un, lc = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, cc = f.fn.init = function(s, a) {
      var u, m;
      if (!s) return this;
      if (s.nodeType) return this[0] = s, this.length = 1, this;
      if (typeof s == "function") return un.ready !== void 0 ? un.ready(s) : s(f);
      if (u = s + "", Vr(u)) u = [null, s, null];
      else if (typeof s == "string") u = lc.exec(s);
      else return f.makeArray(s, this);
      if (u && (u[1] || !a)) if (u[1]) {
        if (a = a instanceof f ? a[0] : a, f.merge(this, f.parseHTML(u[1], a && a.nodeType ? a.ownerDocument || a : h, true)), Br.test(u[1]) && f.isPlainObject(a)) for (u in a) typeof this[u] == "function" ? this[u](a[u]) : this.attr(u, a[u]);
        return this;
      } else return m = h.getElementById(u[2]), m && (this[0] = m, this.length = 1), this;
      else return !a || a.jquery ? (a || un).find(s) : this.constructor(a).find(s);
    };
    cc.prototype = f.fn, un = f(h);
    var uc = /^(?:parents|prev(?:Until|All))/, dc = { children: true, contents: true, next: true, prev: true };
    f.fn.extend({ has: function(s) {
      var a = f(s, this), u = a.length;
      return this.filter(function() {
        for (var m = 0; m < u; m++) if (f.contains(this, a[m])) return true;
      });
    }, closest: function(s, a) {
      var u, m = 0, T = this.length, x = [], I = typeof s != "string" && f(s);
      if (!Hr.test(s)) {
        for (; m < T; m++) for (u = this[m]; u && u !== a; u = u.parentNode) if (u.nodeType < 11 && (I ? I.index(u) > -1 : u.nodeType === 1 && f.find.matchesSelector(u, s))) {
          x.push(u);
          break;
        }
      }
      return this.pushStack(x.length > 1 ? f.uniqueSort(x) : x);
    }, index: function(s) {
      return s ? typeof s == "string" ? c.call(f(s), this[0]) : c.call(this, s.jquery ? s[0] : s) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
    }, add: function(s, a) {
      return this.pushStack(f.uniqueSort(f.merge(this.get(), f(s, a))));
    }, addBack: function(s) {
      return this.add(s == null ? this.prevObject : this.prevObject.filter(s));
    } });
    function Wr(s, a) {
      for (; (s = s[a]) && s.nodeType !== 1; ) ;
      return s;
    }
    f.each({ parent: function(s) {
      var a = s.parentNode;
      return a && a.nodeType !== 11 ? a : null;
    }, parents: function(s) {
      return ci(s, "parentNode");
    }, parentsUntil: function(s, a, u) {
      return ci(s, "parentNode", u);
    }, next: function(s) {
      return Wr(s, "nextSibling");
    }, prev: function(s) {
      return Wr(s, "previousSibling");
    }, nextAll: function(s) {
      return ci(s, "nextSibling");
    }, prevAll: function(s) {
      return ci(s, "previousSibling");
    }, nextUntil: function(s, a, u) {
      return ci(s, "nextSibling", u);
    }, prevUntil: function(s, a, u) {
      return ci(s, "previousSibling", u);
    }, siblings: function(s) {
      return Rr((s.parentNode || {}).firstChild, s);
    }, children: function(s) {
      return Rr(s.firstChild);
    }, contents: function(s) {
      return s.contentDocument != null && n(s.contentDocument) ? s.contentDocument : (P(s, "template") && (s = s.content || s), f.merge([], s.childNodes));
    } }, function(s, a) {
      f.fn[s] = function(u, m) {
        var T = f.map(this, a, u);
        return s.slice(-5) !== "Until" && (m = u), m && typeof m == "string" && (T = f.filter(m, T)), this.length > 1 && (dc[s] || f.uniqueSort(T), uc.test(s) && T.reverse()), this.pushStack(T);
      };
    });
    function fc(s) {
      var a = {};
      return f.each(s.match(Oe) || [], function(u, m) {
        a[m] = true;
      }), a;
    }
    f.Callbacks = function(s) {
      s = typeof s == "string" ? fc(s) : f.extend({}, s);
      var a, u, m, T, x = [], I = [], M = -1, O = function() {
        for (T = T || s.once, m = a = true; I.length; M = -1) for (u = I.shift(); ++M < x.length; ) x[M].apply(u[0], u[1]) === false && s.stopOnFalse && (M = x.length, u = false);
        s.memory || (u = false), a = false, T && (u ? x = [] : x = "");
      }, z = { add: function() {
        return x && (u && !a && (M = x.length - 1, I.push(u)), (function H(j) {
          f.each(j, function(k, G) {
            typeof G == "function" ? (!s.unique || !z.has(G)) && x.push(G) : G && G.length && g(G) !== "string" && H(G);
          });
        })(arguments), u && !a && O()), this;
      }, remove: function() {
        return f.each(arguments, function(H, j) {
          for (var k; (k = f.inArray(j, x, k)) > -1; ) x.splice(k, 1), k <= M && M--;
        }), this;
      }, has: function(H) {
        return H ? f.inArray(H, x) > -1 : x.length > 0;
      }, empty: function() {
        return x && (x = []), this;
      }, disable: function() {
        return T = I = [], x = u = "", this;
      }, disabled: function() {
        return !x;
      }, lock: function() {
        return T = I = [], !u && !a && (x = u = ""), this;
      }, locked: function() {
        return !!T;
      }, fireWith: function(H, j) {
        return T || (j = j || [], j = [H, j.slice ? j.slice() : j], I.push(j), a || O()), this;
      }, fire: function() {
        return z.fireWith(this, arguments), this;
      }, fired: function() {
        return !!m;
      } };
      return z;
    };
    function ui(s) {
      return s;
    }
    function dn(s) {
      throw s;
    }
    function Fr(s, a, u, m) {
      var T;
      try {
        s && typeof (T = s.promise) == "function" ? T.call(s).done(a).fail(u) : s && typeof (T = s.then) == "function" ? T.call(s, a, u) : a.apply(void 0, [s].slice(m));
      } catch (x) {
        u(x);
      }
    }
    f.extend({ Deferred: function(s) {
      var a = [["notify", "progress", f.Callbacks("memory"), f.Callbacks("memory"), 2], ["resolve", "done", f.Callbacks("once memory"), f.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", f.Callbacks("once memory"), f.Callbacks("once memory"), 1, "rejected"]], u = "pending", m = { state: function() {
        return u;
      }, always: function() {
        return T.done(arguments).fail(arguments), this;
      }, catch: function(x) {
        return m.then(null, x);
      }, pipe: function() {
        var x = arguments;
        return f.Deferred(function(I) {
          f.each(a, function(M, O) {
            var z = typeof x[O[4]] == "function" && x[O[4]];
            T[O[1]](function() {
              var H = z && z.apply(this, arguments);
              H && typeof H.promise == "function" ? H.promise().progress(I.notify).done(I.resolve).fail(I.reject) : I[O[0] + "With"](this, z ? [H] : arguments);
            });
          }), x = null;
        }).promise();
      }, then: function(x, I, M) {
        var O = 0;
        function z(H, j, k, G) {
          return function() {
            var te = this, le = arguments, ae = function() {
              var pe, Be;
              if (!(H < O)) {
                if (pe = k.apply(te, le), pe === j.promise()) throw new TypeError("Thenable self-resolution");
                Be = pe && (typeof pe == "object" || typeof pe == "function") && pe.then, typeof Be == "function" ? G ? Be.call(pe, z(O, j, ui, G), z(O, j, dn, G)) : (O++, Be.call(pe, z(O, j, ui, G), z(O, j, dn, G), z(O, j, ui, j.notifyWith))) : (k !== ui && (te = void 0, le = [pe]), (G || j.resolveWith)(te, le));
              }
            }, ve = G ? ae : function() {
              try {
                ae();
              } catch (pe) {
                f.Deferred.exceptionHook && f.Deferred.exceptionHook(pe, ve.error), H + 1 >= O && (k !== dn && (te = void 0, le = [pe]), j.rejectWith(te, le));
              }
            };
            H ? ve() : (f.Deferred.getErrorHook && (ve.error = f.Deferred.getErrorHook()), e.setTimeout(ve));
          };
        }
        return f.Deferred(function(H) {
          a[0][3].add(z(0, H, typeof M == "function" ? M : ui, H.notifyWith)), a[1][3].add(z(0, H, typeof x == "function" ? x : ui)), a[2][3].add(z(0, H, typeof I == "function" ? I : dn));
        }).promise();
      }, promise: function(x) {
        return x != null ? f.extend(x, m) : m;
      } }, T = {};
      return f.each(a, function(x, I) {
        var M = I[2], O = I[5];
        m[I[1]] = M.add, O && M.add(function() {
          u = O;
        }, a[3 - x][2].disable, a[3 - x][3].disable, a[0][2].lock, a[0][3].lock), M.add(I[3].fire), T[I[0]] = function() {
          return T[I[0] + "With"](this === T ? void 0 : this, arguments), this;
        }, T[I[0] + "With"] = M.fireWith;
      }), m.promise(T), s && s.call(T, T), T;
    }, when: function(s) {
      var a = arguments.length, u = a, m = Array(u), T = r.call(arguments), x = f.Deferred(), I = function(M) {
        return function(O) {
          m[M] = this, T[M] = arguments.length > 1 ? r.call(arguments) : O, --a || x.resolveWith(m, T);
        };
      };
      if (a <= 1 && (Fr(s, x.done(I(u)).resolve, x.reject, !a), x.state() === "pending" || typeof (T[u] && T[u].then) == "function")) return x.then();
      for (; u--; ) Fr(T[u], I(u), x.reject);
      return x.promise();
    } });
    var hc = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    f.Deferred.exceptionHook = function(s, a) {
      s && hc.test(s.name) && e.console.warn("jQuery.Deferred exception", s, a);
    }, f.readyException = function(s) {
      e.setTimeout(function() {
        throw s;
      });
    };
    var os = f.Deferred();
    f.fn.ready = function(s) {
      return os.then(s).catch(function(a) {
        f.readyException(a);
      }), this;
    }, f.extend({ isReady: false, readyWait: 1, ready: function(s) {
      (s === true ? --f.readyWait : f.isReady) || (f.isReady = true, !(s !== true && --f.readyWait > 0) && os.resolveWith(h, [f]));
    } }), f.ready.then = os.then;
    function fn() {
      h.removeEventListener("DOMContentLoaded", fn), e.removeEventListener("load", fn), f.ready();
    }
    h.readyState !== "loading" ? e.setTimeout(f.ready) : (h.addEventListener("DOMContentLoaded", fn), e.addEventListener("load", fn));
    var pc = /-([a-z])/g;
    function mc(s, a) {
      return a.toUpperCase();
    }
    function Yt(s) {
      return s.replace(pc, mc);
    }
    function Ri(s) {
      return s.nodeType === 1 || s.nodeType === 9 || !+s.nodeType;
    }
    function Hi() {
      this.expando = f.expando + Hi.uid++;
    }
    Hi.uid = 1, Hi.prototype = { cache: function(s) {
      var a = s[this.expando];
      return a || (a = /* @__PURE__ */ Object.create(null), Ri(s) && (s.nodeType ? s[this.expando] = a : Object.defineProperty(s, this.expando, { value: a, configurable: true }))), a;
    }, set: function(s, a, u) {
      var m, T = this.cache(s);
      if (typeof a == "string") T[Yt(a)] = u;
      else for (m in a) T[Yt(m)] = a[m];
      return u;
    }, get: function(s, a) {
      return a === void 0 ? this.cache(s) : s[this.expando] && s[this.expando][Yt(a)];
    }, access: function(s, a, u) {
      return a === void 0 || a && typeof a == "string" && u === void 0 ? this.get(s, a) : (this.set(s, a, u), u !== void 0 ? u : a);
    }, remove: function(s, a) {
      var u, m = s[this.expando];
      if (m !== void 0) {
        if (a !== void 0) for (Array.isArray(a) ? a = a.map(Yt) : (a = Yt(a), a = a in m ? [a] : a.match(Oe) || []), u = a.length; u--; ) delete m[a[u]];
        (a === void 0 || f.isEmptyObject(m)) && (s.nodeType ? s[this.expando] = void 0 : delete s[this.expando]);
      }
    }, hasData: function(s) {
      var a = s[this.expando];
      return a !== void 0 && !f.isEmptyObject(a);
    } };
    var ce = new Hi(), Re = new Hi(), gc = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, vc = /[A-Z]/g;
    function yc(s) {
      return s === "true" ? true : s === "false" ? false : s === "null" ? null : s === +s + "" ? +s : gc.test(s) ? JSON.parse(s) : s;
    }
    function Gr(s, a, u) {
      var m;
      if (u === void 0 && s.nodeType === 1) if (m = "data-" + a.replace(vc, "-$&").toLowerCase(), u = s.getAttribute(m), typeof u == "string") {
        try {
          u = yc(u);
        } catch (T) {
        }
        Re.set(s, a, u);
      } else u = void 0;
      return u;
    }
    f.extend({ hasData: function(s) {
      return Re.hasData(s) || ce.hasData(s);
    }, data: function(s, a, u) {
      return Re.access(s, a, u);
    }, removeData: function(s, a) {
      Re.remove(s, a);
    }, _data: function(s, a, u) {
      return ce.access(s, a, u);
    }, _removeData: function(s, a) {
      ce.remove(s, a);
    } }), f.fn.extend({ data: function(s, a) {
      var u, m, T, x = this[0], I = x && x.attributes;
      if (s === void 0) {
        if (this.length && (T = Re.get(x), x.nodeType === 1 && !ce.get(x, "hasDataAttrs"))) {
          for (u = I.length; u--; ) I[u] && (m = I[u].name, m.indexOf("data-") === 0 && (m = Yt(m.slice(5)), Gr(x, m, T[m])));
          ce.set(x, "hasDataAttrs", true);
        }
        return T;
      }
      return typeof s == "object" ? this.each(function() {
        Re.set(this, s);
      }) : be(this, function(M) {
        var O;
        if (x && M === void 0) return O = Re.get(x, s), O !== void 0 || (O = Gr(x, s), O !== void 0) ? O : void 0;
        this.each(function() {
          Re.set(this, s, M);
        });
      }, null, a, arguments.length > 1, null, true);
    }, removeData: function(s) {
      return this.each(function() {
        Re.remove(this, s);
      });
    } }), f.extend({ queue: function(s, a, u) {
      var m;
      if (s) return a = (a || "fx") + "queue", m = ce.get(s, a), u && (!m || Array.isArray(u) ? m = ce.set(s, a, f.makeArray(u)) : m.push(u)), m || [];
    }, dequeue: function(s, a) {
      a = a || "fx";
      var u = f.queue(s, a), m = u.length, T = u.shift(), x = f._queueHooks(s, a), I = function() {
        f.dequeue(s, a);
      };
      T === "inprogress" && (T = u.shift(), m--), T && (a === "fx" && u.unshift("inprogress"), delete x.stop, T.call(s, I, x)), !m && x && x.empty.fire();
    }, _queueHooks: function(s, a) {
      var u = a + "queueHooks";
      return ce.get(s, u) || ce.set(s, u, { empty: f.Callbacks("once memory").add(function() {
        ce.remove(s, [a + "queue", u]);
      }) });
    } }), f.fn.extend({ queue: function(s, a) {
      var u = 2;
      return typeof s != "string" && (a = s, s = "fx", u--), arguments.length < u ? f.queue(this[0], s) : a === void 0 ? this : this.each(function() {
        var m = f.queue(this, s, a);
        f._queueHooks(this, s), s === "fx" && m[0] !== "inprogress" && f.dequeue(this, s);
      });
    }, dequeue: function(s) {
      return this.each(function() {
        f.dequeue(this, s);
      });
    }, clearQueue: function(s) {
      return this.queue(s || "fx", []);
    }, promise: function(s, a) {
      var u, m = 1, T = f.Deferred(), x = this, I = this.length, M = function() {
        --m || T.resolveWith(x, [x]);
      };
      for (typeof s != "string" && (a = s, s = void 0), s = s || "fx"; I--; ) u = ce.get(x[I], s + "queueHooks"), u && u.empty && (m++, u.empty.add(M));
      return M(), T.promise(a);
    } });
    var jr = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, Bi = new RegExp("^(?:([+-])=|)(" + jr + ")([a-z%]*)$", "i"), Pt = ["Top", "Right", "Bottom", "Left"];
    function hn(s, a) {
      return s = a || s, s.style.display === "none" || s.style.display === "" && f.css(s, "display") === "none";
    }
    var bc = /^[a-z]/, Ec = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
    function pn(s) {
      return bc.test(s) && Ec.test(s[0].toUpperCase() + s.slice(1));
    }
    function Yr(s, a, u, m) {
      var T, x, I = 20, M = m ? function() {
        return m.cur();
      } : function() {
        return f.css(s, a, "");
      }, O = M(), z = u && u[3] || (pn(a) ? "px" : ""), H = s.nodeType && (!pn(a) || z !== "px" && +O) && Bi.exec(f.css(s, a));
      if (H && H[3] !== z) {
        for (O = O / 2, z = z || H[3], H = +O || 1; I--; ) f.style(s, a, H + z), (1 - x) * (1 - (x = M() / O || 0.5)) <= 0 && (I = 0), H = H / x;
        H = H * 2, f.style(s, a, H + z), u = u || [];
      }
      return u && (H = +H || +O || 0, T = u[1] ? H + (u[1] + 1) * u[2] : +u[2], m && (m.unit = z, m.start = H, m.end = T)), T;
    }
    var Sc = /^-ms-/;
    function as(s) {
      return Yt(s.replace(Sc, "ms-"));
    }
    var Xr = {};
    function Tc(s) {
      var a, u = s.ownerDocument, m = s.nodeName, T = Xr[m];
      return T || (a = u.body.appendChild(u.createElement(m)), T = f.css(a, "display"), a.parentNode.removeChild(a), T === "none" && (T = "block"), Xr[m] = T, T);
    }
    function di(s, a) {
      for (var u, m, T = [], x = 0, I = s.length; x < I; x++) m = s[x], m.style && (u = m.style.display, a ? (u === "none" && (T[x] = ce.get(m, "display") || null, T[x] || (m.style.display = "")), m.style.display === "" && hn(m) && (T[x] = Tc(m))) : u !== "none" && (T[x] = "none", ce.set(m, "display", u)));
      for (x = 0; x < I; x++) T[x] != null && (s[x].style.display = T[x]);
      return s;
    }
    f.fn.extend({ show: function() {
      return di(this, true);
    }, hide: function() {
      return di(this);
    }, toggle: function(s) {
      return typeof s == "boolean" ? s ? this.show() : this.hide() : this.each(function() {
        hn(this) ? f(this).show() : f(this).hide();
      });
    } });
    var Vi = function(s) {
      return f.contains(s.ownerDocument, s) || s.getRootNode(_c) === s.ownerDocument;
    }, _c = { composed: true };
    W.getRootNode || (Vi = function(s) {
      return f.contains(s.ownerDocument, s);
    });
    var qr = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, Tt = { thead: ["table"], col: ["colgroup", "table"], tr: ["tbody", "table"], td: ["tr", "tbody", "table"] };
    Tt.tbody = Tt.tfoot = Tt.colgroup = Tt.caption = Tt.thead, Tt.th = Tt.td;
    function He(s, a) {
      var u;
      return typeof s.getElementsByTagName != "undefined" ? u = i.slice.call(s.getElementsByTagName(a || "*")) : typeof s.querySelectorAll != "undefined" ? u = s.querySelectorAll(a || "*") : u = [], a === void 0 || a && P(s, a) ? f.merge([s], u) : u;
    }
    var Ur = /^$|^module$|\/(?:java|ecma)script/i;
    function ls(s, a) {
      for (var u = 0, m = s.length; u < m; u++) ce.set(s[u], "globalEval", !a || ce.get(a[u], "globalEval"));
    }
    var xc = /<|&#?\w+;/;
    function Kr(s, a, u, m, T) {
      for (var x, I, M, O, z, H, j = a.createDocumentFragment(), k = [], G = 0, te = s.length; G < te; G++) if (x = s[G], x || x === 0) if (g(x) === "object" && (x.nodeType || _(x))) f.merge(k, x.nodeType ? [x] : x);
      else if (!xc.test(x)) k.push(a.createTextNode(x));
      else {
        for (I = I || j.appendChild(a.createElement("div")), M = (qr.exec(x) || ["", ""])[1].toLowerCase(), O = Tt[M] || i, H = O.length; --H > -1; ) I = I.appendChild(a.createElement(O[H]));
        I.innerHTML = f.htmlPrefilter(x), f.merge(k, I.childNodes), I = j.firstChild, I.textContent = "";
      }
      for (j.textContent = "", G = 0; x = k[G++]; ) {
        if (m && f.inArray(x, m) > -1) {
          T && T.push(x);
          continue;
        }
        if (z = Vi(x), I = He(j.appendChild(x), "script"), z && ls(I), u) for (H = 0; x = I[H++]; ) Ur.test(x.type || "") && u.push(x);
      }
      return j;
    }
    function Cc(s) {
      return s.type = (s.getAttribute("type") !== null) + "/" + s.type, s;
    }
    function wc(s) {
      return (s.type || "").slice(0, 5) === "true/" ? s.type = s.type.slice(5) : s.removeAttribute("type"), s;
    }
    function fi(s, a, u, m) {
      a = o(a);
      var T, x, I, M, O, z, H = 0, j = s.length, k = j - 1, G = a[0], te = typeof G == "function";
      if (te) return s.each(function(le) {
        var ae = s.eq(le);
        a[0] = G.call(this, le, ae.html()), fi(ae, a, u, m);
      });
      if (j && (T = Kr(a, s[0].ownerDocument, false, s, m), x = T.firstChild, T.childNodes.length === 1 && (T = x), x || m)) {
        for (I = f.map(He(T, "script"), Cc), M = I.length; H < j; H++) O = T, H !== k && (O = f.clone(O, true, true), M && f.merge(I, He(O, "script"))), u.call(s[H], O, H);
        if (M) for (z = I[I.length - 1].ownerDocument, f.map(I, wc), H = 0; H < M; H++) O = I[H], Ur.test(O.type || "") && !ce.get(O, "globalEval") && f.contains(z, O) && (O.src && (O.type || "").toLowerCase() !== "module" ? f._evalUrl && !O.noModule && f._evalUrl(O.src, { nonce: O.nonce, crossOrigin: O.crossOrigin }, z) : w(O.textContent, O, z));
      }
      return s;
    }
    var mn = /^(?:checkbox|radio)$/i, Zr = /^([^.]*)(?:\.(.+)|)/;
    function hi() {
      return true;
    }
    function pi() {
      return false;
    }
    function cs(s, a, u, m, T, x) {
      var I, M;
      if (typeof a == "object") {
        typeof u != "string" && (m = m || u, u = void 0);
        for (M in a) cs(s, M, u, m, a[M], x);
        return s;
      }
      if (m == null && T == null ? (T = u, m = u = void 0) : T == null && (typeof u == "string" ? (T = m, m = void 0) : (T = m, m = u, u = void 0)), T === false) T = pi;
      else if (!T) return s;
      return x === 1 && (I = T, T = function(O) {
        return f().off(O), I.apply(this, arguments);
      }, T.guid = I.guid || (I.guid = f.guid++)), s.each(function() {
        f.event.add(this, a, T, m, u);
      });
    }
    f.event = { add: function(s, a, u, m, T) {
      var x, I, M, O, z, H, j, k, G, te, le, ae = ce.get(s);
      if (Ri(s)) for (u.handler && (x = u, u = x.handler, T = x.selector), T && f.find.matchesSelector(W, T), u.guid || (u.guid = f.guid++), (O = ae.events) || (O = ae.events = /* @__PURE__ */ Object.create(null)), (I = ae.handle) || (I = ae.handle = function(ve) {
        return typeof f != "undefined" && f.event.triggered !== ve.type ? f.event.dispatch.apply(s, arguments) : void 0;
      }), a = (a || "").match(Oe) || [""], z = a.length; z--; ) M = Zr.exec(a[z]) || [], G = le = M[1], te = (M[2] || "").split(".").sort(), G && (j = f.event.special[G] || {}, G = (T ? j.delegateType : j.bindType) || G, j = f.event.special[G] || {}, H = f.extend({ type: G, origType: le, data: m, handler: u, guid: u.guid, selector: T, needsContext: T && f.expr.match.needsContext.test(T), namespace: te.join(".") }, x), (k = O[G]) || (k = O[G] = [], k.delegateCount = 0, (!j.setup || j.setup.call(s, m, te, I) === false) && s.addEventListener && s.addEventListener(G, I)), j.add && (j.add.call(s, H), H.handler.guid || (H.handler.guid = u.guid)), T ? k.splice(k.delegateCount++, 0, H) : k.push(H));
    }, remove: function(s, a, u, m, T) {
      var x, I, M, O, z, H, j, k, G, te, le, ae = ce.hasData(s) && ce.get(s);
      if (!(!ae || !(O = ae.events))) {
        for (a = (a || "").match(Oe) || [""], z = a.length; z--; ) {
          if (M = Zr.exec(a[z]) || [], G = le = M[1], te = (M[2] || "").split(".").sort(), !G) {
            for (G in O) f.event.remove(s, G + a[z], u, m, true);
            continue;
          }
          for (j = f.event.special[G] || {}, G = (m ? j.delegateType : j.bindType) || G, k = O[G] || [], M = M[2] && new RegExp("(^|\\.)" + te.join("\\.(?:.*\\.|)") + "(\\.|$)"), I = x = k.length; x--; ) H = k[x], (T || le === H.origType) && (!u || u.guid === H.guid) && (!M || M.test(H.namespace)) && (!m || m === H.selector || m === "**" && H.selector) && (k.splice(x, 1), H.selector && k.delegateCount--, j.remove && j.remove.call(s, H));
          I && !k.length && ((!j.teardown || j.teardown.call(s, te, ae.handle) === false) && f.removeEvent(s, G, ae.handle), delete O[G]);
        }
        f.isEmptyObject(O) && ce.remove(s, "handle events");
      }
    }, dispatch: function(s) {
      var a, u, m, T, x, I, M = new Array(arguments.length), O = f.event.fix(s), z = (ce.get(this, "events") || /* @__PURE__ */ Object.create(null))[O.type] || [], H = f.event.special[O.type] || {};
      for (M[0] = O, a = 1; a < arguments.length; a++) M[a] = arguments[a];
      if (O.delegateTarget = this, !(H.preDispatch && H.preDispatch.call(this, O) === false)) {
        for (I = f.event.handlers.call(this, O, z), a = 0; (T = I[a++]) && !O.isPropagationStopped(); ) for (O.currentTarget = T.elem, u = 0; (x = T.handlers[u++]) && !O.isImmediatePropagationStopped(); ) (!O.rnamespace || x.namespace === false || O.rnamespace.test(x.namespace)) && (O.handleObj = x, O.data = x.data, m = ((f.event.special[x.origType] || {}).handle || x.handler).apply(T.elem, M), m !== void 0 && (O.result = m) === false && (O.preventDefault(), O.stopPropagation()));
        return H.postDispatch && H.postDispatch.call(this, O), O.result;
      }
    }, handlers: function(s, a) {
      var u, m, T, x, I, M = [], O = a.delegateCount, z = s.target;
      if (O && !(s.type === "click" && s.button >= 1)) {
        for (; z !== this; z = z.parentNode || this) if (z.nodeType === 1 && !(s.type === "click" && z.disabled === true)) {
          for (x = [], I = {}, u = 0; u < O; u++) m = a[u], T = m.selector + " ", I[T] === void 0 && (I[T] = m.needsContext ? f(T, this).index(z) > -1 : f.find(T, this, null, [z]).length), I[T] && x.push(m);
          x.length && M.push({ elem: z, handlers: x });
        }
      }
      return z = this, O < a.length && M.push({ elem: z, handlers: a.slice(O) }), M;
    }, addProp: function(s, a) {
      Object.defineProperty(f.Event.prototype, s, { enumerable: true, configurable: true, get: typeof a == "function" ? function() {
        if (this.originalEvent) return a(this.originalEvent);
      } : function() {
        if (this.originalEvent) return this.originalEvent[s];
      }, set: function(u) {
        Object.defineProperty(this, s, { enumerable: true, configurable: true, writable: true, value: u });
      } });
    }, fix: function(s) {
      return s[f.expando] ? s : new f.Event(s);
    }, special: f.extend(/* @__PURE__ */ Object.create(null), { load: { noBubble: true }, click: { setup: function(s) {
      var a = this || s;
      return mn.test(a.type) && a.click && P(a, "input") && gn(a, "click", true), false;
    }, trigger: function(s) {
      var a = this || s;
      return mn.test(a.type) && a.click && P(a, "input") && gn(a, "click"), true;
    }, _default: function(s) {
      var a = s.target;
      return mn.test(a.type) && a.click && P(a, "input") && ce.get(a, "click") || P(a, "a");
    } }, beforeunload: { postDispatch: function(s) {
      s.result !== void 0 && s.preventDefault();
    } } }) };
    function gn(s, a, u) {
      if (!u) {
        ce.get(s, a) === void 0 && f.event.add(s, a, hi);
        return;
      }
      ce.set(s, a, false), f.event.add(s, a, { namespace: false, handler: function(m) {
        var T, x = ce.get(this, a);
        if (m.isTrigger & 1 && this[a]) {
          if (x.length) (f.event.special[a] || {}).delegateType && m.stopPropagation();
          else if (x = r.call(arguments), ce.set(this, a, x), this[a](), T = ce.get(this, a), ce.set(this, a, false), x !== T) return m.stopImmediatePropagation(), m.preventDefault(), T && T.value;
        } else x.length && (ce.set(this, a, { value: f.event.trigger(x[0], x.slice(1), this) }), m.stopPropagation(), m.isImmediatePropagationStopped = hi);
      } });
    }
    f.removeEvent = function(s, a, u) {
      s.removeEventListener && s.removeEventListener(a, u);
    }, f.Event = function(s, a) {
      if (!(this instanceof f.Event)) return new f.Event(s, a);
      s && s.type ? (this.originalEvent = s, this.type = s.type, this.isDefaultPrevented = s.defaultPrevented ? hi : pi, this.target = s.target, this.currentTarget = s.currentTarget, this.relatedTarget = s.relatedTarget) : this.type = s, a && f.extend(this, a), this.timeStamp = s && s.timeStamp || Date.now(), this[f.expando] = true;
    }, f.Event.prototype = { constructor: f.Event, isDefaultPrevented: pi, isPropagationStopped: pi, isImmediatePropagationStopped: pi, isSimulated: false, preventDefault: function() {
      var s = this.originalEvent;
      this.isDefaultPrevented = hi, s && !this.isSimulated && s.preventDefault();
    }, stopPropagation: function() {
      var s = this.originalEvent;
      this.isPropagationStopped = hi, s && !this.isSimulated && s.stopPropagation();
    }, stopImmediatePropagation: function() {
      var s = this.originalEvent;
      this.isImmediatePropagationStopped = hi, s && !this.isSimulated && s.stopImmediatePropagation(), this.stopPropagation();
    } }, f.each({ altKey: true, bubbles: true, cancelable: true, changedTouches: true, ctrlKey: true, detail: true, eventPhase: true, metaKey: true, pageX: true, pageY: true, shiftKey: true, view: true, char: true, code: true, charCode: true, key: true, keyCode: true, button: true, buttons: true, clientX: true, clientY: true, offsetX: true, offsetY: true, pointerId: true, pointerType: true, screenX: true, screenY: true, targetTouches: true, toElement: true, touches: true, which: true }, f.event.addProp), f.each({ focus: "focusin", blur: "focusout" }, function(s, a) {
      function u(m) {
        var T = f.event.fix(m);
        T.type = m.type === "focusin" ? "focus" : "blur", T.isSimulated = true, T.target === T.currentTarget && ce.get(this, "handle")(T);
      }
      f.event.special[s] = { setup: function() {
        if (gn(this, s, true), N) this.addEventListener(a, u);
        else return false;
      }, trigger: function() {
        return gn(this, s), true;
      }, teardown: function() {
        if (N) this.removeEventListener(a, u);
        else return false;
      }, _default: function(m) {
        return ce.get(m.target, s);
      }, delegateType: a };
    }), f.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function(s, a) {
      f.event.special[s] = { delegateType: a, bindType: a, handle: function(u) {
        var m, T = this, x = u.relatedTarget, I = u.handleObj;
        return (!x || x !== T && !f.contains(T, x)) && (u.type = I.origType, m = I.handler.apply(this, arguments), u.type = a), m;
      } };
    }), f.fn.extend({ on: function(s, a, u, m) {
      return cs(this, s, a, u, m);
    }, one: function(s, a, u, m) {
      return cs(this, s, a, u, m, 1);
    }, off: function(s, a, u) {
      var m, T;
      if (s && s.preventDefault && s.handleObj) return m = s.handleObj, f(s.delegateTarget).off(m.namespace ? m.origType + "." + m.namespace : m.origType, m.selector, m.handler), this;
      if (typeof s == "object") {
        for (T in s) this.off(T, a, s[T]);
        return this;
      }
      return (a === false || typeof a == "function") && (u = a, a = void 0), u === false && (u = pi), this.each(function() {
        f.event.remove(this, s, u, a);
      });
    } });
    var Ic = /<script|<style|<link/i;
    function Qr(s, a) {
      return P(s, "table") && P(a.nodeType !== 11 ? a : a.firstChild, "tr") && f(s).children("tbody")[0] || s;
    }
    function Jr(s, a) {
      var u, m, T, x = ce.get(s, "events");
      if (a.nodeType === 1) {
        if (x) {
          ce.remove(a, "handle events");
          for (u in x) for (m = 0, T = x[u].length; m < T; m++) f.event.add(a, u, x[u][m]);
        }
        Re.hasData(s) && Re.set(a, f.extend({}, Re.get(s)));
      }
    }
    function eo(s, a, u) {
      for (var m, T = a ? f.filter(a, s) : s, x = 0; (m = T[x]) != null; x++) !u && m.nodeType === 1 && f.cleanData(He(m)), m.parentNode && (u && Vi(m) && ls(He(m, "script")), m.parentNode.removeChild(m));
      return s;
    }
    f.extend({ htmlPrefilter: function(s) {
      return s;
    }, clone: function(s, a, u) {
      var m, T, x, I, M = s.cloneNode(true), O = Vi(s);
      if (N && (s.nodeType === 1 || s.nodeType === 11) && !f.isXMLDoc(s)) for (I = He(M), x = He(s), m = 0, T = x.length; m < T; m++) P(I[m], "textarea") && (I[m].defaultValue = x[m].defaultValue);
      if (a) if (u) for (x = x || He(s), I = I || He(M), m = 0, T = x.length; m < T; m++) Jr(x[m], I[m]);
      else Jr(s, M);
      return I = He(M, "script"), I.length > 0 && ls(I, !O && He(s, "script")), M;
    }, cleanData: function(s) {
      for (var a, u, m, T = f.event.special, x = 0; (u = s[x]) !== void 0; x++) if (Ri(u)) {
        if (a = u[ce.expando]) {
          if (a.events) for (m in a.events) T[m] ? f.event.remove(u, m) : f.removeEvent(u, m, a.handle);
          u[ce.expando] = void 0;
        }
        u[Re.expando] && (u[Re.expando] = void 0);
      }
    } }), f.fn.extend({ detach: function(s) {
      return eo(this, s, true);
    }, remove: function(s) {
      return eo(this, s);
    }, text: function(s) {
      return be(this, function(a) {
        return a === void 0 ? f.text(this) : this.empty().each(function() {
          (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) && (this.textContent = a);
        });
      }, null, s, arguments.length);
    }, append: function() {
      return fi(this, arguments, function(s) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var a = Qr(this, s);
          a.appendChild(s);
        }
      });
    }, prepend: function() {
      return fi(this, arguments, function(s) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var a = Qr(this, s);
          a.insertBefore(s, a.firstChild);
        }
      });
    }, before: function() {
      return fi(this, arguments, function(s) {
        this.parentNode && this.parentNode.insertBefore(s, this);
      });
    }, after: function() {
      return fi(this, arguments, function(s) {
        this.parentNode && this.parentNode.insertBefore(s, this.nextSibling);
      });
    }, empty: function() {
      for (var s, a = 0; (s = this[a]) != null; a++) s.nodeType === 1 && (f.cleanData(He(s, false)), s.textContent = "");
      return this;
    }, clone: function(s, a) {
      return s = s == null ? false : s, a = a == null ? s : a, this.map(function() {
        return f.clone(this, s, a);
      });
    }, html: function(s) {
      return be(this, function(a) {
        var u = this[0] || {}, m = 0, T = this.length;
        if (a === void 0 && u.nodeType === 1) return u.innerHTML;
        if (typeof a == "string" && !Ic.test(a) && !Tt[(qr.exec(a) || ["", ""])[1].toLowerCase()]) {
          a = f.htmlPrefilter(a);
          try {
            for (; m < T; m++) u = this[m] || {}, u.nodeType === 1 && (f.cleanData(He(u, false)), u.innerHTML = a);
            u = 0;
          } catch (x) {
          }
        }
        u && this.empty().append(a);
      }, null, s, arguments.length);
    }, replaceWith: function() {
      var s = [];
      return fi(this, arguments, function(a) {
        var u = this.parentNode;
        f.inArray(this, s) < 0 && (f.cleanData(He(this)), u && u.replaceChild(a, this));
      }, s);
    } }), f.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function(s, a) {
      f.fn[s] = function(u) {
        for (var m, T = [], x = f(u), I = x.length - 1, M = 0; M <= I; M++) m = M === I ? this : this.clone(true), f(x[M])[a](m), l.apply(T, m);
        return this.pushStack(T);
      };
    });
    var Ac = new RegExp("^(" + jr + ")(?!px)[a-z%]+$", "i"), us = /^--/;
    function vn(s) {
      var a = s.ownerDocument.defaultView;
      return a || (a = e), a.getComputedStyle(s);
    }
    function Oc(s, a, u) {
      var m, T, x = {};
      for (T in a) x[T] = s.style[T], s.style[T] = a[T];
      m = u.call(s);
      for (T in a) s.style[T] = x[T];
      return m;
    }
    function to(s, a, u) {
      var m, T = us.test(a);
      return u = u || vn(s), u && (m = u.getPropertyValue(a) || u[a], T && m && (m = m.replace(B, "$1") || void 0), m === "" && !Vi(s) && (m = f.style(s, a))), m !== void 0 ? m + "" : m;
    }
    var io = ["Webkit", "Moz", "ms"], no = h.createElement("div").style;
    function Mc(s) {
      for (var a = s[0].toUpperCase() + s.slice(1), u = io.length; u--; ) if (s = io[u] + a, s in no) return s;
    }
    function ds(s) {
      return s in no ? s : Mc(s) || s;
    }
    var so, ro, Dt = h.createElement("table");
    function oo() {
      if (!(!Dt || !Dt.style)) {
        var s, a = h.createElement("col"), u = h.createElement("tr"), m = h.createElement("td");
        if (Dt.style.cssText = "position:absolute;left:-11111px;border-collapse:separate;border-spacing:0", u.style.cssText = "box-sizing:content-box;border:1px solid;height:1px", m.style.cssText = "height:9px;width:9px;padding:0", a.span = 2, W.appendChild(Dt).appendChild(a).parentNode.appendChild(u).appendChild(m).parentNode.appendChild(m.cloneNode(true)), Dt.offsetWidth === 0) {
          W.removeChild(Dt);
          return;
        }
        s = e.getComputedStyle(u), ro = N || Math.round(parseFloat(e.getComputedStyle(a).width)) === 18, so = Math.round(parseFloat(s.height) + parseFloat(s.borderTopWidth) + parseFloat(s.borderBottomWidth)) === u.offsetHeight, W.removeChild(Dt), Dt = null;
      }
    }
    f.extend(p, { reliableTrDimensions: function() {
      return oo(), so;
    }, reliableColDimensions: function() {
      return oo(), ro;
    } });
    var Lc = { position: "absolute", visibility: "hidden", display: "block" }, ao = { letterSpacing: "0", fontWeight: "400" };
    function lo(s, a, u) {
      var m = Bi.exec(a);
      return m ? Math.max(0, m[2] - (u || 0)) + (m[3] || "px") : a;
    }
    function co(s, a, u, m, T, x) {
      var I = a === "width" ? 1 : 0, M = 0, O = 0, z = 0;
      if (u === (m ? "border" : "content")) return 0;
      for (; I < 4; I += 2) u === "margin" && (z += f.css(s, u + Pt[I], true, T)), m ? (u === "content" && (O -= f.css(s, "padding" + Pt[I], true, T)), u !== "margin" && (O -= f.css(s, "border" + Pt[I] + "Width", true, T))) : (O += f.css(s, "padding" + Pt[I], true, T), u !== "padding" ? O += f.css(s, "border" + Pt[I] + "Width", true, T) : M += f.css(s, "border" + Pt[I] + "Width", true, T));
      return !m && x >= 0 && (O += Math.max(0, Math.ceil(s["offset" + a[0].toUpperCase() + a.slice(1)] - x - O - M - 0.5)) || 0), O + z;
    }
    function uo(s, a, u) {
      var m = vn(s), T = N || u, x = T && f.css(s, "boxSizing", false, m) === "border-box", I = x, M = to(s, a, m), O = "offset" + a[0].toUpperCase() + a.slice(1);
      if (Ac.test(M)) {
        if (!u) return M;
        M = "auto";
      }
      return (M === "auto" || N && x || !p.reliableColDimensions() && P(s, "col") || !p.reliableTrDimensions() && P(s, "tr")) && s.getClientRects().length && (x = f.css(s, "boxSizing", false, m) === "border-box", I = O in s, I && (M = s[O])), M = parseFloat(M) || 0, M + co(s, a, u || (x ? "border" : "content"), I, m, M) + "px";
    }
    f.extend({ cssHooks: {}, style: function(s, a, u, m) {
      if (!(!s || s.nodeType === 3 || s.nodeType === 8 || !s.style)) {
        var T, x, I, M = as(a), O = us.test(a), z = s.style;
        if (O || (a = ds(M)), I = f.cssHooks[a] || f.cssHooks[M], u !== void 0) {
          if (x = typeof u, x === "string" && (T = Bi.exec(u)) && T[1] && (u = Yr(s, a, T), x = "number"), u == null || u !== u) return;
          x === "number" && (u += T && T[3] || (pn(M) ? "px" : "")), N && u === "" && a.indexOf("background") === 0 && (z[a] = "inherit"), (!I || !("set" in I) || (u = I.set(s, u, m)) !== void 0) && (O ? z.setProperty(a, u) : z[a] = u);
        } else return I && "get" in I && (T = I.get(s, false, m)) !== void 0 ? T : z[a];
      }
    }, css: function(s, a, u, m) {
      var T, x, I, M = as(a), O = us.test(a);
      return O || (a = ds(M)), I = f.cssHooks[a] || f.cssHooks[M], I && "get" in I && (T = I.get(s, true, u)), T === void 0 && (T = to(s, a, m)), T === "normal" && a in ao && (T = ao[a]), u === "" || u ? (x = parseFloat(T), u === true || isFinite(x) ? x || 0 : T) : T;
    } }), f.each(["height", "width"], function(s, a) {
      f.cssHooks[a] = { get: function(u, m, T) {
        if (m) return f.css(u, "display") === "none" ? Oc(u, Lc, function() {
          return uo(u, a, T);
        }) : uo(u, a, T);
      }, set: function(u, m, T) {
        var x, I = vn(u), M = T && f.css(u, "boxSizing", false, I) === "border-box", O = T ? co(u, a, T, M, I) : 0;
        return O && (x = Bi.exec(m)) && (x[3] || "px") !== "px" && (u.style[a] = m, m = f.css(u, a)), lo(u, m, O);
      } };
    }), f.each({ margin: "", padding: "", border: "Width" }, function(s, a) {
      f.cssHooks[s + a] = { expand: function(u) {
        for (var m = 0, T = {}, x = typeof u == "string" ? u.split(" ") : [u]; m < 4; m++) T[s + Pt[m] + a] = x[m] || x[m - 2] || x[0];
        return T;
      } }, s !== "margin" && (f.cssHooks[s + a].set = lo);
    }), f.fn.extend({ css: function(s, a) {
      return be(this, function(u, m, T) {
        var x, I, M = {}, O = 0;
        if (Array.isArray(m)) {
          for (x = vn(u), I = m.length; O < I; O++) M[m[O]] = f.css(u, m[O], false, x);
          return M;
        }
        return T !== void 0 ? f.style(u, m, T) : f.css(u, m);
      }, s, a, arguments.length > 1);
    } });
    function Qe(s, a, u, m, T) {
      return new Qe.prototype.init(s, a, u, m, T);
    }
    f.Tween = Qe, Qe.prototype = { constructor: Qe, init: function(s, a, u, m, T, x) {
      this.elem = s, this.prop = u, this.easing = T || f.easing._default, this.options = a, this.start = this.now = this.cur(), this.end = m, this.unit = x || (pn(u) ? "px" : "");
    }, cur: function() {
      var s = Qe.propHooks[this.prop];
      return s && s.get ? s.get(this) : Qe.propHooks._default.get(this);
    }, run: function(s) {
      var a, u = Qe.propHooks[this.prop];
      return this.options.duration ? this.pos = a = f.easing[this.easing](s, this.options.duration * s, 0, 1, this.options.duration) : this.pos = a = s, this.now = (this.end - this.start) * a + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), u && u.set ? u.set(this) : Qe.propHooks._default.set(this), this;
    } }, Qe.prototype.init.prototype = Qe.prototype, Qe.propHooks = { _default: { get: function(s) {
      var a;
      return s.elem.nodeType !== 1 || s.elem[s.prop] != null && s.elem.style[s.prop] == null ? s.elem[s.prop] : (a = f.css(s.elem, s.prop, ""), !a || a === "auto" ? 0 : a);
    }, set: function(s) {
      f.fx.step[s.prop] ? f.fx.step[s.prop](s) : s.elem.nodeType === 1 && (f.cssHooks[s.prop] || s.elem.style[ds(s.prop)] != null) ? f.style(s.elem, s.prop, s.now + s.unit) : s.elem[s.prop] = s.now;
    } } }, f.easing = { linear: function(s) {
      return s;
    }, swing: function(s) {
      return 0.5 - Math.cos(s * Math.PI) / 2;
    }, _default: "swing" }, f.fx = Qe.prototype.init, f.fx.step = {};
    var mi, yn, Pc = /^(?:toggle|show|hide)$/, Dc = /queueHooks$/;
    function fs() {
      yn && (h.hidden === false && e.requestAnimationFrame ? e.requestAnimationFrame(fs) : e.setTimeout(fs, 13), f.fx.tick());
    }
    function fo() {
      return e.setTimeout(function() {
        mi = void 0;
      }), mi = Date.now();
    }
    function bn(s, a) {
      var u, m = 0, T = { height: s };
      for (a = a ? 1 : 0; m < 4; m += 2 - a) u = Pt[m], T["margin" + u] = T["padding" + u] = s;
      return a && (T.opacity = T.width = s), T;
    }
    function ho(s, a, u) {
      for (var m, T = (at.tweeners[a] || []).concat(at.tweeners["*"]), x = 0, I = T.length; x < I; x++) if (m = T[x].call(u, a, s)) return m;
    }
    function zc(s, a, u) {
      var m, T, x, I, M, O, z, H, j = "width" in a || "height" in a, k = this, G = {}, te = s.style, le = s.nodeType && hn(s), ae = ce.get(s, "fxshow");
      u.queue || (I = f._queueHooks(s, "fx"), I.unqueued == null && (I.unqueued = 0, M = I.empty.fire, I.empty.fire = function() {
        I.unqueued || M();
      }), I.unqueued++, k.always(function() {
        k.always(function() {
          I.unqueued--, f.queue(s, "fx").length || I.empty.fire();
        });
      }));
      for (m in a) if (T = a[m], Pc.test(T)) {
        if (delete a[m], x = x || T === "toggle", T === (le ? "hide" : "show")) if (T === "show" && ae && ae[m] !== void 0) le = true;
        else continue;
        G[m] = ae && ae[m] || f.style(s, m);
      }
      if (O = !f.isEmptyObject(a), !(!O && f.isEmptyObject(G))) {
        j && s.nodeType === 1 && (u.overflow = [te.overflow, te.overflowX, te.overflowY], z = ae && ae.display, z == null && (z = ce.get(s, "display")), H = f.css(s, "display"), H === "none" && (z ? H = z : (di([s], true), z = s.style.display || z, H = f.css(s, "display"), di([s]))), (H === "inline" || H === "inline-block" && z != null) && f.css(s, "float") === "none" && (O || (k.done(function() {
          te.display = z;
        }), z == null && (H = te.display, z = H === "none" ? "" : H)), te.display = "inline-block")), u.overflow && (te.overflow = "hidden", k.always(function() {
          te.overflow = u.overflow[0], te.overflowX = u.overflow[1], te.overflowY = u.overflow[2];
        })), O = false;
        for (m in G) O || (ae ? "hidden" in ae && (le = ae.hidden) : ae = ce.set(s, "fxshow", { display: z }), x && (ae.hidden = !le), le && di([s], true), k.done(function() {
          le || di([s]), ce.remove(s, "fxshow");
          for (m in G) f.style(s, m, G[m]);
        })), O = ho(le ? ae[m] : 0, m, k), m in ae || (ae[m] = O.start, le && (O.end = O.start, O.start = 0));
      }
    }
    function $c(s, a) {
      var u, m, T, x, I;
      for (u in s) if (m = as(u), T = a[m], x = s[u], Array.isArray(x) && (T = x[1], x = s[u] = x[0]), u !== m && (s[m] = x, delete s[u]), I = f.cssHooks[m], I && "expand" in I) {
        x = I.expand(x), delete s[m];
        for (u in x) u in s || (s[u] = x[u], a[u] = T);
      } else a[m] = T;
    }
    function at(s, a, u) {
      var m, T, x = 0, I = at.prefilters.length, M = f.Deferred().always(function() {
        delete O.elem;
      }), O = function() {
        if (T) return false;
        for (var j = mi || fo(), k = Math.max(0, z.startTime + z.duration - j), G = 1 - (k / z.duration || 0), te = 0, le = z.tweens.length; te < le; te++) z.tweens[te].run(G);
        return M.notifyWith(s, [z, G, k]), G < 1 && le ? k : (le || M.notifyWith(s, [z, 1, 0]), M.resolveWith(s, [z]), false);
      }, z = M.promise({ elem: s, props: f.extend({}, a), opts: f.extend(true, { specialEasing: {}, easing: f.easing._default }, u), originalProperties: a, originalOptions: u, startTime: mi || fo(), duration: u.duration, tweens: [], createTween: function(j, k) {
        var G = f.Tween(s, z.opts, j, k, z.opts.specialEasing[j] || z.opts.easing);
        return z.tweens.push(G), G;
      }, stop: function(j) {
        var k = 0, G = j ? z.tweens.length : 0;
        if (T) return this;
        for (T = true; k < G; k++) z.tweens[k].run(1);
        return j ? (M.notifyWith(s, [z, 1, 0]), M.resolveWith(s, [z, j])) : M.rejectWith(s, [z, j]), this;
      } }), H = z.props;
      for ($c(H, z.opts.specialEasing); x < I; x++) if (m = at.prefilters[x].call(z, s, H, z.opts), m) return typeof m.stop == "function" && (f._queueHooks(z.elem, z.opts.queue).stop = m.stop.bind(m)), m;
      return f.map(H, ho, z), typeof z.opts.start == "function" && z.opts.start.call(s, z), z.progress(z.opts.progress).done(z.opts.done, z.opts.complete).fail(z.opts.fail).always(z.opts.always), f.fx.timer(f.extend(O, { elem: s, anim: z, queue: z.opts.queue })), z;
    }
    f.Animation = f.extend(at, { tweeners: { "*": [function(s, a) {
      var u = this.createTween(s, a);
      return Yr(u.elem, s, Bi.exec(a), u), u;
    }] }, tweener: function(s, a) {
      typeof s == "function" ? (a = s, s = ["*"]) : s = s.match(Oe);
      for (var u, m = 0, T = s.length; m < T; m++) u = s[m], at.tweeners[u] = at.tweeners[u] || [], at.tweeners[u].unshift(a);
    }, prefilters: [zc], prefilter: function(s, a) {
      a ? at.prefilters.unshift(s) : at.prefilters.push(s);
    } }), f.speed = function(s, a, u) {
      var m = s && typeof s == "object" ? f.extend({}, s) : { complete: u || a || typeof s == "function" && s, duration: s, easing: u && a || a && typeof a != "function" && a };
      return f.fx.off ? m.duration = 0 : typeof m.duration != "number" && (m.duration in f.fx.speeds ? m.duration = f.fx.speeds[m.duration] : m.duration = f.fx.speeds._default), (m.queue == null || m.queue === true) && (m.queue = "fx"), m.old = m.complete, m.complete = function() {
        typeof m.old == "function" && m.old.call(this), m.queue && f.dequeue(this, m.queue);
      }, m;
    }, f.fn.extend({ fadeTo: function(s, a, u, m) {
      return this.filter(hn).css("opacity", 0).show().end().animate({ opacity: a }, s, u, m);
    }, animate: function(s, a, u, m) {
      var T = f.isEmptyObject(s), x = f.speed(a, u, m), I = function() {
        var M = at(this, f.extend({}, s), x);
        (T || ce.get(this, "finish")) && M.stop(true);
      };
      return I.finish = I, T || x.queue === false ? this.each(I) : this.queue(x.queue, I);
    }, stop: function(s, a, u) {
      var m = function(T) {
        var x = T.stop;
        delete T.stop, x(u);
      };
      return typeof s != "string" && (u = a, a = s, s = void 0), a && this.queue(s || "fx", []), this.each(function() {
        var T = true, x = s != null && s + "queueHooks", I = f.timers, M = ce.get(this);
        if (x) M[x] && M[x].stop && m(M[x]);
        else for (x in M) M[x] && M[x].stop && Dc.test(x) && m(M[x]);
        for (x = I.length; x--; ) I[x].elem === this && (s == null || I[x].queue === s) && (I[x].anim.stop(u), T = false, I.splice(x, 1));
        (T || !u) && f.dequeue(this, s);
      });
    }, finish: function(s) {
      return s !== false && (s = s || "fx"), this.each(function() {
        var a, u = ce.get(this), m = u[s + "queue"], T = u[s + "queueHooks"], x = f.timers, I = m ? m.length : 0;
        for (u.finish = true, f.queue(this, s, []), T && T.stop && T.stop.call(this, true), a = x.length; a--; ) x[a].elem === this && x[a].queue === s && (x[a].anim.stop(true), x.splice(a, 1));
        for (a = 0; a < I; a++) m[a] && m[a].finish && m[a].finish.call(this);
        delete u.finish;
      });
    } }), f.each(["toggle", "show", "hide"], function(s, a) {
      var u = f.fn[a];
      f.fn[a] = function(m, T, x) {
        return m == null || typeof m == "boolean" ? u.apply(this, arguments) : this.animate(bn(a, true), m, T, x);
      };
    }), f.each({ slideDown: bn("show"), slideUp: bn("hide"), slideToggle: bn("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function(s, a) {
      f.fn[s] = function(u, m, T) {
        return this.animate(a, u, m, T);
      };
    }), f.timers = [], f.fx.tick = function() {
      var s, a = 0, u = f.timers;
      for (mi = Date.now(); a < u.length; a++) s = u[a], !s() && u[a] === s && u.splice(a--, 1);
      u.length || f.fx.stop(), mi = void 0;
    }, f.fx.timer = function(s) {
      f.timers.push(s), f.fx.start();
    }, f.fx.start = function() {
      yn || (yn = true, fs());
    }, f.fx.stop = function() {
      yn = null;
    }, f.fx.speeds = { slow: 600, fast: 200, _default: 400 }, f.fn.delay = function(s, a) {
      return s = f.fx && f.fx.speeds[s] || s, a = a || "fx", this.queue(a, function(u, m) {
        var T = e.setTimeout(u, s);
        m.stop = function() {
          e.clearTimeout(T);
        };
      });
    };
    var Nc = /^(?:input|select|textarea|button)$/i, kc = /^(?:a|area)$/i;
    f.fn.extend({ prop: function(s, a) {
      return be(this, f.prop, s, a, arguments.length > 1);
    }, removeProp: function(s) {
      return this.each(function() {
        delete this[f.propFix[s] || s];
      });
    } }), f.extend({ prop: function(s, a, u) {
      var m, T, x = s.nodeType;
      if (!(x === 3 || x === 8 || x === 2)) return (x !== 1 || !f.isXMLDoc(s)) && (a = f.propFix[a] || a, T = f.propHooks[a]), u !== void 0 ? T && "set" in T && (m = T.set(s, u, a)) !== void 0 ? m : s[a] = u : T && "get" in T && (m = T.get(s, a)) !== null ? m : s[a];
    }, propHooks: { tabIndex: { get: function(s) {
      var a = s.getAttribute("tabindex");
      return a ? parseInt(a, 10) : Nc.test(s.nodeName) || kc.test(s.nodeName) && s.href ? 0 : -1;
    } } }, propFix: { for: "htmlFor", class: "className" } }), N && (f.propHooks.selected = { get: function(s) {
      var a = s.parentNode;
      return a && a.parentNode && a.parentNode.selectedIndex, null;
    }, set: function(s) {
      var a = s.parentNode;
      a && (a.selectedIndex, a.parentNode && a.parentNode.selectedIndex);
    } }), f.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
      f.propFix[this.toLowerCase()] = this;
    });
    function Xt(s) {
      var a = s.match(Oe) || [];
      return a.join(" ");
    }
    function gi(s) {
      return s.getAttribute && s.getAttribute("class") || "";
    }
    function hs(s) {
      return Array.isArray(s) ? s : typeof s == "string" ? s.match(Oe) || [] : [];
    }
    f.fn.extend({ addClass: function(s) {
      var a, u, m, T, x, I;
      return typeof s == "function" ? this.each(function(M) {
        f(this).addClass(s.call(this, M, gi(this)));
      }) : (a = hs(s), a.length ? this.each(function() {
        if (m = gi(this), u = this.nodeType === 1 && " " + Xt(m) + " ", u) {
          for (x = 0; x < a.length; x++) T = a[x], u.indexOf(" " + T + " ") < 0 && (u += T + " ");
          I = Xt(u), m !== I && this.setAttribute("class", I);
        }
      }) : this);
    }, removeClass: function(s) {
      var a, u, m, T, x, I;
      return typeof s == "function" ? this.each(function(M) {
        f(this).removeClass(s.call(this, M, gi(this)));
      }) : arguments.length ? (a = hs(s), a.length ? this.each(function() {
        if (m = gi(this), u = this.nodeType === 1 && " " + Xt(m) + " ", u) {
          for (x = 0; x < a.length; x++) for (T = a[x]; u.indexOf(" " + T + " ") > -1; ) u = u.replace(" " + T + " ", " ");
          I = Xt(u), m !== I && this.setAttribute("class", I);
        }
      }) : this) : this.attr("class", "");
    }, toggleClass: function(s, a) {
      var u, m, T, x;
      return typeof s == "function" ? this.each(function(I) {
        f(this).toggleClass(s.call(this, I, gi(this), a), a);
      }) : typeof a == "boolean" ? a ? this.addClass(s) : this.removeClass(s) : (u = hs(s), u.length ? this.each(function() {
        for (x = f(this), T = 0; T < u.length; T++) m = u[T], x.hasClass(m) ? x.removeClass(m) : x.addClass(m);
      }) : this);
    }, hasClass: function(s) {
      var a, u, m = 0;
      for (a = " " + s + " "; u = this[m++]; ) if (u.nodeType === 1 && (" " + Xt(gi(u)) + " ").indexOf(a) > -1) return true;
      return false;
    } }), f.fn.extend({ val: function(s) {
      var a, u, m, T = this[0];
      return arguments.length ? (m = typeof s == "function", this.each(function(x) {
        var I;
        this.nodeType === 1 && (m ? I = s.call(this, x, f(this).val()) : I = s, I == null ? I = "" : typeof I == "number" ? I += "" : Array.isArray(I) && (I = f.map(I, function(M) {
          return M == null ? "" : M + "";
        })), a = f.valHooks[this.type] || f.valHooks[this.nodeName.toLowerCase()], (!a || !("set" in a) || a.set(this, I, "value") === void 0) && (this.value = I));
      })) : T ? (a = f.valHooks[T.type] || f.valHooks[T.nodeName.toLowerCase()], a && "get" in a && (u = a.get(T, "value")) !== void 0 ? u : (u = T.value, u == null ? "" : u)) : void 0;
    } }), f.extend({ valHooks: { select: { get: function(s) {
      var a, u, m, T = s.options, x = s.selectedIndex, I = s.type === "select-one", M = I ? null : [], O = I ? x + 1 : T.length;
      for (x < 0 ? m = O : m = I ? x : 0; m < O; m++) if (u = T[m], u.selected && !u.disabled && (!u.parentNode.disabled || !P(u.parentNode, "optgroup"))) {
        if (a = f(u).val(), I) return a;
        M.push(a);
      }
      return M;
    }, set: function(s, a) {
      for (var u, m, T = s.options, x = f.makeArray(a), I = T.length; I--; ) m = T[I], (m.selected = f.inArray(f(m).val(), x) > -1) && (u = true);
      return u || (s.selectedIndex = -1), x;
    } } } }), N && (f.valHooks.option = { get: function(s) {
      var a = s.getAttribute("value");
      return a != null ? a : Xt(f.text(s));
    } }), f.each(["radio", "checkbox"], function() {
      f.valHooks[this] = { set: function(s, a) {
        if (Array.isArray(a)) return s.checked = f.inArray(f(s).val(), a) > -1;
      } };
    });
    var po = /^(?:focusinfocus|focusoutblur)$/, mo = function(s) {
      s.stopPropagation();
    };
    f.extend(f.event, { trigger: function(s, a, u, m) {
      var T, x, I, M, O, z, H, j, k = [u || h], G = E.call(s, "type") ? s.type : s, te = E.call(s, "namespace") ? s.namespace.split(".") : [];
      if (x = j = I = u = u || h, !(u.nodeType === 3 || u.nodeType === 8) && !po.test(G + f.event.triggered) && (G.indexOf(".") > -1 && (te = G.split("."), G = te.shift(), te.sort()), O = G.indexOf(":") < 0 && "on" + G, s = s[f.expando] ? s : new f.Event(G, typeof s == "object" && s), s.isTrigger = m ? 2 : 3, s.namespace = te.join("."), s.rnamespace = s.namespace ? new RegExp("(^|\\.)" + te.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, s.result = void 0, s.target || (s.target = u), a = a == null ? [s] : f.makeArray(a, [s]), H = f.event.special[G] || {}, !(!m && H.trigger && H.trigger.apply(u, a) === false))) {
        if (!m && !H.noBubble && !C(u)) {
          for (M = H.delegateType || G, po.test(M + G) || (x = x.parentNode); x; x = x.parentNode) k.push(x), I = x;
          I === (u.ownerDocument || h) && k.push(I.defaultView || I.parentWindow || e);
        }
        for (T = 0; (x = k[T++]) && !s.isPropagationStopped(); ) j = x, s.type = T > 1 ? M : H.bindType || G, z = (ce.get(x, "events") || /* @__PURE__ */ Object.create(null))[s.type] && ce.get(x, "handle"), z && z.apply(x, a), z = O && x[O], z && z.apply && Ri(x) && (s.result = z.apply(x, a), s.result === false && s.preventDefault());
        return s.type = G, !m && !s.isDefaultPrevented() && (!H._default || H._default.apply(k.pop(), a) === false) && Ri(u) && O && typeof u[G] == "function" && !C(u) && (I = u[O], I && (u[O] = null), f.event.triggered = G, s.isPropagationStopped() && j.addEventListener(G, mo), u[G](), s.isPropagationStopped() && j.removeEventListener(G, mo), f.event.triggered = void 0, I && (u[O] = I)), s.result;
      }
    }, simulate: function(s, a, u) {
      var m = f.extend(new f.Event(), u, { type: s, isSimulated: true });
      f.event.trigger(m, null, a);
    } }), f.fn.extend({ trigger: function(s, a) {
      return this.each(function() {
        f.event.trigger(s, a, this);
      });
    }, triggerHandler: function(s, a) {
      var u = this[0];
      if (u) return f.event.trigger(s, a, u, true);
    } });
    var Wi = e.location, go = { guid: Date.now() }, ps = /\?/;
    f.parseXML = function(s) {
      var a, u;
      if (!s || typeof s != "string") return null;
      try {
        a = new e.DOMParser().parseFromString(s, "text/xml");
      } catch (m) {
      }
      return u = a && a.getElementsByTagName("parsererror")[0], (!a || u) && f.error("Invalid XML: " + (u ? f.map(u.childNodes, function(m) {
        return m.textContent;
      }).join(`
`) : s)), a;
    };
    var Rc = /\[\]$/, vo = /\r?\n/g, Hc = /^(?:submit|button|image|reset|file)$/i, Bc = /^(?:input|select|textarea|keygen)/i;
    function ms(s, a, u, m) {
      var T;
      if (Array.isArray(a)) f.each(a, function(x, I) {
        u || Rc.test(s) ? m(s, I) : ms(s + "[" + (typeof I == "object" && I != null ? x : "") + "]", I, u, m);
      });
      else if (!u && g(a) === "object") for (T in a) ms(s + "[" + T + "]", a[T], u, m);
      else m(s, a);
    }
    f.param = function(s, a) {
      var u, m = [], T = function(x, I) {
        var M = typeof I == "function" ? I() : I;
        m[m.length] = encodeURIComponent(x) + "=" + encodeURIComponent(M == null ? "" : M);
      };
      if (s == null) return "";
      if (Array.isArray(s) || s.jquery && !f.isPlainObject(s)) f.each(s, function() {
        T(this.name, this.value);
      });
      else for (u in s) ms(u, s[u], a, T);
      return m.join("&");
    }, f.fn.extend({ serialize: function() {
      return f.param(this.serializeArray());
    }, serializeArray: function() {
      return this.map(function() {
        var s = f.prop(this, "elements");
        return s ? f.makeArray(s) : this;
      }).filter(function() {
        var s = this.type;
        return this.name && !f(this).is(":disabled") && Bc.test(this.nodeName) && !Hc.test(s) && (this.checked || !mn.test(s));
      }).map(function(s, a) {
        var u = f(this).val();
        return u == null ? null : Array.isArray(u) ? f.map(u, function(m) {
          return { name: a.name, value: m.replace(vo, `\r
`) };
        }) : { name: a.name, value: u.replace(vo, `\r
`) };
      }).get();
    } });
    var Vc = /%20/g, Wc = /#.*$/, Fc = /([?&])_=[^&]*/, Gc = /^(.*?):[ \t]*([^\r\n]*)$/mg, jc = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, Yc = /^(?:GET|HEAD)$/, Xc = /^\/\//, yo = {}, gs = {}, bo = "*/".concat("*"), vs = h.createElement("a");
    vs.href = Wi.href;
    function Eo(s) {
      return function(a, u) {
        typeof a != "string" && (u = a, a = "*");
        var m, T = 0, x = a.toLowerCase().match(Oe) || [];
        if (typeof u == "function") for (; m = x[T++]; ) m[0] === "+" ? (m = m.slice(1) || "*", (s[m] = s[m] || []).unshift(u)) : (s[m] = s[m] || []).push(u);
      };
    }
    function So(s, a, u, m) {
      var T = {}, x = s === gs;
      function I(M) {
        var O;
        return T[M] = true, f.each(s[M] || [], function(z, H) {
          var j = H(a, u, m);
          if (typeof j == "string" && !x && !T[j]) return a.dataTypes.unshift(j), I(j), false;
          if (x) return !(O = j);
        }), O;
      }
      return I(a.dataTypes[0]) || !T["*"] && I("*");
    }
    function ys(s, a) {
      var u, m, T = f.ajaxSettings.flatOptions || {};
      for (u in a) a[u] !== void 0 && ((T[u] ? s : m || (m = {}))[u] = a[u]);
      return m && f.extend(true, s, m), s;
    }
    function qc(s, a, u) {
      for (var m, T, x, I, M = s.contents, O = s.dataTypes; O[0] === "*"; ) O.shift(), m === void 0 && (m = s.mimeType || a.getResponseHeader("Content-Type"));
      if (m) {
        for (T in M) if (M[T] && M[T].test(m)) {
          O.unshift(T);
          break;
        }
      }
      if (O[0] in u) x = O[0];
      else {
        for (T in u) {
          if (!O[0] || s.converters[T + " " + O[0]]) {
            x = T;
            break;
          }
          I || (I = T);
        }
        x = x || I;
      }
      if (x) return x !== O[0] && O.unshift(x), u[x];
    }
    function Uc(s, a, u, m) {
      var T, x, I, M, O, z = {}, H = s.dataTypes.slice();
      if (H[1]) for (I in s.converters) z[I.toLowerCase()] = s.converters[I];
      for (x = H.shift(); x; ) if (s.responseFields[x] && (u[s.responseFields[x]] = a), !O && m && s.dataFilter && (a = s.dataFilter(a, s.dataType)), O = x, x = H.shift(), x) {
        if (x === "*") x = O;
        else if (O !== "*" && O !== x) {
          if (I = z[O + " " + x] || z["* " + x], !I) {
            for (T in z) if (M = T.split(" "), M[1] === x && (I = z[O + " " + M[0]] || z["* " + M[0]], I)) {
              I === true ? I = z[T] : z[T] !== true && (x = M[0], H.unshift(M[1]));
              break;
            }
          }
          if (I !== true) if (I && s.throws) a = I(a);
          else try {
            a = I(a);
          } catch (j) {
            return { state: "parsererror", error: I ? j : "No conversion from " + O + " to " + x };
          }
        }
      }
      return { state: "success", data: a };
    }
    f.extend({ active: 0, lastModified: {}, etag: {}, ajaxSettings: { url: Wi.href, type: "GET", isLocal: jc.test(Wi.protocol), global: true, processData: true, async: true, contentType: "application/x-www-form-urlencoded; charset=UTF-8", accepts: { "*": bo, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" }, contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ }, responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" }, converters: { "* text": String, "text html": true, "text json": JSON.parse, "text xml": f.parseXML }, flatOptions: { url: true, context: true } }, ajaxSetup: function(s, a) {
      return a ? ys(ys(s, f.ajaxSettings), a) : ys(f.ajaxSettings, s);
    }, ajaxPrefilter: Eo(yo), ajaxTransport: Eo(gs), ajax: function(s, a) {
      typeof s == "object" && (a = s, s = void 0), a = a || {};
      var u, m, T, x, I, M, O, z, H, j, k = f.ajaxSetup({}, a), G = k.context || k, te = k.context && (G.nodeType || G.jquery) ? f(G) : f.event, le = f.Deferred(), ae = f.Callbacks("once memory"), ve = k.statusCode || {}, pe = {}, Be = {}, ze = "canceled", de = { readyState: 0, getResponseHeader: function(fe) {
        var xe;
        if (O) {
          if (!x) for (x = {}; xe = Gc.exec(T); ) x[xe[1].toLowerCase() + " "] = (x[xe[1].toLowerCase() + " "] || []).concat(xe[2]);
          xe = x[fe.toLowerCase() + " "];
        }
        return xe == null ? null : xe.join(", ");
      }, getAllResponseHeaders: function() {
        return O ? T : null;
      }, setRequestHeader: function(fe, xe) {
        return O == null && (fe = Be[fe.toLowerCase()] = Be[fe.toLowerCase()] || fe, pe[fe] = xe), this;
      }, overrideMimeType: function(fe) {
        return O == null && (k.mimeType = fe), this;
      }, statusCode: function(fe) {
        var xe;
        if (fe) if (O) de.always(fe[de.status]);
        else for (xe in fe) ve[xe] = [ve[xe], fe[xe]];
        return this;
      }, abort: function(fe) {
        var xe = fe || ze;
        return u && u.abort(xe), En(0, xe), this;
      } };
      if (le.promise(de), k.url = ((s || k.url || Wi.href) + "").replace(Xc, Wi.protocol + "//"), k.type = a.method || a.type || k.method || k.type, k.dataTypes = (k.dataType || "*").toLowerCase().match(Oe) || [""], k.crossDomain == null) {
        M = h.createElement("a");
        try {
          M.href = k.url, M.href = M.href, k.crossDomain = vs.protocol + "//" + vs.host != M.protocol + "//" + M.host;
        } catch (fe) {
          k.crossDomain = true;
        }
      }
      if (So(yo, k, a, de), k.data && k.processData && typeof k.data != "string" && (k.data = f.param(k.data, k.traditional)), O) return de;
      z = f.event && k.global, z && f.active++ === 0 && f.event.trigger("ajaxStart"), k.type = k.type.toUpperCase(), k.hasContent = !Yc.test(k.type), m = k.url.replace(Wc, ""), k.hasContent ? k.data && k.processData && (k.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && (k.data = k.data.replace(Vc, "+")) : (j = k.url.slice(m.length), k.data && (k.processData || typeof k.data == "string") && (m += (ps.test(m) ? "&" : "?") + k.data, delete k.data), k.cache === false && (m = m.replace(Fc, "$1"), j = (ps.test(m) ? "&" : "?") + "_=" + go.guid++ + j), k.url = m + j), k.ifModified && (f.lastModified[m] && de.setRequestHeader("If-Modified-Since", f.lastModified[m]), f.etag[m] && de.setRequestHeader("If-None-Match", f.etag[m])), (k.data && k.hasContent && k.contentType !== false || a.contentType) && de.setRequestHeader("Content-Type", k.contentType), de.setRequestHeader("Accept", k.dataTypes[0] && k.accepts[k.dataTypes[0]] ? k.accepts[k.dataTypes[0]] + (k.dataTypes[0] !== "*" ? ", " + bo + "; q=0.01" : "") : k.accepts["*"]);
      for (H in k.headers) de.setRequestHeader(H, k.headers[H]);
      if (k.beforeSend && (k.beforeSend.call(G, de, k) === false || O)) return de.abort();
      if (ze = "abort", ae.add(k.complete), de.done(k.success), de.fail(k.error), u = So(gs, k, a, de), !u) En(-1, "No Transport");
      else {
        if (de.readyState = 1, z && te.trigger("ajaxSend", [de, k]), O) return de;
        k.async && k.timeout > 0 && (I = e.setTimeout(function() {
          de.abort("timeout");
        }, k.timeout));
        try {
          O = false, u.send(pe, En);
        } catch (fe) {
          if (O) throw fe;
          En(-1, fe);
        }
      }
      function En(fe, xe, xo, Jc) {
        var zt, Es, Fi, vi, yi, mt = xe;
        O || (O = true, I && e.clearTimeout(I), u = void 0, T = Jc || "", de.readyState = fe > 0 ? 4 : 0, zt = fe >= 200 && fe < 300 || fe === 304, xo && (vi = qc(k, de, xo)), !zt && f.inArray("script", k.dataTypes) > -1 && f.inArray("json", k.dataTypes) < 0 && (k.converters["text script"] = function() {
        }), vi = Uc(k, vi, de, zt), zt ? (k.ifModified && (yi = de.getResponseHeader("Last-Modified"), yi && (f.lastModified[m] = yi), yi = de.getResponseHeader("etag"), yi && (f.etag[m] = yi)), fe === 204 || k.type === "HEAD" ? mt = "nocontent" : fe === 304 ? mt = "notmodified" : (mt = vi.state, Es = vi.data, Fi = vi.error, zt = !Fi)) : (Fi = mt, (fe || !mt) && (mt = "error", fe < 0 && (fe = 0))), de.status = fe, de.statusText = (xe || mt) + "", zt ? le.resolveWith(G, [Es, mt, de]) : le.rejectWith(G, [de, mt, Fi]), de.statusCode(ve), ve = void 0, z && te.trigger(zt ? "ajaxSuccess" : "ajaxError", [de, k, zt ? Es : Fi]), ae.fireWith(G, [de, mt]), z && (te.trigger("ajaxComplete", [de, k]), --f.active || f.event.trigger("ajaxStop")));
      }
      return de;
    }, getJSON: function(s, a, u) {
      return f.get(s, a, u, "json");
    }, getScript: function(s, a) {
      return f.get(s, void 0, a, "script");
    } }), f.each(["get", "post"], function(s, a) {
      f[a] = function(u, m, T, x) {
        return (typeof m == "function" || m === null) && (x = x || T, T = m, m = void 0), f.ajax(f.extend({ url: u, type: a, dataType: x, data: m, success: T }, f.isPlainObject(u) && u));
      };
    }), f.ajaxPrefilter(function(s) {
      var a;
      for (a in s.headers) a.toLowerCase() === "content-type" && (s.contentType = s.headers[a] || "");
    }), f._evalUrl = function(s, a, u) {
      return f.ajax({ url: s, type: "GET", dataType: "script", cache: true, async: false, global: false, scriptAttrs: a.crossOrigin ? { crossOrigin: a.crossOrigin } : void 0, converters: { "text script": function() {
      } }, dataFilter: function(m) {
        f.globalEval(m, a, u);
      } });
    }, f.fn.extend({ wrapAll: function(s) {
      var a;
      return this[0] && (typeof s == "function" && (s = s.call(this[0])), a = f(s, this[0].ownerDocument).eq(0).clone(true), this[0].parentNode && a.insertBefore(this[0]), a.map(function() {
        for (var u = this; u.firstElementChild; ) u = u.firstElementChild;
        return u;
      }).append(this)), this;
    }, wrapInner: function(s) {
      return typeof s == "function" ? this.each(function(a) {
        f(this).wrapInner(s.call(this, a));
      }) : this.each(function() {
        var a = f(this), u = a.contents();
        u.length ? u.wrapAll(s) : a.append(s);
      });
    }, wrap: function(s) {
      var a = typeof s == "function";
      return this.each(function(u) {
        f(this).wrapAll(a ? s.call(this, u) : s);
      });
    }, unwrap: function(s) {
      return this.parent(s).not("body").each(function() {
        f(this).replaceWith(this.childNodes);
      }), this;
    } }), f.expr.pseudos.hidden = function(s) {
      return !f.expr.pseudos.visible(s);
    }, f.expr.pseudos.visible = function(s) {
      return !!(s.offsetWidth || s.offsetHeight || s.getClientRects().length);
    }, f.ajaxSettings.xhr = function() {
      return new e.XMLHttpRequest();
    };
    var Kc = { 0: 200 };
    f.ajaxTransport(function(s) {
      var a;
      return { send: function(u, m) {
        var T, x = s.xhr();
        if (x.open(s.type, s.url, s.async, s.username, s.password), s.xhrFields) for (T in s.xhrFields) x[T] = s.xhrFields[T];
        s.mimeType && x.overrideMimeType && x.overrideMimeType(s.mimeType), !s.crossDomain && !u["X-Requested-With"] && (u["X-Requested-With"] = "XMLHttpRequest");
        for (T in u) x.setRequestHeader(T, u[T]);
        a = function(I) {
          return function() {
            a && (a = x.onload = x.onerror = x.onabort = x.ontimeout = null, I === "abort" ? x.abort() : I === "error" ? m(x.status, x.statusText) : m(Kc[x.status] || x.status, x.statusText, (x.responseType || "text") === "text" ? { text: x.responseText } : { binary: x.response }, x.getAllResponseHeaders()));
          };
        }, x.onload = a(), x.onabort = x.onerror = x.ontimeout = a("error"), a = a("abort");
        try {
          x.send(s.hasContent && s.data || null);
        } catch (I) {
          if (a) throw I;
        }
      }, abort: function() {
        a && a();
      } };
    });
    function To(s) {
      return s.scriptAttrs || !s.headers && (s.crossDomain || s.async && f.inArray("json", s.dataTypes) < 0);
    }
    f.ajaxSetup({ accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" }, converters: { "text script": function(s) {
      return f.globalEval(s), s;
    } } }), f.ajaxPrefilter("script", function(s) {
      s.cache === void 0 && (s.cache = false), To(s) && (s.type = "GET");
    }), f.ajaxTransport("script", function(s) {
      if (To(s)) {
        var a, u;
        return { send: function(m, T) {
          a = f("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", u = function(x) {
            a.remove(), u = null, x && T(x.type === "error" ? 404 : 200, x.type);
          }), h.head.appendChild(a[0]);
        }, abort: function() {
          u && u();
        } };
      }
    });
    var _o = [], bs = /(=)\?(?=&|$)|\?\?/;
    f.ajaxSetup({ jsonp: "callback", jsonpCallback: function() {
      var s = _o.pop() || f.expando + "_" + go.guid++;
      return this[s] = true, s;
    } }), f.ajaxPrefilter("jsonp", function(s, a, u) {
      var m, T, x, I = s.jsonp !== false && (bs.test(s.url) ? "url" : typeof s.data == "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && bs.test(s.data) && "data");
      return m = s.jsonpCallback = typeof s.jsonpCallback == "function" ? s.jsonpCallback() : s.jsonpCallback, I ? s[I] = s[I].replace(bs, "$1" + m) : s.jsonp !== false && (s.url += (ps.test(s.url) ? "&" : "?") + s.jsonp + "=" + m), s.converters["script json"] = function() {
        return x || f.error(m + " was not called"), x[0];
      }, s.dataTypes[0] = "json", T = e[m], e[m] = function() {
        x = arguments;
      }, u.always(function() {
        T === void 0 ? f(e).removeProp(m) : e[m] = T, s[m] && (s.jsonpCallback = a.jsonpCallback, _o.push(m)), x && typeof T == "function" && T(x[0]), x = T = void 0;
      }), "script";
    }), f.ajaxPrefilter(function(s, a) {
      typeof s.data != "string" && !f.isPlainObject(s.data) && !Array.isArray(s.data) && !("processData" in a) && (s.processData = false), s.data instanceof e.FormData && (s.contentType = false);
    }), f.parseHTML = function(s, a, u) {
      if (typeof s != "string" && !Vr(s + "")) return [];
      typeof a == "boolean" && (u = a, a = false);
      var m, T;
      return a || (a = new e.DOMParser().parseFromString("", "text/html")), m = Br.exec(s), T = !u && [], m ? [a.createElement(m[1])] : (m = Kr([s], a, T), T && T.length && f(T).remove(), f.merge([], m.childNodes));
    }, f.fn.load = function(s, a, u) {
      var m, T, x, I = this, M = s.indexOf(" ");
      return M > -1 && (m = Xt(s.slice(M)), s = s.slice(0, M)), typeof a == "function" ? (u = a, a = void 0) : a && typeof a == "object" && (T = "POST"), I.length > 0 && f.ajax({ url: s, type: T || "GET", dataType: "html", data: a }).done(function(O) {
        x = arguments, I.html(m ? f("<div>").append(f.parseHTML(O)).find(m) : O);
      }).always(u && function(O, z) {
        I.each(function() {
          u.apply(this, x || [O.responseText, z, O]);
        });
      }), this;
    }, f.expr.pseudos.animated = function(s) {
      return f.grep(f.timers, function(a) {
        return s === a.elem;
      }).length;
    }, f.offset = { setOffset: function(s, a, u) {
      var m, T, x, I, M, O, z, H = f.css(s, "position"), j = f(s), k = {};
      H === "static" && (s.style.position = "relative"), M = j.offset(), x = f.css(s, "top"), O = f.css(s, "left"), z = (H === "absolute" || H === "fixed") && (x + O).indexOf("auto") > -1, z ? (m = j.position(), I = m.top, T = m.left) : (I = parseFloat(x) || 0, T = parseFloat(O) || 0), typeof a == "function" && (a = a.call(s, u, f.extend({}, M))), a.top != null && (k.top = a.top - M.top + I), a.left != null && (k.left = a.left - M.left + T), "using" in a ? a.using.call(s, k) : j.css(k);
    } }, f.fn.extend({ offset: function(s) {
      if (arguments.length) return s === void 0 ? this : this.each(function(T) {
        f.offset.setOffset(this, s, T);
      });
      var a, u, m = this[0];
      if (m) return m.getClientRects().length ? (a = m.getBoundingClientRect(), u = m.ownerDocument.defaultView, { top: a.top + u.pageYOffset, left: a.left + u.pageXOffset }) : { top: 0, left: 0 };
    }, position: function() {
      if (this[0]) {
        var s, a, u, m = this[0], T = { top: 0, left: 0 };
        if (f.css(m, "position") === "fixed") a = m.getBoundingClientRect();
        else {
          for (a = this.offset(), u = m.ownerDocument, s = m.offsetParent || u.documentElement; s && s !== u.documentElement && f.css(s, "position") === "static"; ) s = s.offsetParent || u.documentElement;
          s && s !== m && s.nodeType === 1 && f.css(s, "position") !== "static" && (T = f(s).offset(), T.top += f.css(s, "borderTopWidth", true), T.left += f.css(s, "borderLeftWidth", true));
        }
        return { top: a.top - T.top - f.css(m, "marginTop", true), left: a.left - T.left - f.css(m, "marginLeft", true) };
      }
    }, offsetParent: function() {
      return this.map(function() {
        for (var s = this.offsetParent; s && f.css(s, "position") === "static"; ) s = s.offsetParent;
        return s || W;
      });
    } }), f.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function(s, a) {
      var u = a === "pageYOffset";
      f.fn[s] = function(m) {
        return be(this, function(T, x, I) {
          var M;
          if (C(T) ? M = T : T.nodeType === 9 && (M = T.defaultView), I === void 0) return M ? M[a] : T[x];
          M ? M.scrollTo(u ? M.pageXOffset : I, u ? I : M.pageYOffset) : T[x] = I;
        }, s, m, arguments.length);
      };
    }), f.each({ Height: "height", Width: "width" }, function(s, a) {
      f.each({ padding: "inner" + s, content: a, "": "outer" + s }, function(u, m) {
        f.fn[m] = function(T, x) {
          var I = arguments.length && (u || typeof T != "boolean"), M = u || (T === true || x === true ? "margin" : "border");
          return be(this, function(O, z, H) {
            var j;
            return C(O) ? m.indexOf("outer") === 0 ? O["inner" + s] : O.document.documentElement["client" + s] : O.nodeType === 9 ? (j = O.documentElement, Math.max(O.body["scroll" + s], j["scroll" + s], O.body["offset" + s], j["offset" + s], j["client" + s])) : H === void 0 ? f.css(O, z, M) : f.style(O, z, H, M);
          }, a, I ? T : void 0, I);
        };
      });
    }), f.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(s, a) {
      f.fn[a] = function(u) {
        return this.on(a, u);
      };
    }), f.fn.extend({ bind: function(s, a, u) {
      return this.on(s, null, a, u);
    }, unbind: function(s, a) {
      return this.off(s, null, a);
    }, delegate: function(s, a, u, m) {
      return this.on(a, s, u, m);
    }, undelegate: function(s, a, u) {
      return arguments.length === 1 ? this.off(s, "**") : this.off(a, s || "**", u);
    }, hover: function(s, a) {
      return this.on("mouseenter", s).on("mouseleave", a || s);
    } }), f.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(s, a) {
      f.fn[a] = function(u, m) {
        return arguments.length > 0 ? this.on(a, null, u, m) : this.trigger(a);
      };
    }), f.proxy = function(s, a) {
      var u, m, T;
      if (typeof a == "string" && (u = s[a], a = s, s = u), typeof s == "function") return m = r.call(arguments, 2), T = function() {
        return s.apply(a || this, m.concat(r.call(arguments)));
      }, T.guid = s.guid = s.guid || f.guid++, T;
    }, f.holdReady = function(s) {
      s ? f.readyWait++ : f.ready(true);
    }, f.expr[":"] = f.expr.filters = f.expr.pseudos, typeof define == "function" && define.amd && define("jquery", [], function() {
      return f;
    });
    var Zc = e.jQuery, Qc = e.$;
    return f.noConflict = function(s) {
      return e.$ === f && (e.$ = Qc), s && e.jQuery === f && (e.jQuery = Zc), f;
    }, f;
  }
  var ou = ru(window);
  window.jQuery = window.$ = ou;
  var Ne = "top", qe = "bottom", Ue = "right", ke = "left", Gn = "auto", zi = [Ne, qe, Ue, ke], ei = "start", wi = "end", Pa = "clippingParents", mr = "viewport", Ti = "popper", Da = "reference", rr = zi.reduce(function(e, t) {
    return e.concat([t + "-" + ei, t + "-" + wi]);
  }, []), gr = [].concat(zi, [Gn]).reduce(function(e, t) {
    return e.concat([t, t + "-" + ei, t + "-" + wi]);
  }, []), za = "beforeRead", $a = "read", Na = "afterRead", ka = "beforeMain", Ra = "main", Ha = "afterMain", Ba = "beforeWrite", Va = "write", Wa = "afterWrite", Fa = [za, $a, Na, ka, Ra, Ha, Ba, Va, Wa];
  function yt(e) {
    return e ? (e.nodeName || "").toLowerCase() : null;
  }
  function Ke(e) {
    if (e == null) return window;
    if (e.toString() !== "[object Window]") {
      var t = e.ownerDocument;
      return t && t.defaultView || window;
    }
    return e;
  }
  function ti(e) {
    var t = Ke(e).Element;
    return e instanceof t || e instanceof Element;
  }
  function et(e) {
    var t = Ke(e).HTMLElement;
    return e instanceof t || e instanceof HTMLElement;
  }
  function vr(e) {
    if (typeof ShadowRoot == "undefined") return false;
    var t = Ke(e).ShadowRoot;
    return e instanceof t || e instanceof ShadowRoot;
  }
  function au(e) {
    var t = e.state;
    Object.keys(t.elements).forEach(function(i) {
      var n = t.styles[i] || {}, r = t.attributes[i] || {}, o = t.elements[i];
      !et(o) || !yt(o) || (Object.assign(o.style, n), Object.keys(r).forEach(function(l) {
        var c = r[l];
        c === false ? o.removeAttribute(l) : o.setAttribute(l, c === true ? "" : c);
      }));
    });
  }
  function lu(e) {
    var t = e.state, i = { popper: { position: t.options.strategy, left: "0", top: "0", margin: "0" }, arrow: { position: "absolute" }, reference: {} };
    return Object.assign(t.elements.popper.style, i.popper), t.styles = i, t.elements.arrow && Object.assign(t.elements.arrow.style, i.arrow), function() {
      Object.keys(t.elements).forEach(function(n) {
        var r = t.elements[n], o = t.attributes[n] || {}, l = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : i[n]), c = l.reduce(function(d, v) {
          return d[v] = "", d;
        }, {});
        !et(r) || !yt(r) || (Object.assign(r.style, c), Object.keys(o).forEach(function(d) {
          r.removeAttribute(d);
        }));
      });
    };
  }
  const Ga = { name: "applyStyles", enabled: true, phase: "write", fn: au, effect: lu, requires: ["computeStyles"] };
  function vt(e) {
    return e.split("-")[0];
  }
  var Zt = Math.max, Dn = Math.min, Ii = Math.round;
  function or() {
    var e = navigator.userAgentData;
    return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
      return t.brand + "/" + t.version;
    }).join(" ") : navigator.userAgent;
  }
  function ja() {
    return !/^((?!chrome|android).)*safari/i.test(or());
  }
  function Ai(e, t, i) {
    t === void 0 && (t = false), i === void 0 && (i = false);
    var n = e.getBoundingClientRect(), r = 1, o = 1;
    t && et(e) && (r = e.offsetWidth > 0 && Ii(n.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && Ii(n.height) / e.offsetHeight || 1);
    var l = ti(e) ? Ke(e) : window, c = l.visualViewport, d = !ja() && i, v = (n.left + (d && c ? c.offsetLeft : 0)) / r, E = (n.top + (d && c ? c.offsetTop : 0)) / o, y = n.width / r, b = n.height / o;
    return { width: y, height: b, top: E, right: v + y, bottom: E + b, left: v, x: v, y: E };
  }
  function yr(e) {
    var t = Ai(e), i = e.offsetWidth, n = e.offsetHeight;
    return Math.abs(t.width - i) <= 1 && (i = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), { x: e.offsetLeft, y: e.offsetTop, width: i, height: n };
  }
  function Ya(e, t) {
    var i = t.getRootNode && t.getRootNode();
    if (e.contains(t)) return true;
    if (i && vr(i)) {
      var n = t;
      do {
        if (n && e.isSameNode(n)) return true;
        n = n.parentNode || n.host;
      } while (n);
    }
    return false;
  }
  function At(e) {
    return Ke(e).getComputedStyle(e);
  }
  function cu(e) {
    return ["table", "td", "th"].indexOf(yt(e)) >= 0;
  }
  function Wt(e) {
    return ((ti(e) ? e.ownerDocument : e.document) || window.document).documentElement;
  }
  function jn(e) {
    return yt(e) === "html" ? e : e.assignedSlot || e.parentNode || (vr(e) ? e.host : null) || Wt(e);
  }
  function wo(e) {
    return !et(e) || At(e).position === "fixed" ? null : e.offsetParent;
  }
  function uu(e) {
    var t = /firefox/i.test(or()), i = /Trident/i.test(or());
    if (i && et(e)) {
      var n = At(e);
      if (n.position === "fixed") return null;
    }
    var r = jn(e);
    for (vr(r) && (r = r.host); et(r) && ["html", "body"].indexOf(yt(r)) < 0; ) {
      var o = At(r);
      if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none") return r;
      r = r.parentNode;
    }
    return null;
  }
  function Ji(e) {
    for (var t = Ke(e), i = wo(e); i && cu(i) && At(i).position === "static"; ) i = wo(i);
    return i && (yt(i) === "html" || yt(i) === "body" && At(i).position === "static") ? t : i || uu(e) || t;
  }
  function br(e) {
    return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
  }
  function Ui(e, t, i) {
    return Zt(e, Dn(t, i));
  }
  function du(e, t, i) {
    var n = Ui(e, t, i);
    return n > i ? i : n;
  }
  function Xa() {
    return { top: 0, right: 0, bottom: 0, left: 0 };
  }
  function qa(e) {
    return Object.assign({}, Xa(), e);
  }
  function Ua(e, t) {
    return t.reduce(function(i, n) {
      return i[n] = e, i;
    }, {});
  }
  var fu = function(t, i) {
    return t = typeof t == "function" ? t(Object.assign({}, i.rects, { placement: i.placement })) : t, qa(typeof t != "number" ? t : Ua(t, zi));
  };
  function hu(e) {
    var t, i = e.state, n = e.name, r = e.options, o = i.elements.arrow, l = i.modifiersData.popperOffsets, c = vt(i.placement), d = br(c), v = [ke, Ue].indexOf(c) >= 0, E = v ? "height" : "width";
    if (!(!o || !l)) {
      var y = fu(r.padding, i), b = yr(o), p = d === "y" ? Ne : ke, g = d === "y" ? qe : Ue, C = i.rects.reference[E] + i.rects.reference[d] - l[d] - i.rects.popper[E], _ = l[d] - i.rects.reference[d], h = Ji(o), S = h ? d === "y" ? h.clientHeight || 0 : h.clientWidth || 0 : 0, w = C / 2 - _ / 2, A = y[p], L = S - b[E] - y[g], f = S / 2 - b[E] / 2 + w, P = Ui(A, f, L), D = d;
      i.modifiersData[n] = (t = {}, t[D] = P, t.centerOffset = P - f, t);
    }
  }
  function pu(e) {
    var t = e.state, i = e.options, n = i.element, r = n === void 0 ? "[data-popper-arrow]" : n;
    r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || Ya(t.elements.popper, r) && (t.elements.arrow = r));
  }
  const Ka = { name: "arrow", enabled: true, phase: "main", fn: hu, effect: pu, requires: ["popperOffsets"], requiresIfExists: ["preventOverflow"] };
  function Oi(e) {
    return e.split("-")[1];
  }
  var mu = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
  function gu(e, t) {
    var i = e.x, n = e.y, r = t.devicePixelRatio || 1;
    return { x: Ii(i * r) / r || 0, y: Ii(n * r) / r || 0 };
  }
  function Io(e) {
    var t, i = e.popper, n = e.popperRect, r = e.placement, o = e.variation, l = e.offsets, c = e.position, d = e.gpuAcceleration, v = e.adaptive, E = e.roundOffsets, y = e.isFixed, b = l.x, p = b === void 0 ? 0 : b, g = l.y, C = g === void 0 ? 0 : g, _ = typeof E == "function" ? E({ x: p, y: C }) : { x: p, y: C };
    p = _.x, C = _.y;
    var h = l.hasOwnProperty("x"), S = l.hasOwnProperty("y"), w = ke, A = Ne, L = window;
    if (v) {
      var f = Ji(i), P = "clientHeight", D = "clientWidth";
      if (f === Ke(i) && (f = Wt(i), At(f).position !== "static" && c === "absolute" && (P = "scrollHeight", D = "scrollWidth")), f = f, r === Ne || (r === ke || r === Ue) && o === wi) {
        A = qe;
        var R = y && f === L && L.visualViewport ? L.visualViewport.height : f[P];
        C -= R - n.height, C *= d ? 1 : -1;
      }
      if (r === ke || (r === Ne || r === qe) && o === wi) {
        w = Ue;
        var N = y && f === L && L.visualViewport ? L.visualViewport.width : f[D];
        p -= N - n.width, p *= d ? 1 : -1;
      }
    }
    var $ = Object.assign({ position: c }, v && mu), B = E === true ? gu({ x: p, y: C }, Ke(i)) : { x: p, y: C };
    if (p = B.x, C = B.y, d) {
      var V;
      return Object.assign({}, $, (V = {}, V[A] = S ? "0" : "", V[w] = h ? "0" : "", V.transform = (L.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + C + "px)" : "translate3d(" + p + "px, " + C + "px, 0)", V));
    }
    return Object.assign({}, $, (t = {}, t[A] = S ? C + "px" : "", t[w] = h ? p + "px" : "", t.transform = "", t));
  }
  function vu(e) {
    var t = e.state, i = e.options, n = i.gpuAcceleration, r = n === void 0 ? true : n, o = i.adaptive, l = o === void 0 ? true : o, c = i.roundOffsets, d = c === void 0 ? true : c, v = { placement: vt(t.placement), variation: Oi(t.placement), popper: t.elements.popper, popperRect: t.rects.popper, gpuAcceleration: r, isFixed: t.options.strategy === "fixed" };
    t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Io(Object.assign({}, v, { offsets: t.modifiersData.popperOffsets, position: t.options.strategy, adaptive: l, roundOffsets: d })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Io(Object.assign({}, v, { offsets: t.modifiersData.arrow, position: "absolute", adaptive: false, roundOffsets: d })))), t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-placement": t.placement });
  }
  const Za = { name: "computeStyles", enabled: true, phase: "beforeWrite", fn: vu, data: {} };
  var Sn = { passive: true };
  function yu(e) {
    var t = e.state, i = e.instance, n = e.options, r = n.scroll, o = r === void 0 ? true : r, l = n.resize, c = l === void 0 ? true : l, d = Ke(t.elements.popper), v = [].concat(t.scrollParents.reference, t.scrollParents.popper);
    return o && v.forEach(function(E) {
      E.addEventListener("scroll", i.update, Sn);
    }), c && d.addEventListener("resize", i.update, Sn), function() {
      o && v.forEach(function(E) {
        E.removeEventListener("scroll", i.update, Sn);
      }), c && d.removeEventListener("resize", i.update, Sn);
    };
  }
  const Qa = { name: "eventListeners", enabled: true, phase: "write", fn: function() {
  }, effect: yu, data: {} };
  var bu = { left: "right", right: "left", bottom: "top", top: "bottom" };
  function An(e) {
    return e.replace(/left|right|bottom|top/g, function(t) {
      return bu[t];
    });
  }
  var Eu = { start: "end", end: "start" };
  function Ao(e) {
    return e.replace(/start|end/g, function(t) {
      return Eu[t];
    });
  }
  function Er(e) {
    var t = Ke(e), i = t.pageXOffset, n = t.pageYOffset;
    return { scrollLeft: i, scrollTop: n };
  }
  function Sr(e) {
    return Ai(Wt(e)).left + Er(e).scrollLeft;
  }
  function Su(e, t) {
    var i = Ke(e), n = Wt(e), r = i.visualViewport, o = n.clientWidth, l = n.clientHeight, c = 0, d = 0;
    if (r) {
      o = r.width, l = r.height;
      var v = ja();
      (v || !v && t === "fixed") && (c = r.offsetLeft, d = r.offsetTop);
    }
    return { width: o, height: l, x: c + Sr(e), y: d };
  }
  function Tu(e) {
    var t, i = Wt(e), n = Er(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, o = Zt(i.scrollWidth, i.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), l = Zt(i.scrollHeight, i.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), c = -n.scrollLeft + Sr(e), d = -n.scrollTop;
    return At(r || i).direction === "rtl" && (c += Zt(i.clientWidth, r ? r.clientWidth : 0) - o), { width: o, height: l, x: c, y: d };
  }
  function Tr(e) {
    var t = At(e), i = t.overflow, n = t.overflowX, r = t.overflowY;
    return /auto|scroll|overlay|hidden/.test(i + r + n);
  }
  function Ja(e) {
    return ["html", "body", "#document"].indexOf(yt(e)) >= 0 ? e.ownerDocument.body : et(e) && Tr(e) ? e : Ja(jn(e));
  }
  function Ki(e, t) {
    var i;
    t === void 0 && (t = []);
    var n = Ja(e), r = n === ((i = e.ownerDocument) == null ? void 0 : i.body), o = Ke(n), l = r ? [o].concat(o.visualViewport || [], Tr(n) ? n : []) : n, c = t.concat(l);
    return r ? c : c.concat(Ki(jn(l)));
  }
  function ar(e) {
    return Object.assign({}, e, { left: e.x, top: e.y, right: e.x + e.width, bottom: e.y + e.height });
  }
  function _u(e, t) {
    var i = Ai(e, false, t === "fixed");
    return i.top = i.top + e.clientTop, i.left = i.left + e.clientLeft, i.bottom = i.top + e.clientHeight, i.right = i.left + e.clientWidth, i.width = e.clientWidth, i.height = e.clientHeight, i.x = i.left, i.y = i.top, i;
  }
  function Oo(e, t, i) {
    return t === mr ? ar(Su(e, i)) : ti(t) ? _u(t, i) : ar(Tu(Wt(e)));
  }
  function xu(e) {
    var t = Ki(jn(e)), i = ["absolute", "fixed"].indexOf(At(e).position) >= 0, n = i && et(e) ? Ji(e) : e;
    return ti(n) ? t.filter(function(r) {
      return ti(r) && Ya(r, n) && yt(r) !== "body";
    }) : [];
  }
  function Cu(e, t, i, n) {
    var r = t === "clippingParents" ? xu(e) : [].concat(t), o = [].concat(r, [i]), l = o[0], c = o.reduce(function(d, v) {
      var E = Oo(e, v, n);
      return d.top = Zt(E.top, d.top), d.right = Dn(E.right, d.right), d.bottom = Dn(E.bottom, d.bottom), d.left = Zt(E.left, d.left), d;
    }, Oo(e, l, n));
    return c.width = c.right - c.left, c.height = c.bottom - c.top, c.x = c.left, c.y = c.top, c;
  }
  function el(e) {
    var t = e.reference, i = e.element, n = e.placement, r = n ? vt(n) : null, o = n ? Oi(n) : null, l = t.x + t.width / 2 - i.width / 2, c = t.y + t.height / 2 - i.height / 2, d;
    switch (r) {
      case Ne:
        d = { x: l, y: t.y - i.height };
        break;
      case qe:
        d = { x: l, y: t.y + t.height };
        break;
      case Ue:
        d = { x: t.x + t.width, y: c };
        break;
      case ke:
        d = { x: t.x - i.width, y: c };
        break;
      default:
        d = { x: t.x, y: t.y };
    }
    var v = r ? br(r) : null;
    if (v != null) {
      var E = v === "y" ? "height" : "width";
      switch (o) {
        case ei:
          d[v] = d[v] - (t[E] / 2 - i[E] / 2);
          break;
        case wi:
          d[v] = d[v] + (t[E] / 2 - i[E] / 2);
          break;
      }
    }
    return d;
  }
  function Mi(e, t) {
    t === void 0 && (t = {});
    var i = t, n = i.placement, r = n === void 0 ? e.placement : n, o = i.strategy, l = o === void 0 ? e.strategy : o, c = i.boundary, d = c === void 0 ? Pa : c, v = i.rootBoundary, E = v === void 0 ? mr : v, y = i.elementContext, b = y === void 0 ? Ti : y, p = i.altBoundary, g = p === void 0 ? false : p, C = i.padding, _ = C === void 0 ? 0 : C, h = qa(typeof _ != "number" ? _ : Ua(_, zi)), S = b === Ti ? Da : Ti, w = e.rects.popper, A = e.elements[g ? S : b], L = Cu(ti(A) ? A : A.contextElement || Wt(e.elements.popper), d, E, l), f = Ai(e.elements.reference), P = el({ reference: f, element: w, placement: r }), D = ar(Object.assign({}, w, P)), R = b === Ti ? D : f, N = { top: L.top - R.top + h.top, bottom: R.bottom - L.bottom + h.bottom, left: L.left - R.left + h.left, right: R.right - L.right + h.right }, $ = e.modifiersData.offset;
    if (b === Ti && $) {
      var B = $[r];
      Object.keys(N).forEach(function(V) {
        var X = [Ue, qe].indexOf(V) >= 0 ? 1 : -1, Z = [Ne, qe].indexOf(V) >= 0 ? "y" : "x";
        N[V] += B[Z] * X;
      });
    }
    return N;
  }
  function wu(e, t) {
    t === void 0 && (t = {});
    var i = t, n = i.placement, r = i.boundary, o = i.rootBoundary, l = i.padding, c = i.flipVariations, d = i.allowedAutoPlacements, v = d === void 0 ? gr : d, E = Oi(n), y = E ? c ? rr : rr.filter(function(g) {
      return Oi(g) === E;
    }) : zi, b = y.filter(function(g) {
      return v.indexOf(g) >= 0;
    });
    b.length === 0 && (b = y);
    var p = b.reduce(function(g, C) {
      return g[C] = Mi(e, { placement: C, boundary: r, rootBoundary: o, padding: l })[vt(C)], g;
    }, {});
    return Object.keys(p).sort(function(g, C) {
      return p[g] - p[C];
    });
  }
  function Iu(e) {
    if (vt(e) === Gn) return [];
    var t = An(e);
    return [Ao(e), t, Ao(t)];
  }
  function Au(e) {
    var t = e.state, i = e.options, n = e.name;
    if (!t.modifiersData[n]._skip) {
      for (var r = i.mainAxis, o = r === void 0 ? true : r, l = i.altAxis, c = l === void 0 ? true : l, d = i.fallbackPlacements, v = i.padding, E = i.boundary, y = i.rootBoundary, b = i.altBoundary, p = i.flipVariations, g = p === void 0 ? true : p, C = i.allowedAutoPlacements, _ = t.options.placement, h = vt(_), S = h === _, w = d || (S || !g ? [An(_)] : Iu(_)), A = [_].concat(w).reduce(function(U, Q) {
        return U.concat(vt(Q) === Gn ? wu(t, { placement: Q, boundary: E, rootBoundary: y, padding: v, flipVariations: g, allowedAutoPlacements: C }) : Q);
      }, []), L = t.rects.reference, f = t.rects.popper, P = /* @__PURE__ */ new Map(), D = true, R = A[0], N = 0; N < A.length; N++) {
        var $ = A[N], B = vt($), V = Oi($) === ei, X = [Ne, qe].indexOf(B) >= 0, Z = X ? "width" : "height", F = Mi(t, { placement: $, boundary: E, rootBoundary: y, altBoundary: b, padding: v }), W = X ? V ? Ue : ke : V ? qe : Ne;
        L[Z] > f[Z] && (W = An(W));
        var Y = An(W), J = [];
        if (o && J.push(F[B] <= 0), c && J.push(F[W] <= 0, F[Y] <= 0), J.every(function(U) {
          return U;
        })) {
          R = $, D = false;
          break;
        }
        P.set($, J);
      }
      if (D) for (var oe = g ? 3 : 1, he = function(Q) {
        var ee = A.find(function(K) {
          var se = P.get(K);
          if (se) return se.slice(0, Q).every(function(Se) {
            return Se;
          });
        });
        if (ee) return R = ee, "break";
      }, _e = oe; _e > 0; _e--) {
        var Ee = he(_e);
        if (Ee === "break") break;
      }
      t.placement !== R && (t.modifiersData[n]._skip = true, t.placement = R, t.reset = true);
    }
  }
  const tl = { name: "flip", enabled: true, phase: "main", fn: Au, requiresIfExists: ["offset"], data: { _skip: false } };
  function Mo(e, t, i) {
    return i === void 0 && (i = { x: 0, y: 0 }), { top: e.top - t.height - i.y, right: e.right - t.width + i.x, bottom: e.bottom - t.height + i.y, left: e.left - t.width - i.x };
  }
  function Lo(e) {
    return [Ne, Ue, qe, ke].some(function(t) {
      return e[t] >= 0;
    });
  }
  function Ou(e) {
    var t = e.state, i = e.name, n = t.rects.reference, r = t.rects.popper, o = t.modifiersData.preventOverflow, l = Mi(t, { elementContext: "reference" }), c = Mi(t, { altBoundary: true }), d = Mo(l, n), v = Mo(c, r, o), E = Lo(d), y = Lo(v);
    t.modifiersData[i] = { referenceClippingOffsets: d, popperEscapeOffsets: v, isReferenceHidden: E, hasPopperEscaped: y }, t.attributes.popper = Object.assign({}, t.attributes.popper, { "data-popper-reference-hidden": E, "data-popper-escaped": y });
  }
  const il = { name: "hide", enabled: true, phase: "main", requiresIfExists: ["preventOverflow"], fn: Ou };
  function Mu(e, t, i) {
    var n = vt(e), r = [ke, Ne].indexOf(n) >= 0 ? -1 : 1, o = typeof i == "function" ? i(Object.assign({}, t, { placement: e })) : i, l = o[0], c = o[1];
    return l = l || 0, c = (c || 0) * r, [ke, Ue].indexOf(n) >= 0 ? { x: c, y: l } : { x: l, y: c };
  }
  function Lu(e) {
    var t = e.state, i = e.options, n = e.name, r = i.offset, o = r === void 0 ? [0, 0] : r, l = gr.reduce(function(E, y) {
      return E[y] = Mu(y, t.rects, o), E;
    }, {}), c = l[t.placement], d = c.x, v = c.y;
    t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += d, t.modifiersData.popperOffsets.y += v), t.modifiersData[n] = l;
  }
  const nl = { name: "offset", enabled: true, phase: "main", requires: ["popperOffsets"], fn: Lu };
  function Pu(e) {
    var t = e.state, i = e.name;
    t.modifiersData[i] = el({ reference: t.rects.reference, element: t.rects.popper, placement: t.placement });
  }
  const sl = { name: "popperOffsets", enabled: true, phase: "read", fn: Pu, data: {} };
  function Du(e) {
    return e === "x" ? "y" : "x";
  }
  function zu(e) {
    var t = e.state, i = e.options, n = e.name, r = i.mainAxis, o = r === void 0 ? true : r, l = i.altAxis, c = l === void 0 ? false : l, d = i.boundary, v = i.rootBoundary, E = i.altBoundary, y = i.padding, b = i.tether, p = b === void 0 ? true : b, g = i.tetherOffset, C = g === void 0 ? 0 : g, _ = Mi(t, { boundary: d, rootBoundary: v, padding: y, altBoundary: E }), h = vt(t.placement), S = Oi(t.placement), w = !S, A = br(h), L = Du(A), f = t.modifiersData.popperOffsets, P = t.rects.reference, D = t.rects.popper, R = typeof C == "function" ? C(Object.assign({}, t.rects, { placement: t.placement })) : C, N = typeof R == "number" ? { mainAxis: R, altAxis: R } : Object.assign({ mainAxis: 0, altAxis: 0 }, R), $ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, B = { x: 0, y: 0 };
    if (f) {
      if (o) {
        var V, X = A === "y" ? Ne : ke, Z = A === "y" ? qe : Ue, F = A === "y" ? "height" : "width", W = f[A], Y = W + _[X], J = W - _[Z], oe = p ? -D[F] / 2 : 0, he = S === ei ? P[F] : D[F], _e = S === ei ? -D[F] : -P[F], Ee = t.elements.arrow, U = p && Ee ? yr(Ee) : { width: 0, height: 0 }, Q = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Xa(), ee = Q[X], K = Q[Z], se = Ui(0, P[F], U[F]), Se = w ? P[F] / 2 - oe - se - ee - N.mainAxis : he - se - ee - N.mainAxis, Ge = w ? -P[F] / 2 + oe + se + K + N.mainAxis : _e + se + K + N.mainAxis, Ce = t.elements.arrow && Ji(t.elements.arrow), Ze = Ce ? A === "y" ? Ce.clientTop || 0 : Ce.clientLeft || 0 : 0, ge = (V = $ == null ? void 0 : $[A]) != null ? V : 0, be = W + Se - ge - Ze, Oe = W + Ge - ge, Et = Ui(p ? Dn(Y, be) : Y, W, p ? Zt(J, Oe) : J);
        f[A] = Et, B[A] = Et - W;
      }
      if (c) {
        var st, dt = A === "x" ? Ne : ke, Lt = A === "x" ? qe : Ue, De = f[L], ft = L === "y" ? "height" : "width", je = De + _[dt], rt = De - _[Lt], Te = [Ne, ke].indexOf(h) !== -1, St = (st = $ == null ? void 0 : $[L]) != null ? st : 0, we = Te ? je : De - P[ft] - D[ft] - St + N.altAxis, $e = Te ? De + P[ft] + D[ft] - St - N.altAxis : rt, ht = p && Te ? du(we, De, $e) : Ui(p ? we : je, De, p ? $e : rt);
        f[L] = ht, B[L] = ht - De;
      }
      t.modifiersData[n] = B;
    }
  }
  const rl = { name: "preventOverflow", enabled: true, phase: "main", fn: zu, requiresIfExists: ["offset"] };
  function $u(e) {
    return { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop };
  }
  function Nu(e) {
    return e === Ke(e) || !et(e) ? Er(e) : $u(e);
  }
  function ku(e) {
    var t = e.getBoundingClientRect(), i = Ii(t.width) / e.offsetWidth || 1, n = Ii(t.height) / e.offsetHeight || 1;
    return i !== 1 || n !== 1;
  }
  function Ru(e, t, i) {
    i === void 0 && (i = false);
    var n = et(t), r = et(t) && ku(t), o = Wt(t), l = Ai(e, r, i), c = { scrollLeft: 0, scrollTop: 0 }, d = { x: 0, y: 0 };
    return (n || !n && !i) && ((yt(t) !== "body" || Tr(o)) && (c = Nu(t)), et(t) ? (d = Ai(t, true), d.x += t.clientLeft, d.y += t.clientTop) : o && (d.x = Sr(o))), { x: l.left + c.scrollLeft - d.x, y: l.top + c.scrollTop - d.y, width: l.width, height: l.height };
  }
  function Hu(e) {
    var t = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), n = [];
    e.forEach(function(o) {
      t.set(o.name, o);
    });
    function r(o) {
      i.add(o.name);
      var l = [].concat(o.requires || [], o.requiresIfExists || []);
      l.forEach(function(c) {
        if (!i.has(c)) {
          var d = t.get(c);
          d && r(d);
        }
      }), n.push(o);
    }
    return e.forEach(function(o) {
      i.has(o.name) || r(o);
    }), n;
  }
  function Bu(e) {
    var t = Hu(e);
    return Fa.reduce(function(i, n) {
      return i.concat(t.filter(function(r) {
        return r.phase === n;
      }));
    }, []);
  }
  function Vu(e) {
    var t;
    return function() {
      return t || (t = new Promise(function(i) {
        Promise.resolve().then(function() {
          t = void 0, i(e());
        });
      })), t;
    };
  }
  function Wu(e) {
    var t = e.reduce(function(i, n) {
      var r = i[n.name];
      return i[n.name] = r ? Object.assign({}, r, n, { options: Object.assign({}, r.options, n.options), data: Object.assign({}, r.data, n.data) }) : n, i;
    }, {});
    return Object.keys(t).map(function(i) {
      return t[i];
    });
  }
  var Po = { placement: "bottom", modifiers: [], strategy: "absolute" };
  function Do() {
    for (var e = arguments.length, t = new Array(e), i = 0; i < e; i++) t[i] = arguments[i];
    return !t.some(function(n) {
      return !(n && typeof n.getBoundingClientRect == "function");
    });
  }
  function ol(e) {
    e === void 0 && (e = {});
    var t = e, i = t.defaultModifiers, n = i === void 0 ? [] : i, r = t.defaultOptions, o = r === void 0 ? Po : r;
    return function(c, d, v) {
      v === void 0 && (v = o);
      var E = { placement: "bottom", orderedModifiers: [], options: Object.assign({}, Po, o), modifiersData: {}, elements: { reference: c, popper: d }, attributes: {}, styles: {} }, y = [], b = false, p = { state: E, setOptions: function(h) {
        var S = typeof h == "function" ? h(E.options) : h;
        C(), E.options = Object.assign({}, o, E.options, S), E.scrollParents = { reference: ti(c) ? Ki(c) : c.contextElement ? Ki(c.contextElement) : [], popper: Ki(d) };
        var w = Bu(Wu([].concat(n, E.options.modifiers)));
        return E.orderedModifiers = w.filter(function(A) {
          return A.enabled;
        }), g(), p.update();
      }, forceUpdate: function() {
        if (!b) {
          var h = E.elements, S = h.reference, w = h.popper;
          if (Do(S, w)) {
            E.rects = { reference: Ru(S, Ji(w), E.options.strategy === "fixed"), popper: yr(w) }, E.reset = false, E.placement = E.options.placement, E.orderedModifiers.forEach(function(N) {
              return E.modifiersData[N.name] = Object.assign({}, N.data);
            });
            for (var A = 0; A < E.orderedModifiers.length; A++) {
              if (E.reset === true) {
                E.reset = false, A = -1;
                continue;
              }
              var L = E.orderedModifiers[A], f = L.fn, P = L.options, D = P === void 0 ? {} : P, R = L.name;
              typeof f == "function" && (E = f({ state: E, options: D, name: R, instance: p }) || E);
            }
          }
        }
      }, update: Vu(function() {
        return new Promise(function(_) {
          p.forceUpdate(), _(E);
        });
      }), destroy: function() {
        C(), b = true;
      } };
      if (!Do(c, d)) return p;
      p.setOptions(v).then(function(_) {
        !b && v.onFirstUpdate && v.onFirstUpdate(_);
      });
      function g() {
        E.orderedModifiers.forEach(function(_) {
          var h = _.name, S = _.options, w = S === void 0 ? {} : S, A = _.effect;
          if (typeof A == "function") {
            var L = A({ state: E, name: h, instance: p, options: w }), f = function() {
            };
            y.push(L || f);
          }
        });
      }
      function C() {
        y.forEach(function(_) {
          return _();
        }), y = [];
      }
      return p;
    };
  }
  var Fu = [Qa, sl, Za, Ga, nl, tl, rl, Ka, il], _r = ol({ defaultModifiers: Fu });
  const al = Object.freeze(Object.defineProperty({ __proto__: null, afterMain: Ha, afterRead: Na, afterWrite: Wa, applyStyles: Ga, arrow: Ka, auto: Gn, basePlacements: zi, beforeMain: ka, beforeRead: za, beforeWrite: Ba, bottom: qe, clippingParents: Pa, computeStyles: Za, createPopper: _r, detectOverflow: Mi, end: wi, eventListeners: Qa, flip: tl, hide: il, left: ke, main: Ra, modifierPhases: Fa, offset: nl, placements: gr, popper: Ti, popperGenerator: ol, popperOffsets: sl, preventOverflow: rl, read: $a, reference: Da, right: Ue, start: ei, top: Ne, variationPlacements: rr, viewport: mr, write: Va }, Symbol.toStringTag, { value: "Module" }));
  const $t = /* @__PURE__ */ new Map(), Ts = { set(e, t, i) {
    $t.has(e) || $t.set(e, /* @__PURE__ */ new Map());
    const n = $t.get(e);
    if (!n.has(t) && n.size !== 0) {
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(n.keys())[0]}.`);
      return;
    }
    n.set(t, i);
  }, get(e, t) {
    return $t.has(e) && $t.get(e).get(t) || null;
  }, remove(e, t) {
    if (!$t.has(e)) return;
    const i = $t.get(e);
    i.delete(t), i.size === 0 && $t.delete(e);
  } }, Gu = 1e6, ju = 1e3, lr = "transitionend", ll = (e) => (e && window.CSS && window.CSS.escape && (e = e.replace(/#([^\s"#']+)/g, (t, i) => `#${CSS.escape(i)}`)), e), Yu = (e) => e == null ? `${e}` : Object.prototype.toString.call(e).match(/\s([a-z]+)/i)[1].toLowerCase(), Xu = (e) => {
    do
      e += Math.floor(Math.random() * Gu);
    while (document.getElementById(e));
    return e;
  }, qu = (e) => {
    if (!e) return 0;
    let { transitionDuration: t, transitionDelay: i } = window.getComputedStyle(e);
    const n = Number.parseFloat(t), r = Number.parseFloat(i);
    return !n && !r ? 0 : (t = t.split(",")[0], i = i.split(",")[0], (Number.parseFloat(t) + Number.parseFloat(i)) * ju);
  }, cl = (e) => {
    e.dispatchEvent(new Event(lr));
  }, wt = (e) => !e || typeof e != "object" ? false : (typeof e.jquery != "undefined" && (e = e[0]), typeof e.nodeType != "undefined"), Bt = (e) => wt(e) ? e.jquery ? e[0] : e : typeof e == "string" && e.length > 0 ? document.querySelector(ll(e)) : null, $i = (e) => {
    if (!wt(e) || e.getClientRects().length === 0) return false;
    const t = getComputedStyle(e).getPropertyValue("visibility") === "visible", i = e.closest("details:not([open])");
    if (!i) return t;
    if (i !== e) {
      const n = e.closest("summary");
      if (n && n.parentNode !== i || n === null) return false;
    }
    return t;
  }, Vt = (e) => !e || e.nodeType !== Node.ELEMENT_NODE || e.classList.contains("disabled") ? true : typeof e.disabled != "undefined" ? e.disabled : e.hasAttribute("disabled") && e.getAttribute("disabled") !== "false", ul = (e) => {
    if (!document.documentElement.attachShadow) return null;
    if (typeof e.getRootNode == "function") {
      const t = e.getRootNode();
      return t instanceof ShadowRoot ? t : null;
    }
    return e instanceof ShadowRoot ? e : e.parentNode ? ul(e.parentNode) : null;
  }, zn = () => {
  }, en = (e) => {
    e.offsetHeight;
  }, dl = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, _s = [], Uu = (e) => {
    document.readyState === "loading" ? (_s.length || document.addEventListener("DOMContentLoaded", () => {
      for (const t of _s) t();
    }), _s.push(e)) : e();
  }, tt = () => document.documentElement.dir === "rtl", nt = (e) => {
    Uu(() => {
      const t = dl();
      if (t) {
        const i = e.NAME, n = t.fn[i];
        t.fn[i] = e.jQueryInterface, t.fn[i].Constructor = e, t.fn[i].noConflict = () => (t.fn[i] = n, e.jQueryInterface);
      }
    });
  }, Fe = (e, t = [], i = e) => typeof e == "function" ? e.call(...t) : i, fl = (e, t, i = true) => {
    if (!i) {
      Fe(e);
      return;
    }
    const r = qu(t) + 5;
    let o = false;
    const l = ({ target: c }) => {
      c === t && (o = true, t.removeEventListener(lr, l), Fe(e));
    };
    t.addEventListener(lr, l), setTimeout(() => {
      o || cl(t);
    }, r);
  }, xr = (e, t, i, n) => {
    const r = e.length;
    let o = e.indexOf(t);
    return o === -1 ? !i && n ? e[r - 1] : e[0] : (o += i ? 1 : -1, n && (o = (o + r) % r), e[Math.max(0, Math.min(o, r - 1))]);
  }, Ku = /[^.]*(?=\..*)\.|.*/, Zu = /\..*/, Qu = /::\d+$/, xs = {};
  let zo = 1;
  const hl = { mouseenter: "mouseover", mouseleave: "mouseout" }, Ju = /* @__PURE__ */ new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);
  function pl(e, t) {
    return t && `${t}::${zo++}` || e.uidEvent || zo++;
  }
  function ml(e) {
    const t = pl(e);
    return e.uidEvent = t, xs[t] = xs[t] || {}, xs[t];
  }
  function ed(e, t) {
    return function i(n) {
      return Cr(n, { delegateTarget: e }), i.oneOff && q.off(e, n.type, t), t.apply(e, [n]);
    };
  }
  function td(e, t, i) {
    return function n(r) {
      const o = e.querySelectorAll(t);
      for (let { target: l } = r; l && l !== this; l = l.parentNode) for (const c of o) if (c === l) return Cr(r, { delegateTarget: l }), n.oneOff && q.off(e, r.type, t, i), i.apply(l, [r]);
    };
  }
  function gl(e, t, i = null) {
    return Object.values(e).find((n) => n.callable === t && n.delegationSelector === i);
  }
  function vl(e, t, i) {
    const n = typeof t == "string", r = n ? i : t || i;
    let o = yl(e);
    return Ju.has(o) || (o = e), [n, r, o];
  }
  function $o(e, t, i, n, r) {
    if (typeof t != "string" || !e) return;
    let [o, l, c] = vl(t, i, n);
    t in hl && (l = /* @__PURE__ */ ((g) => function(C) {
      if (!C.relatedTarget || C.relatedTarget !== C.delegateTarget && !C.delegateTarget.contains(C.relatedTarget)) return g.call(this, C);
    })(l));
    const d = ml(e), v = d[c] || (d[c] = {}), E = gl(v, l, o ? i : null);
    if (E) {
      E.oneOff = E.oneOff && r;
      return;
    }
    const y = pl(l, t.replace(Ku, "")), b = o ? td(e, i, l) : ed(e, l);
    b.delegationSelector = o ? i : null, b.callable = l, b.oneOff = r, b.uidEvent = y, v[y] = b, e.addEventListener(c, b, o);
  }
  function cr(e, t, i, n, r) {
    const o = gl(t[i], n, r);
    o && (e.removeEventListener(i, o, !!r), delete t[i][o.uidEvent]);
  }
  function id(e, t, i, n) {
    const r = t[i] || {};
    for (const [o, l] of Object.entries(r)) o.includes(n) && cr(e, t, i, l.callable, l.delegationSelector);
  }
  function yl(e) {
    return e = e.replace(Zu, ""), hl[e] || e;
  }
  const q = { on(e, t, i, n) {
    $o(e, t, i, n, false);
  }, one(e, t, i, n) {
    $o(e, t, i, n, true);
  }, off(e, t, i, n) {
    if (typeof t != "string" || !e) return;
    const [r, o, l] = vl(t, i, n), c = l !== t, d = ml(e), v = d[l] || {}, E = t.startsWith(".");
    if (typeof o != "undefined") {
      if (!Object.keys(v).length) return;
      cr(e, d, l, o, r ? i : null);
      return;
    }
    if (E) for (const y of Object.keys(d)) id(e, d, y, t.slice(1));
    for (const [y, b] of Object.entries(v)) {
      const p = y.replace(Qu, "");
      (!c || t.includes(p)) && cr(e, d, l, b.callable, b.delegationSelector);
    }
  }, trigger(e, t, i) {
    if (typeof t != "string" || !e) return null;
    const n = dl(), r = yl(t), o = t !== r;
    let l = null, c = true, d = true, v = false;
    o && n && (l = n.Event(t, i), n(e).trigger(l), c = !l.isPropagationStopped(), d = !l.isImmediatePropagationStopped(), v = l.isDefaultPrevented());
    const E = Cr(new Event(t, { bubbles: c, cancelable: true }), i);
    return v && E.preventDefault(), d && e.dispatchEvent(E), E.defaultPrevented && l && l.preventDefault(), E;
  } };
  function Cr(e, t = {}) {
    for (const [i, n] of Object.entries(t)) try {
      e[i] = n;
    } catch (r) {
      Object.defineProperty(e, i, { configurable: true, get() {
        return n;
      } });
    }
    return e;
  }
  function No(e) {
    if (e === "true") return true;
    if (e === "false") return false;
    if (e === Number(e).toString()) return Number(e);
    if (e === "" || e === "null") return null;
    if (typeof e != "string") return e;
    try {
      return JSON.parse(decodeURIComponent(e));
    } catch (t) {
      return e;
    }
  }
  function Cs(e) {
    return e.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`);
  }
  const It = { setDataAttribute(e, t, i) {
    e.setAttribute(`data-bs-${Cs(t)}`, i);
  }, removeDataAttribute(e, t) {
    e.removeAttribute(`data-bs-${Cs(t)}`);
  }, getDataAttributes(e) {
    if (!e) return {};
    const t = {}, i = Object.keys(e.dataset).filter((n) => n.startsWith("bs") && !n.startsWith("bsConfig"));
    for (const n of i) {
      let r = n.replace(/^bs/, "");
      r = r.charAt(0).toLowerCase() + r.slice(1), t[r] = No(e.dataset[n]);
    }
    return t;
  }, getDataAttribute(e, t) {
    return No(e.getAttribute(`data-bs-${Cs(t)}`));
  } };
  class tn {
    static get Default() {
      return {};
    }
    static get DefaultType() {
      return {};
    }
    static get NAME() {
      throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(t) {
      return t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
    }
    _configAfterMerge(t) {
      return t;
    }
    _mergeConfigObj(t, i) {
      const n = wt(i) ? It.getDataAttribute(i, "config") : {};
      return Ie(Ie(Ie(Ie({}, this.constructor.Default), typeof n == "object" ? n : {}), wt(i) ? It.getDataAttributes(i) : {}), typeof t == "object" ? t : {});
    }
    _typeCheckConfig(t, i = this.constructor.DefaultType) {
      for (const [n, r] of Object.entries(i)) {
        const o = t[n], l = wt(o) ? "element" : Yu(o);
        if (!new RegExp(r).test(l)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${n}" provided type "${l}" but expected type "${r}".`);
      }
    }
  }
  const nd = "5.3.8";
  class ut extends tn {
    constructor(t, i) {
      super(), t = Bt(t), t && (this._element = t, this._config = this._getConfig(i), Ts.set(this._element, this.constructor.DATA_KEY, this));
    }
    dispose() {
      Ts.remove(this._element, this.constructor.DATA_KEY), q.off(this._element, this.constructor.EVENT_KEY);
      for (const t of Object.getOwnPropertyNames(this)) this[t] = null;
    }
    _queueCallback(t, i, n = true) {
      fl(t, i, n);
    }
    _getConfig(t) {
      return t = this._mergeConfigObj(t, this._element), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
    }
    static getInstance(t) {
      return Ts.get(Bt(t), this.DATA_KEY);
    }
    static getOrCreateInstance(t, i = {}) {
      return this.getInstance(t) || new this(t, typeof i == "object" ? i : null);
    }
    static get VERSION() {
      return nd;
    }
    static get DATA_KEY() {
      return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
      return `.${this.DATA_KEY}`;
    }
    static eventName(t) {
      return `${t}${this.EVENT_KEY}`;
    }
  }
  const ws = (e) => {
    let t = e.getAttribute("data-bs-target");
    if (!t || t === "#") {
      let i = e.getAttribute("href");
      if (!i || !i.includes("#") && !i.startsWith(".")) return null;
      i.includes("#") && !i.startsWith("#") && (i = `#${i.split("#")[1]}`), t = i && i !== "#" ? i.trim() : null;
    }
    return t ? t.split(",").map((i) => ll(i)).join(",") : null;
  }, ne = { find(e, t = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(t, e));
  }, findOne(e, t = document.documentElement) {
    return Element.prototype.querySelector.call(t, e);
  }, children(e, t) {
    return [].concat(...e.children).filter((i) => i.matches(t));
  }, parents(e, t) {
    const i = [];
    let n = e.parentNode.closest(t);
    for (; n; ) i.push(n), n = n.parentNode.closest(t);
    return i;
  }, prev(e, t) {
    let i = e.previousElementSibling;
    for (; i; ) {
      if (i.matches(t)) return [i];
      i = i.previousElementSibling;
    }
    return [];
  }, next(e, t) {
    let i = e.nextElementSibling;
    for (; i; ) {
      if (i.matches(t)) return [i];
      i = i.nextElementSibling;
    }
    return [];
  }, focusableChildren(e) {
    const t = ["a", "button", "input", "textarea", "select", "details", "[tabindex]", '[contenteditable="true"]'].map((i) => `${i}:not([tabindex^="-"])`).join(",");
    return this.find(t, e).filter((i) => !Vt(i) && $i(i));
  }, getSelectorFromElement(e) {
    const t = ws(e);
    return t && ne.findOne(t) ? t : null;
  }, getElementFromSelector(e) {
    const t = ws(e);
    return t ? ne.findOne(t) : null;
  }, getMultipleElementsFromSelector(e) {
    const t = ws(e);
    return t ? ne.find(t) : [];
  } }, Yn = (e, t = "hide") => {
    const i = `click.dismiss${e.EVENT_KEY}`, n = e.NAME;
    q.on(document, i, `[data-bs-dismiss="${n}"]`, function(r) {
      if (["A", "AREA"].includes(this.tagName) && r.preventDefault(), Vt(this)) return;
      const o = ne.getElementFromSelector(this) || this.closest(`.${n}`);
      e.getOrCreateInstance(o)[t]();
    });
  }, sd = "alert", rd = "bs.alert", bl = `.${rd}`, od = `close${bl}`, ad = `closed${bl}`, ld = "fade", cd = "show";
  class Xn extends ut {
    static get NAME() {
      return sd;
    }
    close() {
      if (q.trigger(this._element, od).defaultPrevented) return;
      this._element.classList.remove(cd);
      const i = this._element.classList.contains(ld);
      this._queueCallback(() => this._destroyElement(), this._element, i);
    }
    _destroyElement() {
      this._element.remove(), q.trigger(this._element, ad), this.dispose();
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = Xn.getOrCreateInstance(this);
        if (typeof t == "string") {
          if (i[t] === void 0 || t.startsWith("_") || t === "constructor") throw new TypeError(`No method named "${t}"`);
          i[t](this);
        }
      });
    }
  }
  Yn(Xn, "close");
  nt(Xn);
  const ud = "button", dd = "bs.button", fd = `.${dd}`, hd = ".data-api", pd = "active", ko = '[data-bs-toggle="button"]', md = `click${fd}${hd}`;
  class qn extends ut {
    static get NAME() {
      return ud;
    }
    toggle() {
      this._element.setAttribute("aria-pressed", this._element.classList.toggle(pd));
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = qn.getOrCreateInstance(this);
        t === "toggle" && i[t]();
      });
    }
  }
  q.on(document, md, ko, (e) => {
    e.preventDefault();
    const t = e.target.closest(ko);
    qn.getOrCreateInstance(t).toggle();
  });
  nt(qn);
  const gd = "swipe", Ni = ".bs.swipe", vd = `touchstart${Ni}`, yd = `touchmove${Ni}`, bd = `touchend${Ni}`, Ed = `pointerdown${Ni}`, Sd = `pointerup${Ni}`, Td = "touch", _d = "pen", xd = "pointer-event", Cd = 40, wd = { endCallback: null, leftCallback: null, rightCallback: null }, Id = { endCallback: "(function|null)", leftCallback: "(function|null)", rightCallback: "(function|null)" };
  class $n extends tn {
    constructor(t, i) {
      super(), this._element = t, !(!t || !$n.isSupported()) && (this._config = this._getConfig(i), this._deltaX = 0, this._supportPointerEvents = !!window.PointerEvent, this._initEvents());
    }
    static get Default() {
      return wd;
    }
    static get DefaultType() {
      return Id;
    }
    static get NAME() {
      return gd;
    }
    dispose() {
      q.off(this._element, Ni);
    }
    _start(t) {
      if (!this._supportPointerEvents) {
        this._deltaX = t.touches[0].clientX;
        return;
      }
      this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX);
    }
    _end(t) {
      this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX - this._deltaX), this._handleSwipe(), Fe(this._config.endCallback);
    }
    _move(t) {
      this._deltaX = t.touches && t.touches.length > 1 ? 0 : t.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
      const t = Math.abs(this._deltaX);
      if (t <= Cd) return;
      const i = t / this._deltaX;
      this._deltaX = 0, i && Fe(i > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
      this._supportPointerEvents ? (q.on(this._element, Ed, (t) => this._start(t)), q.on(this._element, Sd, (t) => this._end(t)), this._element.classList.add(xd)) : (q.on(this._element, vd, (t) => this._start(t)), q.on(this._element, yd, (t) => this._move(t)), q.on(this._element, bd, (t) => this._end(t)));
    }
    _eventIsPointerPenTouch(t) {
      return this._supportPointerEvents && (t.pointerType === _d || t.pointerType === Td);
    }
    static isSupported() {
      return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
  }
  const Ad = "carousel", Od = "bs.carousel", Ft = `.${Od}`, El = ".data-api", Md = "ArrowLeft", Ld = "ArrowRight", Pd = 500, Gi = "next", Ei = "prev", _i = "left", On = "right", Dd = `slide${Ft}`, Is = `slid${Ft}`, zd = `keydown${Ft}`, $d = `mouseenter${Ft}`, Nd = `mouseleave${Ft}`, kd = `dragstart${Ft}`, Rd = `load${Ft}${El}`, Hd = `click${Ft}${El}`, Sl = "carousel", Tn = "active", Bd = "slide", Vd = "carousel-item-end", Wd = "carousel-item-start", Fd = "carousel-item-next", Gd = "carousel-item-prev", Tl = ".active", _l = ".carousel-item", jd = Tl + _l, Yd = ".carousel-item img", Xd = ".carousel-indicators", qd = "[data-bs-slide], [data-bs-slide-to]", Ud = '[data-bs-ride="carousel"]', Kd = { [Md]: On, [Ld]: _i }, Zd = { interval: 5e3, keyboard: true, pause: "hover", ride: false, touch: true, wrap: true }, Qd = { interval: "(number|boolean)", keyboard: "boolean", pause: "(string|boolean)", ride: "(boolean|string)", touch: "boolean", wrap: "boolean" };
  class nn extends ut {
    constructor(t, i) {
      super(t, i), this._interval = null, this._activeElement = null, this._isSliding = false, this.touchTimeout = null, this._swipeHelper = null, this._indicatorsElement = ne.findOne(Xd, this._element), this._addEventListeners(), this._config.ride === Sl && this.cycle();
    }
    static get Default() {
      return Zd;
    }
    static get DefaultType() {
      return Qd;
    }
    static get NAME() {
      return Ad;
    }
    next() {
      this._slide(Gi);
    }
    nextWhenVisible() {
      !document.hidden && $i(this._element) && this.next();
    }
    prev() {
      this._slide(Ei);
    }
    pause() {
      this._isSliding && cl(this._element), this._clearInterval();
    }
    cycle() {
      this._clearInterval(), this._updateInterval(), this._interval = setInterval(() => this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
      if (this._config.ride) {
        if (this._isSliding) {
          q.one(this._element, Is, () => this.cycle());
          return;
        }
        this.cycle();
      }
    }
    to(t) {
      const i = this._getItems();
      if (t > i.length - 1 || t < 0) return;
      if (this._isSliding) {
        q.one(this._element, Is, () => this.to(t));
        return;
      }
      const n = this._getItemIndex(this._getActive());
      if (n === t) return;
      const r = t > n ? Gi : Ei;
      this._slide(r, i[t]);
    }
    dispose() {
      this._swipeHelper && this._swipeHelper.dispose(), super.dispose();
    }
    _configAfterMerge(t) {
      return t.defaultInterval = t.interval, t;
    }
    _addEventListeners() {
      this._config.keyboard && q.on(this._element, zd, (t) => this._keydown(t)), this._config.pause === "hover" && (q.on(this._element, $d, () => this.pause()), q.on(this._element, Nd, () => this._maybeEnableCycle())), this._config.touch && $n.isSupported() && this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
      for (const n of ne.find(Yd, this._element)) q.on(n, kd, (r) => r.preventDefault());
      const i = { leftCallback: () => this._slide(this._directionToOrder(_i)), rightCallback: () => this._slide(this._directionToOrder(On)), endCallback: () => {
        this._config.pause === "hover" && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout(() => this._maybeEnableCycle(), Pd + this._config.interval));
      } };
      this._swipeHelper = new $n(this._element, i);
    }
    _keydown(t) {
      if (/input|textarea/i.test(t.target.tagName)) return;
      const i = Kd[t.key];
      i && (t.preventDefault(), this._slide(this._directionToOrder(i)));
    }
    _getItemIndex(t) {
      return this._getItems().indexOf(t);
    }
    _setActiveIndicatorElement(t) {
      if (!this._indicatorsElement) return;
      const i = ne.findOne(Tl, this._indicatorsElement);
      i.classList.remove(Tn), i.removeAttribute("aria-current");
      const n = ne.findOne(`[data-bs-slide-to="${t}"]`, this._indicatorsElement);
      n && (n.classList.add(Tn), n.setAttribute("aria-current", "true"));
    }
    _updateInterval() {
      const t = this._activeElement || this._getActive();
      if (!t) return;
      const i = Number.parseInt(t.getAttribute("data-bs-interval"), 10);
      this._config.interval = i || this._config.defaultInterval;
    }
    _slide(t, i = null) {
      if (this._isSliding) return;
      const n = this._getActive(), r = t === Gi, o = i || xr(this._getItems(), n, r, this._config.wrap);
      if (o === n) return;
      const l = this._getItemIndex(o), c = (p) => q.trigger(this._element, p, { relatedTarget: o, direction: this._orderToDirection(t), from: this._getItemIndex(n), to: l });
      if (c(Dd).defaultPrevented || !n || !o) return;
      const v = !!this._interval;
      this.pause(), this._isSliding = true, this._setActiveIndicatorElement(l), this._activeElement = o;
      const E = r ? Wd : Vd, y = r ? Fd : Gd;
      o.classList.add(y), en(o), n.classList.add(E), o.classList.add(E);
      const b = () => {
        o.classList.remove(E, y), o.classList.add(Tn), n.classList.remove(Tn, y, E), this._isSliding = false, c(Is);
      };
      this._queueCallback(b, n, this._isAnimated()), v && this.cycle();
    }
    _isAnimated() {
      return this._element.classList.contains(Bd);
    }
    _getActive() {
      return ne.findOne(jd, this._element);
    }
    _getItems() {
      return ne.find(_l, this._element);
    }
    _clearInterval() {
      this._interval && (clearInterval(this._interval), this._interval = null);
    }
    _directionToOrder(t) {
      return tt() ? t === _i ? Ei : Gi : t === _i ? Gi : Ei;
    }
    _orderToDirection(t) {
      return tt() ? t === Ei ? _i : On : t === Ei ? On : _i;
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = nn.getOrCreateInstance(this, t);
        if (typeof t == "number") {
          i.to(t);
          return;
        }
        if (typeof t == "string") {
          if (i[t] === void 0 || t.startsWith("_") || t === "constructor") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
  }
  q.on(document, Hd, qd, function(e) {
    const t = ne.getElementFromSelector(this);
    if (!t || !t.classList.contains(Sl)) return;
    e.preventDefault();
    const i = nn.getOrCreateInstance(t), n = this.getAttribute("data-bs-slide-to");
    if (n) {
      i.to(n), i._maybeEnableCycle();
      return;
    }
    if (It.getDataAttribute(this, "slide") === "next") {
      i.next(), i._maybeEnableCycle();
      return;
    }
    i.prev(), i._maybeEnableCycle();
  });
  q.on(window, Rd, () => {
    const e = ne.find(Ud);
    for (const t of e) nn.getOrCreateInstance(t);
  });
  nt(nn);
  const Jd = "collapse", ef = "bs.collapse", sn = `.${ef}`, tf = ".data-api", nf = `show${sn}`, sf = `shown${sn}`, rf = `hide${sn}`, of = `hidden${sn}`, af = `click${sn}${tf}`, As = "show", Ci = "collapse", _n = "collapsing", lf = "collapsed", cf = `:scope .${Ci} .${Ci}`, uf = "collapse-horizontal", df = "width", ff = "height", hf = ".collapse.show, .collapse.collapsing", ur = '[data-bs-toggle="collapse"]', pf = { parent: null, toggle: true }, mf = { parent: "(null|element)", toggle: "boolean" };
  class Li extends ut {
    constructor(t, i) {
      super(t, i), this._isTransitioning = false, this._triggerArray = [];
      const n = ne.find(ur);
      for (const r of n) {
        const o = ne.getSelectorFromElement(r), l = ne.find(o).filter((c) => c === this._element);
        o !== null && l.length && this._triggerArray.push(r);
      }
      this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
    }
    static get Default() {
      return pf;
    }
    static get DefaultType() {
      return mf;
    }
    static get NAME() {
      return Jd;
    }
    toggle() {
      this._isShown() ? this.hide() : this.show();
    }
    show() {
      if (this._isTransitioning || this._isShown()) return;
      let t = [];
      if (this._config.parent && (t = this._getFirstLevelChildren(hf).filter((c) => c !== this._element).map((c) => Li.getOrCreateInstance(c, { toggle: false }))), t.length && t[0]._isTransitioning || q.trigger(this._element, nf).defaultPrevented) return;
      for (const c of t) c.hide();
      const n = this._getDimension();
      this._element.classList.remove(Ci), this._element.classList.add(_n), this._element.style[n] = 0, this._addAriaAndCollapsedClass(this._triggerArray, true), this._isTransitioning = true;
      const r = () => {
        this._isTransitioning = false, this._element.classList.remove(_n), this._element.classList.add(Ci, As), this._element.style[n] = "", q.trigger(this._element, sf);
      }, l = `scroll${n[0].toUpperCase() + n.slice(1)}`;
      this._queueCallback(r, this._element, true), this._element.style[n] = `${this._element[l]}px`;
    }
    hide() {
      if (this._isTransitioning || !this._isShown() || q.trigger(this._element, rf).defaultPrevented) return;
      const i = this._getDimension();
      this._element.style[i] = `${this._element.getBoundingClientRect()[i]}px`, en(this._element), this._element.classList.add(_n), this._element.classList.remove(Ci, As);
      for (const r of this._triggerArray) {
        const o = ne.getElementFromSelector(r);
        o && !this._isShown(o) && this._addAriaAndCollapsedClass([r], false);
      }
      this._isTransitioning = true;
      const n = () => {
        this._isTransitioning = false, this._element.classList.remove(_n), this._element.classList.add(Ci), q.trigger(this._element, of);
      };
      this._element.style[i] = "", this._queueCallback(n, this._element, true);
    }
    _isShown(t = this._element) {
      return t.classList.contains(As);
    }
    _configAfterMerge(t) {
      return t.toggle = !!t.toggle, t.parent = Bt(t.parent), t;
    }
    _getDimension() {
      return this._element.classList.contains(uf) ? df : ff;
    }
    _initializeChildren() {
      if (!this._config.parent) return;
      const t = this._getFirstLevelChildren(ur);
      for (const i of t) {
        const n = ne.getElementFromSelector(i);
        n && this._addAriaAndCollapsedClass([i], this._isShown(n));
      }
    }
    _getFirstLevelChildren(t) {
      const i = ne.find(cf, this._config.parent);
      return ne.find(t, this._config.parent).filter((n) => !i.includes(n));
    }
    _addAriaAndCollapsedClass(t, i) {
      if (t.length) for (const n of t) n.classList.toggle(lf, !i), n.setAttribute("aria-expanded", i);
    }
    static jQueryInterface(t) {
      const i = {};
      return typeof t == "string" && /show|hide/.test(t) && (i.toggle = false), this.each(function() {
        const n = Li.getOrCreateInstance(this, i);
        if (typeof t == "string") {
          if (typeof n[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          n[t]();
        }
      });
    }
  }
  q.on(document, af, ur, function(e) {
    (e.target.tagName === "A" || e.delegateTarget && e.delegateTarget.tagName === "A") && e.preventDefault();
    for (const t of ne.getMultipleElementsFromSelector(this)) Li.getOrCreateInstance(t, { toggle: false }).toggle();
  });
  nt(Li);
  const Ro = "dropdown", gf = "bs.dropdown", si = `.${gf}`, wr = ".data-api", vf = "Escape", Ho = "Tab", yf = "ArrowUp", Bo = "ArrowDown", bf = 2, Ef = `hide${si}`, Sf = `hidden${si}`, Tf = `show${si}`, _f = `shown${si}`, xl = `click${si}${wr}`, Cl = `keydown${si}${wr}`, xf = `keyup${si}${wr}`, xi = "show", Cf = "dropup", wf = "dropend", If = "dropstart", Af = "dropup-center", Of = "dropdown-center", Ut = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)', Mf = `${Ut}.${xi}`, Mn = ".dropdown-menu", Lf = ".navbar", Pf = ".navbar-nav", Df = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", zf = tt() ? "top-end" : "top-start", $f = tt() ? "top-start" : "top-end", Nf = tt() ? "bottom-end" : "bottom-start", kf = tt() ? "bottom-start" : "bottom-end", Rf = tt() ? "left-start" : "right-start", Hf = tt() ? "right-start" : "left-start", Bf = "top", Vf = "bottom", Wf = { autoClose: true, boundary: "clippingParents", display: "dynamic", offset: [0, 2], popperConfig: null, reference: "toggle" }, Ff = { autoClose: "(boolean|string)", boundary: "(string|element)", display: "string", offset: "(array|string|function)", popperConfig: "(null|object|function)", reference: "(string|element|object)" };
  class lt extends ut {
    constructor(t, i) {
      super(t, i), this._popper = null, this._parent = this._element.parentNode, this._menu = ne.next(this._element, Mn)[0] || ne.prev(this._element, Mn)[0] || ne.findOne(Mn, this._parent), this._inNavbar = this._detectNavbar();
    }
    static get Default() {
      return Wf;
    }
    static get DefaultType() {
      return Ff;
    }
    static get NAME() {
      return Ro;
    }
    toggle() {
      return this._isShown() ? this.hide() : this.show();
    }
    show() {
      if (Vt(this._element) || this._isShown()) return;
      const t = { relatedTarget: this._element };
      if (!q.trigger(this._element, Tf, t).defaultPrevented) {
        if (this._createPopper(), "ontouchstart" in document.documentElement && !this._parent.closest(Pf)) for (const n of [].concat(...document.body.children)) q.on(n, "mouseover", zn);
        this._element.focus(), this._element.setAttribute("aria-expanded", true), this._menu.classList.add(xi), this._element.classList.add(xi), q.trigger(this._element, _f, t);
      }
    }
    hide() {
      if (Vt(this._element) || !this._isShown()) return;
      const t = { relatedTarget: this._element };
      this._completeHide(t);
    }
    dispose() {
      this._popper && this._popper.destroy(), super.dispose();
    }
    update() {
      this._inNavbar = this._detectNavbar(), this._popper && this._popper.update();
    }
    _completeHide(t) {
      if (!q.trigger(this._element, Ef, t).defaultPrevented) {
        if ("ontouchstart" in document.documentElement) for (const n of [].concat(...document.body.children)) q.off(n, "mouseover", zn);
        this._popper && this._popper.destroy(), this._menu.classList.remove(xi), this._element.classList.remove(xi), this._element.setAttribute("aria-expanded", "false"), It.removeDataAttribute(this._menu, "popper"), q.trigger(this._element, Sf, t);
      }
    }
    _getConfig(t) {
      if (t = super._getConfig(t), typeof t.reference == "object" && !wt(t.reference) && typeof t.reference.getBoundingClientRect != "function") throw new TypeError(`${Ro.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
      return t;
    }
    _createPopper() {
      if (typeof al == "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org/docs/v2/)");
      let t = this._element;
      this._config.reference === "parent" ? t = this._parent : wt(this._config.reference) ? t = Bt(this._config.reference) : typeof this._config.reference == "object" && (t = this._config.reference);
      const i = this._getPopperConfig();
      this._popper = _r(t, this._menu, i);
    }
    _isShown() {
      return this._menu.classList.contains(xi);
    }
    _getPlacement() {
      const t = this._parent;
      if (t.classList.contains(wf)) return Rf;
      if (t.classList.contains(If)) return Hf;
      if (t.classList.contains(Af)) return Bf;
      if (t.classList.contains(Of)) return Vf;
      const i = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
      return t.classList.contains(Cf) ? i ? $f : zf : i ? kf : Nf;
    }
    _detectNavbar() {
      return this._element.closest(Lf) !== null;
    }
    _getOffset() {
      const { offset: t } = this._config;
      return typeof t == "string" ? t.split(",").map((i) => Number.parseInt(i, 10)) : typeof t == "function" ? (i) => t(i, this._element) : t;
    }
    _getPopperConfig() {
      const t = { placement: this._getPlacement(), modifiers: [{ name: "preventOverflow", options: { boundary: this._config.boundary } }, { name: "offset", options: { offset: this._getOffset() } }] };
      return (this._inNavbar || this._config.display === "static") && (It.setDataAttribute(this._menu, "popper", "static"), t.modifiers = [{ name: "applyStyles", enabled: false }]), Ie(Ie({}, t), Fe(this._config.popperConfig, [void 0, t]));
    }
    _selectMenuItem({ key: t, target: i }) {
      const n = ne.find(Df, this._menu).filter((r) => $i(r));
      n.length && xr(n, i, t === Bo, !n.includes(i)).focus();
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = lt.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (typeof i[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
    static clearMenus(t) {
      if (t.button === bf || t.type === "keyup" && t.key !== Ho) return;
      const i = ne.find(Mf);
      for (const n of i) {
        const r = lt.getInstance(n);
        if (!r || r._config.autoClose === false) continue;
        const o = t.composedPath(), l = o.includes(r._menu);
        if (o.includes(r._element) || r._config.autoClose === "inside" && !l || r._config.autoClose === "outside" && l || r._menu.contains(t.target) && (t.type === "keyup" && t.key === Ho || /input|select|option|textarea|form/i.test(t.target.tagName))) continue;
        const c = { relatedTarget: r._element };
        t.type === "click" && (c.clickEvent = t), r._completeHide(c);
      }
    }
    static dataApiKeydownHandler(t) {
      const i = /input|textarea/i.test(t.target.tagName), n = t.key === vf, r = [yf, Bo].includes(t.key);
      if (!r && !n || i && !n) return;
      t.preventDefault();
      const o = this.matches(Ut) ? this : ne.prev(this, Ut)[0] || ne.next(this, Ut)[0] || ne.findOne(Ut, t.delegateTarget.parentNode), l = lt.getOrCreateInstance(o);
      if (r) {
        t.stopPropagation(), l.show(), l._selectMenuItem(t);
        return;
      }
      l._isShown() && (t.stopPropagation(), l.hide(), o.focus());
    }
  }
  q.on(document, Cl, Ut, lt.dataApiKeydownHandler);
  q.on(document, Cl, Mn, lt.dataApiKeydownHandler);
  q.on(document, xl, lt.clearMenus);
  q.on(document, xf, lt.clearMenus);
  q.on(document, xl, Ut, function(e) {
    e.preventDefault(), lt.getOrCreateInstance(this).toggle();
  });
  nt(lt);
  const wl = "backdrop", Gf = "fade", Vo = "show", Wo = `mousedown.bs.${wl}`, jf = { className: "modal-backdrop", clickCallback: null, isAnimated: false, isVisible: true, rootElement: "body" }, Yf = { className: "string", clickCallback: "(function|null)", isAnimated: "boolean", isVisible: "boolean", rootElement: "(element|string)" };
  class Il extends tn {
    constructor(t) {
      super(), this._config = this._getConfig(t), this._isAppended = false, this._element = null;
    }
    static get Default() {
      return jf;
    }
    static get DefaultType() {
      return Yf;
    }
    static get NAME() {
      return wl;
    }
    show(t) {
      if (!this._config.isVisible) {
        Fe(t);
        return;
      }
      this._append();
      const i = this._getElement();
      this._config.isAnimated && en(i), i.classList.add(Vo), this._emulateAnimation(() => {
        Fe(t);
      });
    }
    hide(t) {
      if (!this._config.isVisible) {
        Fe(t);
        return;
      }
      this._getElement().classList.remove(Vo), this._emulateAnimation(() => {
        this.dispose(), Fe(t);
      });
    }
    dispose() {
      this._isAppended && (q.off(this._element, Wo), this._element.remove(), this._isAppended = false);
    }
    _getElement() {
      if (!this._element) {
        const t = document.createElement("div");
        t.className = this._config.className, this._config.isAnimated && t.classList.add(Gf), this._element = t;
      }
      return this._element;
    }
    _configAfterMerge(t) {
      return t.rootElement = Bt(t.rootElement), t;
    }
    _append() {
      if (this._isAppended) return;
      const t = this._getElement();
      this._config.rootElement.append(t), q.on(t, Wo, () => {
        Fe(this._config.clickCallback);
      }), this._isAppended = true;
    }
    _emulateAnimation(t) {
      fl(t, this._getElement(), this._config.isAnimated);
    }
  }
  const Xf = "focustrap", qf = "bs.focustrap", Nn = `.${qf}`, Uf = `focusin${Nn}`, Kf = `keydown.tab${Nn}`, Zf = "Tab", Qf = "forward", Fo = "backward", Jf = { autofocus: true, trapElement: null }, eh = { autofocus: "boolean", trapElement: "element" };
  class Al extends tn {
    constructor(t) {
      super(), this._config = this._getConfig(t), this._isActive = false, this._lastTabNavDirection = null;
    }
    static get Default() {
      return Jf;
    }
    static get DefaultType() {
      return eh;
    }
    static get NAME() {
      return Xf;
    }
    activate() {
      this._isActive || (this._config.autofocus && this._config.trapElement.focus(), q.off(document, Nn), q.on(document, Uf, (t) => this._handleFocusin(t)), q.on(document, Kf, (t) => this._handleKeydown(t)), this._isActive = true);
    }
    deactivate() {
      this._isActive && (this._isActive = false, q.off(document, Nn));
    }
    _handleFocusin(t) {
      const { trapElement: i } = this._config;
      if (t.target === document || t.target === i || i.contains(t.target)) return;
      const n = ne.focusableChildren(i);
      n.length === 0 ? i.focus() : this._lastTabNavDirection === Fo ? n[n.length - 1].focus() : n[0].focus();
    }
    _handleKeydown(t) {
      t.key === Zf && (this._lastTabNavDirection = t.shiftKey ? Fo : Qf);
    }
  }
  const Go = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", jo = ".sticky-top", xn = "padding-right", Yo = "margin-right";
  class dr {
    constructor() {
      this._element = document.body;
    }
    getWidth() {
      const t = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - t);
    }
    hide() {
      const t = this.getWidth();
      this._disableOverFlow(), this._setElementAttributes(this._element, xn, (i) => i + t), this._setElementAttributes(Go, xn, (i) => i + t), this._setElementAttributes(jo, Yo, (i) => i - t);
    }
    reset() {
      this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, xn), this._resetElementAttributes(Go, xn), this._resetElementAttributes(jo, Yo);
    }
    isOverflowing() {
      return this.getWidth() > 0;
    }
    _disableOverFlow() {
      this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
    }
    _setElementAttributes(t, i, n) {
      const r = this.getWidth(), o = (l) => {
        if (l !== this._element && window.innerWidth > l.clientWidth + r) return;
        this._saveInitialAttribute(l, i);
        const c = window.getComputedStyle(l).getPropertyValue(i);
        l.style.setProperty(i, `${n(Number.parseFloat(c))}px`);
      };
      this._applyManipulationCallback(t, o);
    }
    _saveInitialAttribute(t, i) {
      const n = t.style.getPropertyValue(i);
      n && It.setDataAttribute(t, i, n);
    }
    _resetElementAttributes(t, i) {
      const n = (r) => {
        const o = It.getDataAttribute(r, i);
        if (o === null) {
          r.style.removeProperty(i);
          return;
        }
        It.removeDataAttribute(r, i), r.style.setProperty(i, o);
      };
      this._applyManipulationCallback(t, n);
    }
    _applyManipulationCallback(t, i) {
      if (wt(t)) {
        i(t);
        return;
      }
      for (const n of ne.find(t, this._element)) i(n);
    }
  }
  const th = "modal", ih = "bs.modal", it = `.${ih}`, nh = ".data-api", sh = "Escape", rh = `hide${it}`, oh = `hidePrevented${it}`, Ol = `hidden${it}`, Ml = `show${it}`, ah = `shown${it}`, lh = `resize${it}`, ch = `click.dismiss${it}`, uh = `mousedown.dismiss${it}`, dh = `keydown.dismiss${it}`, fh = `click${it}${nh}`, Xo = "modal-open", hh = "fade", qo = "show", Os = "modal-static", ph = ".modal.show", mh = ".modal-dialog", gh = ".modal-body", vh = '[data-bs-toggle="modal"]', yh = { backdrop: true, focus: true, keyboard: true }, bh = { backdrop: "(boolean|string)", focus: "boolean", keyboard: "boolean" };
  class ii extends ut {
    constructor(t, i) {
      super(t, i), this._dialog = ne.findOne(mh, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = false, this._isTransitioning = false, this._scrollBar = new dr(), this._addEventListeners();
    }
    static get Default() {
      return yh;
    }
    static get DefaultType() {
      return bh;
    }
    static get NAME() {
      return th;
    }
    toggle(t) {
      return this._isShown ? this.hide() : this.show(t);
    }
    show(t) {
      this._isShown || this._isTransitioning || q.trigger(this._element, Ml, { relatedTarget: t }).defaultPrevented || (this._isShown = true, this._isTransitioning = true, this._scrollBar.hide(), document.body.classList.add(Xo), this._adjustDialog(), this._backdrop.show(() => this._showElement(t)));
    }
    hide() {
      !this._isShown || this._isTransitioning || q.trigger(this._element, rh).defaultPrevented || (this._isShown = false, this._isTransitioning = true, this._focustrap.deactivate(), this._element.classList.remove(qo), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
    }
    dispose() {
      q.off(window, it), q.off(this._dialog, it), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
    }
    handleUpdate() {
      this._adjustDialog();
    }
    _initializeBackDrop() {
      return new Il({ isVisible: !!this._config.backdrop, isAnimated: this._isAnimated() });
    }
    _initializeFocusTrap() {
      return new Al({ trapElement: this._element });
    }
    _showElement(t) {
      document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", true), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
      const i = ne.findOne(gh, this._dialog);
      i && (i.scrollTop = 0), en(this._element), this._element.classList.add(qo);
      const n = () => {
        this._config.focus && this._focustrap.activate(), this._isTransitioning = false, q.trigger(this._element, ah, { relatedTarget: t });
      };
      this._queueCallback(n, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
      q.on(this._element, dh, (t) => {
        if (t.key === sh) {
          if (this._config.keyboard) {
            this.hide();
            return;
          }
          this._triggerBackdropTransition();
        }
      }), q.on(window, lh, () => {
        this._isShown && !this._isTransitioning && this._adjustDialog();
      }), q.on(this._element, uh, (t) => {
        q.one(this._element, ch, (i) => {
          if (!(this._element !== t.target || this._element !== i.target)) {
            if (this._config.backdrop === "static") {
              this._triggerBackdropTransition();
              return;
            }
            this._config.backdrop && this.hide();
          }
        });
      });
    }
    _hideModal() {
      this._element.style.display = "none", this._element.setAttribute("aria-hidden", true), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = false, this._backdrop.hide(() => {
        document.body.classList.remove(Xo), this._resetAdjustments(), this._scrollBar.reset(), q.trigger(this._element, Ol);
      });
    }
    _isAnimated() {
      return this._element.classList.contains(hh);
    }
    _triggerBackdropTransition() {
      if (q.trigger(this._element, oh).defaultPrevented) return;
      const i = this._element.scrollHeight > document.documentElement.clientHeight, n = this._element.style.overflowY;
      n === "hidden" || this._element.classList.contains(Os) || (i || (this._element.style.overflowY = "hidden"), this._element.classList.add(Os), this._queueCallback(() => {
        this._element.classList.remove(Os), this._queueCallback(() => {
          this._element.style.overflowY = n;
        }, this._dialog);
      }, this._dialog), this._element.focus());
    }
    _adjustDialog() {
      const t = this._element.scrollHeight > document.documentElement.clientHeight, i = this._scrollBar.getWidth(), n = i > 0;
      if (n && !t) {
        const r = tt() ? "paddingLeft" : "paddingRight";
        this._element.style[r] = `${i}px`;
      }
      if (!n && t) {
        const r = tt() ? "paddingRight" : "paddingLeft";
        this._element.style[r] = `${i}px`;
      }
    }
    _resetAdjustments() {
      this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
    }
    static jQueryInterface(t, i) {
      return this.each(function() {
        const n = ii.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (typeof n[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          n[t](i);
        }
      });
    }
  }
  q.on(document, fh, vh, function(e) {
    const t = ne.getElementFromSelector(this);
    ["A", "AREA"].includes(this.tagName) && e.preventDefault(), q.one(t, Ml, (r) => {
      r.defaultPrevented || q.one(t, Ol, () => {
        $i(this) && this.focus();
      });
    });
    const i = ne.findOne(ph);
    i && ii.getInstance(i).hide(), ii.getOrCreateInstance(t).toggle(this);
  });
  Yn(ii);
  nt(ii);
  const Eh = "offcanvas", Sh = "bs.offcanvas", Mt = `.${Sh}`, Ll = ".data-api", Th = `load${Mt}${Ll}`, _h = "Escape", Uo = "show", Ko = "showing", Zo = "hiding", xh = "offcanvas-backdrop", Pl = ".offcanvas.show", Ch = `show${Mt}`, wh = `shown${Mt}`, Ih = `hide${Mt}`, Qo = `hidePrevented${Mt}`, Dl = `hidden${Mt}`, Ah = `resize${Mt}`, Oh = `click${Mt}${Ll}`, Mh = `keydown.dismiss${Mt}`, Lh = '[data-bs-toggle="offcanvas"]', Ph = { backdrop: true, keyboard: true, scroll: false }, Dh = { backdrop: "(boolean|string)", keyboard: "boolean", scroll: "boolean" };
  class Ot extends ut {
    constructor(t, i) {
      super(t, i), this._isShown = false, this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._addEventListeners();
    }
    static get Default() {
      return Ph;
    }
    static get DefaultType() {
      return Dh;
    }
    static get NAME() {
      return Eh;
    }
    toggle(t) {
      return this._isShown ? this.hide() : this.show(t);
    }
    show(t) {
      if (this._isShown || q.trigger(this._element, Ch, { relatedTarget: t }).defaultPrevented) return;
      this._isShown = true, this._backdrop.show(), this._config.scroll || new dr().hide(), this._element.setAttribute("aria-modal", true), this._element.setAttribute("role", "dialog"), this._element.classList.add(Ko);
      const n = () => {
        (!this._config.scroll || this._config.backdrop) && this._focustrap.activate(), this._element.classList.add(Uo), this._element.classList.remove(Ko), q.trigger(this._element, wh, { relatedTarget: t });
      };
      this._queueCallback(n, this._element, true);
    }
    hide() {
      if (!this._isShown || q.trigger(this._element, Ih).defaultPrevented) return;
      this._focustrap.deactivate(), this._element.blur(), this._isShown = false, this._element.classList.add(Zo), this._backdrop.hide();
      const i = () => {
        this._element.classList.remove(Uo, Zo), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._config.scroll || new dr().reset(), q.trigger(this._element, Dl);
      };
      this._queueCallback(i, this._element, true);
    }
    dispose() {
      this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
    }
    _initializeBackDrop() {
      const t = () => {
        if (this._config.backdrop === "static") {
          q.trigger(this._element, Qo);
          return;
        }
        this.hide();
      }, i = !!this._config.backdrop;
      return new Il({ className: xh, isVisible: i, isAnimated: true, rootElement: this._element.parentNode, clickCallback: i ? t : null });
    }
    _initializeFocusTrap() {
      return new Al({ trapElement: this._element });
    }
    _addEventListeners() {
      q.on(this._element, Mh, (t) => {
        if (t.key === _h) {
          if (this._config.keyboard) {
            this.hide();
            return;
          }
          q.trigger(this._element, Qo);
        }
      });
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = Ot.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (i[t] === void 0 || t.startsWith("_") || t === "constructor") throw new TypeError(`No method named "${t}"`);
          i[t](this);
        }
      });
    }
  }
  q.on(document, Oh, Lh, function(e) {
    const t = ne.getElementFromSelector(this);
    if (["A", "AREA"].includes(this.tagName) && e.preventDefault(), Vt(this)) return;
    q.one(t, Dl, () => {
      $i(this) && this.focus();
    });
    const i = ne.findOne(Pl);
    i && i !== t && Ot.getInstance(i).hide(), Ot.getOrCreateInstance(t).toggle(this);
  });
  q.on(window, Th, () => {
    for (const e of ne.find(Pl)) Ot.getOrCreateInstance(e).show();
  });
  q.on(window, Ah, () => {
    for (const e of ne.find("[aria-modal][class*=show][class*=offcanvas-]")) getComputedStyle(e).position !== "fixed" && Ot.getOrCreateInstance(e).hide();
  });
  Yn(Ot);
  nt(Ot);
  const zh = /^aria-[\w-]*$/i, zl = { "*": ["class", "dir", "id", "lang", "role", zh], a: ["target", "href", "title", "rel"], area: [], b: [], br: [], col: [], code: [], dd: [], div: [], dl: [], dt: [], em: [], hr: [], h1: [], h2: [], h3: [], h4: [], h5: [], h6: [], i: [], img: ["src", "srcset", "alt", "title", "width", "height"], li: [], ol: [], p: [], pre: [], s: [], small: [], span: [], sub: [], sup: [], strong: [], u: [], ul: [] }, $h = /* @__PURE__ */ new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]), Nh = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, kh = (e, t) => {
    const i = e.nodeName.toLowerCase();
    return t.includes(i) ? $h.has(i) ? !!Nh.test(e.nodeValue) : true : t.filter((n) => n instanceof RegExp).some((n) => n.test(i));
  };
  function Rh(e, t, i) {
    if (!e.length) return e;
    if (i && typeof i == "function") return i(e);
    const r = new window.DOMParser().parseFromString(e, "text/html"), o = [].concat(...r.body.querySelectorAll("*"));
    for (const l of o) {
      const c = l.nodeName.toLowerCase();
      if (!Object.keys(t).includes(c)) {
        l.remove();
        continue;
      }
      const d = [].concat(...l.attributes), v = [].concat(t["*"] || [], t[c] || []);
      for (const E of d) kh(E, v) || l.removeAttribute(E.nodeName);
    }
    return r.body.innerHTML;
  }
  const Hh = "TemplateFactory", Bh = { allowList: zl, content: {}, extraClass: "", html: false, sanitize: true, sanitizeFn: null, template: "<div></div>" }, Vh = { allowList: "object", content: "object", extraClass: "(string|function)", html: "boolean", sanitize: "boolean", sanitizeFn: "(null|function)", template: "string" }, Wh = { entry: "(string|element|function|null)", selector: "(string|element)" };
  class Fh extends tn {
    constructor(t) {
      super(), this._config = this._getConfig(t);
    }
    static get Default() {
      return Bh;
    }
    static get DefaultType() {
      return Vh;
    }
    static get NAME() {
      return Hh;
    }
    getContent() {
      return Object.values(this._config.content).map((t) => this._resolvePossibleFunction(t)).filter(Boolean);
    }
    hasContent() {
      return this.getContent().length > 0;
    }
    changeContent(t) {
      return this._checkContent(t), this._config.content = Ie(Ie({}, this._config.content), t), this;
    }
    toHtml() {
      const t = document.createElement("div");
      t.innerHTML = this._maybeSanitize(this._config.template);
      for (const [r, o] of Object.entries(this._config.content)) this._setContent(t, o, r);
      const i = t.children[0], n = this._resolvePossibleFunction(this._config.extraClass);
      return n && i.classList.add(...n.split(" ")), i;
    }
    _typeCheckConfig(t) {
      super._typeCheckConfig(t), this._checkContent(t.content);
    }
    _checkContent(t) {
      for (const [i, n] of Object.entries(t)) super._typeCheckConfig({ selector: i, entry: n }, Wh);
    }
    _setContent(t, i, n) {
      const r = ne.findOne(n, t);
      if (r) {
        if (i = this._resolvePossibleFunction(i), !i) {
          r.remove();
          return;
        }
        if (wt(i)) {
          this._putElementInTemplate(Bt(i), r);
          return;
        }
        if (this._config.html) {
          r.innerHTML = this._maybeSanitize(i);
          return;
        }
        r.textContent = i;
      }
    }
    _maybeSanitize(t) {
      return this._config.sanitize ? Rh(t, this._config.allowList, this._config.sanitizeFn) : t;
    }
    _resolvePossibleFunction(t) {
      return Fe(t, [void 0, this]);
    }
    _putElementInTemplate(t, i) {
      if (this._config.html) {
        i.innerHTML = "", i.append(t);
        return;
      }
      i.textContent = t.textContent;
    }
  }
  const Gh = "tooltip", jh = /* @__PURE__ */ new Set(["sanitize", "allowList", "sanitizeFn"]), Ms = "fade", Yh = "modal", Cn = "show", Xh = ".tooltip-inner", Jo = `.${Yh}`, ea = "hide.bs.modal", ji = "hover", Ls = "focus", Ps = "click", qh = "manual", Uh = "hide", Kh = "hidden", Zh = "show", Qh = "shown", Jh = "inserted", ep = "click", tp = "focusin", ip = "focusout", np = "mouseenter", sp = "mouseleave", rp = { AUTO: "auto", TOP: "top", RIGHT: tt() ? "left" : "right", BOTTOM: "bottom", LEFT: tt() ? "right" : "left" }, op = { allowList: zl, animation: true, boundary: "clippingParents", container: false, customClass: "", delay: 0, fallbackPlacements: ["top", "right", "bottom", "left"], html: false, offset: [0, 6], placement: "top", popperConfig: null, sanitize: true, sanitizeFn: null, selector: false, template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>', title: "", trigger: "hover focus" }, ap = { allowList: "object", animation: "boolean", boundary: "(string|element)", container: "(string|element|boolean)", customClass: "(string|function)", delay: "(number|object)", fallbackPlacements: "array", html: "boolean", offset: "(array|string|function)", placement: "(string|function)", popperConfig: "(null|object|function)", sanitize: "boolean", sanitizeFn: "(null|function)", selector: "(string|boolean)", template: "string", title: "(string|element|function)", trigger: "string" };
  class ri extends ut {
    constructor(t, i) {
      if (typeof al == "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org/docs/v2/)");
      super(t, i), this._isEnabled = true, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
    }
    static get Default() {
      return op;
    }
    static get DefaultType() {
      return ap;
    }
    static get NAME() {
      return Gh;
    }
    enable() {
      this._isEnabled = true;
    }
    disable() {
      this._isEnabled = false;
    }
    toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    }
    toggle() {
      if (this._isEnabled) {
        if (this._isShown()) {
          this._leave();
          return;
        }
        this._enter();
      }
    }
    dispose() {
      clearTimeout(this._timeout), q.off(this._element.closest(Jo), ea, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
    }
    show() {
      if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
      if (!(this._isWithContent() && this._isEnabled)) return;
      const t = q.trigger(this._element, this.constructor.eventName(Zh)), n = (ul(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
      if (t.defaultPrevented || !n) return;
      this._disposePopper();
      const r = this._getTipElement();
      this._element.setAttribute("aria-describedby", r.getAttribute("id"));
      const { container: o } = this._config;
      if (this._element.ownerDocument.documentElement.contains(this.tip) || (o.append(r), q.trigger(this._element, this.constructor.eventName(Jh))), this._popper = this._createPopper(r), r.classList.add(Cn), "ontouchstart" in document.documentElement) for (const c of [].concat(...document.body.children)) q.on(c, "mouseover", zn);
      const l = () => {
        q.trigger(this._element, this.constructor.eventName(Qh)), this._isHovered === false && this._leave(), this._isHovered = false;
      };
      this._queueCallback(l, this.tip, this._isAnimated());
    }
    hide() {
      if (!this._isShown() || q.trigger(this._element, this.constructor.eventName(Uh)).defaultPrevented) return;
      if (this._getTipElement().classList.remove(Cn), "ontouchstart" in document.documentElement) for (const r of [].concat(...document.body.children)) q.off(r, "mouseover", zn);
      this._activeTrigger[Ps] = false, this._activeTrigger[Ls] = false, this._activeTrigger[ji] = false, this._isHovered = null;
      const n = () => {
        this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), q.trigger(this._element, this.constructor.eventName(Kh)));
      };
      this._queueCallback(n, this.tip, this._isAnimated());
    }
    update() {
      this._popper && this._popper.update();
    }
    _isWithContent() {
      return !!this._getTitle();
    }
    _getTipElement() {
      return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
    }
    _createTipElement(t) {
      const i = this._getTemplateFactory(t).toHtml();
      if (!i) return null;
      i.classList.remove(Ms, Cn), i.classList.add(`bs-${this.constructor.NAME}-auto`);
      const n = Xu(this.constructor.NAME).toString();
      return i.setAttribute("id", n), this._isAnimated() && i.classList.add(Ms), i;
    }
    setContent(t) {
      this._newContent = t, this._isShown() && (this._disposePopper(), this.show());
    }
    _getTemplateFactory(t) {
      return this._templateFactory ? this._templateFactory.changeContent(t) : this._templateFactory = new Fh(bi(Ie({}, this._config), { content: t, extraClass: this._resolvePossibleFunction(this._config.customClass) })), this._templateFactory;
    }
    _getContentForTemplate() {
      return { [Xh]: this._getTitle() };
    }
    _getTitle() {
      return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    _initializeOnDelegatedTarget(t) {
      return this.constructor.getOrCreateInstance(t.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
      return this._config.animation || this.tip && this.tip.classList.contains(Ms);
    }
    _isShown() {
      return this.tip && this.tip.classList.contains(Cn);
    }
    _createPopper(t) {
      const i = Fe(this._config.placement, [this, t, this._element]), n = rp[i.toUpperCase()];
      return _r(this._element, t, this._getPopperConfig(n));
    }
    _getOffset() {
      const { offset: t } = this._config;
      return typeof t == "string" ? t.split(",").map((i) => Number.parseInt(i, 10)) : typeof t == "function" ? (i) => t(i, this._element) : t;
    }
    _resolvePossibleFunction(t) {
      return Fe(t, [this._element, this._element]);
    }
    _getPopperConfig(t) {
      const i = { placement: t, modifiers: [{ name: "flip", options: { fallbackPlacements: this._config.fallbackPlacements } }, { name: "offset", options: { offset: this._getOffset() } }, { name: "preventOverflow", options: { boundary: this._config.boundary } }, { name: "arrow", options: { element: `.${this.constructor.NAME}-arrow` } }, { name: "preSetPlacement", enabled: true, phase: "beforeMain", fn: (n) => {
        this._getTipElement().setAttribute("data-popper-placement", n.state.placement);
      } }] };
      return Ie(Ie({}, i), Fe(this._config.popperConfig, [void 0, i]));
    }
    _setListeners() {
      const t = this._config.trigger.split(" ");
      for (const i of t) if (i === "click") q.on(this._element, this.constructor.eventName(ep), this._config.selector, (n) => {
        const r = this._initializeOnDelegatedTarget(n);
        r._activeTrigger[Ps] = !(r._isShown() && r._activeTrigger[Ps]), r.toggle();
      });
      else if (i !== qh) {
        const n = i === ji ? this.constructor.eventName(np) : this.constructor.eventName(tp), r = i === ji ? this.constructor.eventName(sp) : this.constructor.eventName(ip);
        q.on(this._element, n, this._config.selector, (o) => {
          const l = this._initializeOnDelegatedTarget(o);
          l._activeTrigger[o.type === "focusin" ? Ls : ji] = true, l._enter();
        }), q.on(this._element, r, this._config.selector, (o) => {
          const l = this._initializeOnDelegatedTarget(o);
          l._activeTrigger[o.type === "focusout" ? Ls : ji] = l._element.contains(o.relatedTarget), l._leave();
        });
      }
      this._hideModalHandler = () => {
        this._element && this.hide();
      }, q.on(this._element.closest(Jo), ea, this._hideModalHandler);
    }
    _fixTitle() {
      const t = this._element.getAttribute("title");
      t && (!this._element.getAttribute("aria-label") && !this._element.textContent.trim() && this._element.setAttribute("aria-label", t), this._element.setAttribute("data-bs-original-title", t), this._element.removeAttribute("title"));
    }
    _enter() {
      if (this._isShown() || this._isHovered) {
        this._isHovered = true;
        return;
      }
      this._isHovered = true, this._setTimeout(() => {
        this._isHovered && this.show();
      }, this._config.delay.show);
    }
    _leave() {
      this._isWithActiveTrigger() || (this._isHovered = false, this._setTimeout(() => {
        this._isHovered || this.hide();
      }, this._config.delay.hide));
    }
    _setTimeout(t, i) {
      clearTimeout(this._timeout), this._timeout = setTimeout(t, i);
    }
    _isWithActiveTrigger() {
      return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(t) {
      const i = It.getDataAttributes(this._element);
      for (const n of Object.keys(i)) jh.has(n) && delete i[n];
      return t = Ie(Ie({}, i), typeof t == "object" && t ? t : {}), t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
    }
    _configAfterMerge(t) {
      return t.container = t.container === false ? document.body : Bt(t.container), typeof t.delay == "number" && (t.delay = { show: t.delay, hide: t.delay }), typeof t.title == "number" && (t.title = t.title.toString()), typeof t.content == "number" && (t.content = t.content.toString()), t;
    }
    _getDelegateConfig() {
      const t = {};
      for (const [i, n] of Object.entries(this._config)) this.constructor.Default[i] !== n && (t[i] = n);
      return t.selector = false, t.trigger = "manual", t;
    }
    _disposePopper() {
      this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = ri.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (typeof i[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
  }
  nt(ri);
  const lp = "popover", cp = ".popover-header", up = ".popover-body", dp = bi(Ie({}, ri.Default), { content: "", offset: [0, 8], placement: "right", template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>', trigger: "click" }), fp = bi(Ie({}, ri.DefaultType), { content: "(null|string|element|function)" });
  class Ir extends ri {
    static get Default() {
      return dp;
    }
    static get DefaultType() {
      return fp;
    }
    static get NAME() {
      return lp;
    }
    _isWithContent() {
      return this._getTitle() || this._getContent();
    }
    _getContentForTemplate() {
      return { [cp]: this._getTitle(), [up]: this._getContent() };
    }
    _getContent() {
      return this._resolvePossibleFunction(this._config.content);
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = Ir.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (typeof i[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
  }
  nt(Ir);
  const hp = "scrollspy", pp = "bs.scrollspy", Ar = `.${pp}`, mp = ".data-api", gp = `activate${Ar}`, ta = `click${Ar}`, vp = `load${Ar}${mp}`, yp = "dropdown-item", Si = "active", bp = '[data-bs-spy="scroll"]', Ds = "[href]", Ep = ".nav, .list-group", ia = ".nav-link", Sp = ".nav-item", Tp = ".list-group-item", _p = `${ia}, ${Sp} > ${ia}, ${Tp}`, xp = ".dropdown", Cp = ".dropdown-toggle", wp = { offset: null, rootMargin: "0px 0px -25%", smoothScroll: false, target: null, threshold: [0.1, 0.5, 1] }, Ip = { offset: "(number|null)", rootMargin: "string", smoothScroll: "boolean", target: "element", threshold: "array" };
  class Un extends ut {
    constructor(t, i) {
      super(t, i), this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map(), this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element, this._activeTarget = null, this._observer = null, this._previousScrollData = { visibleEntryTop: 0, parentScrollTop: 0 }, this.refresh();
    }
    static get Default() {
      return wp;
    }
    static get DefaultType() {
      return Ip;
    }
    static get NAME() {
      return hp;
    }
    refresh() {
      this._initializeTargetsAndObservables(), this._maybeEnableSmoothScroll(), this._observer ? this._observer.disconnect() : this._observer = this._getNewObserver();
      for (const t of this._observableSections.values()) this._observer.observe(t);
    }
    dispose() {
      this._observer.disconnect(), super.dispose();
    }
    _configAfterMerge(t) {
      return t.target = Bt(t.target) || document.body, t.rootMargin = t.offset ? `${t.offset}px 0px -30%` : t.rootMargin, typeof t.threshold == "string" && (t.threshold = t.threshold.split(",").map((i) => Number.parseFloat(i))), t;
    }
    _maybeEnableSmoothScroll() {
      this._config.smoothScroll && (q.off(this._config.target, ta), q.on(this._config.target, ta, Ds, (t) => {
        const i = this._observableSections.get(t.target.hash);
        if (i) {
          t.preventDefault();
          const n = this._rootElement || window, r = i.offsetTop - this._element.offsetTop;
          if (n.scrollTo) {
            n.scrollTo({ top: r, behavior: "smooth" });
            return;
          }
          n.scrollTop = r;
        }
      }));
    }
    _getNewObserver() {
      const t = { root: this._rootElement, threshold: this._config.threshold, rootMargin: this._config.rootMargin };
      return new IntersectionObserver((i) => this._observerCallback(i), t);
    }
    _observerCallback(t) {
      const i = (l) => this._targetLinks.get(`#${l.target.id}`), n = (l) => {
        this._previousScrollData.visibleEntryTop = l.target.offsetTop, this._process(i(l));
      }, r = (this._rootElement || document.documentElement).scrollTop, o = r >= this._previousScrollData.parentScrollTop;
      this._previousScrollData.parentScrollTop = r;
      for (const l of t) {
        if (!l.isIntersecting) {
          this._activeTarget = null, this._clearActiveClass(i(l));
          continue;
        }
        const c = l.target.offsetTop >= this._previousScrollData.visibleEntryTop;
        if (o && c) {
          if (n(l), !r) return;
          continue;
        }
        !o && !c && n(l);
      }
    }
    _initializeTargetsAndObservables() {
      this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map();
      const t = ne.find(Ds, this._config.target);
      for (const i of t) {
        if (!i.hash || Vt(i)) continue;
        const n = ne.findOne(decodeURI(i.hash), this._element);
        $i(n) && (this._targetLinks.set(decodeURI(i.hash), i), this._observableSections.set(i.hash, n));
      }
    }
    _process(t) {
      this._activeTarget !== t && (this._clearActiveClass(this._config.target), this._activeTarget = t, t.classList.add(Si), this._activateParents(t), q.trigger(this._element, gp, { relatedTarget: t }));
    }
    _activateParents(t) {
      if (t.classList.contains(yp)) {
        ne.findOne(Cp, t.closest(xp)).classList.add(Si);
        return;
      }
      for (const i of ne.parents(t, Ep)) for (const n of ne.prev(i, _p)) n.classList.add(Si);
    }
    _clearActiveClass(t) {
      t.classList.remove(Si);
      const i = ne.find(`${Ds}.${Si}`, t);
      for (const n of i) n.classList.remove(Si);
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = Un.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (i[t] === void 0 || t.startsWith("_") || t === "constructor") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
  }
  q.on(window, vp, () => {
    for (const e of ne.find(bp)) Un.getOrCreateInstance(e);
  });
  nt(Un);
  const Ap = "tab", Op = "bs.tab", oi = `.${Op}`, Mp = `hide${oi}`, Lp = `hidden${oi}`, Pp = `show${oi}`, Dp = `shown${oi}`, zp = `click${oi}`, $p = `keydown${oi}`, Np = `load${oi}`, kp = "ArrowLeft", na = "ArrowRight", Rp = "ArrowUp", sa = "ArrowDown", zs = "Home", ra = "End", Kt = "active", oa = "fade", $s = "show", Hp = "dropdown", $l = ".dropdown-toggle", Bp = ".dropdown-menu", Ns = `:not(${$l})`, Vp = '.list-group, .nav, [role="tablist"]', Wp = ".nav-item, .list-group-item", Fp = `.nav-link${Ns}, .list-group-item${Ns}, [role="tab"]${Ns}`, Nl = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', ks = `${Fp}, ${Nl}`, Gp = `.${Kt}[data-bs-toggle="tab"], .${Kt}[data-bs-toggle="pill"], .${Kt}[data-bs-toggle="list"]`;
  class ni extends ut {
    constructor(t) {
      super(t), this._parent = this._element.closest(Vp), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), q.on(this._element, $p, (i) => this._keydown(i)));
    }
    static get NAME() {
      return Ap;
    }
    show() {
      const t = this._element;
      if (this._elemIsActive(t)) return;
      const i = this._getActiveElem(), n = i ? q.trigger(i, Mp, { relatedTarget: t }) : null;
      q.trigger(t, Pp, { relatedTarget: i }).defaultPrevented || n && n.defaultPrevented || (this._deactivate(i, t), this._activate(t, i));
    }
    _activate(t, i) {
      if (!t) return;
      t.classList.add(Kt), this._activate(ne.getElementFromSelector(t));
      const n = () => {
        if (t.getAttribute("role") !== "tab") {
          t.classList.add($s);
          return;
        }
        t.removeAttribute("tabindex"), t.setAttribute("aria-selected", true), this._toggleDropDown(t, true), q.trigger(t, Dp, { relatedTarget: i });
      };
      this._queueCallback(n, t, t.classList.contains(oa));
    }
    _deactivate(t, i) {
      if (!t) return;
      t.classList.remove(Kt), t.blur(), this._deactivate(ne.getElementFromSelector(t));
      const n = () => {
        if (t.getAttribute("role") !== "tab") {
          t.classList.remove($s);
          return;
        }
        t.setAttribute("aria-selected", false), t.setAttribute("tabindex", "-1"), this._toggleDropDown(t, false), q.trigger(t, Lp, { relatedTarget: i });
      };
      this._queueCallback(n, t, t.classList.contains(oa));
    }
    _keydown(t) {
      if (![kp, na, Rp, sa, zs, ra].includes(t.key)) return;
      t.stopPropagation(), t.preventDefault();
      const i = this._getChildren().filter((r) => !Vt(r));
      let n;
      if ([zs, ra].includes(t.key)) n = i[t.key === zs ? 0 : i.length - 1];
      else {
        const r = [na, sa].includes(t.key);
        n = xr(i, t.target, r, true);
      }
      n && (n.focus({ preventScroll: true }), ni.getOrCreateInstance(n).show());
    }
    _getChildren() {
      return ne.find(ks, this._parent);
    }
    _getActiveElem() {
      return this._getChildren().find((t) => this._elemIsActive(t)) || null;
    }
    _setInitialAttributes(t, i) {
      this._setAttributeIfNotExists(t, "role", "tablist");
      for (const n of i) this._setInitialAttributesOnChild(n);
    }
    _setInitialAttributesOnChild(t) {
      t = this._getInnerElement(t);
      const i = this._elemIsActive(t), n = this._getOuterElement(t);
      t.setAttribute("aria-selected", i), n !== t && this._setAttributeIfNotExists(n, "role", "presentation"), i || t.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(t, "role", "tab"), this._setInitialAttributesOnTargetPanel(t);
    }
    _setInitialAttributesOnTargetPanel(t) {
      const i = ne.getElementFromSelector(t);
      i && (this._setAttributeIfNotExists(i, "role", "tabpanel"), t.id && this._setAttributeIfNotExists(i, "aria-labelledby", `${t.id}`));
    }
    _toggleDropDown(t, i) {
      const n = this._getOuterElement(t);
      if (!n.classList.contains(Hp)) return;
      const r = (o, l) => {
        const c = ne.findOne(o, n);
        c && c.classList.toggle(l, i);
      };
      r($l, Kt), r(Bp, $s), n.setAttribute("aria-expanded", i);
    }
    _setAttributeIfNotExists(t, i, n) {
      t.hasAttribute(i) || t.setAttribute(i, n);
    }
    _elemIsActive(t) {
      return t.classList.contains(Kt);
    }
    _getInnerElement(t) {
      return t.matches(ks) ? t : ne.findOne(ks, t);
    }
    _getOuterElement(t) {
      return t.closest(Wp) || t;
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = ni.getOrCreateInstance(this);
        if (typeof t == "string") {
          if (i[t] === void 0 || t.startsWith("_") || t === "constructor") throw new TypeError(`No method named "${t}"`);
          i[t]();
        }
      });
    }
  }
  q.on(document, zp, Nl, function(e) {
    ["A", "AREA"].includes(this.tagName) && e.preventDefault(), !Vt(this) && ni.getOrCreateInstance(this).show();
  });
  q.on(window, Np, () => {
    for (const e of ne.find(Gp)) ni.getOrCreateInstance(e);
  });
  nt(ni);
  const jp = "toast", Yp = "bs.toast", Gt = `.${Yp}`, Xp = `mouseover${Gt}`, qp = `mouseout${Gt}`, Up = `focusin${Gt}`, Kp = `focusout${Gt}`, Zp = `hide${Gt}`, Qp = `hidden${Gt}`, Jp = `show${Gt}`, em = `shown${Gt}`, tm = "fade", aa = "hide", wn = "show", In = "showing", im = { animation: "boolean", autohide: "boolean", delay: "number" }, nm = { animation: true, autohide: true, delay: 5e3 };
  class Kn extends ut {
    constructor(t, i) {
      super(t, i), this._timeout = null, this._hasMouseInteraction = false, this._hasKeyboardInteraction = false, this._setListeners();
    }
    static get Default() {
      return nm;
    }
    static get DefaultType() {
      return im;
    }
    static get NAME() {
      return jp;
    }
    show() {
      if (q.trigger(this._element, Jp).defaultPrevented) return;
      this._clearTimeout(), this._config.animation && this._element.classList.add(tm);
      const i = () => {
        this._element.classList.remove(In), q.trigger(this._element, em), this._maybeScheduleHide();
      };
      this._element.classList.remove(aa), en(this._element), this._element.classList.add(wn, In), this._queueCallback(i, this._element, this._config.animation);
    }
    hide() {
      if (!this.isShown() || q.trigger(this._element, Zp).defaultPrevented) return;
      const i = () => {
        this._element.classList.add(aa), this._element.classList.remove(In, wn), q.trigger(this._element, Qp);
      };
      this._element.classList.add(In), this._queueCallback(i, this._element, this._config.animation);
    }
    dispose() {
      this._clearTimeout(), this.isShown() && this._element.classList.remove(wn), super.dispose();
    }
    isShown() {
      return this._element.classList.contains(wn);
    }
    _maybeScheduleHide() {
      this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout(() => {
        this.hide();
      }, this._config.delay)));
    }
    _onInteraction(t, i) {
      switch (t.type) {
        case "mouseover":
        case "mouseout": {
          this._hasMouseInteraction = i;
          break;
        }
        case "focusin":
        case "focusout": {
          this._hasKeyboardInteraction = i;
          break;
        }
      }
      if (i) {
        this._clearTimeout();
        return;
      }
      const n = t.relatedTarget;
      this._element === n || this._element.contains(n) || this._maybeScheduleHide();
    }
    _setListeners() {
      q.on(this._element, Xp, (t) => this._onInteraction(t, true)), q.on(this._element, qp, (t) => this._onInteraction(t, false)), q.on(this._element, Up, (t) => this._onInteraction(t, true)), q.on(this._element, Kp, (t) => this._onInteraction(t, false));
    }
    _clearTimeout() {
      clearTimeout(this._timeout), this._timeout = null;
    }
    static jQueryInterface(t) {
      return this.each(function() {
        const i = Kn.getOrCreateInstance(this, t);
        if (typeof t == "string") {
          if (typeof i[t] == "undefined") throw new TypeError(`No method named "${t}"`);
          i[t](this);
        }
      });
    }
  }
  Yn(Kn);
  nt(Kn);
  window.bootstrap = { Tooltip: ri, Modal: ii, Offcanvas: Ot, Collapse: Li, Dropdown: lt, Tab: ni };
  function la(e) {
    return e !== null && typeof e == "object" && "constructor" in e && e.constructor === Object;
  }
  function Or(e = {}, t = {}) {
    const i = ["__proto__", "constructor", "prototype"];
    Object.keys(t).filter((n) => i.indexOf(n) < 0).forEach((n) => {
      typeof e[n] == "undefined" ? e[n] = t[n] : la(t[n]) && la(e[n]) && Object.keys(t[n]).length > 0 && Or(e[n], t[n]);
    });
  }
  const kl = { body: {}, addEventListener() {
  }, removeEventListener() {
  }, activeElement: { blur() {
  }, nodeName: "" }, querySelector() {
    return null;
  }, querySelectorAll() {
    return [];
  }, getElementById() {
    return null;
  }, createEvent() {
    return { initEvent() {
    } };
  }, createElement() {
    return { children: [], childNodes: [], style: {}, setAttribute() {
    }, getElementsByTagName() {
      return [];
    } };
  }, createElementNS() {
    return {};
  }, importNode() {
    return null;
  }, location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" } };
  function Le() {
    const e = typeof document != "undefined" ? document : {};
    return Or(e, kl), e;
  }
  const sm = { document: kl, navigator: { userAgent: "" }, location: { hash: "", host: "", hostname: "", href: "", origin: "", pathname: "", protocol: "", search: "" }, history: { replaceState() {
  }, pushState() {
  }, go() {
  }, back() {
  } }, CustomEvent: function() {
    return this;
  }, addEventListener() {
  }, removeEventListener() {
  }, getComputedStyle() {
    return { getPropertyValue() {
      return "";
    } };
  }, Image() {
  }, Date() {
  }, screen: {}, setTimeout() {
  }, clearTimeout() {
  }, matchMedia() {
    return {};
  }, requestAnimationFrame(e) {
    return typeof setTimeout == "undefined" ? (e(), null) : setTimeout(e, 0);
  }, cancelAnimationFrame(e) {
    typeof setTimeout != "undefined" && clearTimeout(e);
  } };
  function ye() {
    const e = typeof window != "undefined" ? window : {};
    return Or(e, sm), e;
  }
  function kt(e = "") {
    return e.trim().split(" ").filter((t) => !!t.trim());
  }
  function rm(e) {
    const t = e;
    Object.keys(t).forEach((i) => {
      try {
        t[i] = null;
      } catch (n) {
      }
      try {
        delete t[i];
      } catch (n) {
      }
    });
  }
  function Pi(e, t = 0) {
    return setTimeout(e, t);
  }
  function Je() {
    return Date.now();
  }
  function om(e) {
    const t = ye();
    let i;
    return t.getComputedStyle && (i = t.getComputedStyle(e, null)), !i && e.currentStyle && (i = e.currentStyle), i || (i = e.style), i;
  }
  function fr(e, t = "x") {
    const i = ye();
    let n, r, o;
    const l = om(e);
    return i.WebKitCSSMatrix ? (r = l.transform || l.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map((c) => c.replace(",", ".")).join(", ")), o = new i.WebKitCSSMatrix(r === "none" ? "" : r)) : (o = l.MozTransform || l.OTransform || l.MsTransform || l.msTransform || l.transform || l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = o.toString().split(",")), t === "x" && (i.WebKitCSSMatrix ? r = o.m41 : n.length === 16 ? r = parseFloat(n[12]) : r = parseFloat(n[4])), t === "y" && (i.WebKitCSSMatrix ? r = o.m42 : n.length === 16 ? r = parseFloat(n[13]) : r = parseFloat(n[5])), r || 0;
  }
  function qi(e) {
    return typeof e == "object" && e !== null && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
  }
  function am(e) {
    return typeof window != "undefined" && typeof window.HTMLElement != "undefined" ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
  }
  function Ye(...e) {
    const t = Object(e[0]);
    for (let i = 1; i < e.length; i += 1) {
      const n = e[i];
      if (n != null && !am(n)) {
        const r = Object.keys(Object(n)).filter((o) => o !== "__proto__" && o !== "constructor" && o !== "prototype");
        for (let o = 0, l = r.length; o < l; o += 1) {
          const c = r[o], d = Object.getOwnPropertyDescriptor(n, c);
          d !== void 0 && d.enumerable && (qi(t[c]) && qi(n[c]) ? n[c].__swiper__ ? t[c] = n[c] : Ye(t[c], n[c]) : !qi(t[c]) && qi(n[c]) ? (t[c] = {}, n[c].__swiper__ ? t[c] = n[c] : Ye(t[c], n[c])) : t[c] = n[c]);
        }
      }
    }
    return t;
  }
  function qt(e, t, i) {
    e.style.setProperty(t, i);
  }
  function Rl({ swiper: e, targetPosition: t, side: i }) {
    const n = ye(), r = -e.translate;
    let o = null, l;
    const c = e.params.speed;
    e.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(e.cssModeFrameID);
    const d = t > r ? "next" : "prev", v = (y, b) => d === "next" && y >= b || d === "prev" && y <= b, E = () => {
      l = (/* @__PURE__ */ new Date()).getTime(), o === null && (o = l);
      const y = Math.max(Math.min((l - o) / c, 1), 0), b = 0.5 - Math.cos(y * Math.PI) / 2;
      let p = r + b * (t - r);
      if (v(p, t) && (p = t), e.wrapperEl.scrollTo({ [i]: p }), v(p, t)) {
        e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
          e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({ [i]: p });
        }), n.cancelAnimationFrame(e.cssModeFrameID);
        return;
      }
      e.cssModeFrameID = n.requestAnimationFrame(E);
    };
    E();
  }
  function ai(e) {
    return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
  }
  function Pe(e, t = "") {
    const i = ye(), n = [...e.children];
    return i.HTMLSlotElement && e instanceof HTMLSlotElement && n.push(...e.assignedElements()), t ? n.filter((r) => r.matches(t)) : n;
  }
  function lm(e, t) {
    const i = [t];
    for (; i.length > 0; ) {
      const n = i.shift();
      if (e === n) return true;
      i.push(...n.children, ...n.shadowRoot ? n.shadowRoot.children : [], ...n.assignedElements ? n.assignedElements() : []);
    }
  }
  function cm(e, t) {
    const i = ye();
    let n = t.contains(e);
    return !n && i.HTMLSlotElement && t instanceof HTMLSlotElement && (n = [...t.assignedElements()].includes(e), n || (n = lm(e, t))), n;
  }
  function kn(e) {
    try {
      console.warn(e);
      return;
    } catch (t) {
    }
  }
  function Xe(e, t = []) {
    const i = document.createElement(e);
    return i.classList.add(...Array.isArray(t) ? t : kt(t)), i;
  }
  function Rn(e) {
    const t = ye(), i = Le(), n = e.getBoundingClientRect(), r = i.body, o = e.clientTop || r.clientTop || 0, l = e.clientLeft || r.clientLeft || 0, c = e === t ? t.scrollY : e.scrollTop, d = e === t ? t.scrollX : e.scrollLeft;
    return { top: n.top + c - o, left: n.left + d - l };
  }
  function um(e, t) {
    const i = [];
    for (; e.previousElementSibling; ) {
      const n = e.previousElementSibling;
      t ? n.matches(t) && i.push(n) : i.push(n), e = n;
    }
    return i;
  }
  function dm(e, t) {
    const i = [];
    for (; e.nextElementSibling; ) {
      const n = e.nextElementSibling;
      t ? n.matches(t) && i.push(n) : i.push(n), e = n;
    }
    return i;
  }
  function Ht(e, t) {
    return ye().getComputedStyle(e, null).getPropertyValue(t);
  }
  function Qi(e) {
    let t = e, i;
    if (t) {
      for (i = 0; (t = t.previousSibling) !== null; ) t.nodeType === 1 && (i += 1);
      return i;
    }
  }
  function Qt(e, t) {
    const i = [];
    let n = e.parentElement;
    for (; n; ) t ? n.matches(t) && i.push(n) : i.push(n), n = n.parentElement;
    return i;
  }
  function Zi(e, t) {
    function i(n) {
      n.target === e && (t.call(e, n), e.removeEventListener("transitionend", i));
    }
    t && e.addEventListener("transitionend", i);
  }
  function hr(e, t, i) {
    const n = ye();
    return e[t === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(e, null).getPropertyValue(t === "width" ? "margin-left" : "margin-bottom"));
  }
  function ue(e) {
    return (Array.isArray(e) ? e : [e]).filter((t) => !!t);
  }
  function Zn(e) {
    return (t) => Math.abs(t) > 0 && e.browser && e.browser.need3dFix && Math.abs(t) % 90 === 0 ? t + 1e-3 : t;
  }
  function bt(e, t = "") {
    typeof trustedTypes != "undefined" ? e.innerHTML = trustedTypes.createPolicy("html", { createHTML: (i) => i }).createHTML(t) : e.innerHTML = t;
  }
  let Rs;
  function fm() {
    const e = ye(), t = Le();
    return { smoothScroll: t.documentElement && t.documentElement.style && "scrollBehavior" in t.documentElement.style, touch: !!("ontouchstart" in e || e.DocumentTouch && t instanceof e.DocumentTouch) };
  }
  function Hl() {
    return Rs || (Rs = fm()), Rs;
  }
  let Hs;
  function hm({ userAgent: e } = {}) {
    const t = Hl(), i = ye(), n = i.navigator.platform, r = e || i.navigator.userAgent, o = { ios: false, android: false }, l = i.screen.width, c = i.screen.height, d = r.match(/(Android);?[\s\/]+([\d.]+)?/);
    let v = r.match(/(iPad)(?!\1).*OS\s([\d_]+)/);
    const E = r.match(/(iPod)(.*OS\s([\d_]+))?/), y = !v && r.match(/(iPhone\sOS|iOS)\s([\d_]+)/), b = n === "Win32";
    let p = n === "MacIntel";
    const g = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
    return !v && p && t.touch && g.indexOf(`${l}x${c}`) >= 0 && (v = r.match(/(Version)\/([\d.]+)/), v || (v = [0, 1, "13_0_0"]), p = false), d && !b && (o.os = "android", o.android = true), (v || y || E) && (o.os = "ios", o.ios = true), o;
  }
  function Bl(e = {}) {
    return Hs || (Hs = hm(e)), Hs;
  }
  let Bs;
  function pm() {
    const e = ye(), t = Bl();
    let i = false;
    function n() {
      const c = e.navigator.userAgent.toLowerCase();
      return c.indexOf("safari") >= 0 && c.indexOf("chrome") < 0 && c.indexOf("android") < 0;
    }
    if (n()) {
      const c = String(e.navigator.userAgent);
      if (c.includes("Version/")) {
        const [d, v] = c.split("Version/")[1].split(" ")[0].split(".").map((E) => Number(E));
        i = d < 16 || d === 16 && v < 2;
      }
    }
    const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), o = n(), l = o || r && t.ios;
    return { isSafari: i || o, needPerspectiveFix: i, need3dFix: l, isWebView: r };
  }
  function Vl() {
    return Bs || (Bs = pm()), Bs;
  }
  function mm({ swiper: e, on: t, emit: i }) {
    const n = ye();
    let r = null, o = null;
    const l = () => {
      !e || e.destroyed || !e.initialized || (i("beforeResize"), i("resize"));
    }, c = () => {
      !e || e.destroyed || !e.initialized || (r = new ResizeObserver((E) => {
        o = n.requestAnimationFrame(() => {
          const { width: y, height: b } = e;
          let p = y, g = b;
          E.forEach(({ contentBoxSize: C, contentRect: _, target: h }) => {
            h && h !== e.el || (p = _ ? _.width : (C[0] || C).inlineSize, g = _ ? _.height : (C[0] || C).blockSize);
          }), (p !== y || g !== b) && l();
        });
      }), r.observe(e.el));
    }, d = () => {
      o && n.cancelAnimationFrame(o), r && r.unobserve && e.el && (r.unobserve(e.el), r = null);
    }, v = () => {
      !e || e.destroyed || !e.initialized || i("orientationchange");
    };
    t("init", () => {
      if (e.params.resizeObserver && typeof n.ResizeObserver != "undefined") {
        c();
        return;
      }
      n.addEventListener("resize", l), n.addEventListener("orientationchange", v);
    }), t("destroy", () => {
      d(), n.removeEventListener("resize", l), n.removeEventListener("orientationchange", v);
    });
  }
  function gm({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = [], o = ye(), l = (v, E = {}) => {
      const y = o.MutationObserver || o.WebkitMutationObserver, b = new y((p) => {
        if (e.__preventObserver__) return;
        if (p.length === 1) {
          n("observerUpdate", p[0]);
          return;
        }
        const g = function() {
          n("observerUpdate", p[0]);
        };
        o.requestAnimationFrame ? o.requestAnimationFrame(g) : o.setTimeout(g, 0);
      });
      b.observe(v, { attributes: typeof E.attributes == "undefined" ? true : E.attributes, childList: e.isElement || (typeof E.childList == "undefined" ? true : E).childList, characterData: typeof E.characterData == "undefined" ? true : E.characterData }), r.push(b);
    }, c = () => {
      if (e.params.observer) {
        if (e.params.observeParents) {
          const v = Qt(e.hostEl);
          for (let E = 0; E < v.length; E += 1) l(v[E]);
        }
        l(e.hostEl, { childList: e.params.observeSlideChildren }), l(e.wrapperEl, { attributes: false });
      }
    }, d = () => {
      r.forEach((v) => {
        v.disconnect();
      }), r.splice(0, r.length);
    };
    t({ observer: false, observeParents: false, observeSlideChildren: false }), i("init", c), i("destroy", d);
  }
  var vm = { on(e, t, i) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof t != "function") return n;
    const r = i ? "unshift" : "push";
    return e.split(" ").forEach((o) => {
      n.eventsListeners[o] || (n.eventsListeners[o] = []), n.eventsListeners[o][r](t);
    }), n;
  }, once(e, t, i) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof t != "function") return n;
    function r(...o) {
      n.off(e, r), r.__emitterProxy && delete r.__emitterProxy, t.apply(n, o);
    }
    return r.__emitterProxy = t, n.on(e, r, i);
  }, onAny(e, t) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof e != "function") return i;
    const n = t ? "unshift" : "push";
    return i.eventsAnyListeners.indexOf(e) < 0 && i.eventsAnyListeners[n](e), i;
  }, offAny(e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
    const i = t.eventsAnyListeners.indexOf(e);
    return i >= 0 && t.eventsAnyListeners.splice(i, 1), t;
  }, off(e, t) {
    const i = this;
    return !i.eventsListeners || i.destroyed || !i.eventsListeners || e.split(" ").forEach((n) => {
      typeof t == "undefined" ? i.eventsListeners[n] = [] : i.eventsListeners[n] && i.eventsListeners[n].forEach((r, o) => {
        (r === t || r.__emitterProxy && r.__emitterProxy === t) && i.eventsListeners[n].splice(o, 1);
      });
    }), i;
  }, emit(...e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let i, n, r;
    return typeof e[0] == "string" || Array.isArray(e[0]) ? (i = e[0], n = e.slice(1, e.length), r = t) : (i = e[0].events, n = e[0].data, r = e[0].context || t), n.unshift(r), (Array.isArray(i) ? i : i.split(" ")).forEach((l) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((c) => {
        c.apply(r, [l, ...n]);
      }), t.eventsListeners && t.eventsListeners[l] && t.eventsListeners[l].forEach((c) => {
        c.apply(r, n);
      });
    }), t;
  } };
  function ym() {
    const e = this;
    let t, i;
    const n = e.el;
    typeof e.params.width != "undefined" && e.params.width !== null ? t = e.params.width : t = n.clientWidth, typeof e.params.height != "undefined" && e.params.height !== null ? i = e.params.height : i = n.clientHeight, !(t === 0 && e.isHorizontal() || i === 0 && e.isVertical()) && (t = t - parseInt(Ht(n, "padding-left") || 0, 10) - parseInt(Ht(n, "padding-right") || 0, 10), i = i - parseInt(Ht(n, "padding-top") || 0, 10) - parseInt(Ht(n, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(i) && (i = 0), Object.assign(e, { width: t, height: i, size: e.isHorizontal() ? t : i }));
  }
  function bm() {
    const e = this;
    function t(N, $) {
      return parseFloat(N.getPropertyValue(e.getDirectionLabel($)) || 0);
    }
    const i = e.params, { wrapperEl: n, slidesEl: r, rtlTranslate: o, wrongRTL: l } = e, c = e.virtual && i.virtual.enabled, d = c ? e.virtual.slides.length : e.slides.length, v = Pe(r, `.${e.params.slideClass}, swiper-slide`), E = c ? e.virtual.slides.length : v.length;
    let y = [];
    const b = [], p = [];
    let g = i.slidesOffsetBefore;
    typeof g == "function" && (g = i.slidesOffsetBefore.call(e));
    let C = i.slidesOffsetAfter;
    typeof C == "function" && (C = i.slidesOffsetAfter.call(e));
    const _ = e.snapGrid.length, h = e.slidesGrid.length, S = e.size - g - C;
    let w = i.spaceBetween, A = -g, L = 0, f = 0;
    if (typeof S == "undefined") return;
    typeof w == "string" && w.indexOf("%") >= 0 ? w = parseFloat(w.replace("%", "")) / 100 * S : typeof w == "string" && (w = parseFloat(w)), e.virtualSize = -w - g - C, v.forEach((N) => {
      o ? N.style.marginLeft = "" : N.style.marginRight = "", N.style.marginBottom = "", N.style.marginTop = "";
    }), i.centeredSlides && i.cssMode && (qt(n, "--swiper-centered-offset-before", ""), qt(n, "--swiper-centered-offset-after", "")), i.cssMode && (qt(n, "--swiper-slides-offset-before", `${g}px`), qt(n, "--swiper-slides-offset-after", `${C}px`));
    const P = i.grid && i.grid.rows > 1 && e.grid;
    P ? e.grid.initSlides(v) : e.grid && e.grid.unsetSlides();
    let D;
    const R = i.slidesPerView === "auto" && i.breakpoints && Object.keys(i.breakpoints).filter((N) => typeof i.breakpoints[N].slidesPerView != "undefined").length > 0;
    for (let N = 0; N < E; N += 1) {
      D = 0;
      const $ = v[N];
      if (!($ && (P && e.grid.updateSlide(N, $, v), Ht($, "display") === "none"))) {
        if (c && i.slidesPerView === "auto") i.virtual.slidesPerViewAutoSlideSize && (D = i.virtual.slidesPerViewAutoSlideSize), D && $ && (i.roundLengths && (D = Math.floor(D)), $.style[e.getDirectionLabel("width")] = `${D}px`);
        else if (i.slidesPerView === "auto") {
          R && ($.style[e.getDirectionLabel("width")] = "");
          const B = getComputedStyle($), V = $.style.transform, X = $.style.webkitTransform;
          if (V && ($.style.transform = "none"), X && ($.style.webkitTransform = "none"), i.roundLengths) D = e.isHorizontal() ? hr($, "width") : hr($, "height");
          else {
            const Z = t(B, "width"), F = t(B, "padding-left"), W = t(B, "padding-right"), Y = t(B, "margin-left"), J = t(B, "margin-right"), oe = B.getPropertyValue("box-sizing");
            if (oe && oe === "border-box") D = Z + Y + J;
            else {
              const { clientWidth: he, offsetWidth: _e } = $;
              D = Z + F + W + Y + J + (_e - he);
            }
          }
          V && ($.style.transform = V), X && ($.style.webkitTransform = X), i.roundLengths && (D = Math.floor(D));
        } else D = (S - (i.slidesPerView - 1) * w) / i.slidesPerView, i.roundLengths && (D = Math.floor(D)), $ && ($.style[e.getDirectionLabel("width")] = `${D}px`);
        $ && ($.swiperSlideSize = D), p.push(D), i.centeredSlides ? (A = A + D / 2 + L / 2 + w, L === 0 && N !== 0 && (A = A - S / 2 - w), N === 0 && (A = A - S / 2 - w), Math.abs(A) < 1 / 1e3 && (A = 0), i.roundLengths && (A = Math.floor(A)), f % i.slidesPerGroup === 0 && y.push(A), b.push(A)) : (i.roundLengths && (A = Math.floor(A)), (f - Math.min(e.params.slidesPerGroupSkip, f)) % e.params.slidesPerGroup === 0 && y.push(A), b.push(A), A = A + D + w), e.virtualSize += D + w, L = D, f += 1;
      }
    }
    if (e.virtualSize = Math.max(e.virtualSize, S) + C, o && l && (i.effect === "slide" || i.effect === "coverflow") && (n.style.width = `${e.virtualSize + w}px`), i.setWrapperSize && (n.style[e.getDirectionLabel("width")] = `${e.virtualSize + w}px`), P && e.grid.updateWrapperSize(D, y), !i.centeredSlides) {
      const N = i.slidesPerView !== "auto" && i.slidesPerView % 1 !== 0, $ = i.snapToSlideEdge && !i.loop && (i.slidesPerView === "auto" || N);
      let B = y.length;
      if ($) {
        let X;
        if (i.slidesPerView === "auto") {
          X = 1;
          let Z = 0;
          for (let F = p.length - 1; F >= 0 && (Z += p[F] + (F < p.length - 1 ? w : 0), Z <= S); F -= 1) X = p.length - F;
        } else X = Math.floor(i.slidesPerView);
        B = Math.max(E - X, 0);
      }
      const V = [];
      for (let X = 0; X < y.length; X += 1) {
        let Z = y[X];
        i.roundLengths && (Z = Math.floor(Z)), $ ? X <= B && V.push(Z) : y[X] <= e.virtualSize - S && V.push(Z);
      }
      y = V, Math.floor(e.virtualSize - S) - Math.floor(y[y.length - 1]) > 1 && ($ || y.push(e.virtualSize - S));
    }
    if (c && i.loop) {
      const N = p[0] + w;
      if (i.slidesPerGroup > 1) {
        const $ = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / i.slidesPerGroup), B = N * i.slidesPerGroup;
        for (let V = 0; V < $; V += 1) y.push(y[y.length - 1] + B);
      }
      for (let $ = 0; $ < e.virtual.slidesBefore + e.virtual.slidesAfter; $ += 1) i.slidesPerGroup === 1 && y.push(y[y.length - 1] + N), b.push(b[b.length - 1] + N), e.virtualSize += N;
    }
    if (y.length === 0 && (y = [0]), w !== 0) {
      const N = e.isHorizontal() && o ? "marginLeft" : e.getDirectionLabel("marginRight");
      v.filter(($, B) => !i.cssMode || i.loop ? true : B !== v.length - 1).forEach(($) => {
        $.style[N] = `${w}px`;
      });
    }
    if (i.centeredSlides && i.centeredSlidesBounds) {
      let N = 0;
      p.forEach((B) => {
        N += B + (w || 0);
      }), N -= w;
      const $ = N > S ? N - S : 0;
      y = y.map((B) => B <= 0 ? -g : B > $ ? $ + C : B);
    }
    if (i.centerInsufficientSlides) {
      let N = 0;
      if (p.forEach(($) => {
        N += $ + (w || 0);
      }), N -= w, N < S) {
        const $ = (S - N) / 2;
        y.forEach((B, V) => {
          y[V] = B - $;
        }), b.forEach((B, V) => {
          b[V] = B + $;
        });
      }
    }
    if (Object.assign(e, { slides: v, snapGrid: y, slidesGrid: b, slidesSizesGrid: p }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
      qt(n, "--swiper-centered-offset-before", `${-y[0]}px`), qt(n, "--swiper-centered-offset-after", `${e.size / 2 - p[p.length - 1] / 2}px`);
      const N = -e.snapGrid[0], $ = -e.slidesGrid[0];
      e.snapGrid = e.snapGrid.map((B) => B + N), e.slidesGrid = e.slidesGrid.map((B) => B + $);
    }
    if (E !== d && e.emit("slidesLengthChange"), y.length !== _ && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), b.length !== h && e.emit("slidesGridLengthChange"), i.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !c && !i.cssMode && (i.effect === "slide" || i.effect === "fade")) {
      const N = `${i.containerModifierClass}backface-hidden`, $ = e.el.classList.contains(N);
      E <= i.maxBackfaceHiddenSlides ? $ || e.el.classList.add(N) : $ && e.el.classList.remove(N);
    }
  }
  function Em(e) {
    const t = this, i = [], n = t.virtual && t.params.virtual.enabled;
    let r = 0, o;
    typeof e == "number" ? t.setTransition(e) : e === true && t.setTransition(t.params.speed);
    const l = (c) => n ? t.slides[t.getSlideIndexByData(c)] : t.slides[c];
    if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1) if (t.params.centeredSlides) (t.visibleSlides || []).forEach((c) => {
      i.push(c);
    });
    else for (o = 0; o < Math.ceil(t.params.slidesPerView); o += 1) {
      const c = t.activeIndex + o;
      if (c > t.slides.length && !n) break;
      i.push(l(c));
    }
    else i.push(l(t.activeIndex));
    for (o = 0; o < i.length; o += 1) if (typeof i[o] != "undefined") {
      const c = i[o].offsetHeight;
      r = c > r ? c : r;
    }
    (r || r === 0) && (t.wrapperEl.style.height = `${r}px`);
  }
  function Sm() {
    const e = this, t = e.slides, i = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
    for (let n = 0; n < t.length; n += 1) t[n].swiperSlideOffset = (e.isHorizontal() ? t[n].offsetLeft : t[n].offsetTop) - i - e.cssOverflowAdjustment();
  }
  const ca = (e, t, i) => {
    t && !e.classList.contains(i) ? e.classList.add(i) : !t && e.classList.contains(i) && e.classList.remove(i);
  };
  function Tm(e = this && this.translate || 0) {
    const t = this, i = t.params, { slides: n, rtlTranslate: r, snapGrid: o } = t;
    if (n.length === 0) return;
    typeof n[0].swiperSlideOffset == "undefined" && t.updateSlidesOffset();
    let l = -e;
    r && (l = e), t.visibleSlidesIndexes = [], t.visibleSlides = [];
    let c = i.spaceBetween;
    typeof c == "string" && c.indexOf("%") >= 0 ? c = parseFloat(c.replace("%", "")) / 100 * t.size : typeof c == "string" && (c = parseFloat(c));
    for (let d = 0; d < n.length; d += 1) {
      const v = n[d];
      let E = v.swiperSlideOffset;
      i.cssMode && i.centeredSlides && (E -= n[0].swiperSlideOffset);
      const y = (l + (i.centeredSlides ? t.minTranslate() : 0) - E) / (v.swiperSlideSize + c), b = (l - o[0] + (i.centeredSlides ? t.minTranslate() : 0) - E) / (v.swiperSlideSize + c), p = -(l - E), g = p + t.slidesSizesGrid[d], C = p >= 0 && p <= t.size - t.slidesSizesGrid[d], _ = p >= 0 && p < t.size - 1 || g > 1 && g <= t.size || p <= 0 && g >= t.size;
      _ && (t.visibleSlides.push(v), t.visibleSlidesIndexes.push(d)), ca(v, _, i.slideVisibleClass), ca(v, C, i.slideFullyVisibleClass), v.progress = r ? -y : y, v.originalProgress = r ? -b : b;
    }
  }
  function _m(e) {
    const t = this;
    if (typeof e == "undefined") {
      const E = t.rtlTranslate ? -1 : 1;
      e = t && t.translate && t.translate * E || 0;
    }
    const i = t.params, n = t.maxTranslate() - t.minTranslate();
    let { progress: r, isBeginning: o, isEnd: l, progressLoop: c } = t;
    const d = o, v = l;
    if (n === 0) r = 0, o = true, l = true;
    else {
      r = (e - t.minTranslate()) / n;
      const E = Math.abs(e - t.minTranslate()) < 1, y = Math.abs(e - t.maxTranslate()) < 1;
      o = E || r <= 0, l = y || r >= 1, E && (r = 0), y && (r = 1);
    }
    if (i.loop) {
      const E = t.getSlideIndexByData(0), y = t.getSlideIndexByData(t.slides.length - 1), b = t.slidesGrid[E], p = t.slidesGrid[y], g = t.slidesGrid[t.slidesGrid.length - 1], C = Math.abs(e);
      C >= b ? c = (C - b) / g : c = (C + g - p) / g, c > 1 && (c -= 1);
    }
    Object.assign(t, { progress: r, progressLoop: c, isBeginning: o, isEnd: l }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && t.updateSlidesProgress(e), o && !d && t.emit("reachBeginning toEdge"), l && !v && t.emit("reachEnd toEdge"), (d && !o || v && !l) && t.emit("fromEdge"), t.emit("progress", r);
  }
  const Vs = (e, t, i) => {
    t && !e.classList.contains(i) ? e.classList.add(i) : !t && e.classList.contains(i) && e.classList.remove(i);
  };
  function xm() {
    const e = this, { slides: t, params: i, slidesEl: n, activeIndex: r } = e, o = e.virtual && i.virtual.enabled, l = e.grid && i.grid && i.grid.rows > 1, c = (y) => Pe(n, `.${i.slideClass}${y}, swiper-slide${y}`)[0];
    let d, v, E;
    if (o) if (i.loop) {
      let y = r - e.virtual.slidesBefore;
      y < 0 && (y = e.virtual.slides.length + y), y >= e.virtual.slides.length && (y -= e.virtual.slides.length), d = c(`[data-swiper-slide-index="${y}"]`);
    } else d = c(`[data-swiper-slide-index="${r}"]`);
    else l ? (d = t.find((y) => y.column === r), E = t.find((y) => y.column === r + 1), v = t.find((y) => y.column === r - 1)) : d = t[r];
    d && (l || (E = dm(d, `.${i.slideClass}, swiper-slide`)[0], i.loop && !E && (E = t[0]), v = um(d, `.${i.slideClass}, swiper-slide`)[0], i.loop && !v === 0 && (v = t[t.length - 1]))), t.forEach((y) => {
      Vs(y, y === d, i.slideActiveClass), Vs(y, y === E, i.slideNextClass), Vs(y, y === v, i.slidePrevClass);
    }), e.emitSlidesClasses();
  }
  const Ln = (e, t) => {
    if (!e || e.destroyed || !e.params) return;
    const i = () => e.isElement ? "swiper-slide" : `.${e.params.slideClass}`, n = t.closest(i());
    if (n) {
      let r = n.querySelector(`.${e.params.lazyPreloaderClass}`);
      !r && e.isElement && (n.shadowRoot ? r = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
        n.shadowRoot && (r = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), r && !r.lazyPreloaderManaged && r.remove());
      })), r && !r.lazyPreloaderManaged && r.remove();
    }
  }, Ws = (e, t) => {
    if (!e.slides[t]) return;
    const i = e.slides[t].querySelector('[loading="lazy"]');
    i && i.removeAttribute("loading");
  }, pr = (e) => {
    if (!e || e.destroyed || !e.params) return;
    let t = e.params.lazyPreloadPrevNext;
    const i = e.slides.length;
    if (!i || !t || t < 0) return;
    t = Math.min(t, i);
    const n = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), r = e.activeIndex;
    if (e.params.grid && e.params.grid.rows > 1) {
      const l = r, c = [l - t];
      c.push(...Array.from({ length: t }).map((d, v) => l + n + v)), e.slides.forEach((d, v) => {
        c.includes(d.column) && Ws(e, v);
      });
      return;
    }
    const o = r + n - 1;
    if (e.params.rewind || e.params.loop) for (let l = r - t; l <= o + t; l += 1) {
      const c = (l % i + i) % i;
      (c < r || c > o) && Ws(e, c);
    }
    else for (let l = Math.max(r - t, 0); l <= Math.min(o + t, i - 1); l += 1) l !== r && (l > o || l < r) && Ws(e, l);
  };
  function Cm(e) {
    const { slidesGrid: t, params: i } = e, n = e.rtlTranslate ? e.translate : -e.translate;
    let r;
    for (let o = 0; o < t.length; o += 1) typeof t[o + 1] != "undefined" ? n >= t[o] && n < t[o + 1] - (t[o + 1] - t[o]) / 2 ? r = o : n >= t[o] && n < t[o + 1] && (r = o + 1) : n >= t[o] && (r = o);
    return i.normalizeSlideIndex && (r < 0 || typeof r == "undefined") && (r = 0), r;
  }
  function wm(e) {
    const t = this, i = t.rtlTranslate ? t.translate : -t.translate, { snapGrid: n, params: r, activeIndex: o, realIndex: l, snapIndex: c } = t;
    let d = e, v;
    const E = (p) => {
      let g = p - t.virtual.slidesBefore;
      return g < 0 && (g = t.virtual.slides.length + g), g >= t.virtual.slides.length && (g -= t.virtual.slides.length), g;
    };
    if (typeof d == "undefined" && (d = Cm(t)), n.indexOf(i) >= 0) v = n.indexOf(i);
    else {
      const p = Math.min(r.slidesPerGroupSkip, d);
      v = p + Math.floor((d - p) / r.slidesPerGroup);
    }
    if (v >= n.length && (v = n.length - 1), d === o && !t.params.loop) {
      v !== c && (t.snapIndex = v, t.emit("snapIndexChange"));
      return;
    }
    if (d === o && t.params.loop && t.virtual && t.params.virtual.enabled) {
      t.realIndex = E(d);
      return;
    }
    const y = t.grid && r.grid && r.grid.rows > 1;
    let b;
    if (t.virtual && r.virtual.enabled) r.loop ? b = E(d) : b = d;
    else if (y) {
      const p = t.slides.find((C) => C.column === d);
      let g = parseInt(p.getAttribute("data-swiper-slide-index"), 10);
      Number.isNaN(g) && (g = Math.max(t.slides.indexOf(p), 0)), b = Math.floor(g / r.grid.rows);
    } else if (t.slides[d]) {
      const p = t.slides[d].getAttribute("data-swiper-slide-index");
      p ? b = parseInt(p, 10) : b = d;
    } else b = d;
    Object.assign(t, { previousSnapIndex: c, snapIndex: v, previousRealIndex: l, realIndex: b, previousIndex: o, activeIndex: d }), t.initialized && pr(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (l !== b && t.emit("realIndexChange"), t.emit("slideChange"));
  }
  function Im(e, t) {
    const i = this, n = i.params;
    let r = e.closest(`.${n.slideClass}, swiper-slide`);
    !r && i.isElement && t && t.length > 1 && t.includes(e) && [...t.slice(t.indexOf(e) + 1, t.length)].forEach((c) => {
      !r && c.matches && c.matches(`.${n.slideClass}, swiper-slide`) && (r = c);
    });
    let o = false, l;
    if (r) {
      for (let c = 0; c < i.slides.length; c += 1) if (i.slides[c] === r) {
        o = true, l = c;
        break;
      }
    }
    if (r && o) i.clickedSlide = r, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = l;
    else {
      i.clickedSlide = void 0, i.clickedIndex = void 0;
      return;
    }
    n.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
  }
  var Am = { updateSize: ym, updateSlides: bm, updateAutoHeight: Em, updateSlidesOffset: Sm, updateSlidesProgress: Tm, updateProgress: _m, updateSlidesClasses: xm, updateActiveIndex: wm, updateClickedSlide: Im };
  function Om(e = this.isHorizontal() ? "x" : "y") {
    const t = this, { params: i, rtlTranslate: n, translate: r, wrapperEl: o } = t;
    if (i.virtualTranslate) return n ? -r : r;
    if (i.cssMode) return r;
    let l = fr(o, e);
    return l += t.cssOverflowAdjustment(), n && (l = -l), l || 0;
  }
  function Mm(e, t) {
    const i = this, { rtlTranslate: n, params: r, wrapperEl: o, progress: l } = i;
    let c = 0, d = 0;
    const v = 0;
    i.isHorizontal() ? c = n ? -e : e : d = e, r.roundLengths && (c = Math.floor(c), d = Math.floor(d)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? c : d, r.cssMode ? o[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -c : -d : r.virtualTranslate || (i.isHorizontal() ? c -= i.cssOverflowAdjustment() : d -= i.cssOverflowAdjustment(), o.style.transform = `translate3d(${c}px, ${d}px, ${v}px)`);
    let E;
    const y = i.maxTranslate() - i.minTranslate();
    y === 0 ? E = 0 : E = (e - i.minTranslate()) / y, E !== l && i.updateProgress(e), i.emit("setTranslate", i.translate, t);
  }
  function Lm() {
    return -this.snapGrid[0];
  }
  function Pm() {
    return -this.snapGrid[this.snapGrid.length - 1];
  }
  function Dm(e = 0, t = this.params.speed, i = true, n = true, r) {
    const o = this, { params: l, wrapperEl: c } = o;
    if (o.animating && l.preventInteractionOnTransition) return false;
    const d = o.minTranslate(), v = o.maxTranslate();
    let E;
    if (n && e > d ? E = d : n && e < v ? E = v : E = e, o.updateProgress(E), l.cssMode) {
      const y = o.isHorizontal();
      if (t === 0) c[y ? "scrollLeft" : "scrollTop"] = -E;
      else {
        if (!o.support.smoothScroll) return Rl({ swiper: o, targetPosition: -E, side: y ? "left" : "top" }), true;
        c.scrollTo({ [y ? "left" : "top"]: -E, behavior: "smooth" });
      }
      return true;
    }
    return t === 0 ? (o.setTransition(0), o.setTranslate(E), i && (o.emit("beforeTransitionStart", t, r), o.emit("transitionEnd"))) : (o.setTransition(t), o.setTranslate(E), i && (o.emit("beforeTransitionStart", t, r), o.emit("transitionStart")), o.animating || (o.animating = true, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(b) {
      !o || o.destroyed || b.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, o.animating = false, i && o.emit("transitionEnd"));
    }), o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))), true;
  }
  var zm = { getTranslate: Om, setTranslate: Mm, minTranslate: Lm, maxTranslate: Pm, translateTo: Dm };
  function $m(e, t) {
    const i = this;
    i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${e}ms`, i.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), i.emit("setTransition", e, t);
  }
  function Wl({ swiper: e, runCallbacks: t, direction: i, step: n }) {
    const { activeIndex: r, previousIndex: o } = e;
    let l = i;
    l || (r > o ? l = "next" : r < o ? l = "prev" : l = "reset"), e.emit(`transition${n}`), t && l === "reset" ? e.emit(`slideResetTransition${n}`) : t && r !== o && (e.emit(`slideChangeTransition${n}`), l === "next" ? e.emit(`slideNextTransition${n}`) : e.emit(`slidePrevTransition${n}`));
  }
  function Nm(e = true, t) {
    const i = this, { params: n } = i;
    n.cssMode || (n.autoHeight && i.updateAutoHeight(), Wl({ swiper: i, runCallbacks: e, direction: t, step: "Start" }));
  }
  function km(e = true, t) {
    const i = this, { params: n } = i;
    i.animating = false, !n.cssMode && (i.setTransition(0), Wl({ swiper: i, runCallbacks: e, direction: t, step: "End" }));
  }
  var Rm = { setTransition: $m, transitionStart: Nm, transitionEnd: km };
  function Hm(e = 0, t, i = true, n, r) {
    typeof e == "string" && (e = parseInt(e, 10));
    const o = this;
    let l = e;
    l < 0 && (l = 0);
    const { params: c, snapGrid: d, slidesGrid: v, previousIndex: E, activeIndex: y, rtlTranslate: b, wrapperEl: p, enabled: g } = o;
    if (!g && !n && !r || o.destroyed || o.animating && c.preventInteractionOnTransition) return false;
    typeof t == "undefined" && (t = o.params.speed);
    const C = Math.min(o.params.slidesPerGroupSkip, l);
    let _ = C + Math.floor((l - C) / o.params.slidesPerGroup);
    _ >= d.length && (_ = d.length - 1);
    const h = -d[_];
    if (c.normalizeSlideIndex) for (let P = 0; P < v.length; P += 1) {
      const D = -Math.floor(h * 100), R = Math.floor(v[P] * 100), N = Math.floor(v[P + 1] * 100);
      typeof v[P + 1] != "undefined" ? D >= R && D < N - (N - R) / 2 ? l = P : D >= R && D < N && (l = P + 1) : D >= R && (l = P);
    }
    if (o.initialized && l !== y && (!o.allowSlideNext && (b ? h > o.translate && h > o.minTranslate() : h < o.translate && h < o.minTranslate()) || !o.allowSlidePrev && h > o.translate && h > o.maxTranslate() && (y || 0) !== l)) return false;
    l !== (E || 0) && i && o.emit("beforeSlideChangeStart"), o.updateProgress(h);
    let S;
    l > y ? S = "next" : l < y ? S = "prev" : S = "reset";
    const w = o.virtual && o.params.virtual.enabled;
    if (!(w && r) && (b && -h === o.translate || !b && h === o.translate)) return o.updateActiveIndex(l), c.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), c.effect !== "slide" && o.setTranslate(h), S !== "reset" && (o.transitionStart(i, S), o.transitionEnd(i, S)), false;
    if (c.cssMode) {
      const P = o.isHorizontal(), D = b ? h : -h;
      if (t === 0) w && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = true), w && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0 ? (o._cssModeVirtualInitialSet = true, requestAnimationFrame(() => {
        p[P ? "scrollLeft" : "scrollTop"] = D;
      })) : p[P ? "scrollLeft" : "scrollTop"] = D, w && requestAnimationFrame(() => {
        o.wrapperEl.style.scrollSnapType = "", o._immediateVirtual = false;
      });
      else {
        if (!o.support.smoothScroll) return Rl({ swiper: o, targetPosition: D, side: P ? "left" : "top" }), true;
        p.scrollTo({ [P ? "left" : "top"]: D, behavior: "smooth" });
      }
      return true;
    }
    const f = Vl().isSafari;
    return w && !r && f && o.isElement && o.virtual.update(false, false, l), o.setTransition(t), o.setTranslate(h), o.updateActiveIndex(l), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, n), o.transitionStart(i, S), t === 0 ? o.transitionEnd(i, S) : o.animating || (o.animating = true, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(D) {
      !o || o.destroyed || D.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(i, S));
    }), o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)), true;
  }
  function Bm(e = 0, t, i = true, n) {
    typeof e == "string" && (e = parseInt(e, 10));
    const r = this;
    if (r.destroyed) return;
    typeof t == "undefined" && (t = r.params.speed);
    const o = r.grid && r.params.grid && r.params.grid.rows > 1;
    let l = e;
    if (r.params.loop) if (r.virtual && r.params.virtual.enabled) l = l + r.virtual.slidesBefore;
    else {
      let c;
      if (o) {
        const C = l * r.params.grid.rows;
        c = r.slides.find((_) => _.getAttribute("data-swiper-slide-index") * 1 === C).column;
      } else c = r.getSlideIndexByData(l);
      const d = o ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length, { centeredSlides: v, slidesOffsetBefore: E, slidesOffsetAfter: y } = r.params, b = v || !!E || !!y;
      let p = r.params.slidesPerView;
      p === "auto" ? p = r.slidesPerViewDynamic() : (p = Math.ceil(parseFloat(r.params.slidesPerView, 10)), b && p % 2 === 0 && (p = p + 1));
      let g = d - c < p;
      if (b && (g = g || c < Math.ceil(p / 2)), n && b && r.params.slidesPerView !== "auto" && !o && (g = false), g) {
        const C = b ? c < r.activeIndex ? "prev" : "next" : c - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
        r.loopFix({ direction: C, slideTo: true, activeSlideIndex: C === "next" ? c + 1 : c - d + 1, slideRealIndex: C === "next" ? r.realIndex : void 0 });
      }
      if (o) {
        const C = l * r.params.grid.rows;
        l = r.slides.find((_) => _.getAttribute("data-swiper-slide-index") * 1 === C).column;
      } else l = r.getSlideIndexByData(l);
    }
    return requestAnimationFrame(() => {
      r.slideTo(l, t, i, n);
    }), r;
  }
  function Vm(e, t = true, i) {
    const n = this, { enabled: r, params: o, animating: l } = n;
    if (!r || n.destroyed) return n;
    typeof e == "undefined" && (e = n.params.speed);
    let c = o.slidesPerGroup;
    o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (c = Math.max(n.slidesPerViewDynamic("current", true), 1));
    const d = n.activeIndex < o.slidesPerGroupSkip ? 1 : c, v = n.virtual && o.virtual.enabled;
    if (o.loop) {
      if (l && !v && o.loopPreventsSliding) return false;
      if (n.loopFix({ direction: "next" }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && o.cssMode) return requestAnimationFrame(() => {
        n.slideTo(n.activeIndex + d, e, t, i);
      }), true;
    }
    return o.rewind && n.isEnd ? n.slideTo(0, e, t, i) : n.slideTo(n.activeIndex + d, e, t, i);
  }
  function Wm(e, t = true, i) {
    const n = this, { params: r, snapGrid: o, slidesGrid: l, rtlTranslate: c, enabled: d, animating: v } = n;
    if (!d || n.destroyed) return n;
    typeof e == "undefined" && (e = n.params.speed);
    const E = n.virtual && r.virtual.enabled;
    if (r.loop) {
      if (v && !E && r.loopPreventsSliding) return false;
      n.loopFix({ direction: "prev" }), n._clientLeft = n.wrapperEl.clientLeft;
    }
    const y = c ? n.translate : -n.translate;
    function b(S) {
      return S < 0 ? -Math.floor(Math.abs(S)) : Math.floor(S);
    }
    const p = b(y), g = o.map((S) => b(S)), C = r.freeMode && r.freeMode.enabled;
    let _ = o[g.indexOf(p) - 1];
    if (typeof _ == "undefined" && (r.cssMode || C)) {
      let S;
      o.forEach((w, A) => {
        p >= w && (S = A);
      }), typeof S != "undefined" && (_ = C ? o[S] : o[S > 0 ? S - 1 : S]);
    }
    let h = 0;
    if (typeof _ != "undefined" && (h = l.indexOf(_), h < 0 && (h = n.activeIndex - 1), r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (h = h - n.slidesPerViewDynamic("previous", true) + 1, h = Math.max(h, 0))), r.rewind && n.isBeginning) {
      const S = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
      return n.slideTo(S, e, t, i);
    } else if (r.loop && n.activeIndex === 0 && r.cssMode) return requestAnimationFrame(() => {
      n.slideTo(h, e, t, i);
    }), true;
    return n.slideTo(h, e, t, i);
  }
  function Fm(e, t = true, i) {
    const n = this;
    if (!n.destroyed) return typeof e == "undefined" && (e = n.params.speed), n.slideTo(n.activeIndex, e, t, i);
  }
  function Gm(e, t = true, i, n = 0.5) {
    const r = this;
    if (r.destroyed) return;
    typeof e == "undefined" && (e = r.params.speed);
    let o = r.activeIndex;
    const l = Math.min(r.params.slidesPerGroupSkip, o), c = l + Math.floor((o - l) / r.params.slidesPerGroup), d = r.rtlTranslate ? r.translate : -r.translate;
    if (d >= r.snapGrid[c]) {
      const v = r.snapGrid[c], E = r.snapGrid[c + 1];
      d - v > (E - v) * n && (o += r.params.slidesPerGroup);
    } else {
      const v = r.snapGrid[c - 1], E = r.snapGrid[c];
      d - v <= (E - v) * n && (o -= r.params.slidesPerGroup);
    }
    return o = Math.max(o, 0), o = Math.min(o, r.slidesGrid.length - 1), r.slideTo(o, e, t, i);
  }
  function jm() {
    const e = this;
    if (e.destroyed) return;
    const { params: t, slidesEl: i } = e, n = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView;
    let r = e.getSlideIndexWhenGrid(e.clickedIndex), o;
    const l = e.isElement ? "swiper-slide" : `.${t.slideClass}`, c = e.grid && e.params.grid && e.params.grid.rows > 1;
    if (t.loop) {
      if (e.animating) return;
      o = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? e.slideToLoop(o) : r > (c ? (e.slides.length - n) / 2 - (e.params.grid.rows - 1) : e.slides.length - n) ? (e.loopFix(), r = e.getSlideIndex(Pe(i, `${l}[data-swiper-slide-index="${o}"]`)[0]), Pi(() => {
        e.slideTo(r);
      })) : e.slideTo(r);
    } else e.slideTo(r);
  }
  var Ym = { slideTo: Hm, slideToLoop: Bm, slideNext: Vm, slidePrev: Wm, slideReset: Fm, slideToClosest: Gm, slideToClickedSlide: jm };
  function Xm(e, t) {
    const i = this, { params: n, slidesEl: r } = i;
    if (!n.loop || i.virtual && i.params.virtual.enabled) return;
    const o = () => {
      Pe(r, `.${n.slideClass}, swiper-slide`).forEach((g, C) => {
        g.setAttribute("data-swiper-slide-index", C);
      });
    }, l = () => {
      const p = Pe(r, `.${n.slideBlankClass}`);
      p.forEach((g) => {
        g.remove();
      }), p.length > 0 && (i.recalcSlides(), i.updateSlides());
    }, c = i.grid && n.grid && n.grid.rows > 1;
    n.loopAddBlankSlides && (n.slidesPerGroup > 1 || c) && l();
    const d = n.slidesPerGroup * (c ? n.grid.rows : 1), v = i.slides.length % d !== 0, E = c && i.slides.length % n.grid.rows !== 0, y = (p) => {
      for (let g = 0; g < p; g += 1) {
        const C = i.isElement ? Xe("swiper-slide", [n.slideBlankClass]) : Xe("div", [n.slideClass, n.slideBlankClass]);
        i.slidesEl.append(C);
      }
    };
    if (v) {
      if (n.loopAddBlankSlides) {
        const p = d - i.slides.length % d;
        y(p), i.recalcSlides(), i.updateSlides();
      } else kn("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      o();
    } else if (E) {
      if (n.loopAddBlankSlides) {
        const p = n.grid.rows - i.slides.length % n.grid.rows;
        y(p), i.recalcSlides(), i.updateSlides();
      } else kn("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
      o();
    } else o();
    const b = n.centeredSlides || !!n.slidesOffsetBefore || !!n.slidesOffsetAfter;
    i.loopFix({ slideRealIndex: e, direction: b ? void 0 : "next", initial: t });
  }
  function qm({ slideRealIndex: e, slideTo: t = true, direction: i, setTranslate: n, activeSlideIndex: r, initial: o, byController: l, byMousewheel: c } = {}) {
    const d = this;
    if (!d.params.loop) return;
    d.emit("beforeLoopFix");
    const { slides: v, allowSlidePrev: E, allowSlideNext: y, slidesEl: b, params: p } = d, { centeredSlides: g, slidesOffsetBefore: C, slidesOffsetAfter: _, initialSlide: h } = p, S = g || !!C || !!_;
    if (d.allowSlidePrev = true, d.allowSlideNext = true, d.virtual && p.virtual.enabled) {
      t && (!S && d.snapIndex === 0 ? d.slideTo(d.virtual.slides.length, 0, false, true) : S && d.snapIndex < p.slidesPerView ? d.slideTo(d.virtual.slides.length + d.snapIndex, 0, false, true) : d.snapIndex === d.snapGrid.length - 1 && d.slideTo(d.virtual.slidesBefore, 0, false, true)), d.allowSlidePrev = E, d.allowSlideNext = y, d.emit("loopFix");
      return;
    }
    let w = p.slidesPerView;
    w === "auto" ? w = d.slidesPerViewDynamic() : (w = Math.ceil(parseFloat(p.slidesPerView, 10)), S && w % 2 === 0 && (w = w + 1));
    const A = p.slidesPerGroupAuto ? w : p.slidesPerGroup;
    let L = S ? Math.max(A, Math.ceil(w / 2)) : A;
    L % A !== 0 && (L += A - L % A), L += p.loopAdditionalSlides, d.loopedSlides = L;
    const f = d.grid && p.grid && p.grid.rows > 1;
    v.length < w + L || d.params.effect === "cards" && v.length < w + L * 2 ? kn("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : f && p.grid.fill === "row" && kn("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    const P = [], D = [], R = f ? Math.ceil(v.length / p.grid.rows) : v.length, N = o && R - h < w && !S;
    let $ = N ? h : d.activeIndex;
    typeof r == "undefined" ? r = d.getSlideIndex(v.find((Y) => Y.classList.contains(p.slideActiveClass))) : $ = r;
    const B = i === "next" || !i, V = i === "prev" || !i;
    let X = 0, Z = 0;
    const W = (f ? v[r].column : r) + (S && typeof n == "undefined" ? -w / 2 + 0.5 : 0);
    if (W < L) {
      X = Math.max(L - W, A);
      for (let Y = 0; Y < L - W; Y += 1) {
        const J = Y - Math.floor(Y / R) * R;
        if (f) {
          const oe = R - J - 1;
          for (let he = v.length - 1; he >= 0; he -= 1) v[he].column === oe && P.push(he);
        } else P.push(R - J - 1);
      }
    } else if (W + w > R - L) {
      Z = Math.max(W - (R - L * 2), A), N && (Z = Math.max(Z, w - R + h + 1));
      for (let Y = 0; Y < Z; Y += 1) {
        const J = Y - Math.floor(Y / R) * R;
        f ? v.forEach((oe, he) => {
          oe.column === J && D.push(he);
        }) : D.push(J);
      }
    }
    if (d.__preventObserver__ = true, requestAnimationFrame(() => {
      d.__preventObserver__ = false;
    }), d.params.effect === "cards" && v.length < w + L * 2 && (D.includes(r) && D.splice(D.indexOf(r), 1), P.includes(r) && P.splice(P.indexOf(r), 1)), V && P.forEach((Y) => {
      v[Y].swiperLoopMoveDOM = true, b.prepend(v[Y]), v[Y].swiperLoopMoveDOM = false;
    }), B && D.forEach((Y) => {
      v[Y].swiperLoopMoveDOM = true, b.append(v[Y]), v[Y].swiperLoopMoveDOM = false;
    }), d.recalcSlides(), p.slidesPerView === "auto" ? d.updateSlides() : f && (P.length > 0 && V || D.length > 0 && B) && d.slides.forEach((Y, J) => {
      d.grid.updateSlide(J, Y, d.slides);
    }), p.watchSlidesProgress && d.updateSlidesOffset(), t) {
      if (P.length > 0 && V) {
        if (typeof e == "undefined") {
          const Y = d.slidesGrid[$], oe = d.slidesGrid[$ + X] - Y;
          c ? d.setTranslate(d.translate - oe) : (d.slideTo($ + Math.ceil(X), 0, false, true), n && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - oe, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - oe));
        } else if (n) {
          const Y = f ? P.length / p.grid.rows : P.length;
          d.slideTo(d.activeIndex + Y, 0, false, true), d.touchEventsData.currentTranslate = d.translate;
        }
      } else if (D.length > 0 && B) if (typeof e == "undefined") {
        const Y = d.slidesGrid[$], oe = d.slidesGrid[$ - Z] - Y;
        c ? d.setTranslate(d.translate - oe) : (d.slideTo($ - Z, 0, false, true), n && (d.touchEventsData.startTranslate = d.touchEventsData.startTranslate - oe, d.touchEventsData.currentTranslate = d.touchEventsData.currentTranslate - oe));
      } else {
        const Y = f ? D.length / p.grid.rows : D.length;
        d.slideTo(d.activeIndex - Y, 0, false, true);
      }
    }
    if (d.allowSlidePrev = E, d.allowSlideNext = y, d.controller && d.controller.control && !l) {
      const Y = { slideRealIndex: e, direction: i, setTranslate: n, activeSlideIndex: r, byController: true };
      Array.isArray(d.controller.control) ? d.controller.control.forEach((J) => {
        !J.destroyed && J.params.loop && J.loopFix(bi(Ie({}, Y), { slideTo: J.params.slidesPerView === p.slidesPerView ? t : false }));
      }) : d.controller.control instanceof d.constructor && d.controller.control.params.loop && d.controller.control.loopFix(bi(Ie({}, Y), { slideTo: d.controller.control.params.slidesPerView === p.slidesPerView ? t : false }));
    }
    d.emit("loopFix");
  }
  function Um() {
    const e = this, { params: t, slidesEl: i } = e;
    if (!t.loop || !i || e.virtual && e.params.virtual.enabled) return;
    e.recalcSlides();
    const n = [];
    e.slides.forEach((r) => {
      const o = typeof r.swiperSlideIndex == "undefined" ? r.getAttribute("data-swiper-slide-index") * 1 : r.swiperSlideIndex;
      n[o] = r;
    }), e.slides.forEach((r) => {
      r.removeAttribute("data-swiper-slide-index");
    }), n.forEach((r) => {
      i.append(r);
    }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
  }
  var Km = { loopCreate: Xm, loopFix: qm, loopDestroy: Um };
  function Zm(e) {
    const t = this;
    if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
    const i = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
    t.isElement && (t.__preventObserver__ = true), i.style.cursor = "move", i.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(() => {
      t.__preventObserver__ = false;
    });
  }
  function Qm() {
    const e = this;
    e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = true), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(() => {
      e.__preventObserver__ = false;
    }));
  }
  var Jm = { setGrabCursor: Zm, unsetGrabCursor: Qm };
  function eg(e, t = this) {
    function i(n) {
      if (!n || n === Le() || n === ye()) return null;
      n.assignedSlot && (n = n.assignedSlot);
      const r = n.closest(e);
      return !r && !n.getRootNode ? null : r || i(n.getRootNode().host);
    }
    return i(t);
  }
  function ua(e, t, i) {
    const n = ye(), { params: r } = e, o = r.edgeSwipeDetection, l = r.edgeSwipeThreshold;
    return o && (i <= l || i >= n.innerWidth - l) ? o === "prevent" ? (t.preventDefault(), true) : false : true;
  }
  function tg(e) {
    const t = this, i = Le();
    let n = e;
    n.originalEvent && (n = n.originalEvent);
    const r = t.touchEventsData;
    if (n.type === "pointerdown") {
      if (r.pointerId !== null && r.pointerId !== n.pointerId) return;
      r.pointerId = n.pointerId;
    } else n.type === "touchstart" && n.targetTouches.length === 1 && (r.touchId = n.targetTouches[0].identifier);
    if (n.type === "touchstart") {
      ua(t, n, n.targetTouches[0].pageX);
      return;
    }
    const { params: o, touches: l, enabled: c } = t;
    if (!c || !o.simulateTouch && n.pointerType === "mouse" || t.animating && o.preventInteractionOnTransition) return;
    !t.animating && o.cssMode && o.loop && t.loopFix();
    let d = n.target;
    if (o.touchEventsTarget === "wrapper" && !cm(d, t.wrapperEl) || "which" in n && n.which === 3 || "button" in n && n.button > 0 || r.isTouched && r.isMoved) return;
    const v = !!o.noSwipingClass && o.noSwipingClass !== "", E = n.composedPath ? n.composedPath() : n.path;
    v && n.target && n.target.shadowRoot && E && (d = E[0]);
    const y = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`, b = !!(n.target && n.target.shadowRoot);
    if (o.noSwiping && (b ? eg(y, d) : d.closest(y))) {
      t.allowClick = true;
      return;
    }
    if (o.swipeHandler && !d.closest(o.swipeHandler)) return;
    l.currentX = n.pageX, l.currentY = n.pageY;
    const p = l.currentX, g = l.currentY;
    if (!ua(t, n, p)) return;
    Object.assign(r, { isTouched: true, isMoved: false, allowTouchCallbacks: true, isScrolling: void 0, startMoving: void 0 }), l.startX = p, l.startY = g, r.touchStartTime = Je(), t.allowClick = true, t.updateSize(), t.swipeDirection = void 0, o.threshold > 0 && (r.allowThresholdMove = false);
    let C = true;
    d.matches(r.focusableElements) && (C = false, d.nodeName === "SELECT" && (r.isTouched = false)), i.activeElement && i.activeElement.matches(r.focusableElements) && i.activeElement !== d && (n.pointerType === "mouse" || n.pointerType !== "mouse" && !d.matches(r.focusableElements)) && i.activeElement.blur();
    const _ = C && t.allowTouchMove && o.touchStartPreventDefault;
    (o.touchStartForcePreventDefault || _) && !d.isContentEditable && n.preventDefault(), o.freeMode && o.freeMode.enabled && t.freeMode && t.animating && !o.cssMode && t.freeMode.onTouchStart(), t.emit("touchStart", n);
  }
  function ig(e) {
    const t = Le(), i = this, n = i.touchEventsData, { params: r, touches: o, rtlTranslate: l, enabled: c } = i;
    if (!c || !r.simulateTouch && e.pointerType === "mouse") return;
    let d = e;
    if (d.originalEvent && (d = d.originalEvent), d.type === "pointermove" && (n.touchId !== null || d.pointerId !== n.pointerId)) return;
    let v;
    if (d.type === "touchmove") {
      if (v = [...d.changedTouches].find((L) => L.identifier === n.touchId), !v || v.identifier !== n.touchId) return;
    } else v = d;
    if (!n.isTouched) {
      n.startMoving && n.isScrolling && i.emit("touchMoveOpposite", d);
      return;
    }
    const E = v.pageX, y = v.pageY;
    if (d.preventedByNestedSwiper) {
      o.startX = E, o.startY = y;
      return;
    }
    if (!i.allowTouchMove) {
      d.target.matches(n.focusableElements) || (i.allowClick = false), n.isTouched && (Object.assign(o, { startX: E, startY: y, currentX: E, currentY: y }), n.touchStartTime = Je());
      return;
    }
    if (r.touchReleaseOnEdges && !r.loop) if (i.isVertical()) {
      if (y < o.startY && i.translate <= i.maxTranslate() || y > o.startY && i.translate >= i.minTranslate()) {
        n.isTouched = false, n.isMoved = false;
        return;
      }
    } else {
      if (l && (E > o.startX && -i.translate <= i.maxTranslate() || E < o.startX && -i.translate >= i.minTranslate())) return;
      if (!l && (E < o.startX && i.translate <= i.maxTranslate() || E > o.startX && i.translate >= i.minTranslate())) return;
    }
    if (t.activeElement && t.activeElement.matches(n.focusableElements) && t.activeElement !== d.target && d.pointerType !== "mouse" && t.activeElement.blur(), t.activeElement && d.target === t.activeElement && d.target.matches(n.focusableElements)) {
      n.isMoved = true, i.allowClick = false;
      return;
    }
    n.allowTouchCallbacks && i.emit("touchMove", d), o.previousX = o.currentX, o.previousY = o.currentY, o.currentX = E, o.currentY = y;
    const b = o.currentX - o.startX, p = o.currentY - o.startY;
    if (i.params.threshold && Math.sqrt(Me(b, 2) + Me(p, 2)) < i.params.threshold) return;
    if (typeof n.isScrolling == "undefined") {
      let L;
      i.isHorizontal() && o.currentY === o.startY || i.isVertical() && o.currentX === o.startX ? n.isScrolling = false : b * b + p * p >= 25 && (L = Math.atan2(Math.abs(p), Math.abs(b)) * 180 / Math.PI, n.isScrolling = i.isHorizontal() ? L > r.touchAngle : 90 - L > r.touchAngle);
    }
    if (n.isScrolling && i.emit("touchMoveOpposite", d), typeof n.startMoving == "undefined" && (o.currentX !== o.startX || o.currentY !== o.startY) && (n.startMoving = true), n.isScrolling || d.type === "touchmove" && n.preventTouchMoveFromPointerMove) {
      n.isTouched = false;
      return;
    }
    if (!n.startMoving) return;
    i.allowClick = false, !r.cssMode && d.cancelable && d.preventDefault(), r.touchMoveStopPropagation && !r.nested && d.stopPropagation();
    let g = i.isHorizontal() ? b : p, C = i.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
    r.oneWayMovement && (g = Math.abs(g) * (l ? 1 : -1), C = Math.abs(C) * (l ? 1 : -1)), o.diff = g, g *= r.touchRatio, l && (g = -g, C = -C);
    const _ = i.touchesDirection;
    i.swipeDirection = g > 0 ? "prev" : "next", i.touchesDirection = C > 0 ? "prev" : "next";
    const h = i.params.loop && !r.cssMode, S = i.touchesDirection === "next" && i.allowSlideNext || i.touchesDirection === "prev" && i.allowSlidePrev;
    if (!n.isMoved) {
      if (h && S && i.loopFix({ direction: i.swipeDirection }), n.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
        const L = new window.CustomEvent("transitionend", { bubbles: true, cancelable: true, detail: { bySwiperTouchMove: true } });
        i.wrapperEl.dispatchEvent(L);
      }
      n.allowMomentumBounce = false, r.grabCursor && (i.allowSlideNext === true || i.allowSlidePrev === true) && i.setGrabCursor(true), i.emit("sliderFirstMove", d);
    }
    if ((/* @__PURE__ */ new Date()).getTime(), r._loopSwapReset !== false && n.isMoved && n.allowThresholdMove && _ !== i.touchesDirection && h && S && Math.abs(g) >= 1) {
      Object.assign(o, { startX: E, startY: y, currentX: E, currentY: y, startTranslate: n.currentTranslate }), n.loopSwapReset = true, n.startTranslate = n.currentTranslate;
      return;
    }
    i.emit("sliderMove", d), n.isMoved = true, n.currentTranslate = g + n.startTranslate;
    let w = true, A = r.resistanceRatio;
    if (r.touchReleaseOnEdges && (A = 0), g > 0 ? (h && S && n.allowThresholdMove && n.currentTranslate > (r.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] - (r.slidesPerView !== "auto" && i.slides.length - r.slidesPerView >= 2 ? i.slidesSizesGrid[i.activeIndex + 1] + i.params.spaceBetween : 0) - i.params.spaceBetween : i.minTranslate()) && i.loopFix({ direction: "prev", setTranslate: true, activeSlideIndex: 0 }), n.currentTranslate > i.minTranslate() && (w = false, r.resistance && (n.currentTranslate = i.minTranslate() - 1 + Me(-i.minTranslate() + n.startTranslate + g, A)))) : g < 0 && (h && S && n.allowThresholdMove && n.currentTranslate < (r.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween + (r.slidesPerView !== "auto" && i.slides.length - r.slidesPerView >= 2 ? i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween : 0) : i.maxTranslate()) && i.loopFix({ direction: "next", setTranslate: true, activeSlideIndex: i.slides.length - (r.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10))) }), n.currentTranslate < i.maxTranslate() && (w = false, r.resistance && (n.currentTranslate = i.maxTranslate() + 1 - Me(i.maxTranslate() - n.startTranslate - g, A)))), w && (d.preventedByNestedSwiper = true), !i.allowSlideNext && i.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !i.allowSlidePrev && i.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !i.allowSlidePrev && !i.allowSlideNext && (n.currentTranslate = n.startTranslate), r.threshold > 0) if (Math.abs(g) > r.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = true, o.startX = o.currentX, o.startY = o.currentY, n.currentTranslate = n.startTranslate, o.diff = i.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
    !r.followFinger || r.cssMode || ((r.freeMode && r.freeMode.enabled && i.freeMode || r.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(n.currentTranslate), i.setTranslate(n.currentTranslate));
  }
  function ng(e) {
    const t = this, i = t.touchEventsData;
    let n = e;
    n.originalEvent && (n = n.originalEvent);
    let r;
    if (n.type === "touchend" || n.type === "touchcancel") {
      if (r = [...n.changedTouches].find((L) => L.identifier === i.touchId), !r || r.identifier !== i.touchId) return;
    } else {
      if (i.touchId !== null || n.pointerId !== i.pointerId) return;
      r = n;
    }
    if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (t.browser.isSafari || t.browser.isWebView))) return;
    i.pointerId = null, i.touchId = null;
    const { params: l, touches: c, rtlTranslate: d, slidesGrid: v, enabled: E } = t;
    if (!E || !l.simulateTouch && n.pointerType === "mouse") return;
    if (i.allowTouchCallbacks && t.emit("touchEnd", n), i.allowTouchCallbacks = false, !i.isTouched) {
      i.isMoved && l.grabCursor && t.setGrabCursor(false), i.isMoved = false, i.startMoving = false;
      return;
    }
    l.grabCursor && i.isMoved && i.isTouched && (t.allowSlideNext === true || t.allowSlidePrev === true) && t.setGrabCursor(false);
    const y = Je(), b = y - i.touchStartTime;
    if (t.allowClick) {
      const L = n.path || n.composedPath && n.composedPath();
      t.updateClickedSlide(L && L[0] || n.target, L), t.emit("tap click", n), b < 300 && y - i.lastClickTime < 300 && t.emit("doubleTap doubleClick", n);
    }
    if (i.lastClickTime = Je(), Pi(() => {
      t.destroyed || (t.allowClick = true);
    }), !i.isTouched || !i.isMoved || !t.swipeDirection || c.diff === 0 && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) {
      i.isTouched = false, i.isMoved = false, i.startMoving = false;
      return;
    }
    i.isTouched = false, i.isMoved = false, i.startMoving = false;
    let p;
    if (l.followFinger ? p = d ? t.translate : -t.translate : p = -i.currentTranslate, l.cssMode) return;
    if (l.freeMode && l.freeMode.enabled) {
      t.freeMode.onTouchEnd({ currentPos: p });
      return;
    }
    const g = p >= -t.maxTranslate() && !t.params.loop;
    let C = 0, _ = t.slidesSizesGrid[0];
    for (let L = 0; L < v.length; L += L < l.slidesPerGroupSkip ? 1 : l.slidesPerGroup) {
      const f = L < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
      typeof v[L + f] != "undefined" ? (g || p >= v[L] && p < v[L + f]) && (C = L, _ = v[L + f] - v[L]) : (g || p >= v[L]) && (C = L, _ = v[v.length - 1] - v[v.length - 2]);
    }
    let h = null, S = null;
    l.rewind && (t.isBeginning ? S = l.virtual && l.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (h = 0));
    const w = (p - v[C]) / _, A = C < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
    if (b > l.longSwipesMs) {
      if (!l.longSwipes) {
        t.slideTo(t.activeIndex);
        return;
      }
      t.swipeDirection === "next" && (w >= l.longSwipesRatio ? t.slideTo(l.rewind && t.isEnd ? h : C + A) : t.slideTo(C)), t.swipeDirection === "prev" && (w > 1 - l.longSwipesRatio ? t.slideTo(C + A) : S !== null && w < 0 && Math.abs(w) > l.longSwipesRatio ? t.slideTo(S) : t.slideTo(C));
    } else {
      if (!l.shortSwipes) {
        t.slideTo(t.activeIndex);
        return;
      }
      t.navigation && (n.target === t.navigation.nextEl || n.target === t.navigation.prevEl) ? n.target === t.navigation.nextEl ? t.slideTo(C + A) : t.slideTo(C) : (t.swipeDirection === "next" && t.slideTo(h !== null ? h : C + A), t.swipeDirection === "prev" && t.slideTo(S !== null ? S : C));
    }
  }
  function da() {
    const e = this, { params: t, el: i } = e;
    if (i && i.offsetWidth === 0) return;
    t.breakpoints && e.setBreakpoint();
    const { allowSlideNext: n, allowSlidePrev: r, snapGrid: o } = e, l = e.virtual && e.params.virtual.enabled;
    e.allowSlideNext = true, e.allowSlidePrev = true, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
    const c = l && t.loop;
    if ((t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !c) {
      const d = l ? e.virtual.slides : e.slides;
      e.slideTo(d.length - 1, 0, false, true);
    } else e.params.loop && !l ? e.slideToLoop(e.realIndex, 0, false, true) : e.slideTo(e.activeIndex, 0, false, true);
    e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(() => {
      e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
    }, 500)), e.allowSlidePrev = r, e.allowSlideNext = n, e.params.watchOverflow && o !== e.snapGrid && e.checkOverflow();
  }
  function sg(e) {
    const t = this;
    t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
  }
  function rg() {
    const e = this, { wrapperEl: t, rtlTranslate: i, enabled: n } = e;
    if (!n) return;
    e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
    let r;
    const o = e.maxTranslate() - e.minTranslate();
    o === 0 ? r = 0 : r = (e.translate - e.minTranslate()) / o, r !== e.progress && e.updateProgress(i ? -e.translate : e.translate), e.emit("setTranslate", e.translate, false);
  }
  function og(e) {
    const t = this;
    Ln(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
  }
  function ag() {
    const e = this;
    e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = true, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
  }
  const Fl = (e, t) => {
    const i = Le(), { params: n, el: r, wrapperEl: o, device: l } = e, c = !!n.nested, d = t === "on" ? "addEventListener" : "removeEventListener", v = t;
    !r || typeof r == "string" || (i[d]("touchstart", e.onDocumentTouchStart, { passive: false, capture: c }), r[d]("touchstart", e.onTouchStart, { passive: false }), r[d]("pointerdown", e.onTouchStart, { passive: false }), i[d]("touchmove", e.onTouchMove, { passive: false, capture: c }), i[d]("pointermove", e.onTouchMove, { passive: false, capture: c }), i[d]("touchend", e.onTouchEnd, { passive: true }), i[d]("pointerup", e.onTouchEnd, { passive: true }), i[d]("pointercancel", e.onTouchEnd, { passive: true }), i[d]("touchcancel", e.onTouchEnd, { passive: true }), i[d]("pointerout", e.onTouchEnd, { passive: true }), i[d]("pointerleave", e.onTouchEnd, { passive: true }), i[d]("contextmenu", e.onTouchEnd, { passive: true }), (n.preventClicks || n.preventClicksPropagation) && r[d]("click", e.onClick, true), n.cssMode && o[d]("scroll", e.onScroll), n.updateOnWindowResize ? e[v](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", da, true) : e[v]("observerUpdate", da, true), r[d]("load", e.onLoad, { capture: true }));
  };
  function lg() {
    const e = this, { params: t } = e;
    e.onTouchStart = tg.bind(e), e.onTouchMove = ig.bind(e), e.onTouchEnd = ng.bind(e), e.onDocumentTouchStart = ag.bind(e), t.cssMode && (e.onScroll = rg.bind(e)), e.onClick = sg.bind(e), e.onLoad = og.bind(e), Fl(e, "on");
  }
  function cg() {
    Fl(this, "off");
  }
  var ug = { attachEvents: lg, detachEvents: cg };
  const fa = (e, t) => e.grid && t.grid && t.grid.rows > 1;
  function dg() {
    const e = this, { realIndex: t, initialized: i, params: n, el: r } = e, o = n.breakpoints;
    if (!o || o && Object.keys(o).length === 0) return;
    const l = Le(), c = n.breakpointsBase === "window" || !n.breakpointsBase ? n.breakpointsBase : "container", d = ["window", "container"].includes(n.breakpointsBase) || !n.breakpointsBase ? e.el : l.querySelector(n.breakpointsBase), v = e.getBreakpoint(o, c, d);
    if (!v || e.currentBreakpoint === v) return;
    const y = (v in o ? o[v] : void 0) || e.originalParams, b = fa(e, n), p = fa(e, y), g = e.params.grabCursor, C = y.grabCursor, _ = n.enabled;
    b && !p ? (r.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), e.emitContainerClasses()) : !b && p && (r.classList.add(`${n.containerModifierClass}grid`), (y.grid.fill && y.grid.fill === "column" || !y.grid.fill && n.grid.fill === "column") && r.classList.add(`${n.containerModifierClass}grid-column`), e.emitContainerClasses()), g && !C ? e.unsetGrabCursor() : !g && C && e.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((f) => {
      if (typeof y[f] == "undefined") return;
      const P = n[f] && n[f].enabled, D = y[f] && y[f].enabled;
      P && !D && e[f].disable(), !P && D && e[f].enable();
    });
    const h = y.direction && y.direction !== n.direction, S = n.loop && (y.slidesPerView !== n.slidesPerView || h), w = n.loop;
    h && i && e.changeDirection(), Ye(e.params, y);
    const A = e.params.enabled, L = e.params.loop;
    Object.assign(e, { allowTouchMove: e.params.allowTouchMove, allowSlideNext: e.params.allowSlideNext, allowSlidePrev: e.params.allowSlidePrev }), _ && !A ? e.disable() : !_ && A && e.enable(), e.currentBreakpoint = v, e.emit("_beforeBreakpoint", y), i && (S ? (e.loopDestroy(), e.loopCreate(t), e.updateSlides()) : !w && L ? (e.loopCreate(t), e.updateSlides()) : w && !L && e.loopDestroy()), e.emit("breakpoint", y);
  }
  function fg(e, t = "window", i) {
    if (!e || t === "container" && !i) return;
    let n = false;
    const r = ye(), o = t === "window" ? r.innerHeight : i.clientHeight, l = Object.keys(e).map((c) => {
      if (typeof c == "string" && c.indexOf("@") === 0) {
        const d = parseFloat(c.substr(1));
        return { value: o * d, point: c };
      }
      return { value: c, point: c };
    });
    l.sort((c, d) => parseInt(c.value, 10) - parseInt(d.value, 10));
    for (let c = 0; c < l.length; c += 1) {
      const { point: d, value: v } = l[c];
      t === "window" ? r.matchMedia(`(min-width: ${v}px)`).matches && (n = d) : v <= i.clientWidth && (n = d);
    }
    return n || "max";
  }
  var hg = { setBreakpoint: dg, getBreakpoint: fg };
  function pg(e, t) {
    const i = [];
    return e.forEach((n) => {
      typeof n == "object" ? Object.keys(n).forEach((r) => {
        n[r] && i.push(t + r);
      }) : typeof n == "string" && i.push(t + n);
    }), i;
  }
  function mg() {
    const e = this, { classNames: t, params: i, rtl: n, el: r, device: o } = e, l = pg(["initialized", i.direction, { "free-mode": e.params.freeMode && i.freeMode.enabled }, { autoheight: i.autoHeight }, { rtl: n }, { grid: i.grid && i.grid.rows > 1 }, { "grid-column": i.grid && i.grid.rows > 1 && i.grid.fill === "column" }, { android: o.android }, { ios: o.ios }, { "css-mode": i.cssMode }, { centered: i.cssMode && i.centeredSlides }, { "watch-progress": i.watchSlidesProgress }], i.containerModifierClass);
    t.push(...l), r.classList.add(...t), e.emitContainerClasses();
  }
  function gg() {
    const e = this, { el: t, classNames: i } = e;
    !t || typeof t == "string" || (t.classList.remove(...i), e.emitContainerClasses());
  }
  var vg = { addClasses: mg, removeClasses: gg };
  function yg() {
    const e = this, { isLocked: t, params: i } = e, { slidesOffsetBefore: n } = i;
    if (n) {
      const r = e.slides.length - 1, o = e.slidesGrid[r] + e.slidesSizesGrid[r] + n * 2;
      e.isLocked = e.size > o;
    } else e.isLocked = e.snapGrid.length === 1;
    i.allowSlideNext === true && (e.allowSlideNext = !e.isLocked), i.allowSlidePrev === true && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = false), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
  }
  var bg = { checkOverflow: yg }, ha = { init: true, direction: "horizontal", oneWayMovement: false, swiperElementNodeName: "SWIPER-CONTAINER", touchEventsTarget: "wrapper", initialSlide: 0, speed: 300, cssMode: false, updateOnWindowResize: true, resizeObserver: true, nested: false, createElements: false, eventsPrefix: "swiper", enabled: true, focusableElements: "input, select, option, textarea, button, video, label", width: null, height: null, preventInteractionOnTransition: false, userAgent: null, url: null, edgeSwipeDetection: false, edgeSwipeThreshold: 20, autoHeight: false, setWrapperSize: false, virtualTranslate: false, effect: "slide", breakpoints: void 0, breakpointsBase: "window", spaceBetween: 0, slidesPerView: 1, slidesPerGroup: 1, slidesPerGroupSkip: 0, slidesPerGroupAuto: false, centeredSlides: false, centeredSlidesBounds: false, slidesOffsetBefore: 0, slidesOffsetAfter: 0, normalizeSlideIndex: true, centerInsufficientSlides: false, snapToSlideEdge: false, watchOverflow: true, roundLengths: false, touchRatio: 1, touchAngle: 45, simulateTouch: true, shortSwipes: true, longSwipes: true, longSwipesRatio: 0.5, longSwipesMs: 300, followFinger: true, allowTouchMove: true, threshold: 5, touchMoveStopPropagation: false, touchStartPreventDefault: true, touchStartForcePreventDefault: false, touchReleaseOnEdges: false, uniqueNavElements: true, resistance: true, resistanceRatio: 0.85, watchSlidesProgress: false, grabCursor: false, preventClicks: true, preventClicksPropagation: true, slideToClickedSlide: false, loop: false, loopAddBlankSlides: true, loopAdditionalSlides: 0, loopPreventsSliding: true, rewind: false, allowSlidePrev: true, allowSlideNext: true, swipeHandler: null, noSwiping: true, noSwipingClass: "swiper-no-swiping", noSwipingSelector: null, passiveListeners: true, maxBackfaceHiddenSlides: 10, containerModifierClass: "swiper-", slideClass: "swiper-slide", slideBlankClass: "swiper-slide-blank", slideActiveClass: "swiper-slide-active", slideVisibleClass: "swiper-slide-visible", slideFullyVisibleClass: "swiper-slide-fully-visible", slideNextClass: "swiper-slide-next", slidePrevClass: "swiper-slide-prev", wrapperClass: "swiper-wrapper", lazyPreloaderClass: "swiper-lazy-preloader", lazyPreloadPrevNext: 0, runCallbacksOnInit: true, _emitClasses: false };
  function Eg(e, t) {
    return function(n = {}) {
      const r = Object.keys(n)[0], o = n[r];
      if (typeof o != "object" || o === null) {
        Ye(t, n);
        return;
      }
      if (e[r] === true && (e[r] = { enabled: true }), r === "navigation" && e[r] && e[r].enabled && !e[r].prevEl && !e[r].nextEl && (e[r].auto = true), ["pagination", "scrollbar"].indexOf(r) >= 0 && e[r] && e[r].enabled && !e[r].el && (e[r].auto = true), !(r in e && "enabled" in o)) {
        Ye(t, n);
        return;
      }
      typeof e[r] == "object" && !("enabled" in e[r]) && (e[r].enabled = true), e[r] || (e[r] = { enabled: false }), Ye(t, n);
    };
  }
  const Fs = { eventsEmitter: vm, update: Am, translate: zm, transition: Rm, slide: Ym, loop: Km, grabCursor: Jm, events: ug, breakpoints: hg, checkOverflow: bg, classes: vg }, Gs = {};
  class Ve {
    constructor(...t) {
      let i, n;
      t.length === 1 && t[0].constructor && Object.prototype.toString.call(t[0]).slice(8, -1) === "Object" ? n = t[0] : [i, n] = t, n || (n = {}), n = Ye({}, n), i && !n.el && (n.el = i);
      const r = Le();
      if (n.el && typeof n.el == "string" && r.querySelectorAll(n.el).length > 1) {
        const d = [];
        return r.querySelectorAll(n.el).forEach((v) => {
          const E = Ye({}, n, { el: v });
          d.push(new Ve(E));
        }), d;
      }
      const o = this;
      o.__swiper__ = true, o.support = Hl(), o.device = Bl({ userAgent: n.userAgent }), o.browser = Vl(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [...o.__modules__], n.modules && Array.isArray(n.modules) && n.modules.forEach((d) => {
        typeof d == "function" && o.modules.indexOf(d) < 0 && o.modules.push(d);
      });
      const l = {};
      o.modules.forEach((d) => {
        d({ params: n, swiper: o, extendParams: Eg(n, l), on: o.on.bind(o), once: o.once.bind(o), off: o.off.bind(o), emit: o.emit.bind(o) });
      });
      const c = Ye({}, ha, l);
      return o.params = Ye({}, c, Gs, n), o.originalParams = Ye({}, o.params), o.passedParams = Ye({}, n), o.params && o.params.on && Object.keys(o.params.on).forEach((d) => {
        o.on(d, o.params.on[d]);
      }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, { enabled: o.params.enabled, el: i, classNames: [], slides: [], slidesGrid: [], snapGrid: [], slidesSizesGrid: [], isHorizontal() {
        return o.params.direction === "horizontal";
      }, isVertical() {
        return o.params.direction === "vertical";
      }, activeIndex: 0, realIndex: 0, isBeginning: true, isEnd: false, translate: 0, previousTranslate: 0, progress: 0, velocity: 0, animating: false, cssOverflowAdjustment() {
        return Math.trunc(this.translate / Me(2, 23)) * Me(2, 23);
      }, allowSlideNext: o.params.allowSlideNext, allowSlidePrev: o.params.allowSlidePrev, touchEventsData: { isTouched: void 0, isMoved: void 0, allowTouchCallbacks: void 0, touchStartTime: void 0, isScrolling: void 0, currentTranslate: void 0, startTranslate: void 0, allowThresholdMove: void 0, focusableElements: o.params.focusableElements, lastClickTime: 0, clickTimeout: void 0, velocities: [], allowMomentumBounce: void 0, startMoving: void 0, pointerId: null, touchId: null }, allowClick: true, allowTouchMove: o.params.allowTouchMove, touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 }, imagesToLoad: [], imagesLoaded: 0 }), o.emit("_swiper"), o.params.init && o.init(), o;
    }
    getDirectionLabel(t) {
      return this.isHorizontal() ? t : { width: "height", "margin-top": "margin-left", "margin-bottom ": "margin-right", "margin-left": "margin-top", "margin-right": "margin-bottom", "padding-left": "padding-top", "padding-right": "padding-bottom", marginRight: "marginBottom" }[t];
    }
    getSlideIndex(t) {
      const { slidesEl: i, params: n } = this, r = Pe(i, `.${n.slideClass}, swiper-slide`), o = Qi(r[0]);
      return Qi(t) - o;
    }
    getSlideIndexByData(t) {
      return this.getSlideIndex(this.slides.find((i) => i.getAttribute("data-swiper-slide-index") * 1 === t));
    }
    getSlideIndexWhenGrid(t) {
      return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? t = Math.floor(t / this.params.grid.rows) : this.params.grid.fill === "row" && (t = t % Math.ceil(this.slides.length / this.params.grid.rows))), t;
    }
    recalcSlides() {
      const t = this, { slidesEl: i, params: n } = t;
      t.slides = Pe(i, `.${n.slideClass}, swiper-slide`);
    }
    enable() {
      const t = this;
      t.enabled || (t.enabled = true, t.params.grabCursor && t.setGrabCursor(), t.emit("enable"));
    }
    disable() {
      const t = this;
      t.enabled && (t.enabled = false, t.params.grabCursor && t.unsetGrabCursor(), t.emit("disable"));
    }
    setProgress(t, i) {
      const n = this;
      t = Math.min(Math.max(t, 0), 1);
      const r = n.minTranslate(), l = (n.maxTranslate() - r) * t + r;
      n.translateTo(l, typeof i == "undefined" ? 0 : i), n.updateActiveIndex(), n.updateSlidesClasses();
    }
    emitContainerClasses() {
      const t = this;
      if (!t.params._emitClasses || !t.el) return;
      const i = t.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(t.params.containerModifierClass) === 0);
      t.emit("_containerClasses", i.join(" "));
    }
    getSlideClasses(t) {
      const i = this;
      return i.destroyed ? "" : t.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(i.params.slideClass) === 0).join(" ");
    }
    emitSlidesClasses() {
      const t = this;
      if (!t.params._emitClasses || !t.el) return;
      const i = [];
      t.slides.forEach((n) => {
        const r = t.getSlideClasses(n);
        i.push({ slideEl: n, classNames: r }), t.emit("_slideClass", n, r);
      }), t.emit("_slideClasses", i);
    }
    slidesPerViewDynamic(t = "current", i = false) {
      const n = this, { params: r, slides: o, slidesGrid: l, slidesSizesGrid: c, size: d, activeIndex: v } = n;
      let E = 1;
      if (typeof r.slidesPerView == "number") return r.slidesPerView;
      if (r.centeredSlides) {
        let y = o[v] ? Math.ceil(o[v].swiperSlideSize) : 0, b;
        for (let p = v + 1; p < o.length; p += 1) o[p] && !b && (y += Math.ceil(o[p].swiperSlideSize), E += 1, y > d && (b = true));
        for (let p = v - 1; p >= 0; p -= 1) o[p] && !b && (y += o[p].swiperSlideSize, E += 1, y > d && (b = true));
      } else if (t === "current") for (let y = v + 1; y < o.length; y += 1) (i ? l[y] + c[y] - l[v] < d : l[y] - l[v] < d) && (E += 1);
      else for (let y = v - 1; y >= 0; y -= 1) l[v] - l[y] < d && (E += 1);
      return E;
    }
    update() {
      const t = this;
      if (!t || t.destroyed) return;
      const { snapGrid: i, params: n } = t;
      n.breakpoints && t.setBreakpoint(), [...t.el.querySelectorAll('[loading="lazy"]')].forEach((l) => {
        l.complete && Ln(t, l);
      }), t.updateSize(), t.updateSlides(), t.updateProgress(), t.updateSlidesClasses();
      function r() {
        const l = t.rtlTranslate ? t.translate * -1 : t.translate, c = Math.min(Math.max(l, t.maxTranslate()), t.minTranslate());
        t.setTranslate(c), t.updateActiveIndex(), t.updateSlidesClasses();
      }
      let o;
      if (n.freeMode && n.freeMode.enabled && !n.cssMode) r(), n.autoHeight && t.updateAutoHeight();
      else {
        if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && t.isEnd && !n.centeredSlides) {
          const l = t.virtual && n.virtual.enabled ? t.virtual.slides : t.slides;
          o = t.slideTo(l.length - 1, 0, false, true);
        } else o = t.slideTo(t.activeIndex, 0, false, true);
        o || r();
      }
      n.watchOverflow && i !== t.snapGrid && t.checkOverflow(), t.emit("update");
    }
    changeDirection(t, i = true) {
      const n = this, r = n.params.direction;
      return t || (t = r === "horizontal" ? "vertical" : "horizontal"), t === r || t !== "horizontal" && t !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${r}`), n.el.classList.add(`${n.params.containerModifierClass}${t}`), n.emitContainerClasses(), n.params.direction = t, n.slides.forEach((o) => {
        t === "vertical" ? o.style.width = "" : o.style.height = "";
      }), n.emit("changeDirection"), i && n.update()), n;
    }
    changeLanguageDirection(t) {
      const i = this;
      i.rtl && t === "rtl" || !i.rtl && t === "ltr" || (i.rtl = t === "rtl", i.rtlTranslate = i.params.direction === "horizontal" && i.rtl, i.rtl ? (i.el.classList.add(`${i.params.containerModifierClass}rtl`), i.el.dir = "rtl") : (i.el.classList.remove(`${i.params.containerModifierClass}rtl`), i.el.dir = "ltr"), i.update());
    }
    mount(t) {
      const i = this;
      if (i.mounted) return true;
      let n = t || i.params.el;
      if (typeof n == "string" && (n = document.querySelector(n)), !n) return false;
      n.swiper = i, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === i.params.swiperElementNodeName.toUpperCase() && (i.isElement = true);
      const r = () => `.${(i.params.wrapperClass || "").trim().split(" ").join(".")}`;
      let l = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(r()) : Pe(n, r())[0];
      return !l && i.params.createElements && (l = Xe("div", i.params.wrapperClass), n.append(l), Pe(n, `.${i.params.slideClass}`).forEach((c) => {
        l.append(c);
      })), Object.assign(i, { el: n, wrapperEl: l, slidesEl: i.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : l, hostEl: i.isElement ? n.parentNode.host : n, mounted: true, rtl: n.dir.toLowerCase() === "rtl" || Ht(n, "direction") === "rtl", rtlTranslate: i.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || Ht(n, "direction") === "rtl"), wrongRTL: Ht(l, "display") === "-webkit-box" }), true;
    }
    init(t) {
      const i = this;
      if (i.initialized || i.mount(t) === false) return i;
      i.emit("beforeInit"), i.params.breakpoints && i.setBreakpoint(), i.addClasses(), i.updateSize(), i.updateSlides(), i.params.watchOverflow && i.checkOverflow(), i.params.grabCursor && i.enabled && i.setGrabCursor(), i.params.loop && i.virtual && i.params.virtual.enabled ? i.slideTo(i.params.initialSlide + i.virtual.slidesBefore, 0, i.params.runCallbacksOnInit, false, true) : i.slideTo(i.params.initialSlide, 0, i.params.runCallbacksOnInit, false, true), i.params.loop && i.loopCreate(void 0, true), i.attachEvents();
      const r = [...i.el.querySelectorAll('[loading="lazy"]')];
      return i.isElement && r.push(...i.hostEl.querySelectorAll('[loading="lazy"]')), r.forEach((o) => {
        o.complete ? Ln(i, o) : o.addEventListener("load", (l) => {
          Ln(i, l.target);
        });
      }), pr(i), i.initialized = true, pr(i), i.emit("init"), i.emit("afterInit"), i;
    }
    destroy(t = true, i = true) {
      const n = this, { params: r, el: o, wrapperEl: l, slides: c } = n;
      return typeof n.params == "undefined" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = false, n.detachEvents(), r.loop && n.loopDestroy(), i && (n.removeClasses(), o && typeof o != "string" && o.removeAttribute("style"), l && l.removeAttribute("style"), c && c.length && c.forEach((d) => {
        d.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), d.removeAttribute("style"), d.removeAttribute("data-swiper-slide-index");
      })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((d) => {
        n.off(d);
      }), t !== false && (n.el && typeof n.el != "string" && (n.el.swiper = null), rm(n)), n.destroyed = true), null;
    }
    static extendDefaults(t) {
      Ye(Gs, t);
    }
    static get extendedDefaults() {
      return Gs;
    }
    static get defaults() {
      return ha;
    }
    static installModule(t) {
      Ve.prototype.__modules__ || (Ve.prototype.__modules__ = []);
      const i = Ve.prototype.__modules__;
      typeof t == "function" && i.indexOf(t) < 0 && i.push(t);
    }
    static use(t) {
      return Array.isArray(t) ? (t.forEach((i) => Ve.installModule(i)), Ve) : (Ve.installModule(t), Ve);
    }
  }
  Object.keys(Fs).forEach((e) => {
    Object.keys(Fs[e]).forEach((t) => {
      Ve.prototype[t] = Fs[e][t];
    });
  });
  Ve.use([mm, gm]);
  function Sg({ swiper: e, extendParams: t, on: i, emit: n }) {
    t({ virtual: { enabled: false, slides: [], cache: true, slidesPerViewAutoSlideSize: 320, renderSlide: null, renderExternal: null, renderExternalUpdate: true, addSlidesBefore: 0, addSlidesAfter: 0 } });
    let r;
    const o = Le();
    e.virtual = { cache: {}, from: void 0, to: void 0, slides: [], offset: 0, slidesGrid: [] };
    const l = o.createElement("div");
    function c(p, g) {
      const C = e.params.virtual;
      if (C.cache && e.virtual.cache[g]) return e.virtual.cache[g];
      let _;
      return C.renderSlide ? (_ = C.renderSlide.call(e, p, g), typeof _ == "string" && (bt(l, _), _ = l.children[0])) : e.isElement ? _ = Xe("swiper-slide") : _ = Xe("div", e.params.slideClass), _.setAttribute("data-swiper-slide-index", g), C.renderSlide || bt(_, p), C.cache && (e.virtual.cache[g] = _), _;
    }
    function d(p, g, C) {
      const { slidesPerGroup: _, centeredSlides: h, slidesPerView: S, loop: w, initialSlide: A } = e.params;
      if (g && !w && A > 0) return;
      const { addSlidesBefore: L, addSlidesAfter: f, slidesPerViewAutoSlideSize: P } = e.params.virtual, { from: D, to: R, slides: N, slidesGrid: $, offset: B } = e.virtual;
      e.params.cssMode || e.updateActiveIndex();
      const V = typeof C == "undefined" ? e.activeIndex || 0 : C;
      let X;
      e.rtlTranslate ? X = "right" : X = e.isHorizontal() ? "left" : "top";
      let Z;
      if (S === "auto") if (P) {
        let K = e.size;
        K || (K = e.isHorizontal() ? e.el.getBoundingClientRect().width : e.el.getBoundingClientRect().height), Z = Math.max(1, Math.ceil(K / P));
      } else Z = 1;
      else Z = S;
      let F, W;
      h ? (F = Math.floor(Z / 2) + _ + f, W = Math.floor(Z / 2) + _ + L) : (F = Z + (_ - 1) + f, W = (w ? Z : _) + L);
      let Y = V - W, J = V + F;
      w || (Y = Math.max(Y, 0), J = Math.min(J, N.length - 1));
      let oe = (e.slidesGrid[Y] || 0) - (e.slidesGrid[0] || 0);
      w && V >= W ? (Y -= W, h || (oe += e.slidesGrid[0])) : w && V < W && (Y = -W, h && (oe += e.slidesGrid[0])), Object.assign(e.virtual, { from: Y, to: J, offset: oe, slidesGrid: e.slidesGrid, slidesBefore: W, slidesAfter: F });
      function he() {
        e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), n("virtualUpdate");
      }
      if (D === Y && R === J && !p) {
        e.slidesGrid !== $ && oe !== B && e.slides.forEach((K) => {
          K.style[X] = `${oe - Math.abs(e.cssOverflowAdjustment())}px`;
        }), e.updateProgress(), n("virtualUpdate");
        return;
      }
      if (e.params.virtual.renderExternal) {
        e.params.virtual.renderExternal.call(e, { offset: oe, from: Y, to: J, slides: (function() {
          const se = [];
          for (let Se = Y; Se <= J; Se += 1) se.push(N[Se]);
          return se;
        })() }), e.params.virtual.renderExternalUpdate ? he() : n("virtualUpdate");
        return;
      }
      const _e = [], Ee = [], U = (K) => {
        let se = K;
        return K < 0 ? se = N.length + K : se >= N.length && (se = se - N.length), se;
      };
      if (p) e.slides.filter((K) => K.matches(`.${e.params.slideClass}, swiper-slide`)).forEach((K) => {
        K.remove();
      });
      else for (let K = D; K <= R; K += 1) if (K < Y || K > J) {
        const se = U(K);
        e.slides.filter((Se) => Se.matches(`.${e.params.slideClass}[data-swiper-slide-index="${se}"], swiper-slide[data-swiper-slide-index="${se}"]`)).forEach((Se) => {
          Se.remove();
        });
      }
      const Q = w ? -N.length : 0, ee = w ? N.length * 2 : N.length;
      for (let K = Q; K < ee; K += 1) if (K >= Y && K <= J) {
        const se = U(K);
        typeof R == "undefined" || p ? Ee.push(se) : (K > R && Ee.push(se), K < D && _e.push(se));
      }
      if (Ee.forEach((K) => {
        e.slidesEl.append(c(N[K], K));
      }), w) for (let K = _e.length - 1; K >= 0; K -= 1) {
        const se = _e[K];
        e.slidesEl.prepend(c(N[se], se));
      }
      else _e.sort((K, se) => se - K), _e.forEach((K) => {
        e.slidesEl.prepend(c(N[K], K));
      });
      Pe(e.slidesEl, ".swiper-slide, swiper-slide").forEach((K) => {
        K.style[X] = `${oe - Math.abs(e.cssOverflowAdjustment())}px`;
      }), he();
    }
    function v(p) {
      if (typeof p == "object" && "length" in p) for (let g = 0; g < p.length; g += 1) p[g] && e.virtual.slides.push(p[g]);
      else e.virtual.slides.push(p);
      d(true);
    }
    function E(p) {
      const g = e.activeIndex;
      let C = g + 1, _ = 1;
      if (Array.isArray(p)) {
        for (let h = 0; h < p.length; h += 1) p[h] && e.virtual.slides.unshift(p[h]);
        C = g + p.length, _ = p.length;
      } else e.virtual.slides.unshift(p);
      if (e.params.virtual.cache) {
        const h = e.virtual.cache, S = {};
        Object.keys(h).forEach((w) => {
          const A = h[w], L = A.getAttribute("data-swiper-slide-index");
          L && A.setAttribute("data-swiper-slide-index", parseInt(L, 10) + _), S[parseInt(w, 10) + _] = A;
        }), e.virtual.cache = S;
      }
      d(true), e.slideTo(C, 0);
    }
    function y(p) {
      if (typeof p == "undefined" || p === null) return;
      let g = e.activeIndex;
      if (Array.isArray(p)) for (let C = p.length - 1; C >= 0; C -= 1) e.params.virtual.cache && (delete e.virtual.cache[p[C]], Object.keys(e.virtual.cache).forEach((_) => {
        _ > p && (e.virtual.cache[_ - 1] = e.virtual.cache[_], e.virtual.cache[_ - 1].setAttribute("data-swiper-slide-index", _ - 1), delete e.virtual.cache[_]);
      })), e.virtual.slides.splice(p[C], 1), p[C] < g && (g -= 1), g = Math.max(g, 0);
      else e.params.virtual.cache && (delete e.virtual.cache[p], Object.keys(e.virtual.cache).forEach((C) => {
        C > p && (e.virtual.cache[C - 1] = e.virtual.cache[C], e.virtual.cache[C - 1].setAttribute("data-swiper-slide-index", C - 1), delete e.virtual.cache[C]);
      })), e.virtual.slides.splice(p, 1), p < g && (g -= 1), g = Math.max(g, 0);
      d(true), e.slideTo(g, 0);
    }
    function b() {
      e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), d(true), e.slideTo(0, 0);
    }
    i("beforeInit", () => {
      if (!e.params.virtual.enabled) return;
      let p;
      if (typeof e.passedParams.virtual.slides == "undefined") {
        const g = [...e.slidesEl.children].filter((C) => C.matches(`.${e.params.slideClass}, swiper-slide`));
        g && g.length && (e.virtual.slides = [...g], p = true, g.forEach((C, _) => {
          C.setAttribute("data-swiper-slide-index", _), e.virtual.cache[_] = C, C.remove();
        }));
      }
      p || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = true, e.originalParams.watchSlidesProgress = true, d(false, true);
    }), i("setTranslate", () => {
      e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(r), r = setTimeout(() => {
        d();
      }, 100)) : d());
    }), i("init update resize", () => {
      e.params.virtual.enabled && e.params.cssMode && qt(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
    }), Object.assign(e.virtual, { appendSlide: v, prependSlide: E, removeSlide: y, removeAllSlides: b, update: d });
  }
  function Tg({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = Le(), o = ye();
    e.keyboard = { enabled: false }, t({ keyboard: { enabled: false, onlyInViewport: true, pageUpDown: true, speed: void 0 } });
    function l(v) {
      if (!e.enabled) return;
      const { rtlTranslate: E } = e;
      let y = v;
      y.originalEvent && (y = y.originalEvent);
      const b = y.keyCode || y.charCode, p = e.params.keyboard.pageUpDown, g = p && b === 33, C = p && b === 34, _ = b === 37, h = b === 39, S = b === 38, w = b === 40;
      if (!e.allowSlideNext && (e.isHorizontal() && h || e.isVertical() && w || C) || !e.allowSlidePrev && (e.isHorizontal() && _ || e.isVertical() && S || g)) return false;
      if (y.shiftKey || y.altKey || y.ctrlKey || y.metaKey || r.activeElement && (r.activeElement.isContentEditable || r.activeElement.nodeName && (r.activeElement.nodeName.toLowerCase() === "input" || r.activeElement.nodeName.toLowerCase() === "textarea"))) return;
      if (e.params.keyboard.onlyInViewport && (g || C || _ || h || S || w)) {
        let L = false;
        if (Qt(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && Qt(e.el, `.${e.params.slideActiveClass}`).length === 0) return;
        const f = e.el, P = f.clientWidth, D = f.clientHeight, R = o.innerWidth, N = o.innerHeight, $ = Rn(f);
        E && ($.left -= f.scrollLeft);
        const B = [[$.left, $.top], [$.left + P, $.top], [$.left, $.top + D], [$.left + P, $.top + D]];
        for (let V = 0; V < B.length; V += 1) {
          const X = B[V];
          if (X[0] >= 0 && X[0] <= R && X[1] >= 0 && X[1] <= N) {
            if (X[0] === 0 && X[1] === 0) continue;
            L = true;
          }
        }
        if (!L) return;
      }
      const A = e.params.keyboard.speed;
      e.isHorizontal() ? ((g || C || _ || h) && (y.preventDefault ? y.preventDefault() : y.returnValue = false), ((C || h) && !E || (g || _) && E) && e.slideNext(A), ((g || _) && !E || (C || h) && E) && e.slidePrev(A)) : ((g || C || S || w) && (y.preventDefault ? y.preventDefault() : y.returnValue = false), (C || w) && e.slideNext(A), (g || S) && e.slidePrev(A)), n("keyPress", b);
    }
    function c() {
      e.keyboard.enabled || (r.addEventListener("keydown", l), e.keyboard.enabled = true);
    }
    function d() {
      e.keyboard.enabled && (r.removeEventListener("keydown", l), e.keyboard.enabled = false);
    }
    i("init", () => {
      e.params.keyboard.enabled && c();
    }), i("destroy", () => {
      e.keyboard.enabled && d();
    }), Object.assign(e.keyboard, { enable: c, disable: d });
  }
  function _g({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = ye();
    t({ mousewheel: { enabled: false, releaseOnEdges: false, invert: false, forceToAxis: false, sensitivity: 1, eventsTarget: "container", thresholdDelta: null, thresholdTime: null, noMousewheelClass: "swiper-no-mousewheel" } }), e.mousewheel = { enabled: false };
    let o, l = Je(), c;
    const d = [];
    function v(S) {
      let f = 0, P = 0, D = 0, R = 0;
      return "detail" in S && (P = S.detail), "wheelDelta" in S && (P = -S.wheelDelta / 120), "wheelDeltaY" in S && (P = -S.wheelDeltaY / 120), "wheelDeltaX" in S && (f = -S.wheelDeltaX / 120), "axis" in S && S.axis === S.HORIZONTAL_AXIS && (f = P, P = 0), D = f * 10, R = P * 10, "deltaY" in S && (R = S.deltaY), "deltaX" in S && (D = S.deltaX), S.shiftKey && !D && (D = R, R = 0), (D || R) && S.deltaMode && (S.deltaMode === 1 ? (D *= 40, R *= 40) : (D *= 800, R *= 800)), D && !f && (f = D < 1 ? -1 : 1), R && !P && (P = R < 1 ? -1 : 1), { spinX: f, spinY: P, pixelX: D, pixelY: R };
    }
    function E() {
      e.enabled && (e.mouseEntered = true);
    }
    function y() {
      e.enabled && (e.mouseEntered = false);
    }
    function b(S) {
      return e.params.mousewheel.thresholdDelta && S.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && Je() - l < e.params.mousewheel.thresholdTime ? false : S.delta >= 6 && Je() - l < 60 ? true : (S.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), n("scroll", S.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), n("scroll", S.raw)), l = new r.Date().getTime(), false);
    }
    function p(S) {
      const w = e.params.mousewheel;
      if (S.direction < 0) {
        if (e.isEnd && !e.params.loop && w.releaseOnEdges) return true;
      } else if (e.isBeginning && !e.params.loop && w.releaseOnEdges) return true;
      return false;
    }
    function g(S) {
      let w = S, A = true;
      if (!e.enabled || S.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
      const L = e.params.mousewheel;
      e.params.cssMode && w.preventDefault();
      let f = e.el;
      e.params.mousewheel.eventsTarget !== "container" && (f = document.querySelector(e.params.mousewheel.eventsTarget));
      const P = f && f.contains(w.target);
      if (!e.mouseEntered && !P && !L.releaseOnEdges) return true;
      w.originalEvent && (w = w.originalEvent);
      let D = 0;
      const R = e.rtlTranslate ? -1 : 1, N = v(w);
      if (L.forceToAxis) if (e.isHorizontal()) if (Math.abs(N.pixelX) > Math.abs(N.pixelY)) D = -N.pixelX * R;
      else return true;
      else if (Math.abs(N.pixelY) > Math.abs(N.pixelX)) D = -N.pixelY;
      else return true;
      else D = Math.abs(N.pixelX) > Math.abs(N.pixelY) ? -N.pixelX * R : -N.pixelY;
      if (D === 0) return true;
      L.invert && (D = -D);
      let $ = e.getTranslate() + D * L.sensitivity;
      if ($ >= e.minTranslate() && ($ = e.minTranslate()), $ <= e.maxTranslate() && ($ = e.maxTranslate()), A = e.params.loop ? true : !($ === e.minTranslate() || $ === e.maxTranslate()), A && e.params.nested && w.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
        const B = { time: Je(), delta: Math.abs(D), direction: Math.sign(D), raw: S };
        d.length >= 2 && d.shift();
        const V = d.length ? d[d.length - 1] : void 0;
        if (d.push(B), V ? (B.direction !== V.direction || B.delta > V.delta || B.time > V.time + 150) && b(B) : b(B), p(B)) return true;
      } else {
        const B = { time: Je(), delta: Math.abs(D), direction: Math.sign(D) }, V = c && B.time < c.time + 500 && B.delta <= c.delta && B.direction === c.direction;
        if (!V) {
          c = void 0;
          let X = e.getTranslate() + D * L.sensitivity;
          const Z = e.isBeginning, F = e.isEnd;
          if (X >= e.minTranslate() && (X = e.minTranslate()), X <= e.maxTranslate() && (X = e.maxTranslate()), e.setTransition(0), e.setTranslate(X), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!Z && e.isBeginning || !F && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({ direction: B.direction < 0 ? "next" : "prev", byMousewheel: true }), e.params.freeMode.sticky) {
            clearTimeout(o), o = void 0, d.length >= 15 && d.shift();
            const W = d.length ? d[d.length - 1] : void 0, Y = d[0];
            if (d.push(B), W && (B.delta > W.delta || B.direction !== W.direction)) d.splice(0);
            else if (d.length >= 15 && B.time - Y.time < 500 && Y.delta - B.delta >= 1 && B.delta <= 6) {
              const J = D > 0 ? 0.8 : 0.2;
              c = B, d.splice(0), o = Pi(() => {
                e.destroyed || !e.params || e.slideToClosest(e.params.speed, true, void 0, J);
              }, 0);
            }
            o || (o = Pi(() => {
              if (e.destroyed || !e.params) return;
              const J = 0.5;
              c = B, d.splice(0), e.slideToClosest(e.params.speed, true, void 0, J);
            }, 500));
          }
          if (V || n("scroll", w), e.params.autoplay && e.params.autoplay.disableOnInteraction && e.autoplay.stop(), L.releaseOnEdges && (X === e.minTranslate() || X === e.maxTranslate())) return true;
        }
      }
      return w.preventDefault ? w.preventDefault() : w.returnValue = false, false;
    }
    function C(S) {
      let w = e.el;
      e.params.mousewheel.eventsTarget !== "container" && (w = document.querySelector(e.params.mousewheel.eventsTarget)), w[S]("mouseenter", E), w[S]("mouseleave", y), w[S]("wheel", g);
    }
    function _() {
      return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", g), true) : e.mousewheel.enabled ? false : (C("addEventListener"), e.mousewheel.enabled = true, true);
    }
    function h() {
      return e.params.cssMode ? (e.wrapperEl.addEventListener(event, g), true) : e.mousewheel.enabled ? (C("removeEventListener"), e.mousewheel.enabled = false, true) : false;
    }
    i("init", () => {
      !e.params.mousewheel.enabled && e.params.cssMode && h(), e.params.mousewheel.enabled && _();
    }), i("destroy", () => {
      e.params.cssMode && _(), e.mousewheel.enabled && h();
    }), Object.assign(e.mousewheel, { enable: _, disable: h });
  }
  function Mr(e, t, i, n) {
    return e.params.createElements && Object.keys(n).forEach((r) => {
      if (!i[r] && i.auto === true) {
        let o = Pe(e.el, `.${n[r]}`)[0];
        o || (o = Xe("div", n[r]), o.className = n[r], e.el.append(o)), i[r] = o, t[r] = o;
      }
    }), i;
  }
  const pa = '<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>';
  function xg({ swiper: e, extendParams: t, on: i, emit: n }) {
    t({ navigation: { nextEl: null, prevEl: null, addIcons: true, hideOnClick: false, disabledClass: "swiper-button-disabled", hiddenClass: "swiper-button-hidden", lockClass: "swiper-button-lock", navigationDisabledClass: "swiper-navigation-disabled" } }), e.navigation = { nextEl: null, prevEl: null, arrowSvg: pa };
    function r(p) {
      let g;
      return p && typeof p == "string" && e.isElement && (g = e.el.querySelector(p) || e.hostEl.querySelector(p), g) ? g : (p && (typeof p == "string" && (g = [...document.querySelectorAll(p)]), e.params.uniqueNavElements && typeof p == "string" && g && g.length > 1 && e.el.querySelectorAll(p).length === 1 ? g = e.el.querySelector(p) : g && g.length === 1 && (g = g[0])), p && !g ? p : g);
    }
    function o(p, g) {
      const C = e.params.navigation;
      p = ue(p), p.forEach((_) => {
        _ && (_.classList[g ? "add" : "remove"](...C.disabledClass.split(" ")), _.tagName === "BUTTON" && (_.disabled = g), e.params.watchOverflow && e.enabled && _.classList[e.isLocked ? "add" : "remove"](C.lockClass));
      });
    }
    function l() {
      const { nextEl: p, prevEl: g } = e.navigation;
      if (e.params.loop) {
        o(g, false), o(p, false);
        return;
      }
      o(g, e.isBeginning && !e.params.rewind), o(p, e.isEnd && !e.params.rewind);
    }
    function c(p) {
      p.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), n("navigationPrev"));
    }
    function d(p) {
      p.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), n("navigationNext"));
    }
    function v() {
      const p = e.params.navigation;
      if (e.params.navigation = Mr(e, e.originalParams.navigation, e.params.navigation, { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }), !(p.nextEl || p.prevEl)) return;
      let g = r(p.nextEl), C = r(p.prevEl);
      Object.assign(e.navigation, { nextEl: g, prevEl: C }), g = ue(g), C = ue(C);
      const _ = (h, S) => {
        if (h) {
          if (p.addIcons && h.matches(".swiper-button-next,.swiper-button-prev") && !h.querySelector("svg")) {
            const w = document.createElement("div");
            bt(w, pa), h.appendChild(w.querySelector("svg")), w.remove();
          }
          h.addEventListener("click", S === "next" ? d : c);
        }
        !e.enabled && h && h.classList.add(...p.lockClass.split(" "));
      };
      g.forEach((h) => _(h, "next")), C.forEach((h) => _(h, "prev"));
    }
    function E() {
      let { nextEl: p, prevEl: g } = e.navigation;
      p = ue(p), g = ue(g);
      const C = (_, h) => {
        _.removeEventListener("click", h === "next" ? d : c), _.classList.remove(...e.params.navigation.disabledClass.split(" "));
      };
      p.forEach((_) => C(_, "next")), g.forEach((_) => C(_, "prev"));
    }
    i("init", () => {
      e.params.navigation.enabled === false ? b() : (v(), l());
    }), i("toEdge fromEdge lock unlock", () => {
      l();
    }), i("destroy", () => {
      E();
    }), i("enable disable", () => {
      let { nextEl: p, prevEl: g } = e.navigation;
      if (p = ue(p), g = ue(g), e.enabled) {
        l();
        return;
      }
      [...p, ...g].filter((C) => !!C).forEach((C) => C.classList.add(e.params.navigation.lockClass));
    }), i("click", (p, g) => {
      let { nextEl: C, prevEl: _ } = e.navigation;
      C = ue(C), _ = ue(_);
      const h = g.target;
      let S = _.includes(h) || C.includes(h);
      if (e.isElement && !S) {
        const w = g.path || g.composedPath && g.composedPath();
        w && (S = w.find((A) => C.includes(A) || _.includes(A)));
      }
      if (e.params.navigation.hideOnClick && !S) {
        if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === h || e.pagination.el.contains(h))) return;
        let w;
        C.length ? w = C[0].classList.contains(e.params.navigation.hiddenClass) : _.length && (w = _[0].classList.contains(e.params.navigation.hiddenClass)), n(w === true ? "navigationShow" : "navigationHide"), [...C, ..._].filter((A) => !!A).forEach((A) => A.classList.toggle(e.params.navigation.hiddenClass));
      }
    });
    const y = () => {
      e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), v(), l();
    }, b = () => {
      e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), E();
    };
    Object.assign(e.navigation, { enable: y, disable: b, update: l, init: v, destroy: E });
  }
  function Ct(e = "") {
    return `.${e.trim().replace(/([\.:!+\/()[\]#>~*^$|=,'"@{}\\])/g, "\\$1").replace(/ /g, ".")}`;
  }
  function Cg({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = "swiper-pagination";
    t({ pagination: { el: null, bulletElement: "span", clickable: false, hideOnClick: false, renderBullet: null, renderProgressbar: null, renderFraction: null, renderCustom: null, progressbarOpposite: false, type: "bullets", dynamicBullets: false, dynamicMainBullets: 1, formatFractionCurrent: (h) => h, formatFractionTotal: (h) => h, bulletClass: `${r}-bullet`, bulletActiveClass: `${r}-bullet-active`, modifierClass: `${r}-`, currentClass: `${r}-current`, totalClass: `${r}-total`, hiddenClass: `${r}-hidden`, progressbarFillClass: `${r}-progressbar-fill`, progressbarOppositeClass: `${r}-progressbar-opposite`, clickableClass: `${r}-clickable`, lockClass: `${r}-lock`, horizontalClass: `${r}-horizontal`, verticalClass: `${r}-vertical`, paginationDisabledClass: `${r}-disabled` } }), e.pagination = { el: null, bullets: [] };
    let o, l = 0;
    function c() {
      return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
    }
    function d(h, S) {
      const { bulletActiveClass: w } = e.params.pagination;
      h && (h = h[`${S === "prev" ? "previous" : "next"}ElementSibling`], h && (h.classList.add(`${w}-${S}`), h = h[`${S === "prev" ? "previous" : "next"}ElementSibling`], h && h.classList.add(`${w}-${S}-${S}`)));
    }
    function v(h, S, w) {
      if (h = h % w, S = S % w, S === h + 1) return "next";
      if (S === h - 1) return "previous";
    }
    function E(h) {
      const S = h.target.closest(Ct(e.params.pagination.bulletClass));
      if (!S) return;
      h.preventDefault();
      const w = Qi(S) * e.params.slidesPerGroup;
      if (e.params.loop) {
        if (e.realIndex === w) return;
        const A = v(e.realIndex, w, e.slides.length);
        A === "next" ? e.slideNext() : A === "previous" ? e.slidePrev() : e.slideToLoop(w);
      } else e.slideTo(w);
    }
    function y() {
      const h = e.rtl, S = e.params.pagination;
      if (c()) return;
      let w = e.pagination.el;
      w = ue(w);
      let A, L;
      const f = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, P = e.params.loop ? Math.ceil(f / e.params.slidesPerGroup) : e.snapGrid.length;
      if (e.params.loop ? (L = e.previousRealIndex || 0, A = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex != "undefined" ? (A = e.snapIndex, L = e.previousSnapIndex) : (L = e.previousIndex || 0, A = e.activeIndex || 0), S.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
        const D = e.pagination.bullets;
        let R, N, $;
        if (S.dynamicBullets && (o = hr(D[0], e.isHorizontal() ? "width" : "height"), w.forEach((B) => {
          B.style[e.isHorizontal() ? "width" : "height"] = `${o * (S.dynamicMainBullets + 4)}px`;
        }), S.dynamicMainBullets > 1 && L !== void 0 && (l += A - (L || 0), l > S.dynamicMainBullets - 1 ? l = S.dynamicMainBullets - 1 : l < 0 && (l = 0)), R = Math.max(A - l, 0), N = R + (Math.min(D.length, S.dynamicMainBullets) - 1), $ = (N + R) / 2), D.forEach((B) => {
          const V = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((X) => `${S.bulletActiveClass}${X}`)].map((X) => typeof X == "string" && X.includes(" ") ? X.split(" ") : X).flat();
          B.classList.remove(...V);
        }), w.length > 1) D.forEach((B) => {
          const V = Qi(B);
          V === A ? B.classList.add(...S.bulletActiveClass.split(" ")) : e.isElement && B.setAttribute("part", "bullet"), S.dynamicBullets && (V >= R && V <= N && B.classList.add(...`${S.bulletActiveClass}-main`.split(" ")), V === R && d(B, "prev"), V === N && d(B, "next"));
        });
        else {
          const B = D[A];
          if (B && B.classList.add(...S.bulletActiveClass.split(" ")), e.isElement && D.forEach((V, X) => {
            V.setAttribute("part", X === A ? "bullet-active" : "bullet");
          }), S.dynamicBullets) {
            const V = D[R], X = D[N];
            for (let Z = R; Z <= N; Z += 1) D[Z] && D[Z].classList.add(...`${S.bulletActiveClass}-main`.split(" "));
            d(V, "prev"), d(X, "next");
          }
        }
        if (S.dynamicBullets) {
          const B = Math.min(D.length, S.dynamicMainBullets + 4), V = (o * B - o) / 2 - $ * o, X = h ? "right" : "left";
          D.forEach((Z) => {
            Z.style[e.isHorizontal() ? X : "top"] = `${V}px`;
          });
        }
      }
      w.forEach((D, R) => {
        if (S.type === "fraction" && (D.querySelectorAll(Ct(S.currentClass)).forEach((N) => {
          N.textContent = S.formatFractionCurrent(A + 1);
        }), D.querySelectorAll(Ct(S.totalClass)).forEach((N) => {
          N.textContent = S.formatFractionTotal(P);
        })), S.type === "progressbar") {
          let N;
          S.progressbarOpposite ? N = e.isHorizontal() ? "vertical" : "horizontal" : N = e.isHorizontal() ? "horizontal" : "vertical";
          const $ = (A + 1) / P;
          let B = 1, V = 1;
          N === "horizontal" ? B = $ : V = $, D.querySelectorAll(Ct(S.progressbarFillClass)).forEach((X) => {
            X.style.transform = `translate3d(0,0,0) scaleX(${B}) scaleY(${V})`, X.style.transitionDuration = `${e.params.speed}ms`;
          });
        }
        S.type === "custom" && S.renderCustom ? (bt(D, S.renderCustom(e, A + 1, P)), R === 0 && n("paginationRender", D)) : (R === 0 && n("paginationRender", D), n("paginationUpdate", D)), e.params.watchOverflow && e.enabled && D.classList[e.isLocked ? "add" : "remove"](S.lockClass);
      });
    }
    function b() {
      const h = e.params.pagination;
      if (c()) return;
      const S = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
      let w = e.pagination.el;
      w = ue(w);
      let A = "";
      if (h.type === "bullets") {
        let L = e.params.loop ? Math.ceil(S / e.params.slidesPerGroup) : e.snapGrid.length;
        e.params.freeMode && e.params.freeMode.enabled && L > S && (L = S);
        for (let f = 0; f < L; f += 1) h.renderBullet ? A += h.renderBullet.call(e, f, h.bulletClass) : A += `<${h.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${h.bulletClass}"></${h.bulletElement}>`;
      }
      h.type === "fraction" && (h.renderFraction ? A = h.renderFraction.call(e, h.currentClass, h.totalClass) : A = `<span class="${h.currentClass}"></span> / <span class="${h.totalClass}"></span>`), h.type === "progressbar" && (h.renderProgressbar ? A = h.renderProgressbar.call(e, h.progressbarFillClass) : A = `<span class="${h.progressbarFillClass}"></span>`), e.pagination.bullets = [], w.forEach((L) => {
        h.type !== "custom" && bt(L, A || ""), h.type === "bullets" && e.pagination.bullets.push(...L.querySelectorAll(Ct(h.bulletClass)));
      }), h.type !== "custom" && n("paginationRender", w[0]);
    }
    function p() {
      e.params.pagination = Mr(e, e.originalParams.pagination, e.params.pagination, { el: "swiper-pagination" });
      const h = e.params.pagination;
      if (!h.el) return;
      let S;
      typeof h.el == "string" && e.isElement && (S = e.el.querySelector(h.el)), !S && typeof h.el == "string" && (S = [...document.querySelectorAll(h.el)]), S || (S = h.el), !(!S || S.length === 0) && (e.params.uniqueNavElements && typeof h.el == "string" && Array.isArray(S) && S.length > 1 && (S = [...e.el.querySelectorAll(h.el)], S.length > 1 && (S = S.find((w) => Qt(w, ".swiper")[0] === e.el))), Array.isArray(S) && S.length === 1 && (S = S[0]), Object.assign(e.pagination, { el: S }), S = ue(S), S.forEach((w) => {
        h.type === "bullets" && h.clickable && w.classList.add(...(h.clickableClass || "").split(" ")), w.classList.add(h.modifierClass + h.type), w.classList.add(e.isHorizontal() ? h.horizontalClass : h.verticalClass), h.type === "bullets" && h.dynamicBullets && (w.classList.add(`${h.modifierClass}${h.type}-dynamic`), l = 0, h.dynamicMainBullets < 1 && (h.dynamicMainBullets = 1)), h.type === "progressbar" && h.progressbarOpposite && w.classList.add(h.progressbarOppositeClass), h.clickable && w.addEventListener("click", E), e.enabled || w.classList.add(h.lockClass);
      }));
    }
    function g() {
      const h = e.params.pagination;
      if (c()) return;
      let S = e.pagination.el;
      S && (S = ue(S), S.forEach((w) => {
        w.classList.remove(h.hiddenClass), w.classList.remove(h.modifierClass + h.type), w.classList.remove(e.isHorizontal() ? h.horizontalClass : h.verticalClass), h.clickable && (w.classList.remove(...(h.clickableClass || "").split(" ")), w.removeEventListener("click", E));
      })), e.pagination.bullets && e.pagination.bullets.forEach((w) => w.classList.remove(...h.bulletActiveClass.split(" ")));
    }
    i("changeDirection", () => {
      if (!e.pagination || !e.pagination.el) return;
      const h = e.params.pagination;
      let { el: S } = e.pagination;
      S = ue(S), S.forEach((w) => {
        w.classList.remove(h.horizontalClass, h.verticalClass), w.classList.add(e.isHorizontal() ? h.horizontalClass : h.verticalClass);
      });
    }), i("init", () => {
      e.params.pagination.enabled === false ? _() : (p(), b(), y());
    }), i("activeIndexChange", () => {
      typeof e.snapIndex == "undefined" && y();
    }), i("snapIndexChange", () => {
      y();
    }), i("snapGridLengthChange", () => {
      b(), y();
    }), i("destroy", () => {
      g();
    }), i("enable disable", () => {
      let { el: h } = e.pagination;
      h && (h = ue(h), h.forEach((S) => S.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
    }), i("lock unlock", () => {
      y();
    }), i("click", (h, S) => {
      const w = S.target, A = ue(e.pagination.el);
      if (e.params.pagination.el && e.params.pagination.hideOnClick && A && A.length > 0 && !w.classList.contains(e.params.pagination.bulletClass)) {
        if (e.navigation && (e.navigation.nextEl && w === e.navigation.nextEl || e.navigation.prevEl && w === e.navigation.prevEl)) return;
        const L = A[0].classList.contains(e.params.pagination.hiddenClass);
        n(L === true ? "paginationShow" : "paginationHide"), A.forEach((f) => f.classList.toggle(e.params.pagination.hiddenClass));
      }
    });
    const C = () => {
      e.el.classList.remove(e.params.pagination.paginationDisabledClass);
      let { el: h } = e.pagination;
      h && (h = ue(h), h.forEach((S) => S.classList.remove(e.params.pagination.paginationDisabledClass))), p(), b(), y();
    }, _ = () => {
      e.el.classList.add(e.params.pagination.paginationDisabledClass);
      let { el: h } = e.pagination;
      h && (h = ue(h), h.forEach((S) => S.classList.add(e.params.pagination.paginationDisabledClass))), g();
    };
    Object.assign(e.pagination, { enable: C, disable: _, render: b, update: y, init: p, destroy: g });
  }
  function wg({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = Le();
    let o = false, l = null, c = null, d, v, E, y;
    t({ scrollbar: { el: null, dragSize: "auto", hide: false, draggable: false, snapOnRelease: true, lockClass: "swiper-scrollbar-lock", dragClass: "swiper-scrollbar-drag", scrollbarDisabledClass: "swiper-scrollbar-disabled", horizontalClass: "swiper-scrollbar-horizontal", verticalClass: "swiper-scrollbar-vertical" } }), e.scrollbar = { el: null, dragEl: null };
    function b() {
      if (!e.params.scrollbar.el || !e.scrollbar.el) return;
      const { scrollbar: $, rtlTranslate: B } = e, { dragEl: V, el: X } = $, Z = e.params.scrollbar, F = e.params.loop ? e.progressLoop : e.progress;
      let W = v, Y = (E - v) * F;
      B ? (Y = -Y, Y > 0 ? (W = v - Y, Y = 0) : -Y + v > E && (W = E + Y)) : Y < 0 ? (W = v + Y, Y = 0) : Y + v > E && (W = E - Y), e.isHorizontal() ? (V.style.transform = `translate3d(${Y}px, 0, 0)`, V.style.width = `${W}px`) : (V.style.transform = `translate3d(0px, ${Y}px, 0)`, V.style.height = `${W}px`), Z.hide && (clearTimeout(l), X.style.opacity = 1, l = setTimeout(() => {
        X.style.opacity = 0, X.style.transitionDuration = "400ms";
      }, 1e3));
    }
    function p($) {
      !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${$}ms`);
    }
    function g() {
      if (!e.params.scrollbar.el || !e.scrollbar.el) return;
      const { scrollbar: $ } = e, { dragEl: B, el: V } = $;
      B.style.width = "", B.style.height = "", E = e.isHorizontal() ? V.offsetWidth : V.offsetHeight, y = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? v = E * y : v = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? B.style.width = `${v}px` : B.style.height = `${v}px`, y >= 1 ? V.style.display = "none" : V.style.display = "", e.params.scrollbar.hide && (V.style.opacity = 0), e.params.watchOverflow && e.enabled && $.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
    }
    function C($) {
      return e.isHorizontal() ? $.clientX : $.clientY;
    }
    function _($) {
      const { scrollbar: B, rtlTranslate: V } = e, { el: X } = B;
      let Z;
      Z = (C($) - Rn(X)[e.isHorizontal() ? "left" : "top"] - (d !== null ? d : v / 2)) / (E - v), Z = Math.max(Math.min(Z, 1), 0), V && (Z = 1 - Z);
      const F = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * Z;
      e.updateProgress(F), e.setTranslate(F), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    function h($) {
      const B = e.params.scrollbar, { scrollbar: V, wrapperEl: X } = e, { el: Z, dragEl: F } = V;
      o = true, d = $.target === F ? C($) - $.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, $.preventDefault(), $.stopPropagation(), X.style.transitionDuration = "100ms", F.style.transitionDuration = "100ms", _($), clearTimeout(c), Z.style.transitionDuration = "0ms", B.hide && (Z.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), n("scrollbarDragStart", $);
    }
    function S($) {
      const { scrollbar: B, wrapperEl: V } = e, { el: X, dragEl: Z } = B;
      o && ($.preventDefault && $.cancelable ? $.preventDefault() : $.returnValue = false, _($), V.style.transitionDuration = "0ms", X.style.transitionDuration = "0ms", Z.style.transitionDuration = "0ms", n("scrollbarDragMove", $));
    }
    function w($) {
      const B = e.params.scrollbar, { scrollbar: V, wrapperEl: X } = e, { el: Z } = V;
      o && (o = false, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", X.style.transitionDuration = ""), B.hide && (clearTimeout(c), c = Pi(() => {
        Z.style.opacity = 0, Z.style.transitionDuration = "400ms";
      }, 1e3)), n("scrollbarDragEnd", $), B.snapOnRelease && e.slideToClosest());
    }
    function A($) {
      const { scrollbar: B, params: V } = e, X = B.el;
      if (!X) return;
      const Z = X, F = V.passiveListeners ? { passive: false, capture: false } : false, W = V.passiveListeners ? { passive: true, capture: false } : false;
      if (!Z) return;
      const Y = $ === "on" ? "addEventListener" : "removeEventListener";
      Z[Y]("pointerdown", h, F), r[Y]("pointermove", S, F), r[Y]("pointerup", w, W);
    }
    function L() {
      !e.params.scrollbar.el || !e.scrollbar.el || A("on");
    }
    function f() {
      !e.params.scrollbar.el || !e.scrollbar.el || A("off");
    }
    function P() {
      const { scrollbar: $, el: B } = e;
      e.params.scrollbar = Mr(e, e.originalParams.scrollbar, e.params.scrollbar, { el: "swiper-scrollbar" });
      const V = e.params.scrollbar;
      if (!V.el) return;
      let X;
      if (typeof V.el == "string" && e.isElement && (X = e.el.querySelector(V.el)), !X && typeof V.el == "string") {
        if (X = r.querySelectorAll(V.el), !X.length) return;
      } else X || (X = V.el);
      e.params.uniqueNavElements && typeof V.el == "string" && X.length > 1 && B.querySelectorAll(V.el).length === 1 && (X = B.querySelector(V.el)), X.length > 0 && (X = X[0]), X.classList.add(e.isHorizontal() ? V.horizontalClass : V.verticalClass);
      let Z;
      X && (Z = X.querySelector(Ct(e.params.scrollbar.dragClass)), Z || (Z = Xe("div", e.params.scrollbar.dragClass), X.append(Z))), Object.assign($, { el: X, dragEl: Z }), V.draggable && L(), X && X.classList[e.enabled ? "remove" : "add"](...kt(e.params.scrollbar.lockClass));
    }
    function D() {
      const $ = e.params.scrollbar, B = e.scrollbar.el;
      B && B.classList.remove(...kt(e.isHorizontal() ? $.horizontalClass : $.verticalClass)), f();
    }
    i("changeDirection", () => {
      if (!e.scrollbar || !e.scrollbar.el) return;
      const $ = e.params.scrollbar;
      let { el: B } = e.scrollbar;
      B = ue(B), B.forEach((V) => {
        V.classList.remove($.horizontalClass, $.verticalClass), V.classList.add(e.isHorizontal() ? $.horizontalClass : $.verticalClass);
      });
    }), i("init", () => {
      e.params.scrollbar.enabled === false ? N() : (P(), g(), b());
    }), i("update resize observerUpdate lock unlock changeDirection", () => {
      g();
    }), i("setTranslate", () => {
      b();
    }), i("setTransition", ($, B) => {
      p(B);
    }), i("enable disable", () => {
      const { el: $ } = e.scrollbar;
      $ && $.classList[e.enabled ? "remove" : "add"](...kt(e.params.scrollbar.lockClass));
    }), i("destroy", () => {
      D();
    });
    const R = () => {
      e.el.classList.remove(...kt(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...kt(e.params.scrollbar.scrollbarDisabledClass)), P(), g(), b();
    }, N = () => {
      e.el.classList.add(...kt(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...kt(e.params.scrollbar.scrollbarDisabledClass)), D();
    };
    Object.assign(e.scrollbar, { enable: R, disable: N, updateSize: g, setTranslate: b, init: P, destroy: D });
  }
  function Ig({ swiper: e, extendParams: t, on: i }) {
    t({ parallax: { enabled: false } });
    const n = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", r = (c, d) => {
      const { rtl: v } = e, E = v ? -1 : 1, y = c.getAttribute("data-swiper-parallax") || "0";
      let b = c.getAttribute("data-swiper-parallax-x"), p = c.getAttribute("data-swiper-parallax-y");
      const g = c.getAttribute("data-swiper-parallax-scale"), C = c.getAttribute("data-swiper-parallax-opacity"), _ = c.getAttribute("data-swiper-parallax-rotate");
      if (b || p ? (b = b || "0", p = p || "0") : e.isHorizontal() ? (b = y, p = "0") : (p = y, b = "0"), b.indexOf("%") >= 0 ? b = `${parseInt(b, 10) * d * E}%` : b = `${b * d * E}px`, p.indexOf("%") >= 0 ? p = `${parseInt(p, 10) * d}%` : p = `${p * d}px`, typeof C != "undefined" && C !== null) {
        const S = C - (C - 1) * (1 - Math.abs(d));
        c.style.opacity = S;
      }
      let h = `translate3d(${b}, ${p}, 0px)`;
      if (typeof g != "undefined" && g !== null) {
        const S = g - (g - 1) * (1 - Math.abs(d));
        h += ` scale(${S})`;
      }
      if (_ && typeof _ != "undefined" && _ !== null) {
        const S = _ * d * -1;
        h += ` rotate(${S}deg)`;
      }
      c.style.transform = h;
    }, o = () => {
      const { el: c, slides: d, progress: v, snapGrid: E, isElement: y } = e, b = Pe(c, n);
      e.isElement && b.push(...Pe(e.hostEl, n)), b.forEach((p) => {
        r(p, v);
      }), d.forEach((p, g) => {
        let C = p.progress;
        e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (C += Math.ceil(g / 2) - v * (E.length - 1)), C = Math.min(Math.max(C, -1), 1), p.querySelectorAll(`${n}, [data-swiper-parallax-rotate]`).forEach((_) => {
          r(_, C);
        });
      });
    }, l = (c = e.params.speed) => {
      const { el: d, hostEl: v } = e, E = [...d.querySelectorAll(n)];
      e.isElement && E.push(...v.querySelectorAll(n)), E.forEach((y) => {
        let b = parseInt(y.getAttribute("data-swiper-parallax-duration"), 10) || c;
        c === 0 && (b = 0), y.style.transitionDuration = `${b}ms`;
      });
    };
    i("beforeInit", () => {
      e.params.parallax.enabled && (e.params.watchSlidesProgress = true, e.originalParams.watchSlidesProgress = true);
    }), i("init", () => {
      e.params.parallax.enabled && o();
    }), i("setTranslate", () => {
      e.params.parallax.enabled && o();
    }), i("setTransition", (c, d) => {
      e.params.parallax.enabled && l(d);
    });
  }
  function Ag({ swiper: e, extendParams: t, on: i, emit: n }) {
    const r = ye();
    t({ zoom: { enabled: false, limitToOriginalSize: false, maxRatio: 3, minRatio: 1, panOnMouseMove: false, toggle: true, containerClass: "swiper-zoom-container", zoomedSlideClass: "swiper-slide-zoomed" } }), e.zoom = { enabled: false };
    let o = 1, l = false, c = false, d = { x: 0, y: 0 };
    const v = -3;
    let E, y;
    const b = [], p = { originX: 0, originY: 0, slideEl: void 0, slideWidth: void 0, slideHeight: void 0, imageEl: void 0, imageWrapEl: void 0, maxRatio: 3 }, g = { isTouched: void 0, isMoved: void 0, currentX: void 0, currentY: void 0, minX: void 0, minY: void 0, maxX: void 0, maxY: void 0, width: void 0, height: void 0, startX: void 0, startY: void 0, touchesStart: {}, touchesCurrent: {} }, C = { x: void 0, y: void 0, prevPositionX: void 0, prevPositionY: void 0, prevTime: void 0 };
    let _ = 1;
    Object.defineProperty(e.zoom, "scale", { get() {
      return _;
    }, set(U) {
      if (_ !== U) {
        const Q = p.imageEl, ee = p.slideEl;
        n("zoomChange", U, Q, ee);
      }
      _ = U;
    } });
    function h() {
      if (b.length < 2) return 1;
      const U = b[0].pageX, Q = b[0].pageY, ee = b[1].pageX, K = b[1].pageY;
      return Math.sqrt(Me(ee - U, 2) + Me(K - Q, 2));
    }
    function S() {
      const U = e.params.zoom, Q = p.imageWrapEl.getAttribute("data-swiper-zoom") || U.maxRatio;
      if (U.limitToOriginalSize && p.imageEl && p.imageEl.naturalWidth) {
        const ee = p.imageEl.naturalWidth / p.imageEl.offsetWidth;
        return Math.min(ee, Q);
      }
      return Q;
    }
    function w() {
      if (b.length < 2) return { x: null, y: null };
      const U = p.imageEl.getBoundingClientRect();
      return [(b[0].pageX + (b[1].pageX - b[0].pageX) / 2 - U.x - r.scrollX) / o, (b[0].pageY + (b[1].pageY - b[0].pageY) / 2 - U.y - r.scrollY) / o];
    }
    function A() {
      return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
    }
    function L(U) {
      const Q = A();
      return !!(U.target.matches(Q) || e.slides.filter((ee) => ee.contains(U.target)).length > 0);
    }
    function f(U) {
      const Q = `.${e.params.zoom.containerClass}`;
      return !!(U.target.matches(Q) || [...e.hostEl.querySelectorAll(Q)].filter((ee) => ee.contains(U.target)).length > 0);
    }
    function P(U) {
      if (U.pointerType === "mouse" && b.splice(0, b.length), !L(U)) return;
      const Q = e.params.zoom;
      if (E = false, y = false, b.push(U), !(b.length < 2)) {
        if (E = true, p.scaleStart = h(), !p.slideEl) {
          p.slideEl = U.target.closest(`.${e.params.slideClass}, swiper-slide`), p.slideEl || (p.slideEl = e.slides[e.activeIndex]);
          let ee = p.slideEl.querySelector(`.${Q.containerClass}`);
          if (ee && (ee = ee.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = ee, ee ? p.imageWrapEl = Qt(p.imageEl, `.${Q.containerClass}`)[0] : p.imageWrapEl = void 0, !p.imageWrapEl) {
            p.imageEl = void 0;
            return;
          }
          p.maxRatio = S();
        }
        if (p.imageEl) {
          const [ee, K] = w();
          p.originX = ee, p.originY = K, p.imageEl.style.transitionDuration = "0ms";
        }
        l = true;
      }
    }
    function D(U) {
      if (!L(U)) return;
      const Q = e.params.zoom, ee = e.zoom, K = b.findIndex((se) => se.pointerId === U.pointerId);
      K >= 0 && (b[K] = U), !(b.length < 2) && (y = true, p.scaleMove = h(), p.imageEl && (ee.scale = p.scaleMove / p.scaleStart * o, ee.scale > p.maxRatio && (ee.scale = p.maxRatio - 1 + Me(ee.scale - p.maxRatio + 1, 0.5)), ee.scale < Q.minRatio && (ee.scale = Q.minRatio + 1 - Me(Q.minRatio - ee.scale + 1, 0.5)), p.imageEl.style.transform = `translate3d(0,0,0) scale(${ee.scale})`));
    }
    function R(U) {
      if (!L(U) || U.pointerType === "mouse" && U.type === "pointerout") return;
      const Q = e.params.zoom, ee = e.zoom, K = b.findIndex((se) => se.pointerId === U.pointerId);
      K >= 0 && b.splice(K, 1), !(!E || !y) && (E = false, y = false, p.imageEl && (ee.scale = Math.max(Math.min(ee.scale, p.maxRatio), Q.minRatio), p.imageEl.style.transitionDuration = `${e.params.speed}ms`, p.imageEl.style.transform = `translate3d(0,0,0) scale(${ee.scale})`, o = ee.scale, l = false, ee.scale > 1 && p.slideEl ? p.slideEl.classList.add(`${Q.zoomedSlideClass}`) : ee.scale <= 1 && p.slideEl && p.slideEl.classList.remove(`${Q.zoomedSlideClass}`), ee.scale === 1 && (p.originX = 0, p.originY = 0, p.slideEl = void 0)));
    }
    let N;
    function $() {
      e.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function B() {
      clearTimeout(N), e.touchEventsData.preventTouchMoveFromPointerMove = true, N = setTimeout(() => {
        e.destroyed || $();
      });
    }
    function V(U) {
      const Q = e.device;
      if (!p.imageEl || g.isTouched) return;
      Q.android && U.cancelable && U.preventDefault(), g.isTouched = true;
      const ee = b.length > 0 ? b[0] : U;
      g.touchesStart.x = ee.pageX, g.touchesStart.y = ee.pageY;
    }
    function X(U) {
      const ee = U.pointerType === "mouse" && e.params.zoom.panOnMouseMove;
      if (!L(U) || !f(U)) return;
      const K = e.zoom;
      if (!p.imageEl) return;
      if (!g.isTouched || !p.slideEl) {
        ee && W(U);
        return;
      }
      if (ee) {
        W(U);
        return;
      }
      g.isMoved || (g.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, g.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, g.startX = fr(p.imageWrapEl, "x") || 0, g.startY = fr(p.imageWrapEl, "y") || 0, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight, p.imageWrapEl.style.transitionDuration = "0ms");
      const se = g.width * K.scale, Se = g.height * K.scale;
      if (g.minX = Math.min(p.slideWidth / 2 - se / 2, 0), g.maxX = -g.minX, g.minY = Math.min(p.slideHeight / 2 - Se / 2, 0), g.maxY = -g.minY, g.touchesCurrent.x = b.length > 0 ? b[0].pageX : U.pageX, g.touchesCurrent.y = b.length > 0 ? b[0].pageY : U.pageY, Math.max(Math.abs(g.touchesCurrent.x - g.touchesStart.x), Math.abs(g.touchesCurrent.y - g.touchesStart.y)) > 5 && (e.allowClick = false), !g.isMoved && !l) {
        if (e.isHorizontal() && (Math.floor(g.minX) === Math.floor(g.startX) && g.touchesCurrent.x < g.touchesStart.x || Math.floor(g.maxX) === Math.floor(g.startX) && g.touchesCurrent.x > g.touchesStart.x)) {
          g.isTouched = false, $();
          return;
        }
        if (!e.isHorizontal() && (Math.floor(g.minY) === Math.floor(g.startY) && g.touchesCurrent.y < g.touchesStart.y || Math.floor(g.maxY) === Math.floor(g.startY) && g.touchesCurrent.y > g.touchesStart.y)) {
          g.isTouched = false, $();
          return;
        }
      }
      U.cancelable && U.preventDefault(), U.stopPropagation(), B(), g.isMoved = true;
      const Ce = (K.scale - o) / (p.maxRatio - e.params.zoom.minRatio), { originX: Ze, originY: ge } = p;
      g.currentX = g.touchesCurrent.x - g.touchesStart.x + g.startX + Ce * (g.width - Ze * 2), g.currentY = g.touchesCurrent.y - g.touchesStart.y + g.startY + Ce * (g.height - ge * 2), g.currentX < g.minX && (g.currentX = g.minX + 1 - Me(g.minX - g.currentX + 1, 0.8)), g.currentX > g.maxX && (g.currentX = g.maxX - 1 + Me(g.currentX - g.maxX + 1, 0.8)), g.currentY < g.minY && (g.currentY = g.minY + 1 - Me(g.minY - g.currentY + 1, 0.8)), g.currentY > g.maxY && (g.currentY = g.maxY - 1 + Me(g.currentY - g.maxY + 1, 0.8)), C.prevPositionX || (C.prevPositionX = g.touchesCurrent.x), C.prevPositionY || (C.prevPositionY = g.touchesCurrent.y), C.prevTime || (C.prevTime = Date.now()), C.x = (g.touchesCurrent.x - C.prevPositionX) / (Date.now() - C.prevTime) / 2, C.y = (g.touchesCurrent.y - C.prevPositionY) / (Date.now() - C.prevTime) / 2, Math.abs(g.touchesCurrent.x - C.prevPositionX) < 2 && (C.x = 0), Math.abs(g.touchesCurrent.y - C.prevPositionY) < 2 && (C.y = 0), C.prevPositionX = g.touchesCurrent.x, C.prevPositionY = g.touchesCurrent.y, C.prevTime = Date.now(), p.imageWrapEl.style.transform = `translate3d(${g.currentX}px, ${g.currentY}px,0)`;
    }
    function Z() {
      const U = e.zoom;
      if (b.length = 0, !p.imageEl) return;
      if (!g.isTouched || !g.isMoved) {
        g.isTouched = false, g.isMoved = false;
        return;
      }
      g.isTouched = false, g.isMoved = false;
      let Q = 300, ee = 300;
      const K = C.x * Q, se = g.currentX + K, Se = C.y * ee, Ge = g.currentY + Se;
      C.x !== 0 && (Q = Math.abs((se - g.currentX) / C.x)), C.y !== 0 && (ee = Math.abs((Ge - g.currentY) / C.y));
      const Ce = Math.max(Q, ee);
      g.currentX = se, g.currentY = Ge;
      const Ze = g.width * U.scale, ge = g.height * U.scale;
      g.minX = Math.min(p.slideWidth / 2 - Ze / 2, 0), g.maxX = -g.minX, g.minY = Math.min(p.slideHeight / 2 - ge / 2, 0), g.maxY = -g.minY, g.currentX = Math.max(Math.min(g.currentX, g.maxX), g.minX), g.currentY = Math.max(Math.min(g.currentY, g.maxY), g.minY), p.imageWrapEl.style.transitionDuration = `${Ce}ms`, p.imageWrapEl.style.transform = `translate3d(${g.currentX}px, ${g.currentY}px,0)`;
    }
    function F() {
      const U = e.zoom;
      p.slideEl && e.activeIndex !== e.slides.indexOf(p.slideEl) && (p.imageEl && (p.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), p.imageWrapEl && (p.imageWrapEl.style.transform = "translate3d(0,0,0)"), p.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), U.scale = 1, o = 1, p.slideEl = void 0, p.imageEl = void 0, p.imageWrapEl = void 0, p.originX = 0, p.originY = 0);
    }
    function W(U) {
      if (o <= 1 || !p.imageWrapEl || !L(U) || !f(U)) return;
      const Q = r.getComputedStyle(p.imageWrapEl).transform, ee = new r.DOMMatrix(Q);
      if (!c) {
        c = true, d.x = U.clientX, d.y = U.clientY, g.startX = ee.e, g.startY = ee.f, g.width = p.imageEl.offsetWidth || p.imageEl.clientWidth, g.height = p.imageEl.offsetHeight || p.imageEl.clientHeight, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight;
        return;
      }
      const K = (U.clientX - d.x) * v, se = (U.clientY - d.y) * v, Se = g.width * o, Ge = g.height * o, Ce = p.slideWidth, Ze = p.slideHeight, ge = Math.min(Ce / 2 - Se / 2, 0), be = -ge, Oe = Math.min(Ze / 2 - Ge / 2, 0), Et = -Oe, st = Math.max(Math.min(g.startX + K, be), ge), dt = Math.max(Math.min(g.startY + se, Et), Oe);
      p.imageWrapEl.style.transitionDuration = "0ms", p.imageWrapEl.style.transform = `translate3d(${st}px, ${dt}px, 0)`, d.x = U.clientX, d.y = U.clientY, g.startX = st, g.startY = dt, g.currentX = st, g.currentY = dt;
    }
    function Y(U) {
      const Q = e.zoom, ee = e.params.zoom;
      if (!p.slideEl) {
        U && U.target && (p.slideEl = U.target.closest(`.${e.params.slideClass}, swiper-slide`)), p.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = Pe(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex]);
        let ht = p.slideEl.querySelector(`.${ee.containerClass}`);
        ht && (ht = ht.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = ht, ht ? p.imageWrapEl = Qt(p.imageEl, `.${ee.containerClass}`)[0] : p.imageWrapEl = void 0;
      }
      if (!p.imageEl || !p.imageWrapEl) return;
      p.maxRatio = S(), e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), p.slideEl.classList.add(`${ee.zoomedSlideClass}`);
      let K, se, Se, Ge, Ce, Ze, ge, be, Oe, Et, st, dt, Lt, De, ft, je, rt, Te;
      typeof g.touchesStart.x == "undefined" && U ? (K = U.pageX, se = U.pageY) : (K = g.touchesStart.x, se = g.touchesStart.y);
      const St = o, we = typeof U == "number" ? U : null;
      o === 1 && we && (K = void 0, se = void 0, g.touchesStart.x = void 0, g.touchesStart.y = void 0);
      const $e = S();
      Q.scale = we || $e, o = we || $e, U && !(o === 1 && we) ? (rt = p.slideEl.offsetWidth, Te = p.slideEl.offsetHeight, Se = Rn(p.slideEl).left + r.scrollX, Ge = Rn(p.slideEl).top + r.scrollY, Ce = Se + rt / 2 - K, Ze = Ge + Te / 2 - se, Oe = p.imageEl.offsetWidth || p.imageEl.clientWidth, Et = p.imageEl.offsetHeight || p.imageEl.clientHeight, st = Oe * Q.scale, dt = Et * Q.scale, Lt = Math.min(rt / 2 - st / 2, 0), De = Math.min(Te / 2 - dt / 2, 0), ft = -Lt, je = -De, St > 0 && we && typeof g.currentX == "number" && typeof g.currentY == "number" ? (ge = g.currentX * Q.scale / St, be = g.currentY * Q.scale / St) : (ge = Ce * Q.scale, be = Ze * Q.scale), ge < Lt && (ge = Lt), ge > ft && (ge = ft), be < De && (be = De), be > je && (be = je)) : (ge = 0, be = 0), we && Q.scale === 1 && (p.originX = 0, p.originY = 0), g.currentX = ge, g.currentY = be, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = `translate3d(${ge}px, ${be}px,0)`, p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = `translate3d(0,0,0) scale(${Q.scale})`;
    }
    function J() {
      const U = e.zoom, Q = e.params.zoom;
      if (!p.slideEl) {
        e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = Pe(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex];
        let ee = p.slideEl.querySelector(`.${Q.containerClass}`);
        ee && (ee = ee.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = ee, ee ? p.imageWrapEl = Qt(p.imageEl, `.${Q.containerClass}`)[0] : p.imageWrapEl = void 0;
      }
      !p.imageEl || !p.imageWrapEl || (p.maxRatio = S(), e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), U.scale = 1, o = 1, g.currentX = void 0, g.currentY = void 0, g.touchesStart.x = void 0, g.touchesStart.y = void 0, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = "translate3d(0,0,0)", p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = "translate3d(0,0,0) scale(1)", p.slideEl.classList.remove(`${Q.zoomedSlideClass}`), p.slideEl = void 0, p.originX = 0, p.originY = 0, e.params.zoom.panOnMouseMove && (d = { x: 0, y: 0 }, c && (c = false, g.startX = 0, g.startY = 0)));
    }
    function oe(U) {
      const Q = e.zoom;
      Q.scale && Q.scale !== 1 ? J() : Y(U);
    }
    function he() {
      const U = e.params.passiveListeners ? { passive: true, capture: false } : false, Q = e.params.passiveListeners ? { passive: false, capture: true } : true;
      return { passiveListener: U, activeListenerWithCapture: Q };
    }
    function _e() {
      const U = e.zoom;
      if (U.enabled) return;
      U.enabled = true;
      const { passiveListener: Q, activeListenerWithCapture: ee } = he();
      e.wrapperEl.addEventListener("pointerdown", P, Q), e.wrapperEl.addEventListener("pointermove", D, ee), ["pointerup", "pointercancel", "pointerout"].forEach((K) => {
        e.wrapperEl.addEventListener(K, R, Q);
      }), e.wrapperEl.addEventListener("pointermove", X, ee);
    }
    function Ee() {
      const U = e.zoom;
      if (!U.enabled) return;
      U.enabled = false;
      const { passiveListener: Q, activeListenerWithCapture: ee } = he();
      e.wrapperEl.removeEventListener("pointerdown", P, Q), e.wrapperEl.removeEventListener("pointermove", D, ee), ["pointerup", "pointercancel", "pointerout"].forEach((K) => {
        e.wrapperEl.removeEventListener(K, R, Q);
      }), e.wrapperEl.removeEventListener("pointermove", X, ee);
    }
    i("init", () => {
      e.params.zoom.enabled && _e();
    }), i("destroy", () => {
      Ee();
    }), i("touchStart", (U, Q) => {
      e.zoom.enabled && V(Q);
    }), i("touchEnd", (U, Q) => {
      e.zoom.enabled && Z();
    }), i("doubleTap", (U, Q) => {
      !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && oe(Q);
    }), i("transitionEnd", () => {
      e.zoom.enabled && e.params.zoom.enabled && F();
    }), i("slideChange", () => {
      e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && F();
    }), Object.assign(e.zoom, { enable: _e, disable: Ee, in: Y, out: J, toggle: oe });
  }
  function Og({ swiper: e, extendParams: t, on: i }) {
    t({ controller: { control: void 0, inverse: false, by: "slide" } }), e.controller = { control: void 0 };
    function n(d, v) {
      const E = /* @__PURE__ */ (function() {
        let g, C, _;
        return (h, S) => {
          for (C = -1, g = h.length; g - C > 1; ) _ = g + C >> 1, h[_] <= S ? C = _ : g = _;
          return g;
        };
      })();
      this.x = d, this.y = v, this.lastIndex = d.length - 1;
      let y, b;
      return this.interpolate = function(g) {
        return g ? (b = E(this.x, g), y = b - 1, (g - this.x[y]) * (this.y[b] - this.y[y]) / (this.x[b] - this.x[y]) + this.y[y]) : 0;
      }, this;
    }
    function r(d) {
      e.controller.spline = e.params.loop ? new n(e.slidesGrid, d.slidesGrid) : new n(e.snapGrid, d.snapGrid);
    }
    function o(d, v) {
      const E = e.controller.control;
      let y, b;
      const p = e.constructor;
      function g(C) {
        if (C.destroyed) return;
        const _ = e.rtlTranslate ? -e.translate : e.translate;
        e.params.controller.by === "slide" && (r(C), b = -e.controller.spline.interpolate(-_)), (!b || e.params.controller.by === "container") && (y = (C.maxTranslate() - C.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(y) || !Number.isFinite(y)) && (y = 1), b = (_ - e.minTranslate()) * y + C.minTranslate()), e.params.controller.inverse && (b = C.maxTranslate() - b), C.updateProgress(b), C.setTranslate(b, e), C.updateActiveIndex(), C.updateSlidesClasses();
      }
      if (Array.isArray(E)) for (let C = 0; C < E.length; C += 1) E[C] !== v && E[C] instanceof p && g(E[C]);
      else E instanceof p && v !== E && g(E);
    }
    function l(d, v) {
      const E = e.constructor, y = e.controller.control;
      let b;
      function p(g) {
        g.destroyed || (g.setTransition(d, e), d !== 0 && (g.transitionStart(), g.params.autoHeight && Pi(() => {
          g.updateAutoHeight();
        }), Zi(g.wrapperEl, () => {
          y && g.transitionEnd();
        })));
      }
      if (Array.isArray(y)) for (b = 0; b < y.length; b += 1) y[b] !== v && y[b] instanceof E && p(y[b]);
      else y instanceof E && v !== y && p(y);
    }
    function c() {
      e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
    }
    i("beforeInit", () => {
      if (typeof window != "undefined" && (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
        (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach((v) => {
          if (e.controller.control || (e.controller.control = []), v && v.swiper) e.controller.control.push(v.swiper);
          else if (v) {
            const E = `${e.params.eventsPrefix}init`, y = (b) => {
              e.controller.control.push(b.detail[0]), e.update(), v.removeEventListener(E, y);
            };
            v.addEventListener(E, y);
          }
        });
        return;
      }
      e.controller.control = e.params.controller.control;
    }), i("update", () => {
      c();
    }), i("resize", () => {
      c();
    }), i("observerUpdate", () => {
      c();
    }), i("setTranslate", (d, v, E) => {
      !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(v, E);
    }), i("setTransition", (d, v, E) => {
      !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(v, E);
    }), Object.assign(e.controller, { setTranslate: o, setTransition: l });
  }
  function Mg({ swiper: e, extendParams: t, on: i }) {
    t({ a11y: { enabled: true, notificationClass: "swiper-notification", prevSlideMessage: "Previous slide", nextSlideMessage: "Next slide", firstSlideMessage: "This is the first slide", lastSlideMessage: "This is the last slide", paginationBulletMessage: "Go to slide {{index}}", slideLabelMessage: "{{index}} / {{slidesLength}}", containerMessage: null, containerRoleDescriptionMessage: null, containerRole: null, itemRoleDescriptionMessage: null, slideRole: "group", id: null, scrollOnFocus: true, wrapperLiveRegion: true } }), e.a11y = { clicked: false };
    let n = null, r, o, l = (/* @__PURE__ */ new Date()).getTime();
    function c(F) {
      const W = n;
      W.length !== 0 && bt(W, F);
    }
    function d(F = 16) {
      const W = () => Math.round(16 * Math.random()).toString(16);
      return "x".repeat(F).replace(/x/g, W);
    }
    function v(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("tabIndex", "0");
      });
    }
    function E(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("tabIndex", "-1");
      });
    }
    function y(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("role", W);
      });
    }
    function b(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-roledescription", W);
      });
    }
    function p(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-controls", W);
      });
    }
    function g(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-label", W);
      });
    }
    function C(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("id", W);
      });
    }
    function _(F, W) {
      F = ue(F), F.forEach((Y) => {
        Y.setAttribute("aria-live", W);
      });
    }
    function h(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("aria-disabled", true);
      });
    }
    function S(F) {
      F = ue(F), F.forEach((W) => {
        W.setAttribute("aria-disabled", false);
      });
    }
    function w(F) {
      if (F.keyCode !== 13 && F.keyCode !== 32) return;
      const W = e.params.a11y, Y = F.target;
      if (!(e.pagination && e.pagination.el && (Y === e.pagination.el || e.pagination.el.contains(F.target)) && !F.target.matches(Ct(e.params.pagination.bulletClass)))) {
        if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
          const J = ue(e.navigation.prevEl);
          ue(e.navigation.nextEl).includes(Y) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? c(W.lastSlideMessage) : c(W.nextSlideMessage)), J.includes(Y) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? c(W.firstSlideMessage) : c(W.prevSlideMessage));
        }
        e.pagination && Y.matches(Ct(e.params.pagination.bulletClass)) && Y.click();
      }
    }
    function A() {
      if (e.params.loop || e.params.rewind || !e.navigation) return;
      const { nextEl: F, prevEl: W } = e.navigation;
      W && (e.isBeginning ? (h(W), E(W)) : (S(W), v(W))), F && (e.isEnd ? (h(F), E(F)) : (S(F), v(F)));
    }
    function L() {
      return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
    }
    function f() {
      return L() && e.params.pagination.clickable;
    }
    function P() {
      const F = e.params.a11y;
      L() && e.pagination.bullets.forEach((W) => {
        e.params.pagination.clickable && (v(W), e.params.pagination.renderBullet || (y(W, "button"), g(W, F.paginationBulletMessage.replace(/\{\{index\}\}/, Qi(W) + 1)))), W.matches(Ct(e.params.pagination.bulletActiveClass)) ? W.setAttribute("aria-current", "true") : W.removeAttribute("aria-current");
      });
    }
    const D = (F, W, Y) => {
      v(F), F.tagName !== "BUTTON" && (y(F, "button"), F.addEventListener("keydown", w)), g(F, Y), p(F, W);
    }, R = (F) => {
      o && o !== F.target && !o.contains(F.target) && (r = true), e.a11y.clicked = true;
    }, N = () => {
      r = false, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          e.destroyed || (e.a11y.clicked = false);
        });
      });
    }, $ = (F) => {
      l = (/* @__PURE__ */ new Date()).getTime();
    }, B = (F) => {
      if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - l < 100) return;
      const W = F.target.closest(`.${e.params.slideClass}, swiper-slide`);
      if (!W || !e.slides.includes(W)) return;
      o = W;
      const Y = e.virtual && e.params.virtual.enabled, J = (Y ? parseInt(W.getAttribute("data-swiper-slide-index"), 10) : e.slides.indexOf(W)) === e.activeIndex, oe = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(W);
      J || oe || F.sourceCapabilities && F.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
        r || (e.params.loop ? e.slideToLoop(e.getSlideIndexWhenGrid(parseInt(W.getAttribute("data-swiper-slide-index"))), 0) : Y ? e.slideTo(e.getSlideIndexWhenGrid(parseInt(W.getAttribute("data-swiper-slide-index"), 10)), 0) : e.slideTo(e.getSlideIndexWhenGrid(e.slides.indexOf(W)), 0), r = false);
      }));
    }, V = () => {
      const F = e.params.a11y;
      F.itemRoleDescriptionMessage && b(e.slides, F.itemRoleDescriptionMessage), F.slideRole && y(e.slides, F.slideRole);
      const W = e.slides.length;
      F.slideLabelMessage && e.slides.forEach((Y, J) => {
        const oe = e.params.loop ? parseInt(Y.getAttribute("data-swiper-slide-index"), 10) : J, he = F.slideLabelMessage.replace(/\{\{index\}\}/, oe + 1).replace(/\{\{slidesLength\}\}/, W);
        g(Y, he);
      });
    }, X = () => {
      const F = e.params.a11y;
      e.el.append(n);
      const W = e.el;
      F.containerRoleDescriptionMessage && b(W, F.containerRoleDescriptionMessage), F.containerMessage && g(W, F.containerMessage), F.containerRole && y(W, F.containerRole);
      const Y = e.wrapperEl, J = F.id || Y.getAttribute("id") || `swiper-wrapper-${d(16)}`;
      if (C(Y, J), F.wrapperLiveRegion) {
        const Ee = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
        _(Y, Ee);
      }
      V();
      let { nextEl: oe, prevEl: he } = e.navigation ? e.navigation : {};
      oe = ue(oe), he = ue(he), oe && oe.forEach((Ee) => D(Ee, J, F.nextSlideMessage)), he && he.forEach((Ee) => D(Ee, J, F.prevSlideMessage)), f() && ue(e.pagination.el).forEach((U) => {
        U.addEventListener("keydown", w);
      }), Le().addEventListener("visibilitychange", $), e.el.addEventListener("focus", B, true), e.el.addEventListener("pointerdown", R, true), e.el.addEventListener("pointerup", N, true);
    };
    function Z() {
      n && n.remove();
      let { nextEl: F, prevEl: W } = e.navigation ? e.navigation : {};
      F = ue(F), W = ue(W), F && F.forEach((J) => J.removeEventListener("keydown", w)), W && W.forEach((J) => J.removeEventListener("keydown", w)), f() && ue(e.pagination.el).forEach((oe) => {
        oe.removeEventListener("keydown", w);
      }), Le().removeEventListener("visibilitychange", $), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", B, true), e.el.removeEventListener("pointerdown", R, true), e.el.removeEventListener("pointerup", N, true));
    }
    i("beforeInit", () => {
      n = Xe("span", e.params.a11y.notificationClass), n.setAttribute("aria-live", "assertive"), n.setAttribute("aria-atomic", "true");
    }), i("afterInit", () => {
      e.params.a11y.enabled && X();
    }), i("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
      e.params.a11y.enabled && V();
    }), i("fromEdge toEdge afterInit lock unlock", () => {
      e.params.a11y.enabled && A();
    }), i("paginationUpdate", () => {
      e.params.a11y.enabled && P();
    }), i("destroy", () => {
      e.params.a11y.enabled && Z();
    });
  }
  function Lg({ swiper: e, extendParams: t, on: i }) {
    t({ history: { enabled: false, root: "", replaceState: false, key: "slides", keepQuery: false } });
    let n = false, r = {};
    const o = (b) => b.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), l = (b) => {
      const p = ye();
      let g;
      b ? g = new URL(b) : g = p.location;
      const C = g.pathname.slice(1).split("/").filter((w) => w !== ""), _ = C.length, h = C[_ - 2], S = C[_ - 1];
      return { key: h, value: S };
    }, c = (b, p) => {
      const g = ye();
      if (!n || !e.params.history.enabled) return;
      let C;
      e.params.url ? C = new URL(e.params.url) : C = g.location;
      const _ = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${p}"]`) : e.slides[p];
      let h = o(_.getAttribute("data-history"));
      if (e.params.history.root.length > 0) {
        let w = e.params.history.root;
        w[w.length - 1] === "/" && (w = w.slice(0, w.length - 1)), h = `${w}/${b ? `${b}/` : ""}${h}`;
      } else C.pathname.includes(b) || (h = `${b ? `${b}/` : ""}${h}`);
      e.params.history.keepQuery && (h += C.search);
      const S = g.history.state;
      S && S.value === h || (e.params.history.replaceState ? g.history.replaceState({ value: h }, null, h) : g.history.pushState({ value: h }, null, h));
    }, d = (b, p, g) => {
      if (p) for (let C = 0, _ = e.slides.length; C < _; C += 1) {
        const h = e.slides[C];
        if (o(h.getAttribute("data-history")) === p) {
          const w = e.getSlideIndex(h);
          e.slideTo(w, b, g);
        }
      }
      else e.slideTo(0, b, g);
    }, v = () => {
      r = l(e.params.url), d(e.params.speed, r.value, false);
    }, E = () => {
      const b = ye();
      if (e.params.history) {
        if (!b.history || !b.history.pushState) {
          e.params.history.enabled = false, e.params.hashNavigation.enabled = true;
          return;
        }
        if (n = true, r = l(e.params.url), !r.key && !r.value) {
          e.params.history.replaceState || b.addEventListener("popstate", v);
          return;
        }
        d(0, r.value, e.params.runCallbacksOnInit), e.params.history.replaceState || b.addEventListener("popstate", v);
      }
    }, y = () => {
      const b = ye();
      e.params.history.replaceState || b.removeEventListener("popstate", v);
    };
    i("init", () => {
      e.params.history.enabled && E();
    }), i("destroy", () => {
      e.params.history.enabled && y();
    }), i("transitionEnd _freeModeNoMomentumRelease", () => {
      n && c(e.params.history.key, e.activeIndex);
    }), i("slideChange", () => {
      n && e.params.cssMode && c(e.params.history.key, e.activeIndex);
    });
  }
  function Pg({ swiper: e, extendParams: t, emit: i, on: n }) {
    let r = false;
    const o = Le(), l = ye();
    t({ hashNavigation: { enabled: false, replaceState: false, watchState: false, getSlideIndex(y, b) {
      if (e.virtual && e.params.virtual.enabled) {
        const p = e.slides.find((C) => C.getAttribute("data-hash") === b);
        return p ? parseInt(p.getAttribute("data-swiper-slide-index"), 10) : 0;
      }
      return e.getSlideIndex(Pe(e.slidesEl, `.${e.params.slideClass}[data-hash="${b}"], swiper-slide[data-hash="${b}"]`)[0]);
    } } });
    const c = () => {
      i("hashChange");
      const y = o.location.hash.replace("#", ""), b = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], p = b ? b.getAttribute("data-hash") : "";
      if (y !== p) {
        const g = e.params.hashNavigation.getSlideIndex(e, y);
        if (typeof g == "undefined" || Number.isNaN(g)) return;
        e.slideTo(g);
      }
    }, d = () => {
      if (!r || !e.params.hashNavigation.enabled) return;
      const y = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], b = y ? y.getAttribute("data-hash") || y.getAttribute("data-history") : "";
      e.params.hashNavigation.replaceState && l.history && l.history.replaceState ? (l.history.replaceState(null, null, `#${b}` || ""), i("hashSet")) : (o.location.hash = b || "", i("hashSet"));
    }, v = () => {
      if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
      r = true;
      const y = o.location.hash.replace("#", "");
      if (y) {
        const p = e.params.hashNavigation.getSlideIndex(e, y);
        e.slideTo(p || 0, 0, e.params.runCallbacksOnInit, true);
      }
      e.params.hashNavigation.watchState && l.addEventListener("hashchange", c);
    }, E = () => {
      e.params.hashNavigation.watchState && l.removeEventListener("hashchange", c);
    };
    n("init", () => {
      e.params.hashNavigation.enabled && v();
    }), n("destroy", () => {
      e.params.hashNavigation.enabled && E();
    }), n("transitionEnd _freeModeNoMomentumRelease", () => {
      r && d();
    }), n("slideChange", () => {
      r && e.params.cssMode && d();
    });
  }
  function Dg({ swiper: e, extendParams: t, on: i, emit: n, params: r }) {
    e.autoplay = { running: false, paused: false, timeLeft: 0 }, t({ autoplay: { enabled: false, delay: 3e3, waitForTransition: true, disableOnInteraction: false, stopOnLastSlide: false, reverseDirection: false, pauseOnMouseEnter: false } });
    let o, l, c = r && r.autoplay ? r.autoplay.delay : 3e3, d = r && r.autoplay ? r.autoplay.delay : 3e3, v, E = (/* @__PURE__ */ new Date()).getTime(), y, b, p, g, C, _;
    function h(W) {
      !e || e.destroyed || !e.wrapperEl || W.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", h), !(_ || W.detail && W.detail.bySwiperTouchMove) && R());
    }
    const S = () => {
      if (e.destroyed || !e.autoplay.running) return;
      e.autoplay.paused ? y = true : y && (d = v, y = false);
      const W = e.autoplay.paused ? v : E + d - (/* @__PURE__ */ new Date()).getTime();
      e.autoplay.timeLeft = W, n("autoplayTimeLeft", W, W / c), l = requestAnimationFrame(() => {
        S();
      });
    }, w = () => {
      let W;
      return e.virtual && e.params.virtual.enabled ? W = e.slides.find((J) => J.classList.contains("swiper-slide-active")) : W = e.slides[e.activeIndex], W ? parseInt(W.getAttribute("data-swiper-autoplay"), 10) : void 0;
    }, A = () => {
      let W = e.params.autoplay.delay;
      const Y = w();
      return !Number.isNaN(Y) && Y > 0 && (W = Y), W;
    }, L = (W) => {
      if (e.destroyed || !e.autoplay.running) return;
      cancelAnimationFrame(l), S();
      let Y = W;
      typeof Y == "undefined" && (Y = A(), c = Y, d = Y), v = Y;
      const J = e.params.speed, oe = () => {
        !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(J, true, true), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, J, true, true), n("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(J, true, true), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, J, true, true), n("autoplay")), e.params.cssMode && (E = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
          L();
        })));
      };
      return Y > 0 ? (clearTimeout(o), o = setTimeout(() => {
        oe();
      }, Y)) : requestAnimationFrame(() => {
        oe();
      }), Y;
    }, f = () => {
      E = (/* @__PURE__ */ new Date()).getTime(), e.autoplay.running = true, L(), n("autoplayStart");
    }, P = () => {
      e.autoplay.running = false, clearTimeout(o), cancelAnimationFrame(l), n("autoplayStop");
    }, D = (W, Y) => {
      if (e.destroyed || !e.autoplay.running) return;
      clearTimeout(o), W || (C = true);
      const J = () => {
        n("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", h) : R();
      };
      if (e.autoplay.paused = true, Y) {
        J();
        return;
      }
      v = (v || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - E), !(e.isEnd && v < 0 && !e.params.loop) && (v < 0 && (v = 0), J());
    }, R = () => {
      e.isEnd && v < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (E = (/* @__PURE__ */ new Date()).getTime(), C ? (C = false, L(v)) : L(), e.autoplay.paused = false, n("autoplayResume"));
    }, N = () => {
      if (e.destroyed || !e.autoplay.running) return;
      const W = Le();
      W.visibilityState === "hidden" && (C = true, D(true)), W.visibilityState === "visible" && R();
    }, $ = (W) => {
      W.pointerType === "mouse" && (C = true, _ = true, !(e.animating || e.autoplay.paused) && D(true));
    }, B = (W) => {
      W.pointerType === "mouse" && (_ = false, e.autoplay.paused && R());
    }, V = () => {
      e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", $), e.el.addEventListener("pointerleave", B));
    }, X = () => {
      e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", $), e.el.removeEventListener("pointerleave", B));
    }, Z = () => {
      Le().addEventListener("visibilitychange", N);
    }, F = () => {
      Le().removeEventListener("visibilitychange", N);
    };
    i("init", () => {
      e.params.autoplay.enabled && (V(), Z(), f());
    }), i("destroy", () => {
      X(), F(), e.autoplay.running && P();
    }), i("_freeModeStaticRelease", () => {
      (p || C) && R();
    }), i("_freeModeNoMomentumRelease", () => {
      e.params.autoplay.disableOnInteraction ? P() : D(true, true);
    }), i("beforeTransitionStart", (W, Y, J) => {
      e.destroyed || !e.autoplay.running || (J || !e.params.autoplay.disableOnInteraction ? D(true, true) : P());
    }), i("sliderFirstMove", () => {
      if (!(e.destroyed || !e.autoplay.running)) {
        if (e.params.autoplay.disableOnInteraction) {
          P();
          return;
        }
        b = true, p = false, C = false, g = setTimeout(() => {
          C = true, p = true, D(true);
        }, 200);
      }
    }), i("touchEnd", () => {
      if (!(e.destroyed || !e.autoplay.running || !b)) {
        if (clearTimeout(g), clearTimeout(o), e.params.autoplay.disableOnInteraction) {
          p = false, b = false;
          return;
        }
        p && e.params.cssMode && R(), p = false, b = false;
      }
    }), i("slideChange", () => {
      e.destroyed || !e.autoplay.running || e.autoplay.paused && (v = A(), c = A());
    }), Object.assign(e.autoplay, { start: f, stop: P, pause: D, resume: R });
  }
  function zg({ swiper: e, extendParams: t, on: i }) {
    t({ thumbs: { swiper: null, multipleActiveThumbs: true, autoScrollOffset: 0, slideThumbActiveClass: "swiper-slide-thumb-active", thumbsContainerClass: "swiper-thumbs" } });
    let n = false, r = false;
    e.thumbs = { swiper: null };
    function o() {
      const E = e.thumbs.swiper;
      return !E || E.destroyed ? false : E.params.virtual && E.params.virtual.enabled;
    }
    function l() {
      const E = e.thumbs.swiper;
      if (!E || E.destroyed) return;
      const y = E.clickedIndex, b = E.clickedSlide;
      if (b && b.classList.contains(e.params.thumbs.slideThumbActiveClass) || typeof y == "undefined" || y === null) return;
      let p;
      E.params.loop ? p = parseInt(E.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : p = y, e.params.loop ? e.slideToLoop(p) : e.slideTo(p);
    }
    function c() {
      const { thumbs: E } = e.params;
      if (n) return false;
      n = true;
      const y = e.constructor;
      if (E.swiper instanceof y) {
        if (E.swiper.destroyed) return n = false, false;
        e.thumbs.swiper = E.swiper, Object.assign(e.thumbs.swiper.originalParams, { watchSlidesProgress: true, slideToClickedSlide: false }), Object.assign(e.thumbs.swiper.params, { watchSlidesProgress: true, slideToClickedSlide: false }), e.thumbs.swiper.update();
      } else if (qi(E.swiper)) {
        const b = Object.assign({}, E.swiper);
        Object.assign(b, { watchSlidesProgress: true, slideToClickedSlide: false }), e.thumbs.swiper = new y(b), r = true;
      }
      return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", l), o() && e.thumbs.swiper.on("virtualUpdate", () => {
        d(false, { autoScroll: false });
      }), true;
    }
    function d(E, y) {
      var C;
      const b = e.thumbs.swiper;
      if (!b || b.destroyed) return;
      let p = 1;
      const g = e.params.thumbs.slideThumbActiveClass;
      if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (p = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (p = 1), p = Math.floor(p), b.slides.forEach((_) => _.classList.remove(g)), b.params.loop || o()) for (let _ = 0; _ < p; _ += 1) Pe(b.slidesEl, `[data-swiper-slide-index="${e.realIndex + _}"]`).forEach((h) => {
        h.classList.add(g);
      });
      else for (let _ = 0; _ < p; _ += 1) b.slides[e.realIndex + _] && b.slides[e.realIndex + _].classList.add(g);
      ((C = y == null ? void 0 : y.autoScroll) == null || C) && v(E ? 0 : void 0);
    }
    function v(E) {
      const y = e.thumbs.swiper;
      if (!y || y.destroyed) return;
      const b = y.params.slidesPerView === "auto" ? y.slidesPerViewDynamic() : y.params.slidesPerView, p = e.params.thumbs.autoScrollOffset, g = p && !y.params.loop;
      if (e.realIndex !== y.realIndex || g) {
        const C = y.activeIndex;
        let _, h;
        if (y.params.loop) {
          const S = y.slides.find((w) => w.getAttribute("data-swiper-slide-index") === `${e.realIndex}`);
          _ = y.slides.indexOf(S), h = e.activeIndex > e.previousIndex ? "next" : "prev";
        } else _ = e.realIndex, h = _ > e.previousIndex ? "next" : "prev";
        g && (_ += h === "next" ? p : -1 * p), y.visibleSlidesIndexes && y.visibleSlidesIndexes.indexOf(_) < 0 && (y.params.centeredSlides ? _ > C ? _ = _ - Math.floor(b / 2) + 1 : _ = _ + Math.floor(b / 2) - 1 : _ > C && y.params.slidesPerGroup, y.slideTo(_, E));
      }
    }
    i("beforeInit", () => {
      const { thumbs: E } = e.params;
      if (!(!E || !E.swiper)) if (typeof E.swiper == "string" || E.swiper instanceof HTMLElement) {
        const y = Le(), b = () => {
          const g = typeof E.swiper == "string" ? y.querySelector(E.swiper) : E.swiper;
          if (g && g.swiper) E.swiper = g.swiper, c(), d(true);
          else if (g) {
            const C = `${e.params.eventsPrefix}init`, _ = (h) => {
              E.swiper = h.detail[0], g.removeEventListener(C, _), c(), d(true), E.swiper.update(), e.update();
            };
            g.addEventListener(C, _);
          }
          return g;
        }, p = () => {
          if (e.destroyed) return;
          b() || requestAnimationFrame(p);
        };
        requestAnimationFrame(p);
      } else c(), d(true);
    }), i("slideChange update resize observerUpdate", () => {
      d();
    }), i("setTransition", (E, y) => {
      const b = e.thumbs.swiper;
      !b || b.destroyed || b.setTransition(y);
    }), i("beforeDestroy", () => {
      const E = e.thumbs.swiper;
      !E || E.destroyed || r && E.destroy();
    }), Object.assign(e.thumbs, { init: c, update: d });
  }
  function $g({ swiper: e, extendParams: t, emit: i, once: n }) {
    t({ freeMode: { enabled: false, momentum: true, momentumRatio: 1, momentumBounce: true, momentumBounceRatio: 1, momentumVelocityRatio: 1, sticky: false, minimumVelocity: 0.02 } });
    function r() {
      if (e.params.cssMode) return;
      const c = e.getTranslate();
      e.setTranslate(c), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({ currentPos: e.rtl ? e.translate : -e.translate });
    }
    function o() {
      if (e.params.cssMode) return;
      const { touchEventsData: c, touches: d } = e;
      c.velocities.length === 0 && c.velocities.push({ position: d[e.isHorizontal() ? "startX" : "startY"], time: c.touchStartTime }), c.velocities.push({ position: d[e.isHorizontal() ? "currentX" : "currentY"], time: Je() });
    }
    function l({ currentPos: c }) {
      if (e.params.cssMode) return;
      const { params: d, wrapperEl: v, rtlTranslate: E, snapGrid: y, touchEventsData: b } = e, g = Je() - b.touchStartTime;
      if (c < -e.minTranslate()) {
        e.slideTo(e.activeIndex);
        return;
      }
      if (c > -e.maxTranslate()) {
        e.slides.length < y.length ? e.slideTo(y.length - 1) : e.slideTo(e.slides.length - 1);
        return;
      }
      if (d.freeMode.momentum) {
        if (b.velocities.length > 1) {
          const f = b.velocities.pop(), P = b.velocities.pop(), D = f.position - P.position, R = f.time - P.time;
          e.velocity = D / R, e.velocity /= 2, Math.abs(e.velocity) < d.freeMode.minimumVelocity && (e.velocity = 0), (R > 150 || Je() - f.time > 300) && (e.velocity = 0);
        } else e.velocity = 0;
        e.velocity *= d.freeMode.momentumVelocityRatio, b.velocities.length = 0;
        let C = 1e3 * d.freeMode.momentumRatio;
        const _ = e.velocity * C;
        let h = e.translate + _;
        E && (h = -h);
        let S = false, w;
        const A = Math.abs(e.velocity) * 20 * d.freeMode.momentumBounceRatio;
        let L;
        if (h < e.maxTranslate()) d.freeMode.momentumBounce ? (h + e.maxTranslate() < -A && (h = e.maxTranslate() - A), w = e.maxTranslate(), S = true, b.allowMomentumBounce = true) : h = e.maxTranslate(), d.loop && d.centeredSlides && (L = true);
        else if (h > e.minTranslate()) d.freeMode.momentumBounce ? (h - e.minTranslate() > A && (h = e.minTranslate() + A), w = e.minTranslate(), S = true, b.allowMomentumBounce = true) : h = e.minTranslate(), d.loop && d.centeredSlides && (L = true);
        else if (d.freeMode.sticky) {
          let f;
          for (let P = 0; P < y.length; P += 1) if (y[P] > -h) {
            f = P;
            break;
          }
          Math.abs(y[f] - h) < Math.abs(y[f - 1] - h) || e.swipeDirection === "next" ? h = y[f] : h = y[f - 1], h = -h;
        }
        if (L && n("transitionEnd", () => {
          e.loopFix();
        }), e.velocity !== 0) {
          if (E ? C = Math.abs((-h - e.translate) / e.velocity) : C = Math.abs((h - e.translate) / e.velocity), d.freeMode.sticky) {
            const f = Math.abs((E ? -h : h) - e.translate), P = e.slidesSizesGrid[e.activeIndex];
            f < P ? C = d.speed : f < 2 * P ? C = d.speed * 1.5 : C = d.speed * 2.5;
          }
        } else if (d.freeMode.sticky) {
          e.slideToClosest();
          return;
        }
        d.freeMode.momentumBounce && S ? (e.updateProgress(w), e.setTransition(C), e.setTranslate(h), e.transitionStart(true, e.swipeDirection), e.animating = true, Zi(v, () => {
          !e || e.destroyed || !b.allowMomentumBounce || (i("momentumBounce"), e.setTransition(d.speed), setTimeout(() => {
            e.setTranslate(w), Zi(v, () => {
              !e || e.destroyed || e.transitionEnd();
            });
          }, 0));
        })) : e.velocity ? (i("_freeModeNoMomentumRelease"), e.updateProgress(h), e.setTransition(C), e.setTranslate(h), e.transitionStart(true, e.swipeDirection), e.animating || (e.animating = true, Zi(v, () => {
          !e || e.destroyed || e.transitionEnd();
        }))) : e.updateProgress(h), e.updateActiveIndex(), e.updateSlidesClasses();
      } else if (d.freeMode.sticky) {
        e.slideToClosest();
        return;
      } else d.freeMode && i("_freeModeNoMomentumRelease");
      (!d.freeMode.momentum || g >= d.longSwipesMs) && (i("_freeModeStaticRelease"), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
    }
    Object.assign(e, { freeMode: { onTouchStart: r, onTouchMove: o, onTouchEnd: l } });
  }
  function Ng({ swiper: e, extendParams: t, on: i }) {
    t({ grid: { rows: 1, fill: "column" } });
    let n, r, o, l;
    const c = () => {
      let g = e.params.spaceBetween;
      return typeof g == "string" && g.indexOf("%") >= 0 ? g = parseFloat(g.replace("%", "")) / 100 * e.size : typeof g == "string" && (g = parseFloat(g)), g;
    }, d = (g) => {
      const { slidesPerView: C } = e.params, { rows: _, fill: h } = e.params.grid, S = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : g.length;
      o = Math.floor(S / _), Math.floor(S / _) === S / _ ? n = S : n = Math.ceil(S / _) * _, C !== "auto" && h === "row" && (n = Math.max(n, Math.floor(C) * _)), r = n / _;
    }, v = () => {
      e.slides && e.slides.forEach((g) => {
        g.swiperSlideGridSet && (g.style.height = "", g.style[e.getDirectionLabel("margin-top")] = "");
      });
    }, E = (g, C, _) => {
      const { slidesPerGroup: h } = e.params, S = c(), { rows: w, fill: A } = e.params.grid, L = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : _.length;
      let f, P, D;
      if (A === "row" && h > 1) {
        const R = Math.floor(g / (h * w)), N = g - w * h * R, $ = R === 0 ? h : Math.min(Math.ceil((L - R * w * h) / w), h);
        D = Math.floor(N / $), P = N - D * $ + R * h, f = P + D * n / w, C.style.order = f;
      } else A === "column" ? (P = Math.floor(g / w), D = g - P * w, (P > o || P === o && D === w - 1) && (D += 1, D >= w && (D = 0, P += 1))) : (D = Math.floor(g / r), P = g - D * r);
      C.row = D, C.column = P, C.style.height = `calc((100% - ${(w - 1) * S}px) / ${w})`, C.style[e.getDirectionLabel("margin-top")] = D !== 0 ? S && `${S}px` : "", C.swiperSlideGridSet = true;
    }, y = (g, C) => {
      const { centeredSlides: _, roundLengths: h } = e.params, S = c(), { rows: w } = e.params.grid;
      if (e.virtualSize = (g + S) * n, e.virtualSize = Math.ceil(e.virtualSize / w) - S, e.params.cssMode || (e.wrapperEl.style[e.getDirectionLabel("width")] = `${e.virtualSize + S}px`), _) {
        const A = [];
        for (let L = 0; L < C.length; L += 1) {
          let f = C[L];
          h && (f = Math.floor(f)), C[L] < e.virtualSize + C[0] && A.push(f);
        }
        C.splice(0, C.length), C.push(...A);
      }
    }, b = () => {
      l = e.params.grid && e.params.grid.rows > 1;
    }, p = () => {
      const { params: g, el: C } = e, _ = g.grid && g.grid.rows > 1;
      l && !_ ? (C.classList.remove(`${g.containerModifierClass}grid`, `${g.containerModifierClass}grid-column`), o = 1, e.emitContainerClasses()) : !l && _ && (C.classList.add(`${g.containerModifierClass}grid`), g.grid.fill === "column" && C.classList.add(`${g.containerModifierClass}grid-column`), e.emitContainerClasses()), l = _;
    };
    i("init", b), i("update", p), e.grid = { initSlides: d, unsetSlides: v, updateSlide: E, updateWrapperSize: y };
  }
  function kg(e) {
    const t = this, { params: i, slidesEl: n } = t;
    i.loop && t.loopDestroy();
    const r = (o) => {
      if (typeof o == "string") {
        const l = document.createElement("div");
        bt(l, o), n.append(l.children[0]), bt(l, "");
      } else n.append(o);
    };
    if (typeof e == "object" && "length" in e) for (let o = 0; o < e.length; o += 1) e[o] && r(e[o]);
    else r(e);
    t.recalcSlides(), i.loop && t.loopCreate(), (!i.observer || t.isElement) && t.update();
  }
  function Rg(e) {
    const t = this, { params: i, activeIndex: n, slidesEl: r } = t;
    i.loop && t.loopDestroy();
    let o = n + 1;
    const l = (c) => {
      if (typeof c == "string") {
        const d = document.createElement("div");
        bt(d, c), r.prepend(d.children[0]), bt(d, "");
      } else r.prepend(c);
    };
    if (typeof e == "object" && "length" in e) {
      for (let c = 0; c < e.length; c += 1) e[c] && l(e[c]);
      o = n + e.length;
    } else l(e);
    t.recalcSlides(), i.loop && t.loopCreate(), (!i.observer || t.isElement) && t.update(), t.slideTo(o, 0, false);
  }
  function Hg(e, t) {
    const i = this, { params: n, activeIndex: r, slidesEl: o } = i;
    let l = r;
    n.loop && (l -= i.loopedSlides, i.loopDestroy(), i.recalcSlides());
    const c = i.slides.length;
    if (e <= 0) {
      i.prependSlide(t);
      return;
    }
    if (e >= c) {
      i.appendSlide(t);
      return;
    }
    let d = l > e ? l + 1 : l;
    const v = [];
    for (let E = c - 1; E >= e; E -= 1) {
      const y = i.slides[E];
      y.remove(), v.unshift(y);
    }
    if (typeof t == "object" && "length" in t) {
      for (let E = 0; E < t.length; E += 1) t[E] && o.append(t[E]);
      d = l > e ? l + t.length : l;
    } else o.append(t);
    for (let E = 0; E < v.length; E += 1) o.append(v[E]);
    i.recalcSlides(), n.loop && i.loopCreate(), (!n.observer || i.isElement) && i.update(), n.loop ? i.slideTo(d + i.loopedSlides, 0, false) : i.slideTo(d, 0, false);
  }
  function Bg(e) {
    const t = this, { params: i, activeIndex: n } = t;
    let r = n;
    i.loop && (r -= t.loopedSlides, t.loopDestroy());
    let o = r, l;
    if (typeof e == "object" && "length" in e) {
      for (let c = 0; c < e.length; c += 1) l = e[c], t.slides[l] && t.slides[l].remove(), l < o && (o -= 1);
      o = Math.max(o, 0);
    } else l = e, t.slides[l] && t.slides[l].remove(), l < o && (o -= 1), o = Math.max(o, 0);
    t.recalcSlides(), i.loop && t.loopCreate(), (!i.observer || t.isElement) && t.update(), i.loop ? t.slideTo(o + t.loopedSlides, 0, false) : t.slideTo(o, 0, false);
  }
  function Vg() {
    const e = this, t = [];
    for (let i = 0; i < e.slides.length; i += 1) t.push(i);
    e.removeSlide(t);
  }
  function Wg({ swiper: e }) {
    Object.assign(e, { appendSlide: kg.bind(e), prependSlide: Rg.bind(e), addSlide: Hg.bind(e), removeSlide: Bg.bind(e), removeAllSlides: Vg.bind(e) });
  }
  function ki(e) {
    const { effect: t, swiper: i, on: n, setTranslate: r, setTransition: o, overwriteParams: l, perspective: c, recreateShadows: d, getEffectParams: v } = e;
    n("beforeInit", () => {
      if (i.params.effect !== t) return;
      i.classNames.push(`${i.params.containerModifierClass}${t}`), c && c() && i.classNames.push(`${i.params.containerModifierClass}3d`);
      const y = l ? l() : {};
      Object.assign(i.params, y), Object.assign(i.originalParams, y);
    }), n("setTranslate _virtualUpdated", () => {
      i.params.effect === t && r();
    }), n("setTransition", (y, b) => {
      i.params.effect === t && o(b);
    }), n("transitionEnd", () => {
      if (i.params.effect === t && d) {
        if (!v || !v().slideShadows) return;
        i.slides.forEach((y) => {
          y.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((b) => b.remove());
        }), d();
      }
    });
    let E;
    n("virtualUpdate", () => {
      i.params.effect === t && (i.slides.length || (E = true), requestAnimationFrame(() => {
        E && i.slides && i.slides.length && (r(), E = false);
      }));
    });
  }
  function rn(e, t) {
    const i = ai(t);
    return i !== t && (i.style.backfaceVisibility = "hidden", i.style["-webkit-backface-visibility"] = "hidden"), i;
  }
  function Qn({ swiper: e, duration: t, transformElements: i, allSlides: n }) {
    const { activeIndex: r } = e, o = (l) => l.parentElement ? l.parentElement : e.slides.find((d) => d.shadowRoot && d.shadowRoot === l.parentNode);
    if (e.params.virtualTranslate && t !== 0) {
      let l = false, c;
      n ? c = i : c = i.filter((d) => {
        const v = d.classList.contains("swiper-slide-transform") ? o(d) : d;
        return e.getSlideIndex(v) === r;
      }), c.forEach((d) => {
        Zi(d, () => {
          if (l || !e || e.destroyed) return;
          l = true, e.animating = false;
          const v = new window.CustomEvent("transitionend", { bubbles: true, cancelable: true });
          e.wrapperEl.dispatchEvent(v);
        });
      });
    }
  }
  function Fg({ swiper: e, extendParams: t, on: i }) {
    t({ fadeEffect: { crossFade: false } }), ki({ effect: "fade", swiper: e, on: i, setTranslate: () => {
      const { slides: o } = e, l = e.params.fadeEffect;
      for (let c = 0; c < o.length; c += 1) {
        const d = e.slides[c];
        let E = -d.swiperSlideOffset;
        e.params.virtualTranslate || (E -= e.translate);
        let y = 0;
        e.isHorizontal() || (y = E, E = 0);
        const b = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(d.progress), 0) : 1 + Math.min(Math.max(d.progress, -1), 0), p = rn(l, d);
        p.style.opacity = b, p.style.transform = `translate3d(${E}px, ${y}px, 0px)`;
      }
    }, setTransition: (o) => {
      const l = e.slides.map((c) => ai(c));
      l.forEach((c) => {
        c.style.transitionDuration = `${o}ms`;
      }), Qn({ swiper: e, duration: o, transformElements: l, allSlides: true });
    }, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, spaceBetween: 0, virtualTranslate: !e.params.cssMode }) });
  }
  function Gg({ swiper: e, extendParams: t, on: i }) {
    t({ cubeEffect: { slideShadows: true, shadow: true, shadowOffset: 20, shadowScale: 0.94 } });
    const n = (c, d, v) => {
      let E = v ? c.querySelector(".swiper-slide-shadow-left") : c.querySelector(".swiper-slide-shadow-top"), y = v ? c.querySelector(".swiper-slide-shadow-right") : c.querySelector(".swiper-slide-shadow-bottom");
      E || (E = Xe("div", `swiper-slide-shadow-cube swiper-slide-shadow-${v ? "left" : "top"}`.split(" ")), c.append(E)), y || (y = Xe("div", `swiper-slide-shadow-cube swiper-slide-shadow-${v ? "right" : "bottom"}`.split(" ")), c.append(y)), E && (E.style.opacity = Math.max(-d, 0)), y && (y.style.opacity = Math.max(d, 0));
    };
    ki({ effect: "cube", swiper: e, on: i, setTranslate: () => {
      const { el: c, wrapperEl: d, slides: v, width: E, height: y, rtlTranslate: b, size: p, browser: g } = e, C = Zn(e), _ = e.params.cubeEffect, h = e.isHorizontal(), S = e.virtual && e.params.virtual.enabled;
      let w = 0, A;
      _.shadow && (h ? (A = e.wrapperEl.querySelector(".swiper-cube-shadow"), A || (A = Xe("div", "swiper-cube-shadow"), e.wrapperEl.append(A)), A.style.height = `${E}px`) : (A = c.querySelector(".swiper-cube-shadow"), A || (A = Xe("div", "swiper-cube-shadow"), c.append(A))));
      for (let f = 0; f < v.length; f += 1) {
        const P = v[f];
        let D = f;
        S && (D = parseInt(P.getAttribute("data-swiper-slide-index"), 10));
        let R = D * 90, N = Math.floor(R / 360);
        b && (R = -R, N = Math.floor(-R / 360));
        const $ = Math.max(Math.min(P.progress, 1), -1);
        let B = 0, V = 0, X = 0;
        D % 4 === 0 ? (B = -N * 4 * p, X = 0) : (D - 1) % 4 === 0 ? (B = 0, X = -N * 4 * p) : (D - 2) % 4 === 0 ? (B = p + N * 4 * p, X = p) : (D - 3) % 4 === 0 && (B = -p, X = 3 * p + p * 4 * N), b && (B = -B), h || (V = B, B = 0);
        const Z = `rotateX(${C(h ? 0 : -R)}deg) rotateY(${C(h ? R : 0)}deg) translate3d(${B}px, ${V}px, ${X}px)`;
        $ <= 1 && $ > -1 && (w = D * 90 + $ * 90, b && (w = -D * 90 - $ * 90)), P.style.transform = Z, _.slideShadows && n(P, $, h);
      }
      if (d.style.transformOrigin = `50% 50% -${p / 2}px`, d.style["-webkit-transform-origin"] = `50% 50% -${p / 2}px`, _.shadow) if (h) A.style.transform = `translate3d(0px, ${E / 2 + _.shadowOffset}px, ${-E / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${_.shadowScale})`;
      else {
        const f = Math.abs(w) - Math.floor(Math.abs(w) / 90) * 90, P = 1.5 - (Math.sin(f * 2 * Math.PI / 360) / 2 + Math.cos(f * 2 * Math.PI / 360) / 2), D = _.shadowScale, R = _.shadowScale / P, N = _.shadowOffset;
        A.style.transform = `scale3d(${D}, 1, ${R}) translate3d(0px, ${y / 2 + N}px, ${-y / 2 / R}px) rotateX(-89.99deg)`;
      }
      const L = (g.isSafari || g.isWebView) && g.needPerspectiveFix ? -p / 2 : 0;
      d.style.transform = `translate3d(0px,0,${L}px) rotateX(${C(e.isHorizontal() ? 0 : w)}deg) rotateY(${C(e.isHorizontal() ? -w : 0)}deg)`, d.style.setProperty("--swiper-cube-translate-z", `${L}px`);
    }, setTransition: (c) => {
      const { el: d, slides: v } = e;
      if (v.forEach((E) => {
        E.style.transitionDuration = `${c}ms`, E.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((y) => {
          y.style.transitionDuration = `${c}ms`;
        });
      }), e.params.cubeEffect.shadow && !e.isHorizontal()) {
        const E = d.querySelector(".swiper-cube-shadow");
        E && (E.style.transitionDuration = `${c}ms`);
      }
    }, recreateShadows: () => {
      const c = e.isHorizontal();
      e.slides.forEach((d) => {
        const v = Math.max(Math.min(d.progress, 1), -1);
        n(d, v, c);
      });
    }, getEffectParams: () => e.params.cubeEffect, perspective: () => true, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, resistanceRatio: 0, spaceBetween: 0, centeredSlides: false, virtualTranslate: true }) });
  }
  function Di(e, t, i) {
    const n = `swiper-slide-shadow${i ? `-${i}` : ""}${e ? ` swiper-slide-shadow-${e}` : ""}`, r = ai(t);
    let o = r.querySelector(`.${n.split(" ").join(".")}`);
    return o || (o = Xe("div", n.split(" ")), r.append(o)), o;
  }
  function jg({ swiper: e, extendParams: t, on: i }) {
    t({ flipEffect: { slideShadows: true, limitRotation: true } });
    const n = (c, d) => {
      let v = e.isHorizontal() ? c.querySelector(".swiper-slide-shadow-left") : c.querySelector(".swiper-slide-shadow-top"), E = e.isHorizontal() ? c.querySelector(".swiper-slide-shadow-right") : c.querySelector(".swiper-slide-shadow-bottom");
      v || (v = Di("flip", c, e.isHorizontal() ? "left" : "top")), E || (E = Di("flip", c, e.isHorizontal() ? "right" : "bottom")), v && (v.style.opacity = Math.max(-d, 0)), E && (E.style.opacity = Math.max(d, 0));
    };
    ki({ effect: "flip", swiper: e, on: i, setTranslate: () => {
      const { slides: c, rtlTranslate: d } = e, v = e.params.flipEffect, E = Zn(e);
      for (let y = 0; y < c.length; y += 1) {
        const b = c[y];
        let p = b.progress;
        e.params.flipEffect.limitRotation && (p = Math.max(Math.min(b.progress, 1), -1));
        const g = b.swiperSlideOffset;
        let _ = -180 * p, h = 0, S = e.params.cssMode ? -g - e.translate : -g, w = 0;
        e.isHorizontal() ? d && (_ = -_) : (w = S, S = 0, h = -_, _ = 0), b.style.zIndex = -Math.abs(Math.round(p)) + c.length, v.slideShadows && n(b, p);
        const A = `translate3d(${S}px, ${w}px, 0px) rotateX(${E(h)}deg) rotateY(${E(_)}deg)`, L = rn(v, b);
        L.style.transform = A;
      }
    }, setTransition: (c) => {
      const d = e.slides.map((v) => ai(v));
      d.forEach((v) => {
        v.style.transitionDuration = `${c}ms`, v.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((E) => {
          E.style.transitionDuration = `${c}ms`;
        });
      }), Qn({ swiper: e, duration: c, transformElements: d });
    }, recreateShadows: () => {
      e.params.flipEffect, e.slides.forEach((c) => {
        let d = c.progress;
        e.params.flipEffect.limitRotation && (d = Math.max(Math.min(c.progress, 1), -1)), n(c, d);
      });
    }, getEffectParams: () => e.params.flipEffect, perspective: () => true, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, watchSlidesProgress: true, spaceBetween: 0, virtualTranslate: !e.params.cssMode }) });
  }
  function Yg({ swiper: e, extendParams: t, on: i }) {
    t({ coverflowEffect: { rotate: 50, stretch: 0, depth: 100, scale: 1, modifier: 1, slideShadows: true } }), ki({ effect: "coverflow", swiper: e, on: i, setTranslate: () => {
      const { width: o, height: l, slides: c, slidesSizesGrid: d } = e, v = e.params.coverflowEffect, E = e.isHorizontal(), y = e.translate, b = E ? -y + o / 2 : -y + l / 2, p = E ? v.rotate : -v.rotate, g = v.depth, C = Zn(e);
      for (let _ = 0, h = c.length; _ < h; _ += 1) {
        const S = c[_], w = d[_], A = S.swiperSlideOffset, L = (b - A - w / 2) / w, f = typeof v.modifier == "function" ? v.modifier(L) : L * v.modifier;
        let P = E ? p * f : 0, D = E ? 0 : p * f, R = -g * Math.abs(f), N = v.stretch;
        typeof N == "string" && N.indexOf("%") !== -1 && (N = parseFloat(v.stretch) / 100 * w);
        let $ = E ? 0 : N * f, B = E ? N * f : 0, V = 1 - (1 - v.scale) * Math.abs(f);
        Math.abs(B) < 1e-3 && (B = 0), Math.abs($) < 1e-3 && ($ = 0), Math.abs(R) < 1e-3 && (R = 0), Math.abs(P) < 1e-3 && (P = 0), Math.abs(D) < 1e-3 && (D = 0), Math.abs(V) < 1e-3 && (V = 0);
        const X = `translate3d(${B}px,${$}px,${R}px)  rotateX(${C(D)}deg) rotateY(${C(P)}deg) scale(${V})`, Z = rn(v, S);
        if (Z.style.transform = X, S.style.zIndex = -Math.abs(Math.round(f)) + 1, v.slideShadows) {
          let F = E ? S.querySelector(".swiper-slide-shadow-left") : S.querySelector(".swiper-slide-shadow-top"), W = E ? S.querySelector(".swiper-slide-shadow-right") : S.querySelector(".swiper-slide-shadow-bottom");
          F || (F = Di("coverflow", S, E ? "left" : "top")), W || (W = Di("coverflow", S, E ? "right" : "bottom")), F && (F.style.opacity = f > 0 ? f : 0), W && (W.style.opacity = -f > 0 ? -f : 0);
        }
      }
    }, setTransition: (o) => {
      e.slides.map((c) => ai(c)).forEach((c) => {
        c.style.transitionDuration = `${o}ms`, c.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((d) => {
          d.style.transitionDuration = `${o}ms`;
        });
      });
    }, perspective: () => true, overwriteParams: () => ({ watchSlidesProgress: true }) });
  }
  function Xg({ swiper: e, extendParams: t, on: i }) {
    t({ creativeEffect: { limitProgress: 1, shadowPerProgress: false, progressMultiplier: 1, perspective: true, prev: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 }, next: { translate: [0, 0, 0], rotate: [0, 0, 0], opacity: 1, scale: 1 } } });
    const n = (l) => typeof l == "string" ? l : `${l}px`;
    ki({ effect: "creative", swiper: e, on: i, setTranslate: () => {
      const { slides: l, wrapperEl: c, slidesSizesGrid: d } = e, v = e.params.creativeEffect, { progressMultiplier: E } = v, y = e.params.centeredSlides, b = Zn(e);
      if (y) {
        const p = d[0] / 2 - e.params.slidesOffsetBefore || 0;
        c.style.transform = `translateX(calc(50% - ${p}px))`;
      }
      for (let p = 0; p < l.length; p += 1) {
        const g = l[p], C = g.progress, _ = Math.min(Math.max(g.progress, -v.limitProgress), v.limitProgress);
        let h = _;
        y || (h = Math.min(Math.max(g.originalProgress, -v.limitProgress), v.limitProgress));
        const S = g.swiperSlideOffset, w = [e.params.cssMode ? -S - e.translate : -S, 0, 0], A = [0, 0, 0];
        let L = false;
        e.isHorizontal() || (w[1] = w[0], w[0] = 0);
        let f = { translate: [0, 0, 0], rotate: [0, 0, 0], scale: 1, opacity: 1 };
        _ < 0 ? (f = v.next, L = true) : _ > 0 && (f = v.prev, L = true), w.forEach((V, X) => {
          w[X] = `calc(${V}px + (${n(f.translate[X])} * ${Math.abs(_ * E)}))`;
        }), A.forEach((V, X) => {
          let Z = f.rotate[X] * Math.abs(_ * E);
          A[X] = Z;
        }), g.style.zIndex = -Math.abs(Math.round(C)) + l.length;
        const P = w.join(", "), D = `rotateX(${b(A[0])}deg) rotateY(${b(A[1])}deg) rotateZ(${b(A[2])}deg)`, R = h < 0 ? `scale(${1 + (1 - f.scale) * h * E})` : `scale(${1 - (1 - f.scale) * h * E})`, N = h < 0 ? 1 + (1 - f.opacity) * h * E : 1 - (1 - f.opacity) * h * E, $ = `translate3d(${P}) ${D} ${R}`;
        if (L && f.shadow || !L) {
          let V = g.querySelector(".swiper-slide-shadow");
          if (!V && f.shadow && (V = Di("creative", g)), V) {
            const X = v.shadowPerProgress ? _ * (1 / v.limitProgress) : _;
            V.style.opacity = Math.min(Math.max(Math.abs(X), 0), 1);
          }
        }
        const B = rn(v, g);
        B.style.transform = $, B.style.opacity = N, f.origin && (B.style.transformOrigin = f.origin);
      }
    }, setTransition: (l) => {
      const c = e.slides.map((d) => ai(d));
      c.forEach((d) => {
        d.style.transitionDuration = `${l}ms`, d.querySelectorAll(".swiper-slide-shadow").forEach((v) => {
          v.style.transitionDuration = `${l}ms`;
        });
      }), Qn({ swiper: e, duration: l, transformElements: c, allSlides: true });
    }, perspective: () => e.params.creativeEffect.perspective, overwriteParams: () => ({ watchSlidesProgress: true, virtualTranslate: !e.params.cssMode }) });
  }
  function qg({ swiper: e, extendParams: t, on: i }) {
    t({ cardsEffect: { slideShadows: true, rotate: true, perSlideRotate: 2, perSlideOffset: 8 } }), ki({ effect: "cards", swiper: e, on: i, setTranslate: () => {
      const { slides: o, activeIndex: l, rtlTranslate: c } = e, d = e.params.cardsEffect, { startTranslate: v, isTouched: E } = e.touchEventsData, y = c ? -e.translate : e.translate;
      for (let b = 0; b < o.length; b += 1) {
        const p = o[b], g = p.progress, C = Math.min(Math.max(g, -4), 4);
        let _ = p.swiperSlideOffset;
        e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (_ -= o[0].swiperSlideOffset);
        let h = e.params.cssMode ? -_ - e.translate : -_, S = 0;
        const w = -100 * Math.abs(C);
        let A = 1, L = -d.perSlideRotate * C, f = d.perSlideOffset - Math.abs(C) * 0.75;
        const P = e.virtual && e.params.virtual.enabled ? e.virtual.from + b : b, D = (P === l || P === l - 1) && C > 0 && C < 1 && (E || e.params.cssMode) && y < v, R = (P === l || P === l + 1) && C < 0 && C > -1 && (E || e.params.cssMode) && y > v;
        if (D || R) {
          const V = Me(1 - Math.abs((Math.abs(C) - 0.5) / 0.5), 0.5);
          L += -28 * C * V, A += -0.5 * V, f += 96 * V, S = `${(d.rotate || e.isHorizontal() ? -25 : 0) * V * Math.abs(C)}%`;
        }
        if (C < 0 ? h = `calc(${h}px ${c ? "-" : "+"} (${f * Math.abs(C)}%))` : C > 0 ? h = `calc(${h}px ${c ? "-" : "+"} (-${f * Math.abs(C)}%))` : h = `${h}px`, !e.isHorizontal()) {
          const V = S;
          S = h, h = V;
        }
        const N = C < 0 ? `${1 + (1 - A) * C}` : `${1 - (1 - A) * C}`, $ = `
        translate3d(${h}, ${S}, ${w}px)
        rotateZ(${d.rotate ? c ? -L : L : 0}deg)
        scale(${N})
      `;
        if (d.slideShadows) {
          let V = p.querySelector(".swiper-slide-shadow");
          V || (V = Di("cards", p)), V && (V.style.opacity = Math.min(Math.max((Math.abs(C) - 0.5) / 0.5, 0), 1));
        }
        p.style.zIndex = -Math.abs(Math.round(g)) + o.length;
        const B = rn(d, p);
        B.style.transform = $;
      }
    }, setTransition: (o) => {
      const l = e.slides.map((c) => ai(c));
      l.forEach((c) => {
        c.style.transitionDuration = `${o}ms`, c.querySelectorAll(".swiper-slide-shadow").forEach((d) => {
          d.style.transitionDuration = `${o}ms`;
        });
      }), Qn({ swiper: e, duration: o, transformElements: l });
    }, perspective: () => true, overwriteParams: () => ({ _loopSwapReset: false, watchSlidesProgress: true, loopAdditionalSlides: e.params.cardsEffect.rotate ? 3 : 2, centeredSlides: true, virtualTranslate: !e.params.cssMode }) });
  }
  const Ug = [Sg, Tg, _g, xg, Cg, wg, Ig, Ag, Og, Mg, Lg, Pg, Dg, zg, $g, Ng, Wg, Fg, Gg, jg, Yg, Xg, qg];
  Ve.use(Ug);
  function Kg(e) {
    const { effect: t, swiper: i, on: n, setTranslate: r, setTransition: o, overwriteParams: l, perspective: c, recreateShadows: d, getEffectParams: v } = e;
    n("beforeInit", () => {
      if (i.params.effect !== t) return;
      i.classNames.push(`${i.params.containerModifierClass}${t}`), c && c() && i.classNames.push(`${i.params.containerModifierClass}3d`);
      const y = l ? l() : {};
      Object.assign(i.params, y), Object.assign(i.originalParams, y);
    }), n("setTranslate _virtualUpdated", () => {
      i.params.effect === t && r();
    }), n("setTransition", (y, b) => {
      i.params.effect === t && o(b);
    }), n("transitionEnd", () => {
      if (i.params.effect === t && d) {
        if (!v || !v().slideShadows) return;
        i.slides.forEach((y) => {
          y.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((b) => b.remove());
        }), d();
      }
    });
    let E;
    n("virtualUpdate", () => {
      i.params.effect === t && (i.slides.length || (E = true), requestAnimationFrame(() => {
        E && i.slides && i.slides.length && (r(), E = false);
      }));
    });
  }
  function Zg(e) {
    return e.querySelector(".swiper-slide-transform") || e.shadowRoot && e.shadowRoot.querySelector(".swiper-slide-transform") || e;
  }
  function Qg(e, t) {
    function i(n) {
      n.target === e && (t.call(e, n), e.removeEventListener("transitionend", i));
    }
    t && e.addEventListener("transitionend", i);
  }
  function Jg({ swiper: e, duration: t, transformElements: i, allSlides: n }) {
    const { activeIndex: r } = e;
    if (e.params.virtualTranslate && t !== 0) {
      let o = false, l;
      l = i, l.forEach((c) => {
        Qg(c, () => {
          if (o || !e || e.destroyed) return;
          o = true, e.animating = false;
          const d = new window.CustomEvent("transitionend", { bubbles: true, cancelable: true });
          e.wrapperEl.dispatchEvent(d);
        });
      });
    }
  }
  function ev({ swiper: e, extendParams: t, on: i }) {
    t({ stackLiftEffect: {} });
    const n = () => {
      const { slides: c } = e, d = Math.round(c.length > 0 ? c[0].progress : 0), v = c.length;
      for (let E = 0; E < v; E += 1) {
        const y = c[E];
        let p = -y.swiperSlideOffset;
        e.params.virtualTranslate || (p -= e.translate);
        let g = E - d;
        g < 0 && (g += v);
        let C = o(g), _ = r(y, g);
        y.style.setProperty("--swiper-stack-lift-translate-x", `${p}px`), y.style.setProperty("--swiper-stack-lift-translate-y", `${C}px`), y.style.setProperty("--swiper-stack-lift-scale", _), y.style.setProperty("--swiper-stack-lift-z-index", v - g), g === 0 ? y.style.setProperty("--swiper-stack-lift-opacity", 0) : y.style.setProperty("--swiper-stack-lift-opacity", 1), y.dataset.sliderIndex = g;
      }
    };
    function r(c, d) {
      return (c.offsetWidth - 64 * d) / (c.offsetWidth * 1);
    }
    function o(c) {
      return c === 0 ? 0 : c === 1 ? 15 : 15 + (c - 1) * 12;
    }
    Kg({ effect: "stack-lift", swiper: e, on: i, setTranslate: n, setTransition: (c) => {
      const d = e.slides.map((v) => Zg(v));
      d.forEach((v) => {
        v.style.transitionDuration = `${c}ms`;
      }), Jg({ swiper: e, duration: c, transformElements: d, allSlides: true });
    }, perspective: () => true, overwriteParams: () => ({ slidesPerView: 1, slidesPerGroup: 1, spaceBetween: 0, watchSlidesProgress: true, centeredSlides: false, speed: 700, virtualTranslate: !e.params.cssMode }) });
  }
  Ve.use([ev]);
  window.GSP = window.GSP || {};
  window.GSP.Swiper = { Swiper: Ve };
  function tv(e, t, i) {
    if (e == null) return [];
    if (e instanceof EventTarget) return [e];
    if (typeof e == "string") {
      const r = document.querySelectorAll(e);
      return r ? Array.from(r) : [];
    }
    return Array.from(e).filter((n) => n != null);
  }
  const iv = { some: 0, all: 1 };
  function nv(e, t, { root: i, margin: n, amount: r = "some" } = {}) {
    const o = tv(e), l = /* @__PURE__ */ new WeakMap(), c = (v) => {
      v.forEach((E) => {
        const y = l.get(E.target);
        if (E.isIntersecting !== !!y) if (E.isIntersecting) {
          const b = t(E.target, E);
          typeof b == "function" ? l.set(E.target, b) : d.unobserve(E.target);
        } else typeof y == "function" && (y(E), l.delete(E.target));
      });
    }, d = new IntersectionObserver(c, { root: i, rootMargin: n, threshold: typeof r == "number" ? r : iv[r] });
    return o.forEach((v) => d.observe(v)), () => d.disconnect();
  }
  window.GSP = window.GSP || {};
  window.GSP.Motion = { inView: nv };
  var Hn = function() {
    return Hn = Object.assign || function(e) {
      for (var t, i = 1, n = arguments.length; i < n; i++) for (var r in t = arguments[i]) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      return e;
    }, Hn.apply(this, arguments);
  }, sv = (function() {
    function e(t, i, n) {
      var r = this;
      this.endVal = i, this.options = n, this.version = "2.10.0", this.defaults = { startVal: 0, decimalPlaces: 0, duration: 2, useEasing: true, useGrouping: true, useIndianSeparators: false, smartEasingThreshold: 999, smartEasingAmount: 333, separator: ",", decimal: ".", prefix: "", suffix: "", autoAnimate: false, autoAnimateDelay: 200, autoAnimateOnce: false }, this.finalEndVal = null, this.useEasing = true, this.countDown = false, this.error = "", this.startVal = 0, this.paused = true, this.once = false, this.count = function(o) {
        r.startTime || (r.startTime = o);
        var l = o - r.startTime;
        r.remaining = r.duration - l, r.useEasing ? r.countDown ? r.frameVal = r.startVal - r.easingFn(l, 0, r.startVal - r.endVal, r.duration) : r.frameVal = r.easingFn(l, r.startVal, r.endVal - r.startVal, r.duration) : r.frameVal = r.startVal + (r.endVal - r.startVal) * (l / r.duration);
        var c = r.countDown ? r.frameVal < r.endVal : r.frameVal > r.endVal;
        r.frameVal = c ? r.endVal : r.frameVal, r.frameVal = Number(r.frameVal.toFixed(r.options.decimalPlaces)), r.printValue(r.frameVal), l < r.duration ? r.rAF = requestAnimationFrame(r.count) : r.finalEndVal !== null ? r.update(r.finalEndVal) : r.options.onCompleteCallback && r.options.onCompleteCallback();
      }, this.formatNumber = function(o) {
        var l, c, d, v, E = o < 0 ? "-" : "";
        l = Math.abs(o).toFixed(r.options.decimalPlaces);
        var y = (l += "").split(".");
        if (c = y[0], d = y.length > 1 ? r.options.decimal + y[1] : "", r.options.useGrouping) {
          v = "";
          for (var b = 3, p = 0, g = 0, C = c.length; g < C; ++g) r.options.useIndianSeparators && g === 4 && (b = 2, p = 1), g !== 0 && p % b == 0 && (v = r.options.separator + v), p++, v = c[C - g - 1] + v;
          c = v;
        }
        return r.options.numerals && r.options.numerals.length && (c = c.replace(/[0-9]/g, (function(_) {
          return r.options.numerals[+_];
        })), d = d.replace(/[0-9]/g, (function(_) {
          return r.options.numerals[+_];
        }))), E + r.options.prefix + c + d + r.options.suffix;
      }, this.easeOutExpo = function(o, l, c, d) {
        return c * (1 - Math.pow(2, -10 * o / d)) * 1024 / 1023 + l;
      }, this.options = Hn(Hn({}, this.defaults), n), this.options.enableScrollSpy && (this.options.autoAnimate = true), this.options.scrollSpyDelay !== void 0 && (this.options.autoAnimateDelay = this.options.scrollSpyDelay), this.options.scrollSpyOnce && (this.options.autoAnimateOnce = true), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.el = typeof t == "string" ? document.getElementById(t) : t, i = i == null ? this.parse(this.el.innerHTML) : i, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(i), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, this.options.separator === "" && (this.options.useGrouping = false), this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", typeof window != "undefined" && this.options.autoAnimate && (this.error || typeof IntersectionObserver == "undefined" ? this.error ? console.error(this.error, t) : console.error("IntersectionObserver is not supported by this browser") : this.setupObserver());
    }
    return e.prototype.setupObserver = function() {
      var t = this, i = e.observedElements.get(this.el);
      i && i.unobserve(), e.observedElements.set(this.el, this), this.observer = new IntersectionObserver((function(n) {
        for (var r = 0, o = n; r < o.length; r++) {
          var l = o[r];
          l.isIntersecting && t.paused && !t.once ? (t.paused = false, t.autoAnimateTimeout = setTimeout((function() {
            return t.start();
          }), t.options.autoAnimateDelay), t.options.autoAnimateOnce && (t.once = true, t.observer.disconnect())) : l.isIntersecting || t.paused || (clearTimeout(t.autoAnimateTimeout), t.reset());
        }
      }), { threshold: 0 }), this.observer.observe(this.el);
    }, e.prototype.unobserve = function() {
      var t;
      clearTimeout(this.autoAnimateTimeout), (t = this.observer) === null || t === void 0 || t.disconnect(), e.observedElements.delete(this.el);
    }, e.prototype.onDestroy = function() {
      clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = true, this.unobserve(), this.options.onCompleteCallback = null, this.options.onStartCallback = null;
    }, e.prototype.determineDirectionAndSmartEasing = function() {
      var t = this.finalEndVal ? this.finalEndVal : this.endVal;
      this.countDown = this.startVal > t;
      var i = t - this.startVal;
      if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
        this.finalEndVal = t;
        var n = this.countDown ? 1 : -1;
        this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
      } else this.endVal = t, this.finalEndVal = null;
      this.finalEndVal !== null ? this.useEasing = false : this.useEasing = this.options.useEasing;
    }, e.prototype.start = function(t) {
      this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = false, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, e.prototype.pauseResume = function() {
      this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, e.prototype.reset = function() {
      clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = true, this.once = false, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, e.prototype.update = function(t) {
      cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, this.finalEndVal == null && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, e.prototype.printValue = function(t) {
      var i;
      if (this.el) {
        var n = this.formattingFn(t);
        !((i = this.options.plugin) === null || i === void 0) && i.render ? this.options.plugin.render(this.el, n) : this.el.tagName === "INPUT" ? this.el.value = n : this.el.tagName === "text" || this.el.tagName === "tspan" ? this.el.textContent = n : this.el.innerHTML = n;
      }
    }, e.prototype.ensureNumber = function(t) {
      return typeof t == "number" && !isNaN(t);
    }, e.prototype.validateValue = function(t) {
      var i = Number(t);
      return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, e.prototype.resetDuration = function() {
      this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, e.prototype.parse = function(t) {
      var i = function(l) {
        return l.replace(/([.,'  ])/g, "\\$1");
      }, n = i(this.options.separator), r = i(this.options.decimal), o = t.replace(new RegExp(n, "g"), "").replace(new RegExp(r, "g"), ".");
      return parseFloat(o);
    }, e.observedElements = /* @__PURE__ */ new WeakMap(), e;
  })();
  window.CountUp = sv;
  function rv(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }
  var js = { exports: {} }, Ys = { exports: {} }, Pn = { exports: {} }, ov = Pn.exports, ma;
  function Gl() {
    return ma || (ma = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i() : t.EvEmitter = i();
      })(typeof window != "undefined" ? window : ov, function() {
        function t() {
        }
        var i = t.prototype;
        return i.on = function(n, r) {
          if (!(!n || !r)) {
            var o = this._events = this._events || {}, l = o[n] = o[n] || [];
            return l.indexOf(r) == -1 && l.push(r), this;
          }
        }, i.once = function(n, r) {
          if (!(!n || !r)) {
            this.on(n, r);
            var o = this._onceEvents = this._onceEvents || {}, l = o[n] = o[n] || {};
            return l[r] = true, this;
          }
        }, i.off = function(n, r) {
          var o = this._events && this._events[n];
          if (!(!o || !o.length)) {
            var l = o.indexOf(r);
            return l != -1 && o.splice(l, 1), this;
          }
        }, i.emitEvent = function(n, r) {
          var o = this._events && this._events[n];
          if (!(!o || !o.length)) {
            o = o.slice(0), r = r || [];
            for (var l = this._onceEvents && this._onceEvents[n], c = 0; c < o.length; c++) {
              var d = o[c], v = l && l[d];
              v && (this.off(n, d), delete l[d]), d.apply(this, r);
            }
            return this;
          }
        }, i.allOff = function() {
          delete this._events, delete this._onceEvents;
        }, t;
      });
    })(Pn)), Pn.exports;
  }
  var Xs = { exports: {} };
  var ga;
  function on() {
    return ga || (ga = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i() : t.getSize = i();
      })(window, function() {
        function i(p) {
          var g = parseFloat(p), C = p.indexOf("%") == -1 && !isNaN(g);
          return C && g;
        }
        function n() {
        }
        var r = typeof console == "undefined" ? n : function(p) {
          console.error(p);
        }, o = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"], l = o.length;
        function c() {
          for (var p = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, g = 0; g < l; g++) {
            var C = o[g];
            p[C] = 0;
          }
          return p;
        }
        function d(p) {
          var g = getComputedStyle(p);
          return g || r("Style returned " + g + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), g;
        }
        var v = false, E;
        function y() {
          if (!v) {
            v = true;
            var p = document.createElement("div");
            p.style.width = "200px", p.style.padding = "1px 2px 3px 4px", p.style.borderStyle = "solid", p.style.borderWidth = "1px 2px 3px 4px", p.style.boxSizing = "border-box";
            var g = document.body || document.documentElement;
            g.appendChild(p);
            var C = d(p);
            E = Math.round(i(C.width)) == 200, b.isBoxSizeOuter = E, g.removeChild(p);
          }
        }
        function b(p) {
          if (y(), typeof p == "string" && (p = document.querySelector(p)), !(!p || typeof p != "object" || !p.nodeType)) {
            var g = d(p);
            if (g.display == "none") return c();
            var C = {};
            C.width = p.offsetWidth, C.height = p.offsetHeight;
            for (var _ = C.isBorderBox = g.boxSizing == "border-box", h = 0; h < l; h++) {
              var S = o[h], w = g[S], A = parseFloat(w);
              C[S] = isNaN(A) ? 0 : A;
            }
            var L = C.paddingLeft + C.paddingRight, f = C.paddingTop + C.paddingBottom, P = C.marginLeft + C.marginRight, D = C.marginTop + C.marginBottom, R = C.borderLeftWidth + C.borderRightWidth, N = C.borderTopWidth + C.borderBottomWidth, $ = _ && E, B = i(g.width);
            B !== false && (C.width = B + ($ ? 0 : L + R));
            var V = i(g.height);
            return V !== false && (C.height = V + ($ ? 0 : f + N)), C.innerWidth = C.width - (L + R), C.innerHeight = C.height - (f + N), C.outerWidth = C.width + P, C.outerHeight = C.height + D, C;
          }
        }
        return b;
      });
    })(Xs)), Xs.exports;
  }
  var qs = { exports: {} }, Us = { exports: {} }, va;
  function jl() {
    return va || (va = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i() : t.matchesSelector = i();
      })(window, function() {
        var i = (function() {
          var n = window.Element.prototype;
          if (n.matches) return "matches";
          if (n.matchesSelector) return "matchesSelector";
          for (var r = ["webkit", "moz", "ms", "o"], o = 0; o < r.length; o++) {
            var l = r[o], c = l + "MatchesSelector";
            if (n[c]) return c;
          }
        })();
        return function(r, o) {
          return r[i](o);
        };
      });
    })(Us)), Us.exports;
  }
  var ya;
  function Yl() {
    return ya || (ya = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(t, jl()) : t.fizzyUIUtils = i(t, t.matchesSelector);
      })(window, function(i, n) {
        var r = {};
        r.extend = function(c, d) {
          for (var v in d) c[v] = d[v];
          return c;
        }, r.modulo = function(c, d) {
          return (c % d + d) % d;
        };
        var o = Array.prototype.slice;
        r.makeArray = function(c) {
          if (Array.isArray(c)) return c;
          if (c == null) return [];
          var d = typeof c == "object" && typeof c.length == "number";
          return d ? o.call(c) : [c];
        }, r.removeFrom = function(c, d) {
          var v = c.indexOf(d);
          v != -1 && c.splice(v, 1);
        }, r.getParent = function(c, d) {
          for (; c.parentNode && c != document.body; ) if (c = c.parentNode, n(c, d)) return c;
        }, r.getQueryElement = function(c) {
          return typeof c == "string" ? document.querySelector(c) : c;
        }, r.handleEvent = function(c) {
          var d = "on" + c.type;
          this[d] && this[d](c);
        }, r.filterFindElements = function(c, d) {
          c = r.makeArray(c);
          var v = [];
          return c.forEach(function(E) {
            if (E instanceof HTMLElement) {
              if (!d) {
                v.push(E);
                return;
              }
              n(E, d) && v.push(E);
              for (var y = E.querySelectorAll(d), b = 0; b < y.length; b++) v.push(y[b]);
            }
          }), v;
        }, r.debounceMethod = function(c, d, v) {
          v = v || 100;
          var E = c.prototype[d], y = d + "Timeout";
          c.prototype[d] = function() {
            var b = this[y];
            clearTimeout(b);
            var p = arguments, g = this;
            this[y] = setTimeout(function() {
              E.apply(g, p), delete g[y];
            }, v);
          };
        }, r.docReady = function(c) {
          var d = document.readyState;
          d == "complete" || d == "interactive" ? setTimeout(c) : document.addEventListener("DOMContentLoaded", c);
        }, r.toDashed = function(c) {
          return c.replace(/(.)([A-Z])/g, function(d, v, E) {
            return v + "-" + E;
          }).toLowerCase();
        };
        var l = i.console;
        return r.htmlInit = function(c, d) {
          r.docReady(function() {
            var v = r.toDashed(d), E = "data-" + v, y = document.querySelectorAll("[" + E + "]"), b = document.querySelectorAll(".js-" + v), p = r.makeArray(y).concat(r.makeArray(b)), g = E + "-options", C = i.jQuery;
            p.forEach(function(_) {
              var h = _.getAttribute(E) || _.getAttribute(g), S;
              try {
                S = h && JSON.parse(h);
              } catch (A) {
                l && l.error("Error parsing " + E + " on " + _.className + ": " + A);
                return;
              }
              var w = new c(_, S);
              C && C.data(_, d, w);
            });
          });
        }, r;
      });
    })(qs)), qs.exports;
  }
  var Ks = { exports: {} }, ba;
  function av() {
    return ba || (ba = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(Gl(), on()) : (t.Outlayer = {}, t.Outlayer.Item = i(t.EvEmitter, t.getSize));
      })(window, function(i, n) {
        function r(_) {
          for (var h in _) return false;
          return h = null, true;
        }
        var o = document.documentElement.style, l = typeof o.transition == "string" ? "transition" : "WebkitTransition", c = typeof o.transform == "string" ? "transform" : "WebkitTransform", d = { WebkitTransition: "webkitTransitionEnd", transition: "transitionend" }[l], v = { transform: c, transition: l, transitionDuration: l + "Duration", transitionProperty: l + "Property", transitionDelay: l + "Delay" };
        function E(_, h) {
          _ && (this.element = _, this.layout = h, this.position = { x: 0, y: 0 }, this._create());
        }
        var y = E.prototype = Object.create(i.prototype);
        y.constructor = E, y._create = function() {
          this._transn = { ingProperties: {}, clean: {}, onEnd: {} }, this.css({ position: "absolute" });
        }, y.handleEvent = function(_) {
          var h = "on" + _.type;
          this[h] && this[h](_);
        }, y.getSize = function() {
          this.size = n(this.element);
        }, y.css = function(_) {
          var h = this.element.style;
          for (var S in _) {
            var w = v[S] || S;
            h[w] = _[S];
          }
        }, y.getPosition = function() {
          var _ = getComputedStyle(this.element), h = this.layout._getOption("originLeft"), S = this.layout._getOption("originTop"), w = _[h ? "left" : "right"], A = _[S ? "top" : "bottom"], L = parseFloat(w), f = parseFloat(A), P = this.layout.size;
          w.indexOf("%") != -1 && (L = L / 100 * P.width), A.indexOf("%") != -1 && (f = f / 100 * P.height), L = isNaN(L) ? 0 : L, f = isNaN(f) ? 0 : f, L -= h ? P.paddingLeft : P.paddingRight, f -= S ? P.paddingTop : P.paddingBottom, this.position.x = L, this.position.y = f;
        }, y.layoutPosition = function() {
          var _ = this.layout.size, h = {}, S = this.layout._getOption("originLeft"), w = this.layout._getOption("originTop"), A = S ? "paddingLeft" : "paddingRight", L = S ? "left" : "right", f = S ? "right" : "left", P = this.position.x + _[A];
          h[L] = this.getXValue(P), h[f] = "";
          var D = w ? "paddingTop" : "paddingBottom", R = w ? "top" : "bottom", N = w ? "bottom" : "top", $ = this.position.y + _[D];
          h[R] = this.getYValue($), h[N] = "", this.css(h), this.emitEvent("layout", [this]);
        }, y.getXValue = function(_) {
          var h = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && !h ? _ / this.layout.size.width * 100 + "%" : _ + "px";
        }, y.getYValue = function(_) {
          var h = this.layout._getOption("horizontal");
          return this.layout.options.percentPosition && h ? _ / this.layout.size.height * 100 + "%" : _ + "px";
        }, y._transitionTo = function(_, h) {
          this.getPosition();
          var S = this.position.x, w = this.position.y, A = _ == this.position.x && h == this.position.y;
          if (this.setPosition(_, h), A && !this.isTransitioning) {
            this.layoutPosition();
            return;
          }
          var L = _ - S, f = h - w, P = {};
          P.transform = this.getTranslate(L, f), this.transition({ to: P, onTransitionEnd: { transform: this.layoutPosition }, isCleaning: true });
        }, y.getTranslate = function(_, h) {
          var S = this.layout._getOption("originLeft"), w = this.layout._getOption("originTop");
          return _ = S ? _ : -_, h = w ? h : -h, "translate3d(" + _ + "px, " + h + "px, 0)";
        }, y.goTo = function(_, h) {
          this.setPosition(_, h), this.layoutPosition();
        }, y.moveTo = y._transitionTo, y.setPosition = function(_, h) {
          this.position.x = parseFloat(_), this.position.y = parseFloat(h);
        }, y._nonTransition = function(_) {
          this.css(_.to), _.isCleaning && this._removeStyles(_.to);
          for (var h in _.onTransitionEnd) _.onTransitionEnd[h].call(this);
        }, y.transition = function(_) {
          if (!parseFloat(this.layout.options.transitionDuration)) {
            this._nonTransition(_);
            return;
          }
          var h = this._transn;
          for (var S in _.onTransitionEnd) h.onEnd[S] = _.onTransitionEnd[S];
          for (S in _.to) h.ingProperties[S] = true, _.isCleaning && (h.clean[S] = true);
          _.from && (this.css(_.from), this.element.offsetHeight), this.enableTransition(_.to), this.css(_.to), this.isTransitioning = true;
        };
        function b(_) {
          return _.replace(/([A-Z])/g, function(h) {
            return "-" + h.toLowerCase();
          });
        }
        var p = "opacity," + b(c);
        y.enableTransition = function() {
          if (!this.isTransitioning) {
            var _ = this.layout.options.transitionDuration;
            _ = typeof _ == "number" ? _ + "ms" : _, this.css({ transitionProperty: p, transitionDuration: _, transitionDelay: this.staggerDelay || 0 }), this.element.addEventListener(d, this, false);
          }
        }, y.onwebkitTransitionEnd = function(_) {
          this.ontransitionend(_);
        }, y.onotransitionend = function(_) {
          this.ontransitionend(_);
        };
        var g = { "-webkit-transform": "transform" };
        y.ontransitionend = function(_) {
          if (_.target === this.element) {
            var h = this._transn, S = g[_.propertyName] || _.propertyName;
            if (delete h.ingProperties[S], r(h.ingProperties) && this.disableTransition(), S in h.clean && (this.element.style[_.propertyName] = "", delete h.clean[S]), S in h.onEnd) {
              var w = h.onEnd[S];
              w.call(this), delete h.onEnd[S];
            }
            this.emitEvent("transitionEnd", [this]);
          }
        }, y.disableTransition = function() {
          this.removeTransitionStyles(), this.element.removeEventListener(d, this, false), this.isTransitioning = false;
        }, y._removeStyles = function(_) {
          var h = {};
          for (var S in _) h[S] = "";
          this.css(h);
        };
        var C = { transitionProperty: "", transitionDuration: "", transitionDelay: "" };
        return y.removeTransitionStyles = function() {
          this.css(C);
        }, y.stagger = function(_) {
          _ = isNaN(_) ? 0 : _, this.staggerDelay = _ + "ms";
        }, y.removeElem = function() {
          this.element.parentNode.removeChild(this.element), this.css({ display: "" }), this.emitEvent("remove", [this]);
        }, y.remove = function() {
          if (!parseFloat(this.layout.options.transitionDuration)) {
            this.removeElem();
            return;
          }
          this.once("transitionEnd", function() {
            this.removeElem();
          }), this.hide();
        }, y.reveal = function() {
          delete this.isHidden, this.css({ display: "" });
          var _ = this.layout.options, h = {}, S = this.getHideRevealTransitionEndProperty("visibleStyle");
          h[S] = this.onRevealTransitionEnd, this.transition({ from: _.hiddenStyle, to: _.visibleStyle, isCleaning: true, onTransitionEnd: h });
        }, y.onRevealTransitionEnd = function() {
          this.isHidden || this.emitEvent("reveal");
        }, y.getHideRevealTransitionEndProperty = function(_) {
          var h = this.layout.options[_];
          if (h.opacity) return "opacity";
          for (var S in h) return S;
        }, y.hide = function() {
          this.isHidden = true, this.css({ display: "" });
          var _ = this.layout.options, h = {}, S = this.getHideRevealTransitionEndProperty("hiddenStyle");
          h[S] = this.onHideTransitionEnd, this.transition({ from: _.visibleStyle, to: _.hiddenStyle, isCleaning: true, onTransitionEnd: h });
        }, y.onHideTransitionEnd = function() {
          this.isHidden && (this.css({ display: "none" }), this.emitEvent("hide"));
        }, y.destroy = function() {
          this.css({ position: "", left: "", right: "", top: "", bottom: "", transition: "", transform: "" });
        }, E;
      });
    })(Ks)), Ks.exports;
  }
  var Ea;
  function Jn() {
    return Ea || (Ea = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(t, Gl(), on(), Yl(), av()) : t.Outlayer = i(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item);
      })(window, function(i, n, r, o, l) {
        var c = i.console, d = i.jQuery, v = function() {
        }, E = 0, y = {};
        function b(h, S) {
          var w = o.getQueryElement(h);
          if (!w) {
            c && c.error("Bad element for " + this.constructor.namespace + ": " + (w || h));
            return;
          }
          this.element = w, d && (this.$element = d(this.element)), this.options = o.extend({}, this.constructor.defaults), this.option(S);
          var A = ++E;
          this.element.outlayerGUID = A, y[A] = this, this._create();
          var L = this._getOption("initLayout");
          L && this.layout();
        }
        b.namespace = "outlayer", b.Item = l, b.defaults = { containerStyle: { position: "relative" }, initLayout: true, originLeft: true, originTop: true, resize: true, resizeContainer: true, transitionDuration: "0.4s", hiddenStyle: { opacity: 0, transform: "scale(0.001)" }, visibleStyle: { opacity: 1, transform: "scale(1)" } };
        var p = b.prototype;
        o.extend(p, n.prototype), p.option = function(h) {
          o.extend(this.options, h);
        }, p._getOption = function(h) {
          var S = this.constructor.compatOptions[h];
          return S && this.options[S] !== void 0 ? this.options[S] : this.options[h];
        }, b.compatOptions = { initLayout: "isInitLayout", horizontal: "isHorizontal", layoutInstant: "isLayoutInstant", originLeft: "isOriginLeft", originTop: "isOriginTop", resize: "isResizeBound", resizeContainer: "isResizingContainer" }, p._create = function() {
          this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), o.extend(this.element.style, this.options.containerStyle);
          var h = this._getOption("resize");
          h && this.bindResize();
        }, p.reloadItems = function() {
          this.items = this._itemize(this.element.children);
        }, p._itemize = function(h) {
          for (var S = this._filterFindItemElements(h), w = this.constructor.Item, A = [], L = 0; L < S.length; L++) {
            var f = S[L], P = new w(f, this);
            A.push(P);
          }
          return A;
        }, p._filterFindItemElements = function(h) {
          return o.filterFindElements(h, this.options.itemSelector);
        }, p.getItemElements = function() {
          return this.items.map(function(h) {
            return h.element;
          });
        }, p.layout = function() {
          this._resetLayout(), this._manageStamps();
          var h = this._getOption("layoutInstant"), S = h !== void 0 ? h : !this._isLayoutInited;
          this.layoutItems(this.items, S), this._isLayoutInited = true;
        }, p._init = p.layout, p._resetLayout = function() {
          this.getSize();
        }, p.getSize = function() {
          this.size = r(this.element);
        }, p._getMeasurement = function(h, S) {
          var w = this.options[h], A;
          w ? (typeof w == "string" ? A = this.element.querySelector(w) : w instanceof HTMLElement && (A = w), this[h] = A ? r(A)[S] : w) : this[h] = 0;
        }, p.layoutItems = function(h, S) {
          h = this._getItemsForLayout(h), this._layoutItems(h, S), this._postLayout();
        }, p._getItemsForLayout = function(h) {
          return h.filter(function(S) {
            return !S.isIgnored;
          });
        }, p._layoutItems = function(h, S) {
          if (this._emitCompleteOnItems("layout", h), !(!h || !h.length)) {
            var w = [];
            h.forEach(function(A) {
              var L = this._getItemLayoutPosition(A);
              L.item = A, L.isInstant = S || A.isLayoutInstant, w.push(L);
            }, this), this._processLayoutQueue(w);
          }
        }, p._getItemLayoutPosition = function() {
          return { x: 0, y: 0 };
        }, p._processLayoutQueue = function(h) {
          this.updateStagger(), h.forEach(function(S, w) {
            this._positionItem(S.item, S.x, S.y, S.isInstant, w);
          }, this);
        }, p.updateStagger = function() {
          var h = this.options.stagger;
          if (h == null) {
            this.stagger = 0;
            return;
          }
          return this.stagger = _(h), this.stagger;
        }, p._positionItem = function(h, S, w, A, L) {
          A ? h.goTo(S, w) : (h.stagger(L * this.stagger), h.moveTo(S, w));
        }, p._postLayout = function() {
          this.resizeContainer();
        }, p.resizeContainer = function() {
          var h = this._getOption("resizeContainer");
          if (h) {
            var S = this._getContainerSize();
            S && (this._setContainerMeasure(S.width, true), this._setContainerMeasure(S.height, false));
          }
        }, p._getContainerSize = v, p._setContainerMeasure = function(h, S) {
          if (h !== void 0) {
            var w = this.size;
            w.isBorderBox && (h += S ? w.paddingLeft + w.paddingRight + w.borderLeftWidth + w.borderRightWidth : w.paddingBottom + w.paddingTop + w.borderTopWidth + w.borderBottomWidth), h = Math.max(h, 0), this.element.style[S ? "width" : "height"] = h + "px";
          }
        }, p._emitCompleteOnItems = function(h, S) {
          var w = this;
          function A() {
            w.dispatchEvent(h + "Complete", null, [S]);
          }
          var L = S.length;
          if (!S || !L) {
            A();
            return;
          }
          var f = 0;
          function P() {
            f++, f == L && A();
          }
          S.forEach(function(D) {
            D.once(h, P);
          });
        }, p.dispatchEvent = function(h, S, w) {
          var A = S ? [S].concat(w) : w;
          if (this.emitEvent(h, A), d) if (this.$element = this.$element || d(this.element), S) {
            var L = d.Event(S);
            L.type = h, this.$element.trigger(L, w);
          } else this.$element.trigger(h, w);
        }, p.ignore = function(h) {
          var S = this.getItem(h);
          S && (S.isIgnored = true);
        }, p.unignore = function(h) {
          var S = this.getItem(h);
          S && delete S.isIgnored;
        }, p.stamp = function(h) {
          h = this._find(h), h && (this.stamps = this.stamps.concat(h), h.forEach(this.ignore, this));
        }, p.unstamp = function(h) {
          h = this._find(h), h && h.forEach(function(S) {
            o.removeFrom(this.stamps, S), this.unignore(S);
          }, this);
        }, p._find = function(h) {
          if (h) return typeof h == "string" && (h = this.element.querySelectorAll(h)), h = o.makeArray(h), h;
        }, p._manageStamps = function() {
          !this.stamps || !this.stamps.length || (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
        }, p._getBoundingRect = function() {
          var h = this.element.getBoundingClientRect(), S = this.size;
          this._boundingRect = { left: h.left + S.paddingLeft + S.borderLeftWidth, top: h.top + S.paddingTop + S.borderTopWidth, right: h.right - (S.paddingRight + S.borderRightWidth), bottom: h.bottom - (S.paddingBottom + S.borderBottomWidth) };
        }, p._manageStamp = v, p._getElementOffset = function(h) {
          var S = h.getBoundingClientRect(), w = this._boundingRect, A = r(h), L = { left: S.left - w.left - A.marginLeft, top: S.top - w.top - A.marginTop, right: w.right - S.right - A.marginRight, bottom: w.bottom - S.bottom - A.marginBottom };
          return L;
        }, p.handleEvent = o.handleEvent, p.bindResize = function() {
          i.addEventListener("resize", this), this.isResizeBound = true;
        }, p.unbindResize = function() {
          i.removeEventListener("resize", this), this.isResizeBound = false;
        }, p.onresize = function() {
          this.resize();
        }, o.debounceMethod(b, "onresize", 100), p.resize = function() {
          !this.isResizeBound || !this.needsResizeLayout() || this.layout();
        }, p.needsResizeLayout = function() {
          var h = r(this.element), S = this.size && h;
          return S && h.innerWidth !== this.size.innerWidth;
        }, p.addItems = function(h) {
          var S = this._itemize(h);
          return S.length && (this.items = this.items.concat(S)), S;
        }, p.appended = function(h) {
          var S = this.addItems(h);
          S.length && (this.layoutItems(S, true), this.reveal(S));
        }, p.prepended = function(h) {
          var S = this._itemize(h);
          if (S.length) {
            var w = this.items.slice(0);
            this.items = S.concat(w), this._resetLayout(), this._manageStamps(), this.layoutItems(S, true), this.reveal(S), this.layoutItems(w);
          }
        }, p.reveal = function(h) {
          if (this._emitCompleteOnItems("reveal", h), !(!h || !h.length)) {
            var S = this.updateStagger();
            h.forEach(function(w, A) {
              w.stagger(A * S), w.reveal();
            });
          }
        }, p.hide = function(h) {
          if (this._emitCompleteOnItems("hide", h), !(!h || !h.length)) {
            var S = this.updateStagger();
            h.forEach(function(w, A) {
              w.stagger(A * S), w.hide();
            });
          }
        }, p.revealItemElements = function(h) {
          var S = this.getItems(h);
          this.reveal(S);
        }, p.hideItemElements = function(h) {
          var S = this.getItems(h);
          this.hide(S);
        }, p.getItem = function(h) {
          for (var S = 0; S < this.items.length; S++) {
            var w = this.items[S];
            if (w.element == h) return w;
          }
        }, p.getItems = function(h) {
          h = o.makeArray(h);
          var S = [];
          return h.forEach(function(w) {
            var A = this.getItem(w);
            A && S.push(A);
          }, this), S;
        }, p.remove = function(h) {
          var S = this.getItems(h);
          this._emitCompleteOnItems("remove", S), !(!S || !S.length) && S.forEach(function(w) {
            w.remove(), o.removeFrom(this.items, w);
          }, this);
        }, p.destroy = function() {
          var h = this.element.style;
          h.height = "", h.position = "", h.width = "", this.items.forEach(function(w) {
            w.destroy();
          }), this.unbindResize();
          var S = this.element.outlayerGUID;
          delete y[S], delete this.element.outlayerGUID, d && d.removeData(this.element, this.constructor.namespace);
        }, b.data = function(h) {
          h = o.getQueryElement(h);
          var S = h && h.outlayerGUID;
          return S && y[S];
        }, b.create = function(h, S) {
          var w = g(b);
          return w.defaults = o.extend({}, b.defaults), o.extend(w.defaults, S), w.compatOptions = o.extend({}, b.compatOptions), w.namespace = h, w.data = b.data, w.Item = g(l), o.htmlInit(w, h), d && d.bridget && d.bridget(h, w), w;
        };
        function g(h) {
          function S() {
            h.apply(this, arguments);
          }
          return S.prototype = Object.create(h.prototype), S.prototype.constructor = S, S;
        }
        var C = { ms: 1, s: 1e3 };
        function _(h) {
          if (typeof h == "number") return h;
          var S = h.match(/(^\d*\.?\d*)(\w*)/), w = S && S[1], A = S && S[2];
          if (!w.length) return 0;
          w = parseFloat(w);
          var L = C[A] || 1;
          return w * L;
        }
        return b.Item = l, b;
      });
    })(Ys)), Ys.exports;
  }
  var Zs = { exports: {} }, Sa;
  function lv() {
    return Sa || (Sa = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(Jn()) : (t.Isotope = t.Isotope || {}, t.Isotope.Item = i(t.Outlayer));
      })(window, function(i) {
        function n() {
          i.Item.apply(this, arguments);
        }
        var r = n.prototype = Object.create(i.Item.prototype), o = r._create;
        r._create = function() {
          this.id = this.layout.itemGUID++, o.call(this), this.sortData = {};
        }, r.updateSortData = function() {
          if (!this.isIgnored) {
            this.sortData.id = this.id, this.sortData["original-order"] = this.id, this.sortData.random = Math.random();
            var c = this.layout.options.getSortData, d = this.layout._sorters;
            for (var v in c) {
              var E = d[v];
              this.sortData[v] = E(this.element, this);
            }
          }
        };
        var l = r.destroy;
        return r.destroy = function() {
          l.apply(this, arguments), this.css({ display: "" });
        }, n;
      });
    })(Zs)), Zs.exports;
  }
  var Qs = { exports: {} }, Ta;
  function es() {
    return Ta || (Ta = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(on(), Jn()) : (t.Isotope = t.Isotope || {}, t.Isotope.LayoutMode = i(t.getSize, t.Outlayer));
      })(window, function(i, n) {
        function r(c) {
          this.isotope = c, c && (this.options = c.options[this.namespace], this.element = c.element, this.items = c.filteredItems, this.size = c.size);
        }
        var o = r.prototype, l = ["_resetLayout", "_getItemLayoutPosition", "_manageStamp", "_getContainerSize", "_getElementOffset", "needsResizeLayout", "_getOption"];
        return l.forEach(function(c) {
          o[c] = function() {
            return n.prototype[c].apply(this.isotope, arguments);
          };
        }), o.needsVerticalResizeLayout = function() {
          var c = i(this.isotope.element), d = this.isotope.size && c;
          return d && c.innerHeight != this.isotope.size.innerHeight;
        }, o._getMeasurement = function() {
          this.isotope._getMeasurement.apply(this, arguments);
        }, o.getColumnWidth = function() {
          this.getSegmentSize("column", "Width");
        }, o.getRowHeight = function() {
          this.getSegmentSize("row", "Height");
        }, o.getSegmentSize = function(c, d) {
          var v = c + d, E = "outer" + d;
          if (this._getMeasurement(v, E), !this[v]) {
            var y = this.getFirstItemSize();
            this[v] = y && y[E] || this.isotope.size["inner" + d];
          }
        }, o.getFirstItemSize = function() {
          var c = this.isotope.filteredItems[0];
          return c && c.element && i(c.element);
        }, o.layout = function() {
          this.isotope.layout.apply(this.isotope, arguments);
        }, o.getSize = function() {
          this.isotope.getSize(), this.size = this.isotope.size;
        }, r.modes = {}, r.create = function(c, d) {
          function v() {
            r.apply(this, arguments);
          }
          return v.prototype = Object.create(o), v.prototype.constructor = v, d && (v.options = d), v.prototype.namespace = c, r.modes[c] = v, v;
        }, r;
      });
    })(Qs)), Qs.exports;
  }
  var Js = { exports: {} }, er = { exports: {} };
  var _a;
  function cv() {
    return _a || (_a = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(Jn(), on()) : t.Masonry = i(t.Outlayer, t.getSize);
      })(window, function(i, n) {
        var r = i.create("masonry");
        r.compatOptions.fitWidth = "isFitWidth";
        var o = r.prototype;
        return o._resetLayout = function() {
          this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
          for (var l = 0; l < this.cols; l++) this.colYs.push(0);
          this.maxY = 0, this.horizontalColIndex = 0;
        }, o.measureColumns = function() {
          if (this.getContainerWidth(), !this.columnWidth) {
            var l = this.items[0], c = l && l.element;
            this.columnWidth = c && n(c).outerWidth || this.containerWidth;
          }
          var d = this.columnWidth += this.gutter, v = this.containerWidth + this.gutter, E = v / d, y = d - v % d, b = y && y < 1 ? "round" : "floor";
          E = Math[b](E), this.cols = Math.max(E, 1);
        }, o.getContainerWidth = function() {
          var l = this._getOption("fitWidth"), c = l ? this.element.parentNode : this.element, d = n(c);
          this.containerWidth = d && d.innerWidth;
        }, o._getItemLayoutPosition = function(l) {
          l.getSize();
          var c = l.size.outerWidth % this.columnWidth, d = c && c < 1 ? "round" : "ceil", v = Math[d](l.size.outerWidth / this.columnWidth);
          v = Math.min(v, this.cols);
          for (var E = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", y = this[E](v, l), b = { x: this.columnWidth * y.col, y: y.y }, p = y.y + l.size.outerHeight, g = v + y.col, C = y.col; C < g; C++) this.colYs[C] = p;
          return b;
        }, o._getTopColPosition = function(l) {
          var c = this._getTopColGroup(l), d = Math.min.apply(Math, c);
          return { col: c.indexOf(d), y: d };
        }, o._getTopColGroup = function(l) {
          if (l < 2) return this.colYs;
          for (var c = [], d = this.cols + 1 - l, v = 0; v < d; v++) c[v] = this._getColGroupY(v, l);
          return c;
        }, o._getColGroupY = function(l, c) {
          if (c < 2) return this.colYs[l];
          var d = this.colYs.slice(l, l + c);
          return Math.max.apply(Math, d);
        }, o._getHorizontalColPosition = function(l, c) {
          var d = this.horizontalColIndex % this.cols, v = l > 1 && d + l > this.cols;
          d = v ? 0 : d;
          var E = c.size.outerWidth && c.size.outerHeight;
          return this.horizontalColIndex = E ? d + l : this.horizontalColIndex, { col: d, y: this._getColGroupY(d, l) };
        }, o._manageStamp = function(l) {
          var c = n(l), d = this._getElementOffset(l), v = this._getOption("originLeft"), E = v ? d.left : d.right, y = E + c.outerWidth, b = Math.floor(E / this.columnWidth);
          b = Math.max(0, b);
          var p = Math.floor(y / this.columnWidth);
          p -= y % this.columnWidth ? 0 : 1, p = Math.min(this.cols - 1, p);
          for (var g = this._getOption("originTop"), C = (g ? d.top : d.bottom) + c.outerHeight, _ = b; _ <= p; _++) this.colYs[_] = Math.max(C, this.colYs[_]);
        }, o._getContainerSize = function() {
          this.maxY = Math.max.apply(Math, this.colYs);
          var l = { height: this.maxY };
          return this._getOption("fitWidth") && (l.width = this._getContainerFitWidth()), l;
        }, o._getContainerFitWidth = function() {
          for (var l = 0, c = this.cols; --c && this.colYs[c] === 0; ) l++;
          return (this.cols - l) * this.columnWidth - this.gutter;
        }, o.needsResizeLayout = function() {
          var l = this.containerWidth;
          return this.getContainerWidth(), l != this.containerWidth;
        }, r;
      });
    })(er)), er.exports;
  }
  var xa;
  function uv() {
    return xa || (xa = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(es(), cv()) : i(t.Isotope.LayoutMode, t.Masonry);
      })(window, function(i, n) {
        var r = i.create("masonry"), o = r.prototype, l = { _getElementOffset: true, layout: true, _getMeasurement: true };
        for (var c in n.prototype) l[c] || (o[c] = n.prototype[c]);
        var d = o.measureColumns;
        o.measureColumns = function() {
          this.items = this.isotope.filteredItems, d.call(this);
        };
        var v = o._getOption;
        return o._getOption = function(E) {
          return E == "fitWidth" ? this.options.isFitWidth !== void 0 ? this.options.isFitWidth : this.options.fitWidth : v.apply(this.isotope, arguments);
        }, r;
      });
    })(Js)), Js.exports;
  }
  var tr = { exports: {} }, Ca;
  function dv() {
    return Ca || (Ca = 1, (function(e, t) {
      (function(i, n) {
        e.exports = n(es());
      })(window, function(n) {
        var r = n.create("fitRows"), o = r.prototype;
        return o._resetLayout = function() {
          this.x = 0, this.y = 0, this.maxY = 0, this._getMeasurement("gutter", "outerWidth");
        }, o._getItemLayoutPosition = function(l) {
          l.getSize();
          var c = l.size.outerWidth + this.gutter, d = this.isotope.size.innerWidth + this.gutter;
          this.x !== 0 && c + this.x > d && (this.x = 0, this.y = this.maxY);
          var v = { x: this.x, y: this.y };
          return this.maxY = Math.max(this.maxY, this.y + l.size.outerHeight), this.x += c, v;
        }, o._getContainerSize = function() {
          return { height: this.maxY };
        }, r;
      });
    })(tr)), tr.exports;
  }
  var ir = { exports: {} }, wa;
  function fv() {
    return wa || (wa = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(es()) : i(t.Isotope.LayoutMode);
      })(window, function(i) {
        var n = i.create("vertical", { horizontalAlignment: 0 }), r = n.prototype;
        return r._resetLayout = function() {
          this.y = 0;
        }, r._getItemLayoutPosition = function(o) {
          o.getSize();
          var l = (this.isotope.size.innerWidth - o.size.outerWidth) * this.options.horizontalAlignment, c = this.y;
          return this.y += o.size.outerHeight, { x: l, y: c };
        }, r._getContainerSize = function() {
          return { height: this.y };
        }, n;
      });
    })(ir)), ir.exports;
  }
  var Ia;
  function hv() {
    return Ia || (Ia = 1, (function(e) {
      (function(t, i) {
        e.exports ? e.exports = i(t, Jn(), on(), jl(), Yl(), lv(), es(), uv(), dv(), fv()) : t.Isotope = i(t, t.Outlayer, t.getSize, t.matchesSelector, t.fizzyUIUtils, t.Isotope.Item, t.Isotope.LayoutMode);
      })(window, function(i, n, r, o, l, c, d) {
        var v = i.jQuery, E = String.prototype.trim ? function(_) {
          return _.trim();
        } : function(_) {
          return _.replace(/^\s+|\s+$/g, "");
        }, y = n.create("isotope", { layoutMode: "masonry", isJQueryFiltering: true, sortAscending: true });
        y.Item = c, y.LayoutMode = d;
        var b = y.prototype;
        b._create = function() {
          this.itemGUID = 0, this._sorters = {}, this._getSorters(), n.prototype._create.call(this), this.modes = {}, this.filteredItems = this.items, this.sortHistory = ["original-order"];
          for (var _ in d.modes) this._initLayoutMode(_);
        }, b.reloadItems = function() {
          this.itemGUID = 0, n.prototype.reloadItems.call(this);
        }, b._itemize = function() {
          for (var _ = n.prototype._itemize.apply(this, arguments), h = 0; h < _.length; h++) {
            var S = _[h];
            S.id = this.itemGUID++;
          }
          return this._updateItemsSortData(_), _;
        }, b._initLayoutMode = function(_) {
          var h = d.modes[_], S = this.options[_] || {};
          this.options[_] = h.options ? l.extend(h.options, S) : S, this.modes[_] = new h(this);
        }, b.layout = function() {
          if (!this._isLayoutInited && this._getOption("initLayout")) {
            this.arrange();
            return;
          }
          this._layout();
        }, b._layout = function() {
          var _ = this._getIsInstant();
          this._resetLayout(), this._manageStamps(), this.layoutItems(this.filteredItems, _), this._isLayoutInited = true;
        }, b.arrange = function(_) {
          this.option(_), this._getIsInstant();
          var h = this._filter(this.items);
          this.filteredItems = h.matches, this._bindArrangeComplete(), this._isInstant ? this._noTransition(this._hideReveal, [h]) : this._hideReveal(h), this._sort(), this._layout();
        }, b._init = b.arrange, b._hideReveal = function(_) {
          this.reveal(_.needReveal), this.hide(_.needHide);
        }, b._getIsInstant = function() {
          var _ = this._getOption("layoutInstant"), h = _ !== void 0 ? _ : !this._isLayoutInited;
          return this._isInstant = h, h;
        }, b._bindArrangeComplete = function() {
          var _, h, S, w = this;
          function A() {
            _ && h && S && w.dispatchEvent("arrangeComplete", null, [w.filteredItems]);
          }
          this.once("layoutComplete", function() {
            _ = true, A();
          }), this.once("hideComplete", function() {
            h = true, A();
          }), this.once("revealComplete", function() {
            S = true, A();
          });
        }, b._filter = function(_) {
          var h = this.options.filter;
          h = h || "*";
          for (var S = [], w = [], A = [], L = this._getFilterTest(h), f = 0; f < _.length; f++) {
            var P = _[f];
            if (!P.isIgnored) {
              var D = L(P);
              D && S.push(P), D && P.isHidden ? w.push(P) : !D && !P.isHidden && A.push(P);
            }
          }
          return { matches: S, needReveal: w, needHide: A };
        }, b._getFilterTest = function(_) {
          return v && this.options.isJQueryFiltering ? function(h) {
            return v(h.element).is(_);
          } : typeof _ == "function" ? function(h) {
            return _(h.element);
          } : function(h) {
            return o(h.element, _);
          };
        }, b.updateSortData = function(_) {
          var h;
          _ ? (_ = l.makeArray(_), h = this.getItems(_)) : h = this.items, this._getSorters(), this._updateItemsSortData(h);
        }, b._getSorters = function() {
          var _ = this.options.getSortData;
          for (var h in _) {
            var S = _[h];
            this._sorters[h] = p(S);
          }
        }, b._updateItemsSortData = function(_) {
          for (var h = _ && _.length, S = 0; h && S < h; S++) {
            var w = _[S];
            w.updateSortData();
          }
        };
        var p = /* @__PURE__ */ (function() {
          function _(S) {
            if (typeof S != "string") return S;
            var w = E(S).split(" "), A = w[0], L = A.match(/^\[(.+)\]$/), f = L && L[1], P = h(f, A), D = y.sortDataParsers[w[1]];
            return S = D ? function(R) {
              return R && D(P(R));
            } : function(R) {
              return R && P(R);
            }, S;
          }
          function h(S, w) {
            return S ? function(L) {
              return L.getAttribute(S);
            } : function(L) {
              var f = L.querySelector(w);
              return f && f.textContent;
            };
          }
          return _;
        })();
        y.sortDataParsers = { parseInt: function(_) {
          return parseInt(_, 10);
        }, parseFloat: function(_) {
          return parseFloat(_);
        } }, b._sort = function() {
          if (this.options.sortBy) {
            var _ = l.makeArray(this.options.sortBy);
            this._getIsSameSortBy(_) || (this.sortHistory = _.concat(this.sortHistory));
            var h = g(this.sortHistory, this.options.sortAscending);
            this.filteredItems.sort(h);
          }
        }, b._getIsSameSortBy = function(_) {
          for (var h = 0; h < _.length; h++) if (_[h] != this.sortHistory[h]) return false;
          return true;
        };
        function g(_, h) {
          return function(w, A) {
            for (var L = 0; L < _.length; L++) {
              var f = _[L], P = w.sortData[f], D = A.sortData[f];
              if (P > D || P < D) {
                var R = h[f] !== void 0 ? h[f] : h, N = R ? 1 : -1;
                return (P > D ? 1 : -1) * N;
              }
            }
            return 0;
          };
        }
        b._mode = function() {
          var _ = this.options.layoutMode, h = this.modes[_];
          if (!h) throw new Error("No layout mode: " + _);
          return h.options = this.options[_], h;
        }, b._resetLayout = function() {
          n.prototype._resetLayout.call(this), this._mode()._resetLayout();
        }, b._getItemLayoutPosition = function(_) {
          return this._mode()._getItemLayoutPosition(_);
        }, b._manageStamp = function(_) {
          this._mode()._manageStamp(_);
        }, b._getContainerSize = function() {
          return this._mode()._getContainerSize();
        }, b.needsResizeLayout = function() {
          return this._mode().needsResizeLayout();
        }, b.appended = function(_) {
          var h = this.addItems(_);
          if (h.length) {
            var S = this._filterRevealAdded(h);
            this.filteredItems = this.filteredItems.concat(S);
          }
        }, b.prepended = function(_) {
          var h = this._itemize(_);
          if (h.length) {
            this._resetLayout(), this._manageStamps();
            var S = this._filterRevealAdded(h);
            this.layoutItems(this.filteredItems), this.filteredItems = S.concat(this.filteredItems), this.items = h.concat(this.items);
          }
        }, b._filterRevealAdded = function(_) {
          var h = this._filter(_);
          return this.hide(h.needHide), this.reveal(h.matches), this.layoutItems(h.matches, true), h.matches;
        }, b.insert = function(_) {
          var h = this.addItems(_);
          if (h.length) {
            var S, w, A = h.length;
            for (S = 0; S < A; S++) w = h[S], this.element.appendChild(w.element);
            var L = this._filter(h).matches;
            for (S = 0; S < A; S++) h[S].isLayoutInstant = true;
            for (this.arrange(), S = 0; S < A; S++) delete h[S].isLayoutInstant;
            this.reveal(L);
          }
        };
        var C = b.remove;
        return b.remove = function(_) {
          _ = l.makeArray(_);
          var h = this.getItems(_);
          C.call(this, _);
          for (var S = h && h.length, w = 0; S && w < S; w++) {
            var A = h[w];
            l.removeFrom(this.filteredItems, A);
          }
        }, b.shuffle = function() {
          for (var _ = 0; _ < this.items.length; _++) {
            var h = this.items[_];
            h.sortData.random = Math.random();
          }
          this.options.sortBy = "random", this._sort(), this._layout();
        }, b._noTransition = function(_, h) {
          var S = this.options.transitionDuration;
          this.options.transitionDuration = 0;
          var w = _.apply(this, h);
          return this.options.transitionDuration = S, w;
        }, b.getFilteredItemElements = function() {
          return this.filteredItems.map(function(_) {
            return _.element;
          });
        }, y;
      });
    })(js)), js.exports;
  }
  var pv = hv();
  const Xl = rv(pv);
  window.jQuery && (function(e) {
    e.bridget = e.bridget || function(t, i) {
      e.fn[t] = function(n) {
        return this.each(function() {
          new i(this, n);
        });
      };
    }, e.bridget("isotope", Xl);
  })(window.jQuery);
  window.Isotope = Xl;
  var Rt = function() {
    return Rt = Object.assign || function(t) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
      }
      return t;
    }, Rt.apply(this, arguments);
  };
  function mv() {
    for (var e = 0, t = 0, i = arguments.length; t < i; t++) e += arguments[t].length;
    for (var n = Array(e), r = 0, t = 0; t < i; t++) for (var o = arguments[t], l = 0, c = o.length; l < c; l++, r++) n[r] = o[l];
    return n;
  }
  var me = { afterAppendSlide: "lgAfterAppendSlide", init: "lgInit", hasVideo: "lgHasVideo", containerResize: "lgContainerResize", updateSlides: "lgUpdateSlides", afterAppendSubHtml: "lgAfterAppendSubHtml", beforeOpen: "lgBeforeOpen", afterOpen: "lgAfterOpen", slideItemLoad: "lgSlideItemLoad", beforeSlide: "lgBeforeSlide", afterSlide: "lgAfterSlide", posterClick: "lgPosterClick", dragStart: "lgDragStart", dragMove: "lgDragMove", dragEnd: "lgDragEnd", beforeNextSlide: "lgBeforeNextSlide", beforePrevSlide: "lgBeforePrevSlide", beforeClose: "lgBeforeClose", afterClose: "lgAfterClose" }, gv = { mode: "lg-slide", easing: "ease", speed: 400, licenseKey: "0000-0000-000-0000", height: "100%", width: "100%", addClass: "", startClass: "lg-start-zoom", backdropDuration: 300, container: "", startAnimationDuration: 400, zoomFromOrigin: true, hideBarsDelay: 0, showBarsAfter: 1e4, slideDelay: 0, supportLegacyBrowser: true, allowMediaOverlap: false, videoMaxSize: "1280-720", loadYouTubePoster: true, defaultCaptionHeight: 0, ariaLabelledby: "", ariaDescribedby: "", resetScrollPosition: true, hideScrollbar: false, closable: true, swipeToClose: true, closeOnTap: true, showCloseIcon: true, showMaximizeIcon: false, loop: true, escKey: true, keyPress: true, trapFocus: true, controls: true, slideEndAnimation: true, hideControlOnEnd: false, mousewheel: false, getCaptionFromTitleOrAlt: true, appendSubHtmlTo: ".lg-sub-html", subHtmlSelectorRelative: false, preload: 2, numberOfSlideItemsInDom: 10, selector: "", selectWithin: "", nextHtml: "", prevHtml: "", index: 0, iframeWidth: "100%", iframeHeight: "100%", iframeMaxWidth: "100%", iframeMaxHeight: "100%", download: true, counter: true, appendCounterTo: ".lg-toolbar", swipeThreshold: 50, enableSwipe: true, enableDrag: true, dynamic: false, dynamicEl: [], extraProps: [], exThumbImage: "", isMobile: void 0, mobileSettings: { controls: false, showCloseIcon: false, download: false }, plugins: [], strings: { closeGallery: "Close gallery", toggleMaximize: "Toggle maximize", previousSlide: "Previous slide", nextSlide: "Next slide", download: "Download", playVideo: "Play video", mediaLoadingFailed: "Oops... Failed to load content..." } };
  function vv() {
    (function() {
      if (typeof window.CustomEvent == "function") return false;
      function e(t, i) {
        i = i || { bubbles: false, cancelable: false, detail: null };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(t, i.bubbles, i.cancelable, i.detail), n;
      }
      window.CustomEvent = e;
    })(), (function() {
      Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
    })();
  }
  var ql = (function() {
    function e(t) {
      return this.cssVenderPrefixes = ["TransitionDuration", "TransitionTimingFunction", "Transform", "Transition"], this.selector = this._getSelector(t), this.firstElement = this._getFirstEl(), this;
    }
    return e.generateUUID = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(t) {
        var i = Math.random() * 16 | 0, n = t == "x" ? i : i & 3 | 8;
        return n.toString(16);
      });
    }, e.prototype._getSelector = function(t, i) {
      if (i === void 0 && (i = document), typeof t != "string") return t;
      i = i || document;
      var n = t.substring(0, 1);
      return n === "#" ? i.querySelector(t) : i.querySelectorAll(t);
    }, e.prototype._each = function(t) {
      return this.selector ? (this.selector.length !== void 0 ? [].forEach.call(this.selector, t) : t(this.selector, 0), this) : this;
    }, e.prototype._setCssVendorPrefix = function(t, i, n) {
      var r = i.replace(/-([a-z])/gi, function(o, l) {
        return l.toUpperCase();
      });
      this.cssVenderPrefixes.indexOf(r) !== -1 ? (t.style[r.charAt(0).toLowerCase() + r.slice(1)] = n, t.style["webkit" + r] = n, t.style["moz" + r] = n, t.style["ms" + r] = n, t.style["o" + r] = n) : t.style[r] = n;
    }, e.prototype._getFirstEl = function() {
      return this.selector && this.selector.length !== void 0 ? this.selector[0] : this.selector;
    }, e.prototype.isEventMatched = function(t, i) {
      var n = i.split(".");
      return t.split(".").filter(function(r) {
        return r;
      }).every(function(r) {
        return n.indexOf(r) !== -1;
      });
    }, e.prototype.attr = function(t, i) {
      return i === void 0 ? this.firstElement ? this.firstElement.getAttribute(t) : "" : (this._each(function(n) {
        n.setAttribute(t, i);
      }), this);
    }, e.prototype.find = function(t) {
      return re(this._getSelector(t, this.selector));
    }, e.prototype.first = function() {
      return this.selector && this.selector.length !== void 0 ? re(this.selector[0]) : re(this.selector);
    }, e.prototype.eq = function(t) {
      return re(this.selector[t]);
    }, e.prototype.parent = function() {
      return re(this.selector.parentElement);
    }, e.prototype.get = function() {
      return this._getFirstEl();
    }, e.prototype.removeAttr = function(t) {
      var i = t.split(" ");
      return this._each(function(n) {
        i.forEach(function(r) {
          return n.removeAttribute(r);
        });
      }), this;
    }, e.prototype.wrap = function(t) {
      if (!this.firstElement) return this;
      var i = document.createElement("div");
      return i.className = t, this.firstElement.parentNode.insertBefore(i, this.firstElement), this.firstElement.parentNode.removeChild(this.firstElement), i.appendChild(this.firstElement), this;
    }, e.prototype.addClass = function(t) {
      return t === void 0 && (t = ""), this._each(function(i) {
        t.split(" ").forEach(function(n) {
          n && i.classList.add(n);
        });
      }), this;
    }, e.prototype.removeClass = function(t) {
      return this._each(function(i) {
        t.split(" ").forEach(function(n) {
          n && i.classList.remove(n);
        });
      }), this;
    }, e.prototype.hasClass = function(t) {
      return this.firstElement ? this.firstElement.classList.contains(t) : false;
    }, e.prototype.hasAttribute = function(t) {
      return this.firstElement ? this.firstElement.hasAttribute(t) : false;
    }, e.prototype.toggleClass = function(t) {
      return this.firstElement ? (this.hasClass(t) ? this.removeClass(t) : this.addClass(t), this) : this;
    }, e.prototype.css = function(t, i) {
      var n = this;
      return this._each(function(r) {
        n._setCssVendorPrefix(r, t, i);
      }), this;
    }, e.prototype.on = function(t, i) {
      var n = this;
      return this.selector ? (t.split(" ").forEach(function(r) {
        Array.isArray(e.eventListeners[r]) || (e.eventListeners[r] = []), e.eventListeners[r].push(i), n.selector.addEventListener(r.split(".")[0], i);
      }), this) : this;
    }, e.prototype.once = function(t, i) {
      var n = this;
      return this.on(t, function() {
        n.off(t), i(t);
      }), this;
    }, e.prototype.off = function(t) {
      var i = this;
      return this.selector ? (Object.keys(e.eventListeners).forEach(function(n) {
        i.isEventMatched(t, n) && (e.eventListeners[n].forEach(function(r) {
          i.selector.removeEventListener(n.split(".")[0], r);
        }), e.eventListeners[n] = []);
      }), this) : this;
    }, e.prototype.trigger = function(t, i) {
      if (!this.firstElement) return this;
      var n = new CustomEvent(t.split(".")[0], { detail: i || null });
      return this.firstElement.dispatchEvent(n), this;
    }, e.prototype.load = function(t) {
      var i = this;
      return fetch(t).then(function(n) {
        return n.text();
      }).then(function(n) {
        i.selector.innerHTML = n;
      }), this;
    }, e.prototype.html = function(t) {
      return t === void 0 ? this.firstElement ? this.firstElement.innerHTML : "" : (this._each(function(i) {
        i.innerHTML = t;
      }), this);
    }, e.prototype.append = function(t) {
      return this._each(function(i) {
        typeof t == "string" ? i.insertAdjacentHTML("beforeend", t) : i.appendChild(t);
      }), this;
    }, e.prototype.prepend = function(t) {
      return this._each(function(i) {
        typeof t == "string" ? i.insertAdjacentHTML("afterbegin", t) : t instanceof HTMLElement && i.insertBefore(t.cloneNode(true), i.firstChild);
      }), this;
    }, e.prototype.remove = function() {
      return this._each(function(t) {
        t.parentNode.removeChild(t);
      }), this;
    }, e.prototype.empty = function() {
      return this._each(function(t) {
        t.innerHTML = "";
      }), this;
    }, e.prototype.scrollTop = function(t) {
      return t !== void 0 ? (document.body.scrollTop = t, document.documentElement.scrollTop = t, this) : window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }, e.prototype.scrollLeft = function(t) {
      return t !== void 0 ? (document.body.scrollLeft = t, document.documentElement.scrollLeft = t, this) : window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    }, e.prototype.offset = function() {
      if (!this.firstElement) return { left: 0, top: 0 };
      var t = this.firstElement.getBoundingClientRect(), i = re("body").style().marginLeft;
      return { left: t.left - parseFloat(i) + this.scrollLeft(), top: t.top + this.scrollTop() };
    }, e.prototype.style = function() {
      return this.firstElement ? this.firstElement.currentStyle || window.getComputedStyle(this.firstElement) : {};
    }, e.prototype.width = function() {
      var t = this.style();
      return this.firstElement.clientWidth - parseFloat(t.paddingLeft) - parseFloat(t.paddingRight);
    }, e.prototype.height = function() {
      var t = this.style();
      return this.firstElement.clientHeight - parseFloat(t.paddingTop) - parseFloat(t.paddingBottom);
    }, e.eventListeners = {}, e;
  })();
  function re(e) {
    return vv(), new ql(e);
  }
  var yv = ["src", "sources", "subHtml", "subHtmlUrl", "html", "video", "poster", "slideName", "responsive", "srcset", "sizes", "iframe", "downloadUrl", "download", "width", "facebookShareUrl", "tweetText", "iframeTitle", "twitterShareUrl", "pinterestShareUrl", "pinterestText", "fbHtml", "disqusIdentifier", "disqusUrl"];
  function bv(e) {
    return e === "href" ? "src" : (e = e.replace("data-", ""), e = e.charAt(0).toLowerCase() + e.slice(1), e = e.replace(/-([a-z])/g, function(t) {
      return t[1].toUpperCase();
    }), e);
  }
  var Ae = { fetchCaptionFromUrl: function(e, t, i) {
    fetch(e).then(function(n) {
      return n.text();
    }).then(function(n) {
      if (i === "append") {
        var r = '<div class="lg-sub-html">' + n + "</div>";
        t.append(r);
      } else t.html(n);
    });
  }, getSize: function(e, t, i, n) {
    i === void 0 && (i = 0);
    var r = re(e), o = r.attr("data-lg-size") || n;
    if (o) {
      var l = o.split(",");
      if (l[1]) for (var c = window.innerWidth, d = 0; d < l.length; d++) {
        var v = l[d], E = parseInt(v.split("-")[2], 10);
        if (E > c) {
          o = v;
          break;
        }
        d === l.length - 1 && (o = v);
      }
      var y = o.split("-"), b = parseInt(y[0], 10), p = parseInt(y[1], 10), g = t.width(), C = t.height() - i, _ = Math.min(g, b), h = Math.min(C, p), S = Math.min(_ / b, h / p);
      return { width: b * S, height: p * S };
    }
  }, getTransform: function(e, t, i, n, r) {
    if (r) {
      var o = re(e).find("img").first();
      if (o.get()) {
        var l = t.get().getBoundingClientRect(), c = l.width, d = t.height() - (i + n), v = o.width(), E = o.height(), y = o.style(), b = (c - v) / 2 - o.offset().left + (parseFloat(y.paddingLeft) || 0) + (parseFloat(y.borderLeft) || 0) + re(window).scrollLeft() + l.left, p = (d - E) / 2 - o.offset().top + (parseFloat(y.paddingTop) || 0) + (parseFloat(y.borderTop) || 0) + re(window).scrollTop() + i, g = v / r.width, C = E / r.height, _ = "translate3d(" + (b *= -1) + "px, " + (p *= -1) + "px, 0) scale3d(" + g + ", " + C + ", 1)";
        return _;
      }
    }
  }, getIframeMarkup: function(e, t, i, n, r, o) {
    var l = o ? 'title="' + o + '"' : "";
    return '<div class="lg-media-cont lg-has-iframe" style="width:' + e + "; max-width:" + i + "; height: " + t + "; max-height:" + n + `">
                    <iframe class="lg-object" frameborder="0" ` + l + ' src="' + r + `"  allowfullscreen="true"></iframe>
                </div>`;
  }, getImgMarkup: function(e, t, i, n, r, o) {
    var l = n ? 'srcset="' + n + '"' : "", c = r ? 'sizes="' + r + '"' : "", d = "<img " + i + " " + l + "  " + c + ' class="lg-object lg-image" data-index="' + e + '" src="' + t + '" />', v = "";
    if (o) {
      var E = typeof o == "string" ? JSON.parse(o) : o;
      v = E.map(function(y) {
        var b = "";
        return Object.keys(y).forEach(function(p) {
          b += " " + p + '="' + y[p] + '"';
        }), "<source " + b + "></source>";
      });
    }
    return "" + v + d;
  }, getResponsiveSrc: function(e) {
    for (var t = [], i = [], n = "", r = 0; r < e.length; r++) {
      var o = e[r].split(" ");
      o[0] === "" && o.splice(0, 1), i.push(o[0]), t.push(o[1]);
    }
    for (var l = window.innerWidth, c = 0; c < t.length; c++) if (parseInt(t[c], 10) > l) {
      n = i[c];
      break;
    }
    return n;
  }, isImageLoaded: function(e) {
    return !(!e || !e.complete || e.naturalWidth === 0);
  }, getVideoPosterMarkup: function(e, t, i, n, r) {
    var o = "";
    r && r.youtube ? o = "lg-has-youtube" : r && r.vimeo ? o = "lg-has-vimeo" : o = "lg-has-html5";
    var l = t;
    return typeof t != "string" && (l = t.outerHTML), '<div class="lg-video-cont ' + o + '" style="' + i + `">
                <div class="lg-video-play-button">
                <svg
                    viewBox="0 0 20 20"
                    preserveAspectRatio="xMidYMid"
                    focusable="false"
                    aria-labelledby="` + n + `"
                    role="img"
                    class="lg-video-play-icon"
                >
                    <title>` + n + `</title>
                    <polygon class="lg-video-play-icon-inner" points="1,0 20,10 1,20"></polygon>
                </svg>
                <svg class="lg-video-play-icon-bg" viewBox="0 0 50 50" focusable="false">
                    <circle cx="50%" cy="50%" r="20"></circle></svg>
                <svg class="lg-video-play-icon-circle" viewBox="0 0 50 50" focusable="false">
                    <circle cx="50%" cy="50%" r="20"></circle>
                </svg>
            </div>
            ` + l + `
            <img class="lg-object lg-video-poster" src="` + e + `" />
        </div>`;
  }, getFocusableElements: function(e) {
    var t = e.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'), i = [].filter.call(t, function(n) {
      var r = window.getComputedStyle(n);
      return r.display !== "none" && r.visibility !== "hidden";
    });
    return i;
  }, getDynamicOptions: function(e, t, i, n) {
    var r = [], o = mv(yv, t);
    return [].forEach.call(e, function(l) {
      for (var c = {}, d = 0; d < l.attributes.length; d++) {
        var v = l.attributes[d];
        if (v.specified) {
          var E = bv(v.name), y = "";
          o.indexOf(E) > -1 && (y = E), y && (c[y] = v.value);
        }
      }
      var b = re(l), p = b.find("img").first().attr("alt"), g = b.attr("title"), C = n ? b.attr(n) : b.find("img").first().attr("src");
      c.thumb = C, i && !c.subHtml && (c.subHtml = g || p || ""), c.alt = p || g || "", r.push(c);
    }), r;
  }, isMobile: function() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }, isVideo: function(e, t, i) {
    if (!e) {
      if (t) return { html5: true };
      console.error("lightGallery :- data-src is not provided on slide item " + (i + 1) + ". Please make sure the selector property is properly configured. More info - https://www.lightgalleryjs.com/demos/html-markup/");
      return;
    }
    var n = e.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com|be-nocookie\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)([\&|?][\S]*)*/i), r = e.match(/\/\/(?:www\.)?(?:player\.)?vimeo.com\/(?:video\/)?([0-9a-z\-_]+)(.*)?/i), o = e.match(/https?:\/\/(.+)?(wistia\.com|wi\.st)\/(medias|embed)\/([0-9a-z\-_]+)(.*)/);
    if (n) return { youtube: n };
    if (r) return { vimeo: r };
    if (o) return { wistia: o };
  } }, Aa = 0, Ev = (function() {
    function e(t, i) {
      if (this.lgOpened = false, this.index = 0, this.plugins = [], this.lGalleryOn = false, this.lgBusy = false, this.currentItemsInDom = [], this.prevScrollTop = 0, this.bodyPaddingRight = 0, this.isDummyImageRemoved = false, this.dragOrSwipeEnabled = false, this.mediaContainerPosition = { top: 0, bottom: 0 }, !t) return this;
      if (Aa++, this.lgId = Aa, this.el = t, this.LGel = re(t), this.generateSettings(i), this.buildModules(), this.settings.dynamic && this.settings.dynamicEl !== void 0 && !Array.isArray(this.settings.dynamicEl)) throw "When using dynamic mode, you must also define dynamicEl as an Array.";
      return this.galleryItems = this.getItems(), this.normalizeSettings(), this.init(), this.validateLicense(), this;
    }
    return e.prototype.generateSettings = function(t) {
      if (this.settings = Rt(Rt({}, gv), t), this.settings.isMobile && typeof this.settings.isMobile == "function" ? this.settings.isMobile() : Ae.isMobile()) {
        var i = Rt(Rt({}, this.settings.mobileSettings), this.settings.mobileSettings);
        this.settings = Rt(Rt({}, this.settings), i);
      }
    }, e.prototype.normalizeSettings = function() {
      if (this.settings.slideEndAnimation && (this.settings.hideControlOnEnd = false), this.settings.closable || (this.settings.swipeToClose = false), this.zoomFromOrigin = this.settings.zoomFromOrigin, this.settings.dynamic && (this.zoomFromOrigin = false), this.settings.container) {
        var t = this.settings.container;
        if (typeof t == "function") this.settings.container = t();
        else if (typeof t == "string") {
          var i = document.querySelector(t);
          this.settings.container = i != null ? i : document.body;
        }
      } else this.settings.container = document.body;
      this.settings.preload = Math.min(this.settings.preload, this.galleryItems.length);
    }, e.prototype.init = function() {
      var t = this;
      this.addSlideVideoInfo(this.galleryItems), this.buildStructure(), this.LGel.trigger(me.init, { instance: this }), this.settings.keyPress && this.keyPress(), setTimeout(function() {
        t.enableDrag(), t.enableSwipe(), t.triggerPosterClick();
      }, 50), this.arrow(), this.settings.mousewheel && this.mousewheel(), this.settings.dynamic || this.openGalleryOnItemClick();
    }, e.prototype.openGalleryOnItemClick = function() {
      for (var t = this, i = function(o) {
        var l = n.items[o], c = re(l), d = ql.generateUUID();
        c.attr("data-lg-id", d).on("click.lgcustom-item-" + d, function(v) {
          v.preventDefault();
          var E = t.settings.index || o;
          t.openGallery(E, l);
        });
      }, n = this, r = 0; r < this.items.length; r++) i(r);
    }, e.prototype.buildModules = function() {
      var t = this;
      this.settings.plugins.forEach(function(i) {
        t.plugins.push(new i(t, re));
      });
    }, e.prototype.validateLicense = function() {
      this.settings.licenseKey ? this.settings.licenseKey === "0000-0000-000-0000" && console.warn("lightGallery: " + this.settings.licenseKey + " license key is not valid for production use") : console.error("Please provide a valid license key");
    }, e.prototype.getSlideItem = function(t) {
      return re(this.getSlideItemId(t));
    }, e.prototype.getSlideItemId = function(t) {
      return "#lg-item-" + this.lgId + "-" + t;
    }, e.prototype.getIdName = function(t) {
      return t + "-" + this.lgId;
    }, e.prototype.getElementById = function(t) {
      return re("#" + this.getIdName(t));
    }, e.prototype.manageSingleSlideClassName = function() {
      this.galleryItems.length < 2 ? this.outer.addClass("lg-single-item") : this.outer.removeClass("lg-single-item");
    }, e.prototype.buildStructure = function() {
      var t = this, i = this.$container && this.$container.get();
      if (!i) {
        var n = "", r = "";
        this.settings.controls && (n = '<button type="button" id="' + this.getIdName("lg-prev") + '" aria-label="' + this.settings.strings.previousSlide + '" class="lg-prev lg-icon"> ' + this.settings.prevHtml + ` </button>
                <button type="button" id="` + this.getIdName("lg-next") + '" aria-label="' + this.settings.strings.nextSlide + '" class="lg-next lg-icon"> ' + this.settings.nextHtml + " </button>"), this.settings.appendSubHtmlTo !== ".lg-item" && (r = '<div class="lg-sub-html" role="status" aria-live="polite"></div>');
        var o = "";
        this.settings.allowMediaOverlap && (o += "lg-media-overlap ");
        var l = this.settings.ariaLabelledby ? 'aria-labelledby="' + this.settings.ariaLabelledby + '"' : "", c = this.settings.ariaDescribedby ? 'aria-describedby="' + this.settings.ariaDescribedby + '"' : "", d = "lg-container " + this.settings.addClass + " " + (document.body !== this.settings.container ? "lg-inline" : ""), v = this.settings.closable && this.settings.showCloseIcon ? '<button type="button" aria-label="' + this.settings.strings.closeGallery + '" id="' + this.getIdName("lg-close") + '" class="lg-close lg-icon"></button>' : "", E = this.settings.showMaximizeIcon ? '<button type="button" aria-label="' + this.settings.strings.toggleMaximize + '" id="' + this.getIdName("lg-maximize") + '" class="lg-maximize lg-icon"></button>' : "", y = `
        <div class="` + d + '" id="' + this.getIdName("lg-container") + '" tabindex="-1" aria-modal="true" ' + l + " " + c + ` role="dialog"
        >
            <div id="` + this.getIdName("lg-backdrop") + `" class="lg-backdrop"></div>

            <div id="` + this.getIdName("lg-outer") + '" class="lg-outer lg-use-css3 lg-css3 lg-hide-items ' + o + ` ">

              <div id="` + this.getIdName("lg-content") + `" class="lg-content">
                <div id="` + this.getIdName("lg-inner") + `" class="lg-inner">
                </div>
                ` + n + `
              </div>
                <div id="` + this.getIdName("lg-toolbar") + `" class="lg-toolbar lg-group">
                    ` + E + `
                    ` + v + `
                    </div>
                    ` + (this.settings.appendSubHtmlTo === ".lg-outer" ? r : "") + `
                <div id="` + this.getIdName("lg-components") + `" class="lg-components">
                    ` + (this.settings.appendSubHtmlTo === ".lg-sub-html" ? r : "") + `
                </div>
            </div>
        </div>
        `;
        re(this.settings.container).append(y), document.body !== this.settings.container && re(this.settings.container).css("position", "relative"), this.outer = this.getElementById("lg-outer"), this.$lgComponents = this.getElementById("lg-components"), this.$backdrop = this.getElementById("lg-backdrop"), this.$container = this.getElementById("lg-container"), this.$inner = this.getElementById("lg-inner"), this.$content = this.getElementById("lg-content"), this.$toolbar = this.getElementById("lg-toolbar"), this.$backdrop.css("transition-duration", this.settings.backdropDuration + "ms");
        var b = this.settings.mode + " ";
        this.manageSingleSlideClassName(), this.settings.enableDrag && (b += "lg-grab "), this.outer.addClass(b), this.$inner.css("transition-timing-function", this.settings.easing), this.$inner.css("transition-duration", this.settings.speed + "ms"), this.settings.download && this.$toolbar.append('<a id="' + this.getIdName("lg-download") + '" target="_blank" rel="noopener" aria-label="' + this.settings.strings.download + '" download class="lg-download lg-icon"></a>'), this.counter(), re(window).on("resize.lg.global" + this.lgId + " orientationchange.lg.global" + this.lgId, function() {
          t.refreshOnResize();
        }), this.hideBars(), this.manageCloseGallery(), this.toggleMaximize(), this.initModules();
      }
    }, e.prototype.refreshOnResize = function() {
      if (this.lgOpened) {
        var t = this.galleryItems[this.index], i = t.__slideVideoInfo;
        this.mediaContainerPosition = this.getMediaContainerPosition();
        var n = this.mediaContainerPosition, r = n.top, o = n.bottom;
        if (this.currentImageSize = Ae.getSize(this.items[this.index], this.outer, r + o, i && this.settings.videoMaxSize), i && this.resizeVideoSlide(this.index, this.currentImageSize), this.zoomFromOrigin && !this.isDummyImageRemoved) {
          var l = this.getDummyImgStyles(this.currentImageSize);
          this.outer.find(".lg-current .lg-dummy-img").first().attr("style", l);
        }
        this.LGel.trigger(me.containerResize);
      }
    }, e.prototype.resizeVideoSlide = function(t, i) {
      var n = this.getVideoContStyle(i), r = this.getSlideItem(t);
      r.find(".lg-video-cont").attr("style", n);
    }, e.prototype.updateSlides = function(t, i) {
      if (this.index > t.length - 1 && (this.index = t.length - 1), t.length === 1 && (this.index = 0), !t.length) {
        this.closeGallery();
        return;
      }
      var n = this.galleryItems[i].src;
      this.galleryItems = t, this.updateControls(), this.$inner.empty(), this.currentItemsInDom = [];
      var r = 0;
      this.galleryItems.some(function(o, l) {
        return o.src === n ? (r = l, true) : false;
      }), this.currentItemsInDom = this.organizeSlideItems(r, -1), this.loadContent(r, true), this.getSlideItem(r).addClass("lg-current"), this.index = r, this.updateCurrentCounter(r), this.LGel.trigger(me.updateSlides);
    }, e.prototype.getItems = function() {
      if (this.items = [], this.settings.dynamic) return this.settings.dynamicEl || [];
      if (this.settings.selector === "this") this.items.push(this.el);
      else if (this.settings.selector) if (typeof this.settings.selector == "string") if (this.settings.selectWithin) {
        var t = re(this.settings.selectWithin);
        this.items = t.find(this.settings.selector).get();
      } else this.items = this.el.querySelectorAll(this.settings.selector);
      else this.items = this.settings.selector;
      else this.items = this.el.children;
      return Ae.getDynamicOptions(this.items, this.settings.extraProps, this.settings.getCaptionFromTitleOrAlt, this.settings.exThumbImage);
    }, e.prototype.shouldHideScrollbar = function() {
      return this.settings.hideScrollbar && document.body === this.settings.container;
    }, e.prototype.hideScrollbar = function() {
      if (this.shouldHideScrollbar()) {
        this.bodyPaddingRight = parseFloat(re("body").style().paddingRight);
        var t = document.documentElement.getBoundingClientRect(), i = window.innerWidth - t.width;
        re(document.body).css("padding-right", i + this.bodyPaddingRight + "px"), re(document.body).addClass("lg-overlay-open");
      }
    }, e.prototype.resetScrollBar = function() {
      this.shouldHideScrollbar() && (re(document.body).css("padding-right", this.bodyPaddingRight + "px"), re(document.body).removeClass("lg-overlay-open"));
    }, e.prototype.openGallery = function(t, i) {
      var n = this;
      if (t === void 0 && (t = this.settings.index), !this.lgOpened) {
        this.lgOpened = true, this.outer.removeClass("lg-hide-items"), this.hideScrollbar(), this.$container.addClass("lg-show");
        var r = this.getItemsToBeInsertedToDom(t, t);
        this.currentItemsInDom = r;
        var o = "";
        r.forEach(function(b) {
          o = o + ('<div id="' + b + '" class="lg-item"></div>');
        }), this.$inner.append(o), this.addHtml(t);
        var l = "";
        this.mediaContainerPosition = this.getMediaContainerPosition();
        var c = this.mediaContainerPosition, d = c.top, v = c.bottom;
        this.settings.allowMediaOverlap || this.setMediaContainerPosition(d, v);
        var E = this.galleryItems[t].__slideVideoInfo;
        this.zoomFromOrigin && i && (this.currentImageSize = Ae.getSize(i, this.outer, d + v, E && this.settings.videoMaxSize), l = Ae.getTransform(i, this.outer, d, v, this.currentImageSize)), (!this.zoomFromOrigin || !l) && (this.outer.addClass(this.settings.startClass), this.getSlideItem(t).removeClass("lg-complete"));
        var y = this.settings.zoomFromOrigin ? 100 : this.settings.backdropDuration;
        setTimeout(function() {
          n.outer.addClass("lg-components-open");
        }, y), this.index = t, this.LGel.trigger(me.beforeOpen), this.getSlideItem(t).addClass("lg-current"), this.lGalleryOn = false, this.prevScrollTop = re(window).scrollTop(), setTimeout(function() {
          if (n.zoomFromOrigin && l) {
            var b = n.getSlideItem(t);
            b.css("transform", l), setTimeout(function() {
              b.addClass("lg-start-progress lg-start-end-progress").css("transition-duration", n.settings.startAnimationDuration + "ms"), n.outer.addClass("lg-zoom-from-image");
            }), setTimeout(function() {
              b.css("transform", "translate3d(0, 0, 0)");
            }, 100);
          }
          setTimeout(function() {
            n.$backdrop.addClass("in"), n.$container.addClass("lg-show-in");
          }, 10), setTimeout(function() {
            n.settings.trapFocus && document.body === n.settings.container && n.trapFocus();
          }, n.settings.backdropDuration + 50), (!n.zoomFromOrigin || !l) && setTimeout(function() {
            n.outer.addClass("lg-visible");
          }, n.settings.backdropDuration), n.slide(t, false, false, false), n.LGel.trigger(me.afterOpen);
        }), document.body === this.settings.container && re("html").addClass("lg-on");
      }
    }, e.prototype.getMediaContainerPosition = function() {
      if (this.settings.allowMediaOverlap) return { top: 0, bottom: 0 };
      var t = this.$toolbar.get().clientHeight || 0, i = this.outer.find(".lg-components .lg-sub-html").get(), n = this.settings.defaultCaptionHeight || i && i.clientHeight || 0, r = this.outer.find(".lg-thumb-outer").get(), o = r ? r.clientHeight : 0, l = o + n;
      return { top: t, bottom: l };
    }, e.prototype.setMediaContainerPosition = function(t, i) {
      t === void 0 && (t = 0), i === void 0 && (i = 0), this.$content.css("top", t + "px").css("bottom", i + "px");
    }, e.prototype.hideBars = function() {
      var t = this;
      setTimeout(function() {
        t.outer.removeClass("lg-hide-items"), t.settings.hideBarsDelay > 0 && (t.outer.on("mousemove.lg click.lg touchstart.lg", function() {
          t.outer.removeClass("lg-hide-items"), clearTimeout(t.hideBarTimeout), t.hideBarTimeout = setTimeout(function() {
            t.outer.addClass("lg-hide-items");
          }, t.settings.hideBarsDelay);
        }), t.outer.trigger("mousemove.lg"));
      }, this.settings.showBarsAfter);
    }, e.prototype.initPictureFill = function(t) {
      if (this.settings.supportLegacyBrowser) try {
        picturefill({ elements: [t.get()] });
      } catch (i) {
        console.warn("lightGallery :- If you want srcset or picture tag to be supported for older browser please include picturefil javascript library in your document.");
      }
    }, e.prototype.counter = function() {
      if (this.settings.counter) {
        var t = `<div class="lg-counter" role="status" aria-live="polite">
                <span id="` + this.getIdName("lg-counter-current") + '" class="lg-counter-current">' + (this.index + 1) + ` </span> /
                <span id="` + this.getIdName("lg-counter-all") + '" class="lg-counter-all">' + this.galleryItems.length + " </span></div>";
        this.outer.find(this.settings.appendCounterTo).append(t);
      }
    }, e.prototype.addHtml = function(t) {
      var i, n;
      if (this.galleryItems[t].subHtmlUrl ? n = this.galleryItems[t].subHtmlUrl : i = this.galleryItems[t].subHtml, !n) if (i) {
        var r = i.substring(0, 1);
        if (r === "." || r === "#") try {
          this.settings.subHtmlSelectorRelative && !this.settings.dynamic ? i = re(this.items).eq(t).find(i).first().html() : i = re(i).first().html();
        } catch (l) {
          console.warn('Error processing subHtml selector "' + i + '"'), i = "";
        }
      } else i = "";
      if (this.settings.appendSubHtmlTo !== ".lg-item") n ? Ae.fetchCaptionFromUrl(n, this.outer.find(".lg-sub-html"), "replace") : this.outer.find(".lg-sub-html").html(i);
      else {
        var o = re(this.getSlideItemId(t));
        n ? Ae.fetchCaptionFromUrl(n, o, "append") : o.append('<div class="lg-sub-html">' + i + "</div>");
      }
      typeof i != "undefined" && i !== null && (i === "" ? this.outer.find(this.settings.appendSubHtmlTo).addClass("lg-empty-html") : this.outer.find(this.settings.appendSubHtmlTo).removeClass("lg-empty-html")), this.LGel.trigger(me.afterAppendSubHtml, { index: t });
    }, e.prototype.preload = function(t) {
      for (var i = 1; i <= this.settings.preload && !(i >= this.galleryItems.length - t); i++) this.loadContent(t + i, false);
      for (var n = 1; n <= this.settings.preload && !(t - n < 0); n++) this.loadContent(t - n, false);
    }, e.prototype.getDummyImgStyles = function(t) {
      return t ? "width:" + t.width + `px;
                margin-left: -` + t.width / 2 + `px;
                margin-top: -` + t.height / 2 + `px;
                height:` + t.height + "px" : "";
    }, e.prototype.getVideoContStyle = function(t) {
      return t ? "width:" + t.width + `px;
                height:` + t.height + "px" : "";
    }, e.prototype.getDummyImageContent = function(t, i, n) {
      var r;
      if (this.settings.dynamic || (r = re(this.items).eq(i)), r) {
        var o = void 0;
        if (this.settings.exThumbImage ? o = r.attr(this.settings.exThumbImage) : o = r.find("img").first().attr("src"), !o) return "";
        var l = this.getDummyImgStyles(this.currentImageSize), c = document.createElement("img");
        return c.alt = n || "", c.src = o, c.className = "lg-dummy-img", c.style.cssText = l, t.addClass("lg-first-slide"), this.outer.addClass("lg-first-slide-loading"), c;
      }
      return "";
    }, e.prototype.setImgMarkup = function(t, i, n) {
      var r = this.galleryItems[n], o = r.alt, l = r.srcset, c = r.sizes, d = r.sources, v = "", E = o ? 'alt="' + o + '"' : "";
      this.isFirstSlideWithZoomAnimation() ? v = this.getDummyImageContent(i, n, E) : v = Ae.getImgMarkup(n, t, E, l, c, d);
      var y = document.createElement("picture");
      y.className = "lg-img-wrap", re(y).append(v), i.prepend(y);
    }, e.prototype.onSlideObjectLoad = function(t, i, n, r) {
      var o = t.find(".lg-object").first();
      Ae.isImageLoaded(o.get()) || i ? n() : (o.on("load.lg error.lg", function() {
        n && n();
      }), o.on("error.lg", function() {
        r && r();
      }));
    }, e.prototype.onLgObjectLoad = function(t, i, n, r, o, l) {
      var c = this;
      this.onSlideObjectLoad(t, l, function() {
        c.triggerSlideItemLoad(t, i, n, r, o);
      }, function() {
        t.addClass("lg-complete lg-complete_"), t.html('<span class="lg-error-msg">' + c.settings.strings.mediaLoadingFailed + "</span>");
      });
    }, e.prototype.triggerSlideItemLoad = function(t, i, n, r, o) {
      var l = this, c = this.galleryItems[i], d = o && this.getSlideType(c) === "video" && !c.poster ? r : 0;
      setTimeout(function() {
        t.addClass("lg-complete lg-complete_"), l.LGel.trigger(me.slideItemLoad, { index: i, delay: n || 0, isFirstSlide: o });
      }, d);
    }, e.prototype.isFirstSlideWithZoomAnimation = function() {
      return !!(!this.lGalleryOn && this.zoomFromOrigin && this.currentImageSize);
    }, e.prototype.addSlideVideoInfo = function(t) {
      var i = this;
      t.forEach(function(n, r) {
        n.__slideVideoInfo = Ae.isVideo(n.src, !!n.video, r), n.__slideVideoInfo && i.settings.loadYouTubePoster && !n.poster && n.__slideVideoInfo.youtube && (n.poster = "//img.youtube.com/vi/" + n.__slideVideoInfo.youtube[1] + "/maxresdefault.jpg");
      });
    }, e.prototype.loadContent = function(t, i) {
      var n = this, r = this.galleryItems[t], o = re(this.getSlideItemId(t)), l = r.poster, c = r.srcset, d = r.sizes, v = r.sources, E = r.src, y = r.video, b = y && typeof y == "string" ? JSON.parse(y) : y;
      if (r.responsive) {
        var p = r.responsive.split(",");
        E = Ae.getResponsiveSrc(p) || E;
      }
      var g = r.__slideVideoInfo, C = "", _ = !!r.iframe, h = !this.lGalleryOn, S = 0;
      if (h && (this.zoomFromOrigin && this.currentImageSize ? S = this.settings.startAnimationDuration + 10 : S = this.settings.backdropDuration + 10), !o.hasClass("lg-loaded")) {
        if (g) {
          var w = this.mediaContainerPosition, A = w.top, L = w.bottom, f = Ae.getSize(this.items[t], this.outer, A + L, g && this.settings.videoMaxSize);
          C = this.getVideoContStyle(f);
        }
        if (_) {
          var P = Ae.getIframeMarkup(this.settings.iframeWidth, this.settings.iframeHeight, this.settings.iframeMaxWidth, this.settings.iframeMaxHeight, E, r.iframeTitle);
          o.prepend(P);
        } else if (l) {
          var D = "", R = h && this.zoomFromOrigin && this.currentImageSize;
          R && (D = this.getDummyImageContent(o, t, ""));
          var P = Ae.getVideoPosterMarkup(l, D || "", C, this.settings.strings.playVideo, g);
          o.prepend(P);
        } else if (g) {
          var P = '<div class="lg-video-cont " style="' + C + '"></div>';
          o.prepend(P);
        } else if (this.setImgMarkup(E, o, t), c || v) {
          var N = o.find(".lg-object");
          this.initPictureFill(N);
        }
        (l || g) && this.LGel.trigger(me.hasVideo, { index: t, src: E, html5Video: b, hasPoster: !!l }), this.LGel.trigger(me.afterAppendSlide, { index: t }), this.lGalleryOn && this.settings.appendSubHtmlTo === ".lg-item" && this.addHtml(t);
      }
      var $ = 0;
      S && !re(document.body).hasClass("lg-from-hash") && ($ = S), this.isFirstSlideWithZoomAnimation() && (setTimeout(function() {
        o.removeClass("lg-start-end-progress lg-start-progress").removeAttr("style");
      }, this.settings.startAnimationDuration + 100), o.hasClass("lg-loaded") || setTimeout(function() {
        if (n.getSlideType(r) === "image") {
          var B = r.alt, V = B ? 'alt="' + B + '"' : "";
          if (o.find(".lg-img-wrap").append(Ae.getImgMarkup(t, E, V, c, d, r.sources)), c || v) {
            var X = o.find(".lg-object");
            n.initPictureFill(X);
          }
        }
        (n.getSlideType(r) === "image" || n.getSlideType(r) === "video" && l) && (n.onLgObjectLoad(o, t, S, $, true, false), n.onSlideObjectLoad(o, !!(g && g.html5 && !l), function() {
          n.loadContentOnFirstSlideLoad(t, o, $);
        }, function() {
          n.loadContentOnFirstSlideLoad(t, o, $);
        }));
      }, this.settings.startAnimationDuration + 100)), o.addClass("lg-loaded"), (!this.isFirstSlideWithZoomAnimation() || this.getSlideType(r) === "video" && !l) && this.onLgObjectLoad(o, t, S, $, h, !!(g && g.html5 && !l)), (!this.zoomFromOrigin || !this.currentImageSize) && o.hasClass("lg-complete_") && !this.lGalleryOn && setTimeout(function() {
        o.addClass("lg-complete");
      }, this.settings.backdropDuration), this.lGalleryOn = true, i === true && (o.hasClass("lg-complete_") ? this.preload(t) : o.find(".lg-object").first().on("load.lg error.lg", function() {
        n.preload(t);
      }));
    }, e.prototype.loadContentOnFirstSlideLoad = function(t, i, n) {
      var r = this;
      setTimeout(function() {
        i.find(".lg-dummy-img").remove(), i.removeClass("lg-first-slide"), r.outer.removeClass("lg-first-slide-loading"), r.isDummyImageRemoved = true, r.preload(t);
      }, n + 300);
    }, e.prototype.getItemsToBeInsertedToDom = function(t, i, n) {
      var r = this;
      n === void 0 && (n = 0);
      var o = [], l = Math.max(n, 3);
      l = Math.min(l, this.galleryItems.length);
      var c = "lg-item-" + this.lgId + "-" + i;
      if (this.galleryItems.length <= 3) return this.galleryItems.forEach(function(E, y) {
        o.push("lg-item-" + r.lgId + "-" + y);
      }), o;
      if (t < (this.galleryItems.length - 1) / 2) {
        for (var d = t; d > t - l / 2 && d >= 0; d--) o.push("lg-item-" + this.lgId + "-" + d);
        for (var v = o.length, d = 0; d < l - v; d++) o.push("lg-item-" + this.lgId + "-" + (t + d + 1));
      } else {
        for (var d = t; d <= this.galleryItems.length - 1 && d < t + l / 2; d++) o.push("lg-item-" + this.lgId + "-" + d);
        for (var v = o.length, d = 0; d < l - v; d++) o.push("lg-item-" + this.lgId + "-" + (t - d - 1));
      }
      return this.settings.loop && (t === this.galleryItems.length - 1 ? o.push("lg-item-" + this.lgId + "-0") : t === 0 && o.push("lg-item-" + this.lgId + "-" + (this.galleryItems.length - 1))), o.indexOf(c) === -1 && o.push("lg-item-" + this.lgId + "-" + i), o;
    }, e.prototype.organizeSlideItems = function(t, i) {
      var n = this, r = this.getItemsToBeInsertedToDom(t, i, this.settings.numberOfSlideItemsInDom);
      return r.forEach(function(o) {
        n.currentItemsInDom.indexOf(o) === -1 && n.$inner.append('<div id="' + o + '" class="lg-item"></div>');
      }), this.currentItemsInDom.forEach(function(o) {
        r.indexOf(o) === -1 && re("#" + o).remove();
      }), r;
    }, e.prototype.getPreviousSlideIndex = function() {
      var t = 0;
      try {
        var i = this.outer.find(".lg-current").first().attr("id");
        t = parseInt(i.split("-")[3]) || 0;
      } catch (n) {
        t = 0;
      }
      return t;
    }, e.prototype.setDownloadValue = function(t) {
      if (this.settings.download) {
        var i = this.galleryItems[t], n = i.downloadUrl === false || i.downloadUrl === "false";
        if (n) this.outer.addClass("lg-hide-download");
        else {
          var r = this.getElementById("lg-download");
          this.outer.removeClass("lg-hide-download"), r.attr("href", i.downloadUrl || i.src), i.download && r.attr("download", i.download);
        }
      }
    }, e.prototype.makeSlideAnimation = function(t, i, n) {
      var r = this;
      this.lGalleryOn && n.addClass("lg-slide-progress"), setTimeout(function() {
        r.outer.addClass("lg-no-trans"), r.outer.find(".lg-item").removeClass("lg-prev-slide lg-next-slide"), t === "prev" ? (i.addClass("lg-prev-slide"), n.addClass("lg-next-slide")) : (i.addClass("lg-next-slide"), n.addClass("lg-prev-slide")), setTimeout(function() {
          r.outer.find(".lg-item").removeClass("lg-current"), i.addClass("lg-current"), r.outer.removeClass("lg-no-trans");
        }, 50);
      }, this.lGalleryOn ? this.settings.slideDelay : 0);
    }, e.prototype.slide = function(t, i, n, r) {
      var o = this, l = this.getPreviousSlideIndex();
      if (this.currentItemsInDom = this.organizeSlideItems(t, l), !(this.lGalleryOn && l === t)) {
        var c = this.galleryItems.length;
        if (!this.lgBusy) {
          this.settings.counter && this.updateCurrentCounter(t);
          var d = this.getSlideItem(t), v = this.getSlideItem(l), E = this.galleryItems[t], y = E.__slideVideoInfo;
          if (this.outer.attr("data-lg-slide-type", this.getSlideType(E)), this.setDownloadValue(t), y) {
            var b = this.mediaContainerPosition, p = b.top, g = b.bottom, C = Ae.getSize(this.items[t], this.outer, p + g, y && this.settings.videoMaxSize);
            this.resizeVideoSlide(t, C);
          }
          if (this.LGel.trigger(me.beforeSlide, { prevIndex: l, index: t, fromTouch: !!i, fromThumb: !!n }), this.lgBusy = true, clearTimeout(this.hideBarTimeout), this.arrowDisable(t), r || (t < l ? r = "prev" : t > l && (r = "next")), !i) this.makeSlideAnimation(r, d, v);
          else {
            this.outer.find(".lg-item").removeClass("lg-prev-slide lg-current lg-next-slide");
            var _ = void 0, h = void 0;
            c > 2 ? (_ = t - 1, h = t + 1, (t === 0 && l === c - 1 || t === c - 1 && l === 0) && (h = 0, _ = c - 1)) : (_ = 0, h = 1), r === "prev" ? this.getSlideItem(h).addClass("lg-next-slide") : this.getSlideItem(_).addClass("lg-prev-slide"), d.addClass("lg-current");
          }
          this.lGalleryOn ? setTimeout(function() {
            o.loadContent(t, true), o.settings.appendSubHtmlTo !== ".lg-item" && o.addHtml(t);
          }, this.settings.speed + 50 + (i ? 0 : this.settings.slideDelay)) : this.loadContent(t, true), setTimeout(function() {
            o.lgBusy = false, v.removeClass("lg-slide-progress"), o.LGel.trigger(me.afterSlide, { prevIndex: l, index: t, fromTouch: i, fromThumb: n });
          }, (this.lGalleryOn ? this.settings.speed + 100 : 100) + (i ? 0 : this.settings.slideDelay));
        }
        this.index = t;
      }
    }, e.prototype.updateCurrentCounter = function(t) {
      this.getElementById("lg-counter-current").html(t + 1 + "");
    }, e.prototype.updateCounterTotal = function() {
      this.getElementById("lg-counter-all").html(this.galleryItems.length + "");
    }, e.prototype.getSlideType = function(t) {
      return t.__slideVideoInfo ? "video" : t.iframe ? "iframe" : "image";
    }, e.prototype.touchMove = function(t, i, n) {
      var r = i.pageX - t.pageX, o = i.pageY - t.pageY, l = false;
      if (this.swipeDirection ? l = true : Math.abs(r) > 15 ? (this.swipeDirection = "horizontal", l = true) : Math.abs(o) > 15 && (this.swipeDirection = "vertical", l = true), !!l) {
        var c = this.getSlideItem(this.index);
        if (this.swipeDirection === "horizontal") {
          n == null || n.preventDefault(), this.outer.addClass("lg-dragging"), this.setTranslate(c, r, 0);
          var d = c.get().offsetWidth, v = d * 15 / 100, E = v - Math.abs(r * 10 / 100);
          this.setTranslate(this.outer.find(".lg-prev-slide").first(), -d + r - E, 0), this.setTranslate(this.outer.find(".lg-next-slide").first(), d + r + E, 0);
        } else if (this.swipeDirection === "vertical" && this.settings.swipeToClose) {
          n == null || n.preventDefault(), this.$container.addClass("lg-dragging-vertical");
          var y = 1 - Math.abs(o) / window.innerHeight;
          this.$backdrop.css("opacity", y);
          var b = 1 - Math.abs(o) / (window.innerWidth * 2);
          this.setTranslate(c, 0, o, b, b), Math.abs(o) > 100 && this.outer.addClass("lg-hide-items").removeClass("lg-components-open");
        }
      }
    }, e.prototype.touchEnd = function(t, i, n) {
      var r = this, o;
      this.settings.mode !== "lg-slide" && this.outer.addClass("lg-slide"), setTimeout(function() {
        r.$container.removeClass("lg-dragging-vertical"), r.outer.removeClass("lg-dragging lg-hide-items").addClass("lg-components-open");
        var l = true;
        if (r.swipeDirection === "horizontal") {
          o = t.pageX - i.pageX;
          var c = Math.abs(t.pageX - i.pageX);
          o < 0 && c > r.settings.swipeThreshold ? (r.goToNextSlide(true), l = false) : o > 0 && c > r.settings.swipeThreshold && (r.goToPrevSlide(true), l = false);
        } else if (r.swipeDirection === "vertical") if (o = Math.abs(t.pageY - i.pageY), r.settings.closable && r.settings.swipeToClose && o > 100) {
          r.closeGallery();
          return;
        } else r.$backdrop.css("opacity", 1);
        if (r.outer.find(".lg-item").removeAttr("style"), l && Math.abs(t.pageX - i.pageX) < 5) {
          var d = re(n.target);
          r.isPosterElement(d) && r.LGel.trigger(me.posterClick);
        }
        r.swipeDirection = void 0;
      }), setTimeout(function() {
        !r.outer.hasClass("lg-dragging") && r.settings.mode !== "lg-slide" && r.outer.removeClass("lg-slide");
      }, this.settings.speed + 100);
    }, e.prototype.enableSwipe = function() {
      var t = this, i = {}, n = {}, r = false, o = false;
      this.settings.enableSwipe && (this.$inner.on("touchstart.lg", function(l) {
        t.dragOrSwipeEnabled = true;
        var c = t.getSlideItem(t.index);
        (re(l.target).hasClass("lg-item") || c.get().contains(l.target)) && !t.outer.hasClass("lg-zoomed") && !t.lgBusy && l.touches.length === 1 && (o = true, t.touchAction = "swipe", t.manageSwipeClass(), i = { pageX: l.touches[0].pageX, pageY: l.touches[0].pageY });
      }), this.$inner.on("touchmove.lg", function(l) {
        o && t.touchAction === "swipe" && l.touches.length === 1 && (n = { pageX: l.touches[0].pageX, pageY: l.touches[0].pageY }, t.touchMove(i, n, l), r = true);
      }), this.$inner.on("touchend.lg", function(l) {
        if (t.touchAction === "swipe") {
          if (r) r = false, t.touchEnd(n, i, l);
          else if (o) {
            var c = re(l.target);
            t.isPosterElement(c) && t.LGel.trigger(me.posterClick);
          }
          t.touchAction = void 0, o = false;
        }
      }));
    }, e.prototype.enableDrag = function() {
      var t = this, i = {}, n = {}, r = false, o = false;
      this.settings.enableDrag && (this.outer.on("mousedown.lg", function(l) {
        t.dragOrSwipeEnabled = true;
        var c = t.getSlideItem(t.index);
        (re(l.target).hasClass("lg-item") || c.get().contains(l.target)) && !t.outer.hasClass("lg-zoomed") && !t.lgBusy && (l.preventDefault(), t.lgBusy || (t.manageSwipeClass(), i = { pageX: l.pageX, pageY: l.pageY }, r = true, t.outer.get().scrollLeft += 1, t.outer.get().scrollLeft -= 1, t.outer.removeClass("lg-grab").addClass("lg-grabbing"), t.LGel.trigger(me.dragStart)));
      }), re(window).on("mousemove.lg.global" + this.lgId, function(l) {
        r && t.lgOpened && (o = true, n = { pageX: l.pageX, pageY: l.pageY }, t.touchMove(i, n), t.LGel.trigger(me.dragMove));
      }), re(window).on("mouseup.lg.global" + this.lgId, function(l) {
        if (t.lgOpened) {
          var c = re(l.target);
          o ? (o = false, t.touchEnd(n, i, l), t.LGel.trigger(me.dragEnd)) : t.isPosterElement(c) && t.LGel.trigger(me.posterClick), r && (r = false, t.outer.removeClass("lg-grabbing").addClass("lg-grab"));
        }
      }));
    }, e.prototype.triggerPosterClick = function() {
      var t = this;
      this.$inner.on("click.lg", function(i) {
        !t.dragOrSwipeEnabled && t.isPosterElement(re(i.target)) && t.LGel.trigger(me.posterClick);
      });
    }, e.prototype.manageSwipeClass = function() {
      var t = this.index + 1, i = this.index - 1;
      this.settings.loop && this.galleryItems.length > 2 && (this.index === 0 ? i = this.galleryItems.length - 1 : this.index === this.galleryItems.length - 1 && (t = 0)), this.outer.find(".lg-item").removeClass("lg-next-slide lg-prev-slide"), i > -1 && this.getSlideItem(i).addClass("lg-prev-slide"), this.getSlideItem(t).addClass("lg-next-slide");
    }, e.prototype.goToNextSlide = function(t) {
      var i = this, n = this.settings.loop;
      t && this.galleryItems.length < 3 && (n = false), this.lgBusy || (this.index + 1 < this.galleryItems.length ? (this.index++, this.LGel.trigger(me.beforeNextSlide, { index: this.index }), this.slide(this.index, !!t, false, "next")) : n ? (this.index = 0, this.LGel.trigger(me.beforeNextSlide, { index: this.index }), this.slide(this.index, !!t, false, "next")) : this.settings.slideEndAnimation && !t && (this.outer.addClass("lg-right-end"), setTimeout(function() {
        i.outer.removeClass("lg-right-end");
      }, 400)));
    }, e.prototype.goToPrevSlide = function(t) {
      var i = this, n = this.settings.loop;
      t && this.galleryItems.length < 3 && (n = false), this.lgBusy || (this.index > 0 ? (this.index--, this.LGel.trigger(me.beforePrevSlide, { index: this.index, fromTouch: t }), this.slide(this.index, !!t, false, "prev")) : n ? (this.index = this.galleryItems.length - 1, this.LGel.trigger(me.beforePrevSlide, { index: this.index, fromTouch: t }), this.slide(this.index, !!t, false, "prev")) : this.settings.slideEndAnimation && !t && (this.outer.addClass("lg-left-end"), setTimeout(function() {
        i.outer.removeClass("lg-left-end");
      }, 400)));
    }, e.prototype.keyPress = function() {
      var t = this;
      re(window).on("keydown.lg.global" + this.lgId, function(i) {
        t.lgOpened && t.settings.escKey === true && i.keyCode === 27 && (i.preventDefault(), t.settings.allowMediaOverlap && t.outer.hasClass("lg-can-toggle") && t.outer.hasClass("lg-components-open") ? t.outer.removeClass("lg-components-open") : t.closeGallery()), t.lgOpened && t.galleryItems.length > 1 && (i.keyCode === 37 && (i.preventDefault(), t.goToPrevSlide()), i.keyCode === 39 && (i.preventDefault(), t.goToNextSlide()));
      });
    }, e.prototype.arrow = function() {
      var t = this;
      this.getElementById("lg-prev").on("click.lg", function() {
        t.goToPrevSlide();
      }), this.getElementById("lg-next").on("click.lg", function() {
        t.goToNextSlide();
      });
    }, e.prototype.arrowDisable = function(t) {
      if (!this.settings.loop && this.settings.hideControlOnEnd) {
        var i = this.getElementById("lg-prev"), n = this.getElementById("lg-next");
        t + 1 === this.galleryItems.length ? n.attr("disabled", "disabled").addClass("disabled") : n.removeAttr("disabled").removeClass("disabled"), t === 0 ? i.attr("disabled", "disabled").addClass("disabled") : i.removeAttr("disabled").removeClass("disabled");
      }
    }, e.prototype.setTranslate = function(t, i, n, r, o) {
      r === void 0 && (r = 1), o === void 0 && (o = 1), t.css("transform", "translate3d(" + i + "px, " + n + "px, 0px) scale3d(" + r + ", " + o + ", 1)");
    }, e.prototype.mousewheel = function() {
      var t = this, i = 0;
      this.outer.on("wheel.lg", function(n) {
        if (!(!n.deltaY || t.galleryItems.length < 2)) {
          n.preventDefault();
          var r = (/* @__PURE__ */ new Date()).getTime();
          r - i < 1e3 || (i = r, n.deltaY > 0 ? t.goToNextSlide() : n.deltaY < 0 && t.goToPrevSlide());
        }
      });
    }, e.prototype.isSlideElement = function(t) {
      return t.hasClass("lg-outer") || t.hasClass("lg-item") || t.hasClass("lg-img-wrap") || t.hasClass("lg-img-rotate");
    }, e.prototype.isPosterElement = function(t) {
      var i = this.getSlideItem(this.index).find(".lg-video-play-button").get();
      return t.hasClass("lg-video-poster") || t.hasClass("lg-video-play-button") || i && i.contains(t.get());
    }, e.prototype.toggleMaximize = function() {
      var t = this;
      this.getElementById("lg-maximize").on("click.lg", function() {
        t.$container.toggleClass("lg-inline"), t.refreshOnResize();
      });
    }, e.prototype.invalidateItems = function() {
      for (var t = 0; t < this.items.length; t++) {
        var i = this.items[t], n = re(i);
        n.off("click.lgcustom-item-" + n.attr("data-lg-id"));
      }
    }, e.prototype.trapFocus = function() {
      var t = this;
      this.$container.get().focus({ preventScroll: true }), re(window).on("keydown.lg.global" + this.lgId, function(i) {
        if (t.lgOpened) {
          var n = i.key === "Tab" || i.keyCode === 9;
          if (n) {
            var r = Ae.getFocusableElements(t.$container.get()), o = r[0], l = r[r.length - 1];
            i.shiftKey ? document.activeElement === o && (l.focus(), i.preventDefault()) : document.activeElement === l && (o.focus(), i.preventDefault());
          }
        }
      });
    }, e.prototype.manageCloseGallery = function() {
      var t = this;
      if (this.settings.closable) {
        var i = false;
        this.getElementById("lg-close").on("click.lg", function() {
          t.closeGallery();
        }), this.settings.closeOnTap && (this.outer.on("mousedown.lg", function(n) {
          var r = re(n.target);
          t.isSlideElement(r) ? i = true : i = false;
        }), this.outer.on("mousemove.lg", function() {
          i = false;
        }), this.outer.on("mouseup.lg", function(n) {
          var r = re(n.target);
          t.isSlideElement(r) && i && (t.outer.hasClass("lg-dragging") || t.closeGallery());
        }));
      }
    }, e.prototype.closeGallery = function(t) {
      var i = this;
      if (!this.lgOpened || !this.settings.closable && !t) return 0;
      this.LGel.trigger(me.beforeClose), this.settings.resetScrollPosition && !this.settings.hideScrollbar && re(window).scrollTop(this.prevScrollTop);
      var n = this.items[this.index], r;
      if (this.zoomFromOrigin && n) {
        var o = this.mediaContainerPosition, l = o.top, c = o.bottom, d = this.galleryItems[this.index], v = d.__slideVideoInfo, E = d.poster, y = Ae.getSize(n, this.outer, l + c, v && E && this.settings.videoMaxSize);
        r = Ae.getTransform(n, this.outer, l, c, y);
      }
      this.zoomFromOrigin && r ? (this.outer.addClass("lg-closing lg-zoom-from-image"), this.getSlideItem(this.index).addClass("lg-start-end-progress").css("transition-duration", this.settings.startAnimationDuration + "ms").css("transform", r)) : (this.outer.addClass("lg-hide-items"), this.outer.removeClass("lg-zoom-from-image")), this.destroyModules(), this.lGalleryOn = false, this.isDummyImageRemoved = false, this.zoomFromOrigin = this.settings.zoomFromOrigin, clearTimeout(this.hideBarTimeout), this.hideBarTimeout = false, re("html").removeClass("lg-on"), this.outer.removeClass("lg-visible lg-components-open"), this.$backdrop.removeClass("in").css("opacity", 0);
      var b = this.zoomFromOrigin && r ? Math.max(this.settings.startAnimationDuration, this.settings.backdropDuration) : this.settings.backdropDuration;
      return this.$container.removeClass("lg-show-in"), setTimeout(function() {
        i.zoomFromOrigin && r && i.outer.removeClass("lg-zoom-from-image"), i.$container.removeClass("lg-show"), i.resetScrollBar(), i.$backdrop.removeAttr("style").css("transition-duration", i.settings.backdropDuration + "ms"), i.outer.removeClass("lg-closing " + i.settings.startClass), i.getSlideItem(i.index).removeClass("lg-start-end-progress"), i.$inner.empty(), i.lgOpened && i.LGel.trigger(me.afterClose, { instance: i }), i.$container.get() && i.$container.get().blur(), i.lgOpened = false;
      }, b + 100), b + 100;
    }, e.prototype.initModules = function() {
      this.plugins.forEach(function(t) {
        try {
          t.init();
        } catch (i) {
          console.warn("lightGallery:- make sure lightGallery module is properly initiated");
        }
      });
    }, e.prototype.destroyModules = function(t) {
      this.plugins.forEach(function(i) {
        try {
          t ? i.destroy() : i.closeGallery && i.closeGallery();
        } catch (n) {
          console.warn("lightGallery:- make sure lightGallery module is properly destroyed");
        }
      });
    }, e.prototype.refresh = function(t) {
      this.settings.dynamic || this.invalidateItems(), t ? this.galleryItems = t : this.galleryItems = this.getItems(), this.updateControls(), this.openGalleryOnItemClick(), this.LGel.trigger(me.updateSlides);
    }, e.prototype.updateControls = function() {
      this.addSlideVideoInfo(this.galleryItems), this.updateCounterTotal(), this.manageSingleSlideClassName();
    }, e.prototype.destroyGallery = function() {
      this.destroyModules(true), this.settings.dynamic || this.invalidateItems(), re(window).off(".lg.global" + this.lgId), this.LGel.off(".lg"), this.$container.remove();
    }, e.prototype.destroy = function() {
      var t = this.closeGallery(true);
      return t ? setTimeout(this.destroyGallery.bind(this), t) : this.destroyGallery(), t;
    }, e;
  })();
  function Sv(e, t) {
    return new Ev(e, t);
  }
  var Bn = function() {
    return Bn = Object.assign || function(t) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
      }
      return t;
    }, Bn.apply(this, arguments);
  }, Tv = { thumbnail: true, animateThumb: true, currentPagerPosition: "middle", alignThumbnails: "middle", thumbWidth: 100, thumbHeight: "80px", thumbMargin: 5, appendThumbnailsTo: ".lg-components", toggleThumb: false, enableThumbDrag: true, enableThumbSwipe: true, thumbnailSwipeThreshold: 10, loadYouTubeThumbnail: true, youTubeThumbSize: 1, thumbnailPluginStrings: { toggleThumbnails: "Toggle thumbnails" } }, Yi = { containerResize: "lgContainerResize", updateSlides: "lgUpdateSlides", beforeOpen: "lgBeforeOpen", beforeSlide: "lgBeforeSlide" }, _v = (function() {
    function e(t, i) {
      return this.thumbOuterWidth = 0, this.thumbTotalWidth = 0, this.translateX = 0, this.thumbClickable = false, this.core = t, this.$LG = i, this;
    }
    return e.prototype.init = function() {
      this.settings = Bn(Bn({}, Tv), this.core.settings), this.thumbOuterWidth = 0, this.thumbTotalWidth = this.core.galleryItems.length * (this.settings.thumbWidth + this.settings.thumbMargin), this.translateX = 0, this.setAnimateThumbStyles(), this.core.settings.allowMediaOverlap || (this.settings.toggleThumb = false), this.settings.thumbnail && (this.build(), this.settings.animateThumb ? (this.settings.enableThumbDrag && this.enableThumbDrag(), this.settings.enableThumbSwipe && this.enableThumbSwipe(), this.thumbClickable = false) : this.thumbClickable = true, this.toggleThumbBar(), this.thumbKeyPress());
    }, e.prototype.build = function() {
      var t = this;
      this.setThumbMarkup(), this.manageActiveClassOnSlideChange(), this.$lgThumb.first().on("click.lg touchend.lg", function(i) {
        var n = t.$LG(i.target);
        n.hasAttribute("data-lg-item-id") && setTimeout(function() {
          if (t.thumbClickable && !t.core.lgBusy) {
            var r = parseInt(n.attr("data-lg-item-id"));
            t.core.slide(r, false, true, false);
          }
        }, 50);
      }), this.core.LGel.on(Yi.beforeSlide + ".thumb", function(i) {
        var n = i.detail.index;
        t.animateThumb(n);
      }), this.core.LGel.on(Yi.beforeOpen + ".thumb", function() {
        t.thumbOuterWidth = t.core.outer.get().offsetWidth;
      }), this.core.LGel.on(Yi.updateSlides + ".thumb", function() {
        t.rebuildThumbnails();
      }), this.core.LGel.on(Yi.containerResize + ".thumb", function() {
        t.core.lgOpened && setTimeout(function() {
          t.thumbOuterWidth = t.core.outer.get().offsetWidth, t.animateThumb(t.core.index), t.thumbOuterWidth = t.core.outer.get().offsetWidth;
        }, 50);
      });
    }, e.prototype.setThumbMarkup = function() {
      var t = "lg-thumb-outer ";
      this.settings.alignThumbnails && (t += "lg-thumb-align-" + this.settings.alignThumbnails);
      var i = '<div class="' + t + `">
        <div class="lg-thumb lg-group">
        </div>
        </div>`;
      this.core.outer.addClass("lg-has-thumb"), this.settings.appendThumbnailsTo === ".lg-components" ? this.core.$lgComponents.append(i) : this.core.outer.append(i), this.$thumbOuter = this.core.outer.find(".lg-thumb-outer").first(), this.$lgThumb = this.core.outer.find(".lg-thumb").first(), this.settings.animateThumb && this.core.outer.find(".lg-thumb").css("transition-duration", this.core.settings.speed + "ms").css("width", this.thumbTotalWidth + "px").css("position", "relative"), this.setThumbItemHtml(this.core.galleryItems);
    }, e.prototype.enableThumbDrag = function() {
      var t = this, i = { cords: { startX: 0, endX: 0 }, isMoved: false, newTranslateX: 0, startTime: /* @__PURE__ */ new Date(), endTime: /* @__PURE__ */ new Date(), touchMoveTime: 0 }, n = false;
      this.$thumbOuter.addClass("lg-grab"), this.core.outer.find(".lg-thumb").first().on("mousedown.lg.thumb", function(r) {
        t.thumbTotalWidth > t.thumbOuterWidth && (r.preventDefault(), i.cords.startX = r.pageX, i.startTime = /* @__PURE__ */ new Date(), t.thumbClickable = false, n = true, t.core.outer.get().scrollLeft += 1, t.core.outer.get().scrollLeft -= 1, t.$thumbOuter.removeClass("lg-grab").addClass("lg-grabbing"));
      }), this.$LG(window).on("mousemove.lg.thumb.global" + this.core.lgId, function(r) {
        t.core.lgOpened && n && (i.cords.endX = r.pageX, i = t.onThumbTouchMove(i));
      }), this.$LG(window).on("mouseup.lg.thumb.global" + this.core.lgId, function() {
        t.core.lgOpened && (i.isMoved ? i = t.onThumbTouchEnd(i) : t.thumbClickable = true, n && (n = false, t.$thumbOuter.removeClass("lg-grabbing").addClass("lg-grab")));
      });
    }, e.prototype.enableThumbSwipe = function() {
      var t = this, i = { cords: { startX: 0, endX: 0 }, isMoved: false, newTranslateX: 0, startTime: /* @__PURE__ */ new Date(), endTime: /* @__PURE__ */ new Date(), touchMoveTime: 0 };
      this.$lgThumb.on("touchstart.lg", function(n) {
        t.thumbTotalWidth > t.thumbOuterWidth && (n.preventDefault(), i.cords.startX = n.targetTouches[0].pageX, t.thumbClickable = false, i.startTime = /* @__PURE__ */ new Date());
      }), this.$lgThumb.on("touchmove.lg", function(n) {
        t.thumbTotalWidth > t.thumbOuterWidth && (n.preventDefault(), i.cords.endX = n.targetTouches[0].pageX, i = t.onThumbTouchMove(i));
      }), this.$lgThumb.on("touchend.lg", function() {
        i.isMoved ? i = t.onThumbTouchEnd(i) : t.thumbClickable = true;
      });
    }, e.prototype.rebuildThumbnails = function() {
      var t = this;
      this.$thumbOuter.addClass("lg-rebuilding-thumbnails"), setTimeout(function() {
        t.thumbTotalWidth = t.core.galleryItems.length * (t.settings.thumbWidth + t.settings.thumbMargin), t.$lgThumb.css("width", t.thumbTotalWidth + "px"), t.$lgThumb.empty(), t.setThumbItemHtml(t.core.galleryItems), t.animateThumb(t.core.index);
      }, 50), setTimeout(function() {
        t.$thumbOuter.removeClass("lg-rebuilding-thumbnails");
      }, 200);
    }, e.prototype.setTranslate = function(t) {
      this.$lgThumb.css("transform", "translate3d(-" + t + "px, 0px, 0px)");
    }, e.prototype.getPossibleTransformX = function(t) {
      return t > this.thumbTotalWidth - this.thumbOuterWidth && (t = this.thumbTotalWidth - this.thumbOuterWidth), t < 0 && (t = 0), t;
    }, e.prototype.animateThumb = function(t) {
      if (this.$lgThumb.css("transition-duration", this.core.settings.speed + "ms"), this.settings.animateThumb) {
        var i = 0;
        switch (this.settings.currentPagerPosition) {
          case "left":
            i = 0;
            break;
          case "middle":
            i = this.thumbOuterWidth / 2 - this.settings.thumbWidth / 2;
            break;
          case "right":
            i = this.thumbOuterWidth - this.settings.thumbWidth;
        }
        this.translateX = (this.settings.thumbWidth + this.settings.thumbMargin) * t - 1 - i, this.translateX > this.thumbTotalWidth - this.thumbOuterWidth && (this.translateX = this.thumbTotalWidth - this.thumbOuterWidth), this.translateX < 0 && (this.translateX = 0), this.setTranslate(this.translateX);
      }
    }, e.prototype.onThumbTouchMove = function(t) {
      return t.newTranslateX = this.translateX, t.isMoved = true, t.touchMoveTime = (/* @__PURE__ */ new Date()).valueOf(), t.newTranslateX -= t.cords.endX - t.cords.startX, t.newTranslateX = this.getPossibleTransformX(t.newTranslateX), this.setTranslate(t.newTranslateX), this.$thumbOuter.addClass("lg-dragging"), t;
    }, e.prototype.onThumbTouchEnd = function(t) {
      t.isMoved = false, t.endTime = /* @__PURE__ */ new Date(), this.$thumbOuter.removeClass("lg-dragging");
      var i = t.endTime.valueOf() - t.startTime.valueOf(), n = t.cords.endX - t.cords.startX, r = Math.abs(n) / i;
      return r > 0.15 && t.endTime.valueOf() - t.touchMoveTime < 30 ? (r += 1, r > 2 && (r += 1), r = r + r * (Math.abs(n) / this.thumbOuterWidth), this.$lgThumb.css("transition-duration", Math.min(r - 1, 2) + "settings"), n = n * r, this.translateX = this.getPossibleTransformX(this.translateX - n), this.setTranslate(this.translateX)) : this.translateX = t.newTranslateX, Math.abs(t.cords.endX - t.cords.startX) < this.settings.thumbnailSwipeThreshold && (this.thumbClickable = true), t;
    }, e.prototype.getThumbHtml = function(t, i, n) {
      var r = this.core.galleryItems[i].__slideVideoInfo || {}, o;
      r.youtube && this.settings.loadYouTubeThumbnail ? o = "//img.youtube.com/vi/" + r.youtube[1] + "/" + this.settings.youTubeThumbSize + ".jpg" : o = t;
      var l = document.createElement("div");
      l.setAttribute("data-lg-item-id", i + ""), l.className = "lg-thumb-item " + (i === this.core.index ? "active" : ""), l.style.cssText = "width: " + this.settings.thumbWidth + "px; height: " + this.settings.thumbHeight + "; margin-right: " + this.settings.thumbMargin + "px;";
      var c = document.createElement("img");
      return c.alt = n || "", c.setAttribute("data-lg-item-id", i + ""), c.src = o, l.appendChild(c), l;
    }, e.prototype.setThumbItemHtml = function(t) {
      for (var i = 0; i < t.length; i++) {
        var n = this.getThumbHtml(t[i].thumb, i, t[i].alt);
        this.$lgThumb.append(n);
      }
    }, e.prototype.setAnimateThumbStyles = function() {
      this.settings.animateThumb && this.core.outer.addClass("lg-animate-thumb");
    }, e.prototype.manageActiveClassOnSlideChange = function() {
      var t = this;
      this.core.LGel.on(Yi.beforeSlide + ".thumb", function(i) {
        var n = t.core.outer.find(".lg-thumb-item"), r = i.detail.index;
        n.removeClass("active"), n.eq(r).addClass("active");
      });
    }, e.prototype.toggleThumbBar = function() {
      var t = this;
      this.settings.toggleThumb && (this.core.outer.addClass("lg-can-toggle"), this.core.$toolbar.append('<button type="button" aria-label="' + this.settings.thumbnailPluginStrings.toggleThumbnails + '" class="lg-toggle-thumb lg-icon"></button>'), this.core.outer.find(".lg-toggle-thumb").first().on("click.lg", function() {
        t.core.outer.toggleClass("lg-components-open");
      }));
    }, e.prototype.thumbKeyPress = function() {
      var t = this;
      this.$LG(window).on("keydown.lg.thumb.global" + this.core.lgId, function(i) {
        !t.core.lgOpened || !t.settings.toggleThumb || (i.keyCode === 38 ? (i.preventDefault(), t.core.outer.addClass("lg-components-open")) : i.keyCode === 40 && (i.preventDefault(), t.core.outer.removeClass("lg-components-open")));
      });
    }, e.prototype.destroy = function() {
      this.settings.thumbnail && (this.$LG(window).off(".lg.thumb.global" + this.core.lgId), this.core.LGel.off(".lg.thumb"), this.core.LGel.off(".thumb"), this.$thumbOuter.remove(), this.core.outer.removeClass("lg-has-thumb"));
    }, e;
  })();
  var Vn = function() {
    return Vn = Object.assign || function(t) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
      }
      return t;
    }, Vn.apply(this, arguments);
  }, xv = { scale: 1, zoom: true, infiniteZoom: true, actualSize: true, showZoomInOutIcons: false, actualSizeIcons: { zoomIn: "lg-zoom-in", zoomOut: "lg-zoom-out" }, enableZoomAfter: 300, zoomPluginStrings: { zoomIn: "Zoom in", zoomOut: "Zoom out", viewActualSize: "View actual size" } }, _t = { containerResize: "lgContainerResize", beforeOpen: "lgBeforeOpen", afterOpen: "lgAfterOpen", slideItemLoad: "lgSlideItemLoad", afterSlide: "lgAfterSlide", rotateLeft: "lgRotateLeft", rotateRight: "lgRotateRight", flipHorizontal: "lgFlipHorizontal", flipVertical: "lgFlipVertical" }, nr = 500, Cv = (function() {
    function e(t, i) {
      return this.core = t, this.$LG = i, this.settings = Vn(Vn({}, xv), this.core.settings), this;
    }
    return e.prototype.buildTemplates = function() {
      var t = this.settings.showZoomInOutIcons ? '<button id="' + this.core.getIdName("lg-zoom-in") + '" type="button" aria-label="' + this.settings.zoomPluginStrings.zoomIn + '" class="lg-zoom-in lg-icon"></button><button id="' + this.core.getIdName("lg-zoom-out") + '" type="button" aria-label="' + this.settings.zoomPluginStrings.zoomOut + '" class="lg-zoom-out lg-icon"></button>' : "";
      this.settings.actualSize && (t += '<button id="' + this.core.getIdName("lg-actual-size") + '" type="button" aria-label="' + this.settings.zoomPluginStrings.viewActualSize + '" class="' + this.settings.actualSizeIcons.zoomIn + ' lg-icon"></button>'), this.core.outer.addClass("lg-use-transition-for-zoom"), this.core.$toolbar.first().append(t);
    }, e.prototype.enableZoom = function(t) {
      var i = this, n = this.settings.enableZoomAfter + t.detail.delay;
      this.$LG("body").first().hasClass("lg-from-hash") && t.detail.delay ? n = 0 : this.$LG("body").first().removeClass("lg-from-hash"), this.zoomableTimeout = setTimeout(function() {
        i.isImageSlide(i.core.index) && (i.core.getSlideItem(t.detail.index).addClass("lg-zoomable"), t.detail.index === i.core.index && i.setZoomEssentials());
      }, n + 30);
    }, e.prototype.enableZoomOnSlideItemLoad = function() {
      this.core.LGel.on(_t.slideItemLoad + ".zoom", this.enableZoom.bind(this));
    }, e.prototype.getDragCords = function(t) {
      return { x: t.pageX, y: t.pageY };
    }, e.prototype.getSwipeCords = function(t) {
      var i = t.touches[0].pageX, n = t.touches[0].pageY;
      return { x: i, y: n };
    }, e.prototype.getDragAllowedAxises = function(t, i) {
      if (!this.containerRect) return { allowX: false, allowY: false };
      var n = this.core.getSlideItem(this.core.index).find(".lg-image").first().get(), r = 0, o = 0, l = n.getBoundingClientRect();
      t ? (r = n.offsetHeight * t, o = n.offsetWidth * t) : i ? (r = l.height + i * l.height, o = l.width + i * l.width) : (r = l.height, o = l.width);
      var c = r > this.containerRect.height, d = o > this.containerRect.width;
      return { allowX: d, allowY: c };
    }, e.prototype.setZoomEssentials = function() {
      this.containerRect = this.core.$content.get().getBoundingClientRect();
    }, e.prototype.zoomImage = function(t, i, n, r) {
      if (!(!this.containerRect || Math.abs(i) <= 0)) {
        var o = this.containerRect.width / 2 + this.containerRect.left, l = this.containerRect.height / 2 + this.containerRect.top + this.scrollTop, c, d;
        t === 1 && (this.positionChanged = false);
        var v = this.getDragAllowedAxises(0, i), E = v.allowY, y = v.allowX;
        this.positionChanged && (c = this.left / (this.scale - i), d = this.top / (this.scale - i), this.pageX = o - c, this.pageY = l - d, this.positionChanged = false);
        var b = this.getPossibleSwipeDragCords(i), p, g, C = o - this.pageX, _ = l - this.pageY;
        if (t - i > 1) {
          var h = (t - i) / Math.abs(i);
          C = (i < 0 ? -C : C) + this.left * (h + (i < 0 ? -1 : 1)), _ = (i < 0 ? -_ : _) + this.top * (h + (i < 0 ? -1 : 1)), p = C / h, g = _ / h;
        } else {
          var h = (t - i) * i;
          p = C * h, g = _ * h;
        }
        n && (y ? this.isBeyondPossibleLeft(p, b.minX) ? p = b.minX : this.isBeyondPossibleRight(p, b.maxX) && (p = b.maxX) : t > 1 && (p < b.minX ? p = b.minX : p > b.maxX && (p = b.maxX)), E ? this.isBeyondPossibleTop(g, b.minY) ? g = b.minY : this.isBeyondPossibleBottom(g, b.maxY) && (g = b.maxY) : t > 1 && (g < b.minY ? g = b.minY : g > b.maxY && (g = b.maxY))), this.setZoomStyles({ x: p, y: g, scale: t }), this.left = p, this.top = g, r && this.setZoomImageSize();
      }
    }, e.prototype.resetImageTranslate = function(t) {
      if (this.isImageSlide(t)) {
        var i = this.core.getSlideItem(t).find(".lg-image").first();
        this.imageReset = false, i.removeClass("reset-transition reset-transition-y reset-transition-x"), this.core.outer.removeClass("lg-actual-size"), i.css("width", "auto").css("height", "auto"), setTimeout(function() {
          i.removeClass("no-transition");
        }, 10);
      }
    }, e.prototype.setZoomImageSize = function() {
      var t = this, i = this.core.getSlideItem(this.core.index).find(".lg-image").first();
      setTimeout(function() {
        var n = t.getCurrentImageActualSizeScale();
        t.scale >= n && (i.addClass("no-transition"), t.imageReset = true);
      }, nr), setTimeout(function() {
        var n = t.getCurrentImageActualSizeScale();
        if (t.scale >= n) {
          var r = t.getDragAllowedAxises(t.scale);
          i.css("width", i.get().naturalWidth + "px").css("height", i.get().naturalHeight + "px"), t.core.outer.addClass("lg-actual-size"), r.allowX && r.allowY ? i.addClass("reset-transition") : r.allowX && !r.allowY ? i.addClass("reset-transition-x") : !r.allowX && r.allowY && i.addClass("reset-transition-y");
        }
      }, nr + 50);
    }, e.prototype.setZoomStyles = function(t) {
      var i = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first(), n = this.core.getSlideItem(this.core.index).find(".lg-image").first(), r = this.core.outer.find(".lg-current .lg-dummy-img").first();
      this.scale = t.scale, n.css("transform", "scale3d(" + t.scale + ", " + t.scale + ", 1)"), r.css("transform", "scale3d(" + t.scale + ", " + t.scale + ", 1)");
      var o = "translate3d(" + t.x + "px, " + t.y + "px, 0)";
      i.css("transform", o);
    }, e.prototype.setActualSize = function(t, i) {
      var n = this;
      if (!this.zoomInProgress) {
        this.zoomInProgress = true;
        var r = this.core.galleryItems[this.core.index];
        this.resetImageTranslate(t), setTimeout(function() {
          if (!(!r.src || n.core.outer.hasClass("lg-first-slide-loading"))) {
            var o = n.getCurrentImageActualSizeScale(), l = n.scale;
            n.core.outer.hasClass("lg-zoomed") ? n.scale = 1 : n.scale = n.getScale(o), n.setPageCords(i), n.beginZoom(n.scale), n.zoomImage(n.scale, n.scale - l, true, true);
          }
        }, 50), setTimeout(function() {
          n.core.outer.removeClass("lg-grabbing").addClass("lg-grab");
        }, 60), setTimeout(function() {
          n.zoomInProgress = false;
        }, nr + 110);
      }
    }, e.prototype.getNaturalWidth = function(t) {
      var i = this.core.getSlideItem(t).find(".lg-image").first(), n = this.core.galleryItems[t].width;
      return n ? parseFloat(n) : i.get().naturalWidth;
    }, e.prototype.getActualSizeScale = function(t, i) {
      var n, r;
      return t >= i ? (n = t / i, r = n || 2) : r = 1, r;
    }, e.prototype.getCurrentImageActualSizeScale = function() {
      var t = this.core.getSlideItem(this.core.index).find(".lg-image").first(), i = t.get().offsetWidth, n = this.getNaturalWidth(this.core.index) || i;
      return this.getActualSizeScale(n, i);
    }, e.prototype.getPageCords = function(t) {
      var i = {};
      if (t) i.x = t.pageX || t.touches[0].pageX, i.y = t.pageY || t.touches[0].pageY;
      else {
        var n = this.core.$content.get().getBoundingClientRect();
        i.x = n.width / 2 + n.left, i.y = n.height / 2 + this.scrollTop + n.top;
      }
      return i;
    }, e.prototype.setPageCords = function(t) {
      var i = this.getPageCords(t);
      this.pageX = i.x, this.pageY = i.y;
    }, e.prototype.manageActualPixelClassNames = function() {
      var t = this.core.getElementById("lg-actual-size");
      t.removeClass(this.settings.actualSizeIcons.zoomIn).addClass(this.settings.actualSizeIcons.zoomOut);
    }, e.prototype.beginZoom = function(t) {
      return this.core.outer.removeClass("lg-zoom-drag-transition lg-zoom-dragging"), t > 1 ? (this.core.outer.addClass("lg-zoomed"), this.manageActualPixelClassNames()) : this.resetZoom(), t > 1;
    }, e.prototype.getScale = function(t) {
      var i = this.getCurrentImageActualSizeScale();
      return t < 1 ? t = 1 : t > i && (t = i), t;
    }, e.prototype.init = function() {
      var t = this;
      if (this.settings.zoom) {
        this.buildTemplates(), this.enableZoomOnSlideItemLoad();
        var i = null;
        this.core.outer.on("dblclick.lg", function(n) {
          t.$LG(n.target).hasClass("lg-image") && t.setActualSize(t.core.index, n);
        }), this.core.outer.on("touchstart.lg", function(n) {
          var r = t.$LG(n.target);
          n.touches.length === 1 && r.hasClass("lg-image") && (i ? (clearTimeout(i), i = null, n.preventDefault(), t.setActualSize(t.core.index, n)) : i = setTimeout(function() {
            i = null;
          }, 300));
        }), this.core.LGel.on(_t.containerResize + ".zoom " + _t.rotateRight + ".zoom " + _t.rotateLeft + ".zoom " + _t.flipHorizontal + ".zoom " + _t.flipVertical + ".zoom", function() {
          if (!(!t.core.lgOpened || !t.isImageSlide(t.core.index) || t.core.touchAction)) {
            var n = t.core.getSlideItem(t.core.index).find(".lg-img-wrap").first();
            t.top = 0, t.left = 0, t.setZoomEssentials(), t.setZoomSwipeStyles(n, { x: 0, y: 0 }), t.positionChanged = true;
          }
        }), this.$LG(window).on("scroll.lg.zoom.global" + this.core.lgId, function() {
          t.core.lgOpened && (t.scrollTop = t.$LG(window).scrollTop());
        }), this.core.getElementById("lg-zoom-out").on("click.lg", function() {
          if (t.isImageSlide(t.core.index)) {
            var n = 0;
            t.imageReset && (t.resetImageTranslate(t.core.index), n = 50), setTimeout(function() {
              var r = t.scale - t.settings.scale;
              r < 1 && (r = 1), t.beginZoom(r), t.zoomImage(r, -t.settings.scale, true, !t.settings.infiniteZoom);
            }, n);
          }
        }), this.core.getElementById("lg-zoom-in").on("click.lg", function() {
          t.zoomIn();
        }), this.core.getElementById("lg-actual-size").on("click.lg", function() {
          t.setActualSize(t.core.index);
        }), this.core.LGel.on(_t.beforeOpen + ".zoom", function() {
          t.core.outer.find(".lg-item").removeClass("lg-zoomable");
        }), this.core.LGel.on(_t.afterOpen + ".zoom", function() {
          t.scrollTop = t.$LG(window).scrollTop(), t.pageX = t.core.outer.width() / 2, t.pageY = t.core.outer.height() / 2 + t.scrollTop, t.scale = 1;
        }), this.core.LGel.on(_t.afterSlide + ".zoom", function(n) {
          var r = n.detail.prevIndex;
          t.scale = 1, t.positionChanged = false, t.zoomInProgress = false, t.resetZoom(r), t.resetImageTranslate(r), t.isImageSlide(t.core.index) && t.setZoomEssentials();
        }), this.zoomDrag(), this.pinchZoom(), this.zoomSwipe(), this.zoomableTimeout = false, this.positionChanged = false, this.zoomInProgress = false;
      }
    }, e.prototype.zoomIn = function() {
      if (this.isImageSlide(this.core.index)) {
        var t = this.scale + this.settings.scale;
        this.settings.infiniteZoom || (t = this.getScale(t)), this.beginZoom(t), this.zoomImage(t, Math.min(this.settings.scale, t - this.scale), true, !this.settings.infiniteZoom);
      }
    }, e.prototype.resetZoom = function(t) {
      this.core.outer.removeClass("lg-zoomed lg-zoom-drag-transition");
      var i = this.core.getElementById("lg-actual-size"), n = this.core.getSlideItem(t !== void 0 ? t : this.core.index);
      i.removeClass(this.settings.actualSizeIcons.zoomOut).addClass(this.settings.actualSizeIcons.zoomIn), n.find(".lg-img-wrap").first().removeAttr("style"), n.find(".lg-image").first().removeAttr("style"), this.scale = 1, this.left = 0, this.top = 0, this.setPageCords();
    }, e.prototype.getTouchDistance = function(t) {
      return Math.sqrt((t.touches[0].pageX - t.touches[1].pageX) * (t.touches[0].pageX - t.touches[1].pageX) + (t.touches[0].pageY - t.touches[1].pageY) * (t.touches[0].pageY - t.touches[1].pageY));
    }, e.prototype.pinchZoom = function() {
      var t = this, i = 0, n = false, r = 1, o = 0, l = this.core.getSlideItem(this.core.index);
      this.core.outer.on("touchstart.lg", function(c) {
        if (l = t.core.getSlideItem(t.core.index), !!t.isImageSlide(t.core.index) && c.touches.length === 2) {
          if (c.preventDefault(), t.core.outer.hasClass("lg-first-slide-loading")) return;
          r = t.scale || 1, t.core.outer.removeClass("lg-zoom-drag-transition lg-zoom-dragging"), t.setPageCords(c), t.resetImageTranslate(t.core.index), t.core.touchAction = "pinch", i = t.getTouchDistance(c);
        }
      }), this.core.$inner.on("touchmove.lg", function(c) {
        if (c.touches.length === 2 && t.core.touchAction === "pinch" && (t.$LG(c.target).hasClass("lg-item") || l.get().contains(c.target))) {
          c.preventDefault();
          var d = t.getTouchDistance(c), v = i - d;
          if (!n && Math.abs(v) > 5 && (n = true), n) {
            o = t.scale;
            var E = Math.max(1, r + -v * 0.02);
            t.scale = Math.round((E + Number.EPSILON) * 100) / 100;
            var y = t.scale - o;
            t.zoomImage(t.scale, Math.round((y + Number.EPSILON) * 100) / 100, false, false);
          }
        }
      }), this.core.$inner.on("touchend.lg", function(c) {
        if (t.core.touchAction === "pinch" && (t.$LG(c.target).hasClass("lg-item") || l.get().contains(c.target))) {
          if (n = false, i = 0, t.scale <= 1) t.resetZoom();
          else {
            var d = t.getCurrentImageActualSizeScale();
            if (t.scale >= d) {
              var v = d - t.scale;
              v === 0 && (v = 0.01), t.zoomImage(d, v, false, true);
            }
            t.manageActualPixelClassNames(), t.core.outer.addClass("lg-zoomed");
          }
          t.core.touchAction = void 0;
        }
      });
    }, e.prototype.touchendZoom = function(t, i, n, r, o) {
      var l = i.x - t.x, c = i.y - t.y, d = Math.abs(l) / o + 1, v = Math.abs(c) / o + 1;
      d > 2 && (d += 1), v > 2 && (v += 1), l = l * d, c = c * v;
      var E = this.core.getSlideItem(this.core.index).find(".lg-img-wrap").first(), y = {};
      y.x = this.left + l, y.y = this.top + c;
      var b = this.getPossibleSwipeDragCords();
      (Math.abs(l) > 15 || Math.abs(c) > 15) && (r && (this.isBeyondPossibleTop(y.y, b.minY) ? y.y = b.minY : this.isBeyondPossibleBottom(y.y, b.maxY) && (y.y = b.maxY)), n && (this.isBeyondPossibleLeft(y.x, b.minX) ? y.x = b.minX : this.isBeyondPossibleRight(y.x, b.maxX) && (y.x = b.maxX)), r ? this.top = y.y : y.y = this.top, n ? this.left = y.x : y.x = this.left, this.setZoomSwipeStyles(E, y), this.positionChanged = true);
    }, e.prototype.getZoomSwipeCords = function(t, i, n, r, o) {
      var l = {};
      if (r) {
        if (l.y = this.top + (i.y - t.y), this.isBeyondPossibleTop(l.y, o.minY)) {
          var c = o.minY - l.y;
          l.y = o.minY - c / 6;
        } else if (this.isBeyondPossibleBottom(l.y, o.maxY)) {
          var d = l.y - o.maxY;
          l.y = o.maxY + d / 6;
        }
      } else l.y = this.top;
      if (n) {
        if (l.x = this.left + (i.x - t.x), this.isBeyondPossibleLeft(l.x, o.minX)) {
          var v = o.minX - l.x;
          l.x = o.minX - v / 6;
        } else if (this.isBeyondPossibleRight(l.x, o.maxX)) {
          var E = l.x - o.maxX;
          l.x = o.maxX + E / 6;
        }
      } else l.x = this.left;
      return l;
    }, e.prototype.isBeyondPossibleLeft = function(t, i) {
      return t >= i;
    }, e.prototype.isBeyondPossibleRight = function(t, i) {
      return t <= i;
    }, e.prototype.isBeyondPossibleTop = function(t, i) {
      return t >= i;
    }, e.prototype.isBeyondPossibleBottom = function(t, i) {
      return t <= i;
    }, e.prototype.isImageSlide = function(t) {
      var i = this.core.galleryItems[t];
      return this.core.getSlideType(i) === "image";
    }, e.prototype.getPossibleSwipeDragCords = function(t) {
      var i = this.core.getSlideItem(this.core.index).find(".lg-image").first(), n = this.core.mediaContainerPosition.bottom, r = i.get().getBoundingClientRect(), o = r.height, l = r.width;
      t && (o = o + t * o, l = l + t * l);
      var c = (o - this.containerRect.height) / 2, d = (this.containerRect.height - o) / 2 + n, v = (l - this.containerRect.width) / 2, E = (this.containerRect.width - l) / 2, y = { minY: c, maxY: d, minX: v, maxX: E };
      return y;
    }, e.prototype.setZoomSwipeStyles = function(t, i) {
      t.css("transform", "translate3d(" + i.x + "px, " + i.y + "px, 0)");
    }, e.prototype.zoomSwipe = function() {
      var t = this, i = {}, n = {}, r = false, o = false, l = false, c = /* @__PURE__ */ new Date(), d = /* @__PURE__ */ new Date(), v, E, y = this.core.getSlideItem(this.core.index);
      this.core.$inner.on("touchstart.lg", function(b) {
        if (t.isImageSlide(t.core.index) && (y = t.core.getSlideItem(t.core.index), (t.$LG(b.target).hasClass("lg-item") || y.get().contains(b.target)) && b.touches.length === 1 && t.core.outer.hasClass("lg-zoomed"))) {
          b.preventDefault(), c = /* @__PURE__ */ new Date(), t.core.touchAction = "zoomSwipe", E = t.core.getSlideItem(t.core.index).find(".lg-img-wrap").first();
          var p = t.getDragAllowedAxises(0);
          l = p.allowY, o = p.allowX, (o || l) && (i = t.getSwipeCords(b)), v = t.getPossibleSwipeDragCords(), t.core.outer.addClass("lg-zoom-dragging lg-zoom-drag-transition");
        }
      }), this.core.$inner.on("touchmove.lg", function(b) {
        if (b.touches.length === 1 && t.core.touchAction === "zoomSwipe" && (t.$LG(b.target).hasClass("lg-item") || y.get().contains(b.target))) {
          b.preventDefault(), t.core.touchAction = "zoomSwipe", n = t.getSwipeCords(b);
          var p = t.getZoomSwipeCords(i, n, o, l, v);
          (Math.abs(n.x - i.x) > 15 || Math.abs(n.y - i.y) > 15) && (r = true, t.setZoomSwipeStyles(E, p));
        }
      }), this.core.$inner.on("touchend.lg", function(b) {
        if (t.core.touchAction === "zoomSwipe" && (t.$LG(b.target).hasClass("lg-item") || y.get().contains(b.target))) {
          if (b.preventDefault(), t.core.touchAction = void 0, t.core.outer.removeClass("lg-zoom-dragging"), !r) return;
          r = false, d = /* @__PURE__ */ new Date();
          var p = d.valueOf() - c.valueOf();
          t.touchendZoom(i, n, o, l, p);
        }
      });
    }, e.prototype.zoomDrag = function() {
      var t = this, i = {}, n = {}, r = false, o = false, l = false, c = false, d, v, E, y;
      this.core.outer.on("mousedown.lg.zoom", function(b) {
        if (t.isImageSlide(t.core.index)) {
          var p = t.core.getSlideItem(t.core.index);
          if (t.$LG(b.target).hasClass("lg-item") || p.get().contains(b.target)) {
            d = /* @__PURE__ */ new Date(), y = t.core.getSlideItem(t.core.index).find(".lg-img-wrap").first();
            var g = t.getDragAllowedAxises(0);
            c = g.allowY, l = g.allowX, t.core.outer.hasClass("lg-zoomed") && t.$LG(b.target).hasClass("lg-object") && (l || c) && (b.preventDefault(), i = t.getDragCords(b), E = t.getPossibleSwipeDragCords(), r = true, t.core.outer.removeClass("lg-grab").addClass("lg-grabbing lg-zoom-drag-transition lg-zoom-dragging"));
          }
        }
      }), this.$LG(window).on("mousemove.lg.zoom.global" + this.core.lgId, function(b) {
        if (r) {
          o = true, n = t.getDragCords(b);
          var p = t.getZoomSwipeCords(i, n, l, c, E);
          t.setZoomSwipeStyles(y, p);
        }
      }), this.$LG(window).on("mouseup.lg.zoom.global" + this.core.lgId, function(b) {
        if (r) {
          if (v = /* @__PURE__ */ new Date(), r = false, t.core.outer.removeClass("lg-zoom-dragging"), o && (i.x !== n.x || i.y !== n.y)) {
            n = t.getDragCords(b);
            var p = v.valueOf() - d.valueOf();
            t.touchendZoom(i, n, l, c, p);
          }
          o = false;
        }
        t.core.outer.removeClass("lg-grabbing").addClass("lg-grab");
      });
    }, e.prototype.closeGallery = function() {
      this.resetZoom(), this.zoomInProgress = false;
    }, e.prototype.destroy = function() {
      this.$LG(window).off(".lg.zoom.global" + this.core.lgId), this.core.LGel.off(".lg.zoom"), this.core.LGel.off(".zoom"), clearTimeout(this.zoomableTimeout), this.zoomableTimeout = false;
    }, e;
  })();
  var Jt = function() {
    return Jt = Object.assign || function(t) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
      }
      return t;
    }, Jt.apply(this, arguments);
  }, wv = { autoplayFirstVideo: true, youTubePlayerParams: false, vimeoPlayerParams: false, wistiaPlayerParams: false, gotoNextSlideOnVideoEnd: true, autoplayVideoOnSlide: false, videojs: false, videojsTheme: "", videojsOptions: {} }, Xi = { hasVideo: "lgHasVideo", slideItemLoad: "lgSlideItemLoad", beforeSlide: "lgBeforeSlide", afterSlide: "lgAfterSlide", posterClick: "lgPosterClick" }, Lr = function(e) {
    return Object.keys(e).map(function(t) {
      return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
    }).join("&");
  }, Iv = function(e) {
    var t = e.slice(1).split("&").map(function(i) {
      return i.split("=");
    }).reduce(function(i, n) {
      var r = n.map(decodeURIComponent), o = r[0], l = r[1];
      return i[o] = l, i;
    }, {});
    return t;
  }, Av = function(e, t) {
    if (!e.youtube) return "";
    var i = e.youtube[2] ? Iv(e.youtube[2]) : "", n = { wmode: "opaque", autoplay: 0, mute: 1, enablejsapi: 1 }, r = t || {}, o = Jt(Jt(Jt({}, n), r), i), l = "?" + Lr(o);
    return l;
  }, Ov = function(e) {
    return e.includes("youtube-nocookie.com");
  }, Mv = function(e, t) {
    if (!t || !t.vimeo) return "";
    var i = t.vimeo[2] || "", n = Object.assign({}, { autoplay: 0, muted: 1 }, e), r = n && Object.keys(n).length !== 0 ? Lr(n) : "", o = t.vimeo[0].split("/").pop() || "", l = o.split("?")[0] || "", c = l.split("#")[0], d = t.vimeo[1] !== c;
    d && (i = i.replace("/" + c, "")), i = i[0] == "?" ? "&" + i.slice(1) : i || "";
    var v = d ? "h=" + c : "";
    r = v ? "&" + r : r;
    var E = "?" + v + r + i;
    return E;
  }, Lv = (function() {
    function e(t) {
      return this.core = t, this.settings = Jt(Jt({}, wv), this.core.settings), this;
    }
    return e.prototype.init = function() {
      var t = this;
      this.core.LGel.on(Xi.hasVideo + ".video", this.onHasVideo.bind(this)), this.core.LGel.on(Xi.posterClick + ".video", function() {
        var i = t.core.getSlideItem(t.core.index);
        t.loadVideoOnPosterClick(i);
      }), this.core.LGel.on(Xi.slideItemLoad + ".video", this.onSlideItemLoad.bind(this)), this.core.LGel.on(Xi.beforeSlide + ".video", this.onBeforeSlide.bind(this)), this.core.LGel.on(Xi.afterSlide + ".video", this.onAfterSlide.bind(this));
    }, e.prototype.onSlideItemLoad = function(t) {
      var i = this, n = t.detail, r = n.isFirstSlide, o = n.index;
      this.settings.autoplayFirstVideo && r && o === this.core.index && setTimeout(function() {
        i.loadAndPlayVideo(o);
      }, 200), !r && this.settings.autoplayVideoOnSlide && o === this.core.index && this.loadAndPlayVideo(o);
    }, e.prototype.onHasVideo = function(t) {
      var i = t.detail, n = i.index, r = i.src, o = i.html5Video, l = i.hasPoster;
      l || (this.appendVideos(this.core.getSlideItem(n), { src: r, addClass: "lg-object", index: n, html5Video: o }), this.gotoNextSlideOnVideoEnd(r, n));
    }, e.prototype.onBeforeSlide = function(t) {
      if (this.core.lGalleryOn) {
        var i = t.detail.prevIndex;
        this.pauseVideo(i);
      }
    }, e.prototype.onAfterSlide = function(t) {
      var i = this, n = t.detail, r = n.index, o = n.prevIndex, l = this.core.getSlideItem(r);
      this.settings.autoplayVideoOnSlide && r !== o && l.hasClass("lg-complete") && setTimeout(function() {
        i.loadAndPlayVideo(r);
      }, 100);
    }, e.prototype.loadAndPlayVideo = function(t) {
      var i = this.core.getSlideItem(t), n = this.core.galleryItems[t];
      n.poster ? this.loadVideoOnPosterClick(i, true) : this.playVideo(t);
    }, e.prototype.playVideo = function(t) {
      this.controlVideo(t, "play");
    }, e.prototype.pauseVideo = function(t) {
      this.controlVideo(t, "pause");
    }, e.prototype.getVideoHtml = function(t, i, n, r) {
      var o = "", l = this.core.galleryItems[n].__slideVideoInfo || {}, c = this.core.galleryItems[n], d = c.title || c.alt;
      d = d ? 'title="' + d + '"' : "";
      var v = `allowtransparency="true"
            frameborder="0"
            scrolling="no"
            allowfullscreen
            mozallowfullscreen
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen`;
      if (l.youtube) {
        var E = "lg-youtube" + n, y = Av(l, this.settings.youTubePlayerParams), b = Ov(t), p = b ? "//www.youtube-nocookie.com/" : "//www.youtube.com/";
        o = '<iframe allow="autoplay" id=' + E + ' class="lg-video-object lg-youtube ' + i + '" ' + d + ' src="' + p + "embed/" + (l.youtube[1] + y) + '" ' + v + "></iframe>";
      } else if (l.vimeo) {
        var E = "lg-vimeo" + n, g = Mv(this.settings.vimeoPlayerParams, l);
        o = '<iframe allow="autoplay" id=' + E + ' class="lg-video-object lg-vimeo ' + i + '" ' + d + ' src="//player.vimeo.com/video/' + (l.vimeo[1] + g) + '" ' + v + "></iframe>";
      } else if (l.wistia) {
        var C = "lg-wistia" + n, g = Lr(this.settings.wistiaPlayerParams);
        g = g ? "?" + g : "", o = '<iframe allow="autoplay" id="' + C + '" src="//fast.wistia.net/embed/iframe/' + (l.wistia[4] + g) + '" ' + d + ' class="wistia_embed lg-video-object lg-wistia ' + i + '" name="wistia_embed" ' + v + "></iframe>";
      } else if (l.html5) {
        for (var _ = "", h = 0; h < r.source.length; h++) {
          var S = r.source[h].type, w = S ? 'type="' + S + '"' : "";
          _ += '<source src="' + r.source[h].src + '" ' + w + ">";
        }
        if (r.tracks) for (var A = function(P) {
          var D = "", R = r.tracks[P];
          Object.keys(R || {}).forEach(function(N) {
            D += N + '="' + R[N] + '" ';
          }), _ += "<track " + D + ">";
        }, h = 0; h < r.tracks.length; h++) A(h);
        var L = "", f = r.attributes || {};
        Object.keys(f || {}).forEach(function(P) {
          L += P + '="' + f[P] + '" ';
        }), o = '<video class="lg-video-object lg-html5 ' + (this.settings.videojs && this.settings.videojsTheme ? this.settings.videojsTheme + " " : "") + " " + (this.settings.videojs ? " video-js" : "") + '" ' + L + `>
                ` + _ + `
                Your browser does not support HTML5 video.
            </video>`;
      }
      return o;
    }, e.prototype.appendVideos = function(t, i) {
      var n, r = this.getVideoHtml(i.src, i.addClass, i.index, i.html5Video);
      t.find(".lg-video-cont").append(r);
      var o = t.find(".lg-video-object").first();
      if (i.html5Video && o.on("mousedown.lg.video", function(l) {
        l.stopPropagation();
      }), this.settings.videojs && (!((n = this.core.galleryItems[i.index].__slideVideoInfo) === null || n === void 0) && n.html5)) try {
        return videojs(o.get(), this.settings.videojsOptions);
      } catch (l) {
        console.error("lightGallery:- Make sure you have included videojs");
      }
    }, e.prototype.gotoNextSlideOnVideoEnd = function(t, i) {
      var n = this, r = this.core.getSlideItem(i).find(".lg-video-object").first(), o = this.core.galleryItems[i].__slideVideoInfo || {};
      if (this.settings.gotoNextSlideOnVideoEnd) {
        if (o.html5) r.on("ended", function() {
          n.core.goToNextSlide();
        });
        else if (o.vimeo) try {
          new Vimeo.Player(r.get()).on("ended", function() {
            n.core.goToNextSlide();
          });
        } catch (l) {
          console.error("lightGallery:- Make sure you have included //github.com/vimeo/player.js");
        }
        else if (o.wistia) try {
          window._wq = window._wq || [], window._wq.push({ id: r.attr("id"), onReady: function(l) {
            l.bind("end", function() {
              n.core.goToNextSlide();
            });
          } });
        } catch (l) {
          console.error("lightGallery:- Make sure you have included //fast.wistia.com/assets/external/E-v1.js");
        }
      }
    }, e.prototype.controlVideo = function(t, i) {
      var n = this.core.getSlideItem(t).find(".lg-video-object").first(), r = this.core.galleryItems[t].__slideVideoInfo || {};
      if (n.get()) {
        if (r.youtube) try {
          n.get().contentWindow.postMessage('{"event":"command","func":"' + i + 'Video","args":""}', "*");
        } catch (o) {
          console.error("lightGallery:- " + o);
        }
        else if (r.vimeo) try {
          new Vimeo.Player(n.get())[i]();
        } catch (o) {
          console.error("lightGallery:- Make sure you have included //github.com/vimeo/player.js");
        }
        else if (r.html5) if (this.settings.videojs) try {
          videojs(n.get())[i]();
        } catch (o) {
          console.error("lightGallery:- Make sure you have included videojs");
        }
        else n.get()[i]();
        else if (r.wistia) try {
          window._wq = window._wq || [], window._wq.push({ id: n.attr("id"), onReady: function(o) {
            o[i]();
          } });
        } catch (o) {
          console.error("lightGallery:- Make sure you have included //fast.wistia.com/assets/external/E-v1.js");
        }
      }
    }, e.prototype.loadVideoOnPosterClick = function(t, i) {
      var n = this;
      if (t.hasClass("lg-video-loaded")) i && this.playVideo(this.core.index);
      else if (t.hasClass("lg-has-video")) this.playVideo(this.core.index);
      else {
        t.addClass("lg-has-video");
        var r = void 0, o = this.core.galleryItems[this.core.index].src, l = this.core.galleryItems[this.core.index].video;
        l && (r = typeof l == "string" ? JSON.parse(l) : l);
        var c = this.appendVideos(t, { src: o, addClass: "", index: this.core.index, html5Video: r });
        this.gotoNextSlideOnVideoEnd(o, this.core.index);
        var d = t.find(".lg-object").first().get();
        t.find(".lg-video-cont").first().append(d), t.addClass("lg-video-loading"), c && c.ready(function() {
          c.on("loadedmetadata", function() {
            n.onVideoLoadAfterPosterClick(t, n.core.index);
          });
        }), t.find(".lg-video-object").first().on("load.lg error.lg loadedmetadata.lg", function() {
          setTimeout(function() {
            n.onVideoLoadAfterPosterClick(t, n.core.index);
          }, 50);
        });
      }
    }, e.prototype.onVideoLoadAfterPosterClick = function(t, i) {
      t.addClass("lg-video-loaded"), this.playVideo(i);
    }, e.prototype.destroy = function() {
      this.core.LGel.off(".lg.video"), this.core.LGel.off(".video");
    }, e;
  })();
  var Wn = function() {
    return Wn = Object.assign || function(t) {
      for (var i, n = 1, r = arguments.length; n < r; n++) {
        i = arguments[n];
        for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (t[o] = i[o]);
      }
      return t;
    }, Wn.apply(this, arguments);
  };
  function Pv(e, t, i, n) {
    function r(o) {
      return o instanceof i ? o : new i(function(l) {
        l(o);
      });
    }
    return new (i || (i = Promise))(function(o, l) {
      function c(E) {
        try {
          v(n.next(E));
        } catch (y) {
          l(y);
        }
      }
      function d(E) {
        try {
          v(n.throw(E));
        } catch (y) {
          l(y);
        }
      }
      function v(E) {
        E.done ? o(E.value) : r(E.value).then(c, d);
      }
      v((n = n.apply(e, [])).next());
    });
  }
  function Dv(e, t) {
    var i = { label: 0, sent: function() {
      if (o[0] & 1) throw o[1];
      return o[1];
    }, trys: [], ops: [] }, n, r, o, l;
    return l = { next: c(0), throw: c(1), return: c(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
      return this;
    }), l;
    function c(v) {
      return function(E) {
        return d([v, E]);
      };
    }
    function d(v) {
      if (n) throw new TypeError("Generator is already executing.");
      for (; i; ) try {
        if (n = 1, r && (o = v[0] & 2 ? r.return : v[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, v[1])).done) return o;
        switch (r = 0, o && (v = [v[0] & 2, o.value]), v[0]) {
          case 0:
          case 1:
            o = v;
            break;
          case 4:
            return i.label++, { value: v[1], done: false };
          case 5:
            i.label++, r = v[1], v = [0];
            continue;
          case 7:
            v = i.ops.pop(), i.trys.pop();
            continue;
          default:
            if (o = i.trys, !(o = o.length > 0 && o[o.length - 1]) && (v[0] === 6 || v[0] === 2)) {
              i = 0;
              continue;
            }
            if (v[0] === 3 && (!o || v[1] > o[0] && v[1] < o[3])) {
              i.label = v[1];
              break;
            }
            if (v[0] === 6 && i.label < o[1]) {
              i.label = o[1], o = v;
              break;
            }
            if (o && i.label < o[2]) {
              i.label = o[2], i.ops.push(v);
              break;
            }
            o[2] && i.ops.pop(), i.trys.pop();
            continue;
        }
        v = t.call(e, i);
      } catch (E) {
        v = [6, E], r = 0;
      } finally {
        n = o = 0;
      }
      if (v[0] & 5) throw v[1];
      return { value: v[0] ? v[1] : void 0, done: true };
    }
  }
  var zv = { init: "lgInit" }, $v = { showVimeoThumbnails: true, showThumbnailWithPlayButton: false }, Nv = (function() {
    function e(t) {
      return this.core = t, this.settings = Wn(Wn({}, $v), this.core.settings), this;
    }
    return e.prototype.init = function() {
      var t = this;
      this.settings.showVimeoThumbnails && this.core.LGel.on(zv.init + ".vimeothumbnails", function(i) {
        var n = i.detail.instance, r = n.$container.find(".lg-thumb-outer").get();
        r && t.setVimeoThumbnails(n);
      });
    }, e.prototype.setVimeoThumbnails = function(t) {
      return Pv(this, void 0, void 0, function() {
        var i, n, r, o, l;
        return Dv(this, function(c) {
          switch (c.label) {
            case 0:
              i = 0, c.label = 1;
            case 1:
              return i < t.galleryItems.length ? (n = t.galleryItems[i], r = n.__slideVideoInfo || {}, r.vimeo ? [4, fetch("https://vimeo.com/api/oembed.json?url=" + encodeURIComponent(n.src))] : [3, 4]) : [3, 5];
            case 2:
              return o = c.sent(), [4, o.json()];
            case 3:
              l = c.sent(), t.$container.find(".lg-thumb-item").eq(i).find("img").attr("src", this.settings.showThumbnailWithPlayButton ? l.thumbnail_url_with_play_button : l.thumbnail_url), c.label = 4;
            case 4:
              return i++, [3, 1];
            case 5:
              return [2];
          }
        });
      });
    }, e.prototype.destroy = function() {
      this.core.LGel.off(".lg.vimeothumbnails"), this.core.LGel.off(".vimeothumbnails");
    }, e;
  })();
  window.lightGallery = Sv;
  window.lgThumbnail = _v;
  window.lgZoom = Cv;
  window.lgVideo = Lv;
  window.lgVimeoThumbnail = Nv;
  function Fn(e) {
    "@babel/helpers - typeof";
    return Fn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Fn(e);
  }
  var kv = (typeof HTMLElement == "undefined" ? "undefined" : Fn(HTMLElement)) === "object";
  function sr(e) {
    return kv ? e instanceof HTMLElement : e && Fn(e) === "object" && e !== null && e.nodeType === 1 && typeof e.nodeName == "string";
  }
  function xt(e, t) {
    t.forEach(function(i) {
      e.classList.add(i);
    });
  }
  function gt(e, t) {
    t.forEach(function(i) {
      e.classList.remove(i);
    });
  }
  var Rv = ".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}";
  function Hv() {
    if (!document.querySelector(".drift-base-styles")) {
      var e = document.createElement("style");
      e.type = "text/css", e.classList.add("drift-base-styles"), e.appendChild(document.createTextNode(Rv));
      var t = document.head;
      t.insertBefore(e, t.firstChild);
    }
  }
  function We() {
    throw new Error("Missing parameter");
  }
  function Bv(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function Vv(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(e, n.key, n);
    }
  }
  function Wv(e, t, i) {
    return t && Vv(e.prototype, t), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  var Fv = (function() {
    function e(t) {
      Bv(this, e), this.isShowing = false;
      var i = t.namespace, n = i === void 0 ? null : i, r = t.zoomFactor, o = r === void 0 ? We() : r, l = t.containerEl, c = l === void 0 ? We() : l;
      this.settings = { namespace: n, zoomFactor: o, containerEl: c }, this.openClasses = this._buildClasses("open"), this._buildElement();
    }
    return Wv(e, [{ key: "_buildClasses", value: function(i) {
      var n = ["drift-".concat(i)], r = this.settings.namespace;
      return r && n.push("".concat(r, "-").concat(i)), n;
    } }, { key: "_buildElement", value: function() {
      this.el = document.createElement("div"), xt(this.el, this._buildClasses("bounding-box"));
    } }, { key: "show", value: function(i, n) {
      this.isShowing = true, this.settings.containerEl.appendChild(this.el);
      var r = this.el.style;
      r.width = "".concat(Math.round(i / this.settings.zoomFactor), "px"), r.height = "".concat(Math.round(n / this.settings.zoomFactor), "px"), xt(this.el, this.openClasses);
    } }, { key: "hide", value: function() {
      this.isShowing && this.settings.containerEl.removeChild(this.el), this.isShowing = false, gt(this.el, this.openClasses);
    } }, { key: "setPosition", value: function(i, n, r) {
      var o = window.pageXOffset, l = window.pageYOffset, c = r.left + i * r.width - this.el.clientWidth / 2 + o, d = r.top + n * r.height - this.el.clientHeight / 2 + l;
      c < r.left + o ? c = r.left + o : c + this.el.clientWidth > r.left + r.width + o && (c = r.left + r.width - this.el.clientWidth + o), d < r.top + l ? d = r.top + l : d + this.el.clientHeight > r.top + r.height + l && (d = r.top + r.height - this.el.clientHeight + l), this.el.style.left = "".concat(c, "px"), this.el.style.top = "".concat(d, "px");
    } }]), e;
  })();
  function Gv(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function jv(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(e, n.key, n);
    }
  }
  function Yv(e, t, i) {
    return t && jv(e.prototype, t), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  var Xv = (function() {
    function e() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      Gv(this, e), this._show = this._show.bind(this), this._hide = this._hide.bind(this), this._handleEntry = this._handleEntry.bind(this), this._handleMovement = this._handleMovement.bind(this);
      var i = t.el, n = i === void 0 ? We() : i, r = t.zoomPane, o = r === void 0 ? We() : r, l = t.sourceAttribute, c = l === void 0 ? We() : l, d = t.handleTouch, v = d === void 0 ? We() : d, E = t.onShow, y = E === void 0 ? null : E, b = t.onHide, p = b === void 0 ? null : b, g = t.hoverDelay, C = g === void 0 ? 0 : g, _ = t.touchDelay, h = _ === void 0 ? 0 : _, S = t.hoverBoundingBox, w = S === void 0 ? We() : S, A = t.touchBoundingBox, L = A === void 0 ? We() : A, f = t.namespace, P = f === void 0 ? null : f, D = t.zoomFactor, R = D === void 0 ? We() : D, N = t.boundingBoxContainer, $ = N === void 0 ? We() : N, B = t.passive, V = B === void 0 ? false : B;
      this.settings = { el: n, zoomPane: o, sourceAttribute: c, handleTouch: v, onShow: y, onHide: p, hoverDelay: C, touchDelay: h, hoverBoundingBox: w, touchBoundingBox: L, namespace: P, zoomFactor: R, boundingBoxContainer: $, passive: V }, (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) && (this.boundingBox = new Fv({ namespace: this.settings.namespace, zoomFactor: this.settings.zoomFactor, containerEl: this.settings.boundingBoxContainer })), this.enabled = true, this._bindEvents();
    }
    return Yv(e, [{ key: "_preventDefault", value: function(i) {
      i.preventDefault();
    } }, { key: "_preventDefaultAllowTouchScroll", value: function(i) {
      (!this.settings.touchDelay || !this._isTouchEvent(i) || this.isShowing) && i.preventDefault();
    } }, { key: "_isTouchEvent", value: function(i) {
      return !!i.touches;
    } }, { key: "_bindEvents", value: function() {
      this.settings.el.addEventListener("mouseenter", this._handleEntry), this.settings.el.addEventListener("mouseleave", this._hide), this.settings.el.addEventListener("mousemove", this._handleMovement);
      var i = { passive: this.settings.passive };
      this.settings.handleTouch ? (this.settings.el.addEventListener("touchstart", this._handleEntry, i), this.settings.el.addEventListener("touchend", this._hide), this.settings.el.addEventListener("touchmove", this._handleMovement, i)) : (this.settings.el.addEventListener("touchstart", this._preventDefault, i), this.settings.el.addEventListener("touchend", this._preventDefault), this.settings.el.addEventListener("touchmove", this._preventDefault, i));
    } }, { key: "_unbindEvents", value: function() {
      this.settings.el.removeEventListener("mouseenter", this._handleEntry), this.settings.el.removeEventListener("mouseleave", this._hide), this.settings.el.removeEventListener("mousemove", this._handleMovement), this.settings.handleTouch ? (this.settings.el.removeEventListener("touchstart", this._handleEntry), this.settings.el.removeEventListener("touchend", this._hide), this.settings.el.removeEventListener("touchmove", this._handleMovement)) : (this.settings.el.removeEventListener("touchstart", this._preventDefault), this.settings.el.removeEventListener("touchend", this._preventDefault), this.settings.el.removeEventListener("touchmove", this._preventDefault));
    } }, { key: "_handleEntry", value: function(i) {
      this._preventDefaultAllowTouchScroll(i), this._lastMovement = i, i.type == "mouseenter" && this.settings.hoverDelay ? this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay) : this.settings.touchDelay ? this.entryTimeout = setTimeout(this._show, this.settings.touchDelay) : this._show();
    } }, { key: "_show", value: function() {
      if (this.enabled) {
        var i = this.settings.onShow;
        if (i && typeof i == "function" && i(), this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight), this._lastMovement) {
          var n = this._lastMovement.touches;
          (n && this.settings.touchBoundingBox || !n && this.settings.hoverBoundingBox) && this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight);
        }
        this._handleMovement();
      }
    } }, { key: "_hide", value: function(i) {
      i && this._preventDefaultAllowTouchScroll(i), this._lastMovement = null, this.entryTimeout && clearTimeout(this.entryTimeout), this.boundingBox && this.boundingBox.hide();
      var n = this.settings.onHide;
      n && typeof n == "function" && n(), this.settings.zoomPane.hide();
    } }, { key: "_handleMovement", value: function(i) {
      if (i) this._preventDefaultAllowTouchScroll(i), this._lastMovement = i;
      else if (this._lastMovement) i = this._lastMovement;
      else return;
      var n, r;
      if (i.touches) {
        var o = i.touches[0];
        n = o.clientX, r = o.clientY;
      } else n = i.clientX, r = i.clientY;
      var l = this.settings.el, c = l.getBoundingClientRect(), d = n - c.left, v = r - c.top, E = d / this.settings.el.clientWidth, y = v / this.settings.el.clientHeight;
      this.boundingBox && this.boundingBox.setPosition(E, y, c), this.settings.zoomPane.setPosition(E, y, c);
    } }, { key: "isShowing", get: function() {
      return this.settings.zoomPane.isShowing;
    } }]), e;
  })();
  function qv(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function Uv(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(e, n.key, n);
    }
  }
  function Kv(e, t, i) {
    return t && Uv(e.prototype, t), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  var Zv = (function() {
    function e() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (qv(this, e), this.HAS_ANIMATION = false, typeof document != "undefined") {
        var i = document.createElement("div").style;
        this.HAS_ANIMATION = "animation" in i || "webkitAnimation" in i;
      }
      this._completeShow = this._completeShow.bind(this), this._completeHide = this._completeHide.bind(this), this._handleLoad = this._handleLoad.bind(this), this.isShowing = false;
      var n = t.container, r = n === void 0 ? null : n, o = t.zoomFactor, l = o === void 0 ? We() : o, c = t.inline, d = c === void 0 ? We() : c, v = t.namespace, E = v === void 0 ? null : v, y = t.showWhitespaceAtEdges, b = y === void 0 ? We() : y, p = t.containInline, g = p === void 0 ? We() : p, C = t.inlineOffsetX, _ = C === void 0 ? 0 : C, h = t.inlineOffsetY, S = h === void 0 ? 0 : h, w = t.inlineContainer, A = w === void 0 ? document.body : w;
      this.settings = { container: r, zoomFactor: l, inline: d, namespace: E, showWhitespaceAtEdges: b, containInline: g, inlineOffsetX: _, inlineOffsetY: S, inlineContainer: A }, this.openClasses = this._buildClasses("open"), this.openingClasses = this._buildClasses("opening"), this.closingClasses = this._buildClasses("closing"), this.inlineClasses = this._buildClasses("inline"), this.loadingClasses = this._buildClasses("loading"), this._buildElement();
    }
    return Kv(e, [{ key: "_buildClasses", value: function(i) {
      var n = ["drift-".concat(i)], r = this.settings.namespace;
      return r && n.push("".concat(r, "-").concat(i)), n;
    } }, { key: "_buildElement", value: function() {
      this.el = document.createElement("div"), xt(this.el, this._buildClasses("zoom-pane"));
      var i = document.createElement("div");
      xt(i, this._buildClasses("zoom-pane-loader")), this.el.appendChild(i), this.imgEl = document.createElement("img"), this.el.appendChild(this.imgEl);
    } }, { key: "_setImageURL", value: function(i) {
      this.imgEl.setAttribute("src", i);
    } }, { key: "_setImageSize", value: function(i, n) {
      this.imgEl.style.width = "".concat(i * this.settings.zoomFactor, "px"), this.imgEl.style.height = "".concat(n * this.settings.zoomFactor, "px");
    } }, { key: "setPosition", value: function(i, n, r) {
      var o = this.imgEl.offsetWidth, l = this.imgEl.offsetHeight, c = this.el.offsetWidth, d = this.el.offsetHeight, v = c / 2, E = d / 2, y = o * i, b = l * n, p = v - y, g = E - b, C = c - o, _ = d - l, h = C > 0, S = _ > 0, w = h ? C / 2 : 0, A = S ? _ / 2 : 0, L = h ? C / 2 : C, f = S ? _ / 2 : _;
      if (this.el.parentElement === this.settings.inlineContainer) {
        var P = window.pageXOffset, D = window.pageYOffset, R = r.left + i * r.width - c / 2 + this.settings.inlineOffsetX + P, N = r.top + n * r.height - d / 2 + this.settings.inlineOffsetY + D;
        this.settings.containInline && (R < r.left + P ? R = r.left + P : R + c > r.left + r.width + P && (R = r.left + r.width - c + P), N < r.top + D ? N = r.top + D : N + d > r.top + r.height + D && (N = r.top + r.height - d + D)), this.el.style.left = "".concat(R, "px"), this.el.style.top = "".concat(N, "px");
      }
      this.settings.showWhitespaceAtEdges || (p > w ? p = w : p < L && (p = L), g > A ? g = A : g < f && (g = f)), this.imgEl.style.transform = "translate(".concat(p, "px, ").concat(g, "px)"), this.imgEl.style.webkitTransform = "translate(".concat(p, "px, ").concat(g, "px)");
    } }, { key: "_removeListenersAndResetClasses", value: function() {
      this.el.removeEventListener("animationend", this._completeShow), this.el.removeEventListener("animationend", this._completeHide), this.el.removeEventListener("webkitAnimationEnd", this._completeShow), this.el.removeEventListener("webkitAnimationEnd", this._completeHide), gt(this.el, this.openClasses), gt(this.el, this.closingClasses);
    } }, { key: "show", value: function(i, n, r) {
      this._removeListenersAndResetClasses(), this.isShowing = true, xt(this.el, this.openClasses), this.imgEl.getAttribute("src") != i && (xt(this.el, this.loadingClasses), this.imgEl.addEventListener("load", this._handleLoad), this._setImageURL(i)), this._setImageSize(n, r), this._isInline ? this._showInline() : this._showInContainer(), this.HAS_ANIMATION && (this.el.addEventListener("animationend", this._completeShow), this.el.addEventListener("webkitAnimationEnd", this._completeShow), xt(this.el, this.openingClasses));
    } }, { key: "_showInline", value: function() {
      this.settings.inlineContainer.appendChild(this.el), xt(this.el, this.inlineClasses);
    } }, { key: "_showInContainer", value: function() {
      this.settings.container.appendChild(this.el);
    } }, { key: "hide", value: function() {
      this._removeListenersAndResetClasses(), this.isShowing = false, this.HAS_ANIMATION ? (this.el.addEventListener("animationend", this._completeHide), this.el.addEventListener("webkitAnimationEnd", this._completeHide), xt(this.el, this.closingClasses)) : (gt(this.el, this.openClasses), gt(this.el, this.inlineClasses));
    } }, { key: "_completeShow", value: function() {
      this.el.removeEventListener("animationend", this._completeShow), this.el.removeEventListener("webkitAnimationEnd", this._completeShow), gt(this.el, this.openingClasses);
    } }, { key: "_completeHide", value: function() {
      this.el.removeEventListener("animationend", this._completeHide), this.el.removeEventListener("webkitAnimationEnd", this._completeHide), gt(this.el, this.openClasses), gt(this.el, this.closingClasses), gt(this.el, this.inlineClasses), this.el.style.left = "", this.el.style.top = "", this.el.parentElement === this.settings.container ? this.settings.container.removeChild(this.el) : this.el.parentElement === this.settings.inlineContainer && this.settings.inlineContainer.removeChild(this.el);
    } }, { key: "_handleLoad", value: function() {
      this.imgEl.removeEventListener("load", this._handleLoad), gt(this.el, this.loadingClasses);
    } }, { key: "_isInline", get: function() {
      var i = this.settings.inline;
      return i === true || typeof i == "number" && window.innerWidth <= i;
    } }]), e;
  })();
  function Qv(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function Jv(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      n.enumerable = n.enumerable || false, n.configurable = true, "value" in n && (n.writable = true), Object.defineProperty(e, n.key, n);
    }
  }
  function ey(e, t, i) {
    return t && Jv(e.prototype, t), Object.defineProperty(e, "prototype", { writable: false }), e;
  }
  var ct = (function() {
    function e(t) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (Qv(this, e), this.VERSION = "1.5.1", this.triggerEl = t, this.destroy = this.destroy.bind(this), !sr(this.triggerEl)) throw new TypeError("`new Drift` requires a DOM element as its first argument.");
      var n = i.namespace || null, r = i.showWhitespaceAtEdges || false, o = i.containInline || false, l = i.inlineOffsetX || 0, c = i.inlineOffsetY || 0, d = i.inlineContainer || document.body, v = i.sourceAttribute || "data-zoom", E = i.zoomFactor || 3, y = i.paneContainer === void 0 ? document.body : i.paneContainer, b = i.inlinePane || 375, p = "handleTouch" in i ? !!i.handleTouch : true, g = i.onShow || null, C = i.onHide || null, _ = "injectBaseStyles" in i ? !!i.injectBaseStyles : true, h = i.hoverDelay || 0, S = i.touchDelay || 0, w = i.hoverBoundingBox || false, A = i.touchBoundingBox || false, L = i.boundingBoxContainer || document.body, f = i.passive || false;
      if (b !== true && !sr(y)) throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
      if (!sr(d)) throw new TypeError("`inlineContainer` must be a DOM element");
      this.settings = { namespace: n, showWhitespaceAtEdges: r, containInline: o, inlineOffsetX: l, inlineOffsetY: c, inlineContainer: d, sourceAttribute: v, zoomFactor: E, paneContainer: y, inlinePane: b, handleTouch: p, onShow: g, onHide: C, injectBaseStyles: _, hoverDelay: h, touchDelay: S, hoverBoundingBox: w, touchBoundingBox: A, boundingBoxContainer: L, passive: f }, this.settings.injectBaseStyles && Hv(), this._buildZoomPane(), this._buildTrigger();
    }
    return ey(e, [{ key: "_buildZoomPane", value: function() {
      this.zoomPane = new Zv({ container: this.settings.paneContainer, zoomFactor: this.settings.zoomFactor, showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges, containInline: this.settings.containInline, inline: this.settings.inlinePane, namespace: this.settings.namespace, inlineOffsetX: this.settings.inlineOffsetX, inlineOffsetY: this.settings.inlineOffsetY, inlineContainer: this.settings.inlineContainer });
    } }, { key: "_buildTrigger", value: function() {
      this.trigger = new Xv({ el: this.triggerEl, zoomPane: this.zoomPane, handleTouch: this.settings.handleTouch, onShow: this.settings.onShow, onHide: this.settings.onHide, sourceAttribute: this.settings.sourceAttribute, hoverDelay: this.settings.hoverDelay, touchDelay: this.settings.touchDelay, hoverBoundingBox: this.settings.hoverBoundingBox, touchBoundingBox: this.settings.touchBoundingBox, namespace: this.settings.namespace, zoomFactor: this.settings.zoomFactor, boundingBoxContainer: this.settings.boundingBoxContainer, passive: this.settings.passive });
    } }, { key: "setZoomImageURL", value: function(i) {
      this.zoomPane._setImageURL(i);
    } }, { key: "disable", value: function() {
      this.trigger.enabled = false;
    } }, { key: "enable", value: function() {
      this.trigger.enabled = true;
    } }, { key: "destroy", value: function() {
      this.trigger._hide(), this.trigger._unbindEvents();
    } }, { key: "isShowing", get: function() {
      return this.zoomPane.isShowing;
    } }, { key: "zoomFactor", get: function() {
      return this.settings.zoomFactor;
    }, set: function(i) {
      this.settings.zoomFactor = i, this.zoomPane.settings.zoomFactor = i, this.trigger.settings.zoomFactor = i, this.boundingBox.settings.zoomFactor = i;
    } }]), e;
  })();
  Object.defineProperty(ct.prototype, "isShowing", { get: function() {
    return this.isShowing;
  } });
  Object.defineProperty(ct.prototype, "zoomFactor", { get: function() {
    return this.zoomFactor;
  }, set: function(t) {
    this.zoomFactor = t;
  } });
  ct.prototype.setZoomImageURL = ct.prototype.setZoomImageURL;
  ct.prototype.disable = ct.prototype.disable;
  ct.prototype.enable = ct.prototype.enable;
  ct.prototype.destroy = ct.prototype.destroy;
  window.Drift = ct;
  var Oa = "1.3.25";
  function Ul(e, t, i) {
    return Math.max(e, Math.min(t, i));
  }
  function ty(e, t, i) {
    return (1 - i) * e + i * t;
  }
  function iy(e, t, i, n) {
    return ty(e, t, 1 - Math.exp(-i * n));
  }
  function ny(e, t) {
    return (e % t + t) % t;
  }
  var sy = class {
    constructor() {
      ie(this, "isRunning", false);
      ie(this, "value", 0);
      ie(this, "from", 0);
      ie(this, "to", 0);
      ie(this, "currentTime", 0);
      ie(this, "lerp");
      ie(this, "duration");
      ie(this, "easing");
      ie(this, "onUpdate");
    }
    advance(e) {
      var i;
      if (!this.isRunning) return;
      let t = false;
      if (this.duration && this.easing) {
        this.currentTime += e;
        const n = Ul(0, this.currentTime / this.duration, 1);
        t = n >= 1;
        const r = t ? 1 : this.easing(n);
        this.value = this.from + (this.to - this.from) * r;
      } else this.lerp ? (this.value = iy(this.value, this.to, this.lerp * 60, e), Math.round(this.value) === Math.round(this.to) && (this.value = this.to, t = true)) : (this.value = this.to, t = true);
      t && this.stop(), (i = this.onUpdate) == null || i.call(this, this.value, t);
    }
    stop() {
      this.isRunning = false;
    }
    fromTo(e, t, { lerp: i, duration: n, easing: r, onStart: o, onUpdate: l }) {
      this.from = this.value = e, this.to = t, this.lerp = i, this.duration = n, this.easing = r, this.currentTime = 0, this.isRunning = true, o == null || o(), this.onUpdate = l;
    }
  };
  function ry(e, t) {
    let i;
    return function(...n) {
      clearTimeout(i), i = setTimeout(() => {
        i = void 0, e.apply(this, n);
      }, t);
    };
  }
  var oy = class {
    constructor(e, t, { autoResize: i = true, debounce: n = 250 } = {}) {
      ie(this, "width", 0);
      ie(this, "height", 0);
      ie(this, "scrollHeight", 0);
      ie(this, "scrollWidth", 0);
      ie(this, "debouncedResize");
      ie(this, "wrapperResizeObserver");
      ie(this, "contentResizeObserver");
      ie(this, "resize", () => {
        this.onWrapperResize(), this.onContentResize();
      });
      ie(this, "onWrapperResize", () => {
        this.wrapper instanceof Window ? (this.width = window.innerWidth, this.height = window.innerHeight) : (this.width = this.wrapper.clientWidth, this.height = this.wrapper.clientHeight);
      });
      ie(this, "onContentResize", () => {
        this.wrapper instanceof Window ? (this.scrollHeight = this.content.scrollHeight, this.scrollWidth = this.content.scrollWidth) : (this.scrollHeight = this.wrapper.scrollHeight, this.scrollWidth = this.wrapper.scrollWidth);
      });
      this.wrapper = e, this.content = t, i && (this.debouncedResize = ry(this.resize, n), this.wrapper instanceof Window ? window.addEventListener("resize", this.debouncedResize) : (this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize), this.wrapperResizeObserver.observe(this.wrapper)), this.contentResizeObserver = new ResizeObserver(this.debouncedResize), this.contentResizeObserver.observe(this.content)), this.resize();
    }
    destroy() {
      var e, t;
      (e = this.wrapperResizeObserver) == null || e.disconnect(), (t = this.contentResizeObserver) == null || t.disconnect(), this.wrapper === window && this.debouncedResize && window.removeEventListener("resize", this.debouncedResize);
    }
    get limit() {
      return { x: this.scrollWidth - this.width, y: this.scrollHeight - this.height };
    }
  }, Kl = class {
    constructor() {
      ie(this, "events", {});
    }
    emit(e, ...t) {
      var n;
      const i = this.events[e] || [];
      for (let r = 0, o = i.length; r < o; r++) (n = i[r]) == null || n.call(i, ...t);
    }
    on(e, t) {
      return this.events[e] ? this.events[e].push(t) : this.events[e] = [t], () => {
        var i;
        this.events[e] = (i = this.events[e]) == null ? void 0 : i.filter((n) => t !== n);
      };
    }
    off(e, t) {
      var i;
      this.events[e] = (i = this.events[e]) == null ? void 0 : i.filter((n) => t !== n);
    }
    destroy() {
      this.events = {};
    }
  };
  const ay = 100 / 6, Nt = { passive: false };
  function Ma(e, t) {
    return e === 1 ? ay : e === 2 ? t : 1;
  }
  var ly = class {
    constructor(e, t = { wheelMultiplier: 1, touchMultiplier: 1 }) {
      ie(this, "touchStart", { x: 0, y: 0 });
      ie(this, "lastDelta", { x: 0, y: 0 });
      ie(this, "window", { width: 0, height: 0 });
      ie(this, "emitter", new Kl());
      ie(this, "onTouchStart", (e2) => {
        const { clientX: t2, clientY: i } = e2.targetTouches ? e2.targetTouches[0] : e2;
        this.touchStart.x = t2, this.touchStart.y = i, this.lastDelta = { x: 0, y: 0 }, this.emitter.emit("scroll", { deltaX: 0, deltaY: 0, event: e2 });
      });
      ie(this, "onTouchMove", (e2) => {
        const { clientX: t2, clientY: i } = e2.targetTouches ? e2.targetTouches[0] : e2, n = -(t2 - this.touchStart.x) * this.options.touchMultiplier, r = -(i - this.touchStart.y) * this.options.touchMultiplier;
        this.touchStart.x = t2, this.touchStart.y = i, this.lastDelta = { x: n, y: r }, this.emitter.emit("scroll", { deltaX: n, deltaY: r, event: e2 });
      });
      ie(this, "onTouchEnd", (e2) => {
        this.emitter.emit("scroll", { deltaX: this.lastDelta.x, deltaY: this.lastDelta.y, event: e2 });
      });
      ie(this, "onWheel", (e2) => {
        let { deltaX: t2, deltaY: i, deltaMode: n } = e2;
        const r = Ma(n, this.window.width), o = Ma(n, this.window.height);
        t2 *= r, i *= o, t2 *= this.options.wheelMultiplier, i *= this.options.wheelMultiplier, this.emitter.emit("scroll", { deltaX: t2, deltaY: i, event: e2 });
      });
      ie(this, "onWindowResize", () => {
        this.window = { width: window.innerWidth, height: window.innerHeight };
      });
      this.element = e, this.options = t, window.addEventListener("resize", this.onWindowResize), this.onWindowResize(), this.element.addEventListener("wheel", this.onWheel, Nt), this.element.addEventListener("touchstart", this.onTouchStart, Nt), this.element.addEventListener("touchmove", this.onTouchMove, Nt), this.element.addEventListener("touchend", this.onTouchEnd, Nt);
    }
    on(e, t) {
      return this.emitter.on(e, t);
    }
    destroy() {
      this.emitter.destroy(), window.removeEventListener("resize", this.onWindowResize), this.element.removeEventListener("wheel", this.onWheel, Nt), this.element.removeEventListener("touchstart", this.onTouchStart, Nt), this.element.removeEventListener("touchmove", this.onTouchMove, Nt), this.element.removeEventListener("touchend", this.onTouchEnd, Nt);
    }
  };
  const La = (e) => Math.min(1, 1.001 - Me(2, -10 * e));
  var cy = class {
    constructor({ wrapper: e = window, content: t = document.documentElement, eventsTarget: i = e, smoothWheel: n = true, syncTouch: r = false, syncTouchLerp: o = 0.075, touchInertiaExponent: l = 1.7, duration: c, easing: d, lerp: v = 0.1, infinite: E = false, orientation: y = "vertical", gestureOrientation: b = y === "horizontal" ? "both" : "vertical", touchMultiplier: p = 1, wheelMultiplier: g = 1, autoResize: C = true, prevent: _, virtualScroll: h, overscroll: S = true, autoRaf: w = false, anchors: A = false, autoToggle: L = false, allowNestedScroll: f = false, __experimental__naiveDimensions: P = false, naiveDimensions: D = P, stopInertiaOnNavigate: R = false } = {}) {
      ie(this, "_isScrolling", false);
      ie(this, "_isStopped", false);
      ie(this, "_isLocked", false);
      ie(this, "_preventNextNativeScrollEvent", false);
      ie(this, "_resetVelocityTimeout", null);
      ie(this, "_rafId", null);
      ie(this, "_isDraggingSelection", false);
      ie(this, "isTouching");
      ie(this, "isIos");
      ie(this, "time", 0);
      ie(this, "userData", {});
      ie(this, "lastVelocity", 0);
      ie(this, "velocity", 0);
      ie(this, "direction", 0);
      ie(this, "options");
      ie(this, "targetScroll");
      ie(this, "animatedScroll");
      ie(this, "animate", new sy());
      ie(this, "emitter", new Kl());
      ie(this, "dimensions");
      ie(this, "virtualScroll");
      ie(this, "onScrollEnd", (e2) => {
        e2 instanceof CustomEvent || (this.isScrolling === "smooth" || this.isScrolling === false) && e2.stopPropagation();
      });
      ie(this, "dispatchScrollendEvent", () => {
        this.options.wrapper.dispatchEvent(new CustomEvent("scrollend", { bubbles: this.options.wrapper === window, detail: { lenisScrollEnd: true } }));
      });
      ie(this, "onTransitionEnd", (e2) => {
        var t2;
        (t2 = e2.propertyName) != null && t2.includes("overflow") && e2.target === this.rootElement && this.checkOverflow();
      });
      ie(this, "onClick", (e2) => {
        const t2 = e2.composedPath().filter((n2) => n2 instanceof HTMLAnchorElement && n2.href).map((n2) => new URL(n2.href)), i2 = new URL(window.location.href);
        if (this.options.anchors) {
          const n2 = t2.find((r2) => i2.host === r2.host && i2.pathname === r2.pathname && r2.hash);
          if (n2) {
            const r2 = typeof this.options.anchors == "object" && this.options.anchors ? this.options.anchors : void 0, o2 = decodeURIComponent(n2.hash);
            this.scrollTo(o2, r2);
            return;
          }
        }
        if (this.options.stopInertiaOnNavigate && t2.some((n2) => i2.host === n2.host && i2.pathname !== n2.pathname)) {
          this.reset();
          return;
        }
      });
      ie(this, "onPointerDown", (e2) => {
        e2.button === 1 && this.reset();
      });
      ie(this, "onVirtualScroll", (e2) => {
        if (typeof this.options.virtualScroll == "function" && this.options.virtualScroll(e2) === false) return;
        const { deltaX: t2, deltaY: i2, event: n2 } = e2;
        if (this.emitter.emit("virtual-scroll", { deltaX: t2, deltaY: i2, event: n2 }), n2.ctrlKey || n2.lenisStopPropagation) return;
        const r2 = n2.type.includes("touch"), o2 = n2.type.includes("wheel");
        if (r2 && this.isIos && (n2.type === "touchstart" && (this._isDraggingSelection = this.isTouchOnSelectionHandle(n2)), this._isDraggingSelection)) {
          n2.type === "touchend" && (this._isDraggingSelection = false);
          return;
        }
        this.isTouching = n2.type === "touchstart" || n2.type === "touchmove";
        const l2 = t2 === 0 && i2 === 0;
        if (this.options.syncTouch && r2 && n2.type === "touchstart" && l2 && !this.isStopped && !this.isLocked) {
          this.reset();
          return;
        }
        const c2 = this.options.gestureOrientation === "vertical" && i2 === 0 || this.options.gestureOrientation === "horizontal" && t2 === 0;
        if (l2 || c2) return;
        let d2 = n2.composedPath();
        d2 = d2.slice(0, d2.indexOf(this.rootElement));
        const v2 = this.options.prevent, E2 = Math.abs(t2) >= Math.abs(i2) ? "horizontal" : "vertical";
        if (d2.find((g2) => {
          var C2, _2, h2, S2, w2;
          return g2 instanceof HTMLElement && (typeof v2 == "function" && (v2 == null ? void 0 : v2(g2)) || ((C2 = g2.hasAttribute) == null ? void 0 : C2.call(g2, "data-lenis-prevent")) || E2 === "vertical" && ((_2 = g2.hasAttribute) == null ? void 0 : _2.call(g2, "data-lenis-prevent-vertical")) || E2 === "horizontal" && ((h2 = g2.hasAttribute) == null ? void 0 : h2.call(g2, "data-lenis-prevent-horizontal")) || r2 && ((S2 = g2.hasAttribute) == null ? void 0 : S2.call(g2, "data-lenis-prevent-touch")) || o2 && ((w2 = g2.hasAttribute) == null ? void 0 : w2.call(g2, "data-lenis-prevent-wheel")) || this.options.allowNestedScroll && this.hasNestedScroll(g2, { deltaX: t2, deltaY: i2 }));
        })) return;
        if (this.isStopped || this.isLocked) {
          n2.cancelable && n2.preventDefault();
          return;
        }
        if (!(this.options.syncTouch && r2 || this.options.smoothWheel && o2)) {
          this.isScrolling = "native", this.animate.stop(), n2.lenisStopPropagation = true;
          return;
        }
        let y2 = i2;
        this.options.gestureOrientation === "both" ? y2 = Math.abs(i2) > Math.abs(t2) ? i2 : t2 : this.options.gestureOrientation === "horizontal" && (y2 = t2), (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && this.limit > 0 && (this.animatedScroll > 0 && this.animatedScroll < this.limit || this.animatedScroll === 0 && i2 > 0 || this.animatedScroll === this.limit && i2 < 0)) && (n2.lenisStopPropagation = true), n2.cancelable && n2.preventDefault();
        const b2 = r2 && this.options.syncTouch, p2 = r2 && n2.type === "touchend";
        p2 && (y2 = Math.sign(y2) * Me(Math.abs(this.velocity), this.options.touchInertiaExponent)), this.scrollTo(this.targetScroll + y2, Ie({ programmatic: false }, b2 ? { lerp: p2 ? this.options.syncTouchLerp : 1 } : { lerp: this.options.lerp, duration: this.options.duration, easing: this.options.easing }));
      });
      ie(this, "onNativeScroll", () => {
        if (this._resetVelocityTimeout !== null && (clearTimeout(this._resetVelocityTimeout), this._resetVelocityTimeout = null), this._preventNextNativeScrollEvent) {
          this._preventNextNativeScrollEvent = false;
          return;
        }
        if (this.isScrolling === false || this.isScrolling === "native") {
          const e2 = this.animatedScroll;
          this.animatedScroll = this.targetScroll = this.actualScroll, this.lastVelocity = this.velocity, this.velocity = this.animatedScroll - e2, this.direction = Math.sign(this.animatedScroll - e2), this.isStopped || (this.isScrolling = "native"), this.emit(), this.velocity !== 0 && (this._resetVelocityTimeout = setTimeout(() => {
            this.lastVelocity = this.velocity, this.velocity = 0, this.isScrolling = false, this.emit();
          }, 400));
        }
      });
      ie(this, "raf", (e2) => {
        const t2 = e2 - (this.time || e2);
        this.time = e2, this.animate.advance(t2 * 1e-3), this.options.autoRaf && (this._rafId = requestAnimationFrame(this.raf));
      });
      window.lenisVersion = Oa, window.lenis || (window.lenis = {}), window.lenis.version = Oa, y === "horizontal" && (window.lenis.horizontal = true), r === true && (window.lenis.touch = true), this.isIos = /(iPad|iPhone|iPod)/g.test(navigator.userAgent), (!e || e === document.documentElement) && (e = window), typeof c == "number" && typeof d != "function" ? d = La : typeof d == "function" && typeof c != "number" && (c = 1), this.options = { wrapper: e, content: t, eventsTarget: i, smoothWheel: n, syncTouch: r, syncTouchLerp: o, touchInertiaExponent: l, duration: c, easing: d, lerp: v, infinite: E, gestureOrientation: b, orientation: y, touchMultiplier: p, wheelMultiplier: g, autoResize: C, prevent: _, virtualScroll: h, overscroll: S, autoRaf: w, anchors: A, autoToggle: L, allowNestedScroll: f, naiveDimensions: D, stopInertiaOnNavigate: R }, this.dimensions = new oy(e, t, { autoResize: C }), this.updateClassName(), this.targetScroll = this.animatedScroll = this.actualScroll, this.options.wrapper.addEventListener("scroll", this.onNativeScroll), this.options.wrapper.addEventListener("scrollend", this.onScrollEnd, { capture: true }), (this.options.anchors || this.options.stopInertiaOnNavigate) && this.options.wrapper.addEventListener("click", this.onClick), this.options.wrapper.addEventListener("pointerdown", this.onPointerDown), this.virtualScroll = new ly(i, { touchMultiplier: p, wheelMultiplier: g }), this.virtualScroll.on("scroll", this.onVirtualScroll), this.options.autoToggle && (this.checkOverflow(), this.rootElement.addEventListener("transitionend", this.onTransitionEnd)), this.options.autoRaf && (this._rafId = requestAnimationFrame(this.raf));
    }
    destroy() {
      this.emitter.destroy(), this.options.wrapper.removeEventListener("scroll", this.onNativeScroll), this.options.wrapper.removeEventListener("scrollend", this.onScrollEnd, { capture: true }), this.options.wrapper.removeEventListener("pointerdown", this.onPointerDown), (this.options.anchors || this.options.stopInertiaOnNavigate) && this.options.wrapper.removeEventListener("click", this.onClick), this.virtualScroll.destroy(), this.dimensions.destroy(), this.cleanUpClassName(), this._rafId && cancelAnimationFrame(this._rafId);
    }
    on(e, t) {
      return this.emitter.on(e, t);
    }
    off(e, t) {
      return this.emitter.off(e, t);
    }
    get overflow() {
      const e = this.isHorizontal ? "overflow-x" : "overflow-y";
      return getComputedStyle(this.rootElement)[e];
    }
    checkOverflow() {
      ["hidden", "clip"].includes(this.overflow) ? this.internalStop() : this.internalStart();
    }
    setScroll(e) {
      this.isHorizontal ? this.options.wrapper.scrollTo({ left: e, behavior: "instant" }) : this.options.wrapper.scrollTo({ top: e, behavior: "instant" });
    }
    isTouchOnSelectionHandle(e) {
      var v;
      const t = window.getSelection();
      if (!t || t.isCollapsed || t.rangeCount === 0) return false;
      const i = (v = e.targetTouches[0]) != null ? v : e.changedTouches[0];
      if (!i) return false;
      const n = t.getRangeAt(0).getClientRects();
      if (n.length === 0) return false;
      const r = n[0], o = n[n.length - 1], l = 40, c = Math.hypot(i.clientX - r.left, i.clientY - r.top) <= l, d = Math.hypot(i.clientX - o.right, i.clientY - o.bottom) <= l;
      return c || d;
    }
    resize() {
      this.dimensions.resize(), this.animatedScroll = this.targetScroll = this.actualScroll, this.emit();
    }
    emit() {
      this.emitter.emit("scroll", this);
    }
    reset() {
      this.isLocked = false, this.isScrolling = false, this.animatedScroll = this.targetScroll = this.actualScroll, this.lastVelocity = this.velocity = 0, this.animate.stop();
    }
    start() {
      if (this.isStopped) {
        if (this.options.autoToggle) {
          this.rootElement.style.removeProperty("overflow");
          return;
        }
        this.internalStart();
      }
    }
    internalStart() {
      this.isStopped && (this.reset(), this.isStopped = false, this.emit());
    }
    stop() {
      if (!this.isStopped) {
        if (this.options.autoToggle) {
          this.rootElement.style.setProperty("overflow", "clip");
          return;
        }
        this.internalStop();
      }
    }
    internalStop() {
      this.isStopped || (this.reset(), this.isStopped = true, this.emit());
    }
    scrollTo(e, { offset: t = 0, immediate: i = false, lock: n = false, programmatic: r = true, lerp: o = r ? this.options.lerp : void 0, duration: l = r ? this.options.duration : void 0, easing: c = r ? this.options.easing : void 0, onStart: d, onComplete: v, force: E = false, userData: y } = {}) {
      if ((this.isStopped || this.isLocked) && !E) return;
      let b = e, p = t;
      if (typeof b == "string" && ["top", "left", "start", "#"].includes(b)) b = 0;
      else if (typeof b == "string" && ["bottom", "right", "end"].includes(b)) b = this.limit;
      else {
        let g = null;
        if (typeof b == "string" ? (g = b.startsWith("#") ? document.getElementById(b.slice(1)) : document.querySelector(b), g || (b === "#top" ? b = 0 : console.warn("Lenis: Target not found", b))) : b instanceof HTMLElement && (b != null && b.nodeType) && (g = b), g) {
          if (this.options.wrapper !== window) {
            const A = this.rootElement.getBoundingClientRect();
            p -= this.isHorizontal ? A.left : A.top;
          }
          const C = g.getBoundingClientRect(), _ = getComputedStyle(g), h = this.isHorizontal ? Number.parseFloat(_.scrollMarginLeft) : Number.parseFloat(_.scrollMarginTop), S = getComputedStyle(this.rootElement), w = this.isHorizontal ? Number.parseFloat(S.scrollPaddingLeft) : Number.parseFloat(S.scrollPaddingTop);
          b = (this.isHorizontal ? C.left : C.top) + this.animatedScroll - (Number.isNaN(h) ? 0 : h) - (Number.isNaN(w) ? 0 : w);
        }
      }
      if (typeof b == "number") {
        if (b += p, this.options.infinite) {
          if (r) {
            this.targetScroll = this.animatedScroll = this.scroll;
            const g = b - this.animatedScroll;
            g > this.limit / 2 ? b -= this.limit : g < -this.limit / 2 && (b += this.limit);
          }
        } else b = Ul(0, b, this.limit);
        if (b === this.targetScroll) {
          d == null || d(this), v == null || v(this);
          return;
        }
        if (this.userData = y != null ? y : {}, i) {
          this.animatedScroll = this.targetScroll = b, this.setScroll(this.scroll), this.reset(), this.preventNextNativeScrollEvent(), this.emit(), v == null || v(this), this.userData = {}, requestAnimationFrame(() => {
            this.dispatchScrollendEvent();
          });
          return;
        }
        r || (this.targetScroll = b), typeof l == "number" && typeof c != "function" ? c = La : typeof c == "function" && typeof l != "number" && (l = 1), this.animate.fromTo(this.animatedScroll, b, { duration: l, easing: c, lerp: o, onStart: () => {
          n && (this.isLocked = true), this.isScrolling = "smooth", d == null || d(this);
        }, onUpdate: (g, C) => {
          this.isScrolling = "smooth", this.lastVelocity = this.velocity, this.velocity = g - this.animatedScroll, this.direction = Math.sign(this.velocity), this.animatedScroll = g, this.setScroll(this.scroll), r && (this.targetScroll = g), C || this.emit(), C && (this.reset(), this.emit(), v == null || v(this), this.userData = {}, requestAnimationFrame(() => {
            this.dispatchScrollendEvent();
          }), this.preventNextNativeScrollEvent());
        } });
      }
    }
    preventNextNativeScrollEvent() {
      this._preventNextNativeScrollEvent = true, requestAnimationFrame(() => {
        this._preventNextNativeScrollEvent = false;
      });
    }
    hasNestedScroll(e, { deltaX: t, deltaY: i }) {
      var f;
      const n = Date.now();
      e._lenis || (e._lenis = {});
      const r = e._lenis;
      let o, l, c, d, v, E, y, b, p, g;
      if (n - ((f = r.time) != null ? f : 0) > 2e3) {
        r.time = Date.now();
        const P = window.getComputedStyle(e);
        if (r.computedStyle = P, o = ["auto", "overlay", "scroll"].includes(P.overflowX), l = ["auto", "overlay", "scroll"].includes(P.overflowY), v = ["auto"].includes(P.overscrollBehaviorX), E = ["auto"].includes(P.overscrollBehaviorY), r.hasOverflowX = o, r.hasOverflowY = l, !(o || l)) return false;
        y = e.scrollWidth, b = e.scrollHeight, p = e.clientWidth, g = e.clientHeight, c = y > p, d = b > g, r.isScrollableX = c, r.isScrollableY = d, r.scrollWidth = y, r.scrollHeight = b, r.clientWidth = p, r.clientHeight = g, r.hasOverscrollBehaviorX = v, r.hasOverscrollBehaviorY = E;
      } else c = r.isScrollableX, d = r.isScrollableY, o = r.hasOverflowX, l = r.hasOverflowY, y = r.scrollWidth, b = r.scrollHeight, p = r.clientWidth, g = r.clientHeight, v = r.hasOverscrollBehaviorX, E = r.hasOverscrollBehaviorY;
      if (!(o && c || l && d)) return false;
      const C = Math.abs(t) >= Math.abs(i) ? "horizontal" : "vertical";
      let _, h, S, w, A, L;
      if (C === "horizontal") _ = Math.round(e.scrollLeft), h = y - p, S = t, w = o, A = c, L = v;
      else if (C === "vertical") _ = Math.round(e.scrollTop), h = b - g, S = i, w = l, A = d, L = E;
      else return false;
      return !L && (_ >= h || _ <= 0) ? true : (S > 0 ? _ < h : _ > 0) && w && A;
    }
    get rootElement() {
      return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
    }
    get limit() {
      return this.options.naiveDimensions ? this.isHorizontal ? this.rootElement.scrollWidth - this.rootElement.clientWidth : this.rootElement.scrollHeight - this.rootElement.clientHeight : this.dimensions.limit[this.isHorizontal ? "x" : "y"];
    }
    get isHorizontal() {
      return this.options.orientation === "horizontal";
    }
    get actualScroll() {
      var t, i;
      const e = this.options.wrapper;
      return this.isHorizontal ? (t = e.scrollX) != null ? t : e.scrollLeft : (i = e.scrollY) != null ? i : e.scrollTop;
    }
    get scroll() {
      return this.options.infinite ? ny(this.animatedScroll, this.limit) : this.animatedScroll;
    }
    get progress() {
      return this.limit === 0 ? 1 : this.scroll / this.limit;
    }
    get isScrolling() {
      return this._isScrolling;
    }
    set isScrolling(e) {
      this._isScrolling !== e && (this._isScrolling = e, this.updateClassName());
    }
    get isStopped() {
      return this._isStopped;
    }
    set isStopped(e) {
      this._isStopped !== e && (this._isStopped = e, this.updateClassName());
    }
    get isLocked() {
      return this._isLocked;
    }
    set isLocked(e) {
      this._isLocked !== e && (this._isLocked = e, this.updateClassName());
    }
    get isSmooth() {
      return this.isScrolling === "smooth";
    }
    get className() {
      let e = "lenis";
      return this.options.autoToggle && (e += " lenis-autoToggle"), this.isStopped && (e += " lenis-stopped"), this.isLocked && (e += " lenis-locked"), this.isScrolling && (e += " lenis-scrolling"), this.isScrolling === "smooth" && (e += " lenis-smooth"), e;
    }
    updateClassName() {
      this.cleanUpClassName(), this.className.split(" ").forEach((e) => {
        this.rootElement.classList.add(e);
      });
    }
    cleanUpClassName() {
      for (const e of Array.from(this.rootElement.classList)) (e === "lenis" || e.startsWith("lenis-")) && this.rootElement.classList.remove(e);
    }
  };
  window.Lenis = cy;
})();
